
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1717"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1717"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("88tg0", function(module, exports) {
var SphericalMercator = function() {
    // Closures including constants and other precalculated values.
    var cache = {}, EPSLN = 1.0e-10, D2R = Math.PI / 180, R2D = 180 / Math.PI, // 900913 properties.
    A = 6378137.0, MAXEXTENT = 20037508.342789244;
    // SphericalMercator constructor: precaches calculations
    // for fast tile lookups.
    function SphericalMercator(options) {
        options = options || {};
        this.size = options.size || 256;
        if (!cache[this.size]) {
            var size = this.size;
            var c = cache[this.size] = {};
            c.Bc = [];
            c.Cc = [];
            c.zc = [];
            c.Ac = [];
            for(var d = 0; d < 30; d++){
                c.Bc.push(size / 360);
                c.Cc.push(size / (2 * Math.PI));
                c.zc.push(size / 2);
                c.Ac.push(size);
                size *= 2;
            }
        }
        this.Bc = cache[this.size].Bc;
        this.Cc = cache[this.size].Cc;
        this.zc = cache[this.size].zc;
        this.Ac = cache[this.size].Ac;
    }
    // Convert lon lat to screen pixel value
    //
    // - `ll` {Array} `[lon, lat]` array of geographic coordinates.
    // - `zoom` {Number} zoom level.
    SphericalMercator.prototype.px = function(ll, zoom) {
        var d = this.zc[zoom];
        var f = Math.min(Math.max(Math.sin(D2R * ll[1]), -0.9999), 0.9999);
        var x = Math.round(d + ll[0] * this.Bc[zoom]);
        var y = Math.round(d + 0.5 * Math.log((1 + f) / (1 - f)) * -this.Cc[zoom]);
        x > this.Ac[zoom] && (x = this.Ac[zoom]);
        y > this.Ac[zoom] && (y = this.Ac[zoom]);
        //(x < 0) && (x = 0);
        //(y < 0) && (y = 0);
        return [
            x,
            y
        ];
    };
    // Convert screen pixel value to lon lat
    //
    // - `px` {Array} `[x, y]` array of geographic coordinates.
    // - `zoom` {Number} zoom level.
    SphericalMercator.prototype.ll = function(px, zoom) {
        var g = (px[1] - this.zc[zoom]) / -this.Cc[zoom];
        var lon = (px[0] - this.zc[zoom]) / this.Bc[zoom];
        var lat = R2D * (2 * Math.atan(Math.exp(g)) - 0.5 * Math.PI);
        return [
            lon,
            lat
        ];
    };
    // Convert tile xyz value to bbox of the form `[w, s, e, n]`
    //
    // - `x` {Number} x (longitude) number.
    // - `y` {Number} y (latitude) number.
    // - `zoom` {Number} zoom.
    // - `tms_style` {Boolean} whether to compute using tms-style.
    // - `srs` {String} projection for resulting bbox (WGS84|900913).
    // - `return` {Array} bbox array of values in form `[w, s, e, n]`.
    SphericalMercator.prototype.bbox = function(x, y, zoom, tms_style, srs) {
        // Convert xyz into bbox with srs WGS84
        if (tms_style) y = Math.pow(2, zoom) - 1 - y;
        // Use +y to make sure it's a number to avoid inadvertent concatenation.
        var ll = [
            x * this.size,
            (+y + 1) * this.size
        ]; // lower left
        // Use +x to make sure it's a number to avoid inadvertent concatenation.
        var ur = [
            (+x + 1) * this.size,
            y * this.size
        ]; // upper right
        var bbox = this.ll(ll, zoom).concat(this.ll(ur, zoom));
        // If web mercator requested reproject to 900913.
        if (srs === '900913') return this.convert(bbox, '900913');
        else return bbox;
    };
    // Convert bbox to xyx bounds
    //
    // - `bbox` {Number} bbox in the form `[w, s, e, n]`.
    // - `zoom` {Number} zoom.
    // - `tms_style` {Boolean} whether to compute using tms-style.
    // - `srs` {String} projection of input bbox (WGS84|900913).
    // - `@return` {Object} XYZ bounds containing minX, maxX, minY, maxY properties.
    SphericalMercator.prototype.xyz = function(bbox, zoom, tms_style, srs) {
        // If web mercator provided reproject to WGS84.
        if (srs === '900913') bbox = this.convert(bbox, 'WGS84');
        var ll = [
            bbox[0],
            bbox[1]
        ]; // lower left
        var ur = [
            bbox[2],
            bbox[3]
        ]; // upper right
        var px_ll = this.px(ll, zoom);
        var px_ur = this.px(ur, zoom);
        // Y = 0 for XYZ is the top hence minY uses px_ur[1].
        var x = [
            Math.floor(px_ll[0] / this.size),
            Math.floor((px_ur[0] - 1) / this.size)
        ];
        var y = [
            Math.floor(px_ur[1] / this.size),
            Math.floor((px_ll[1] - 1) / this.size)
        ];
        var bounds = {
            minX: Math.min.apply(Math, x) < 0 ? 0 : Math.min.apply(Math, x),
            minY: Math.min.apply(Math, y) < 0 ? 0 : Math.min.apply(Math, y),
            maxX: Math.max.apply(Math, x),
            maxY: Math.max.apply(Math, y)
        };
        if (tms_style) {
            var tms = {
                minY: Math.pow(2, zoom) - 1 - bounds.maxY,
                maxY: Math.pow(2, zoom) - 1 - bounds.minY
            };
            bounds.minY = tms.minY;
            bounds.maxY = tms.maxY;
        }
        return bounds;
    };
    // Convert projection of given bbox.
    //
    // - `bbox` {Number} bbox in the form `[w, s, e, n]`.
    // - `to` {String} projection of output bbox (WGS84|900913). Input bbox
    //   assumed to be the "other" projection.
    // - `@return` {Object} bbox with reprojected coordinates.
    SphericalMercator.prototype.convert = function(bbox, to) {
        if (to === '900913') return this.forward(bbox.slice(0, 2)).concat(this.forward(bbox.slice(2, 4)));
        else return this.inverse(bbox.slice(0, 2)).concat(this.inverse(bbox.slice(2, 4)));
    };
    // Convert lon/lat values to 900913 x/y.
    SphericalMercator.prototype.forward = function(ll) {
        var xy = [
            A * ll[0] * D2R,
            A * Math.log(Math.tan(Math.PI * 0.25 + 0.5 * ll[1] * D2R))
        ];
        // if xy value is beyond maxextent (e.g. poles), return maxextent.
        xy[0] > MAXEXTENT && (xy[0] = MAXEXTENT);
        xy[0] < -MAXEXTENT && (xy[0] = -MAXEXTENT);
        xy[1] > MAXEXTENT && (xy[1] = MAXEXTENT);
        xy[1] < -MAXEXTENT && (xy[1] = -MAXEXTENT);
        return xy;
    };
    // Convert 900913 x/y values to lon/lat.
    SphericalMercator.prototype.inverse = function(xy) {
        return [
            xy[0] * R2D / A,
            (Math.PI * 0.5 - 2.0 * Math.atan(Math.exp(-xy[1] / A))) * R2D
        ];
    };
    return SphericalMercator;
}();
module.exports = exports = SphericalMercator;

});

parcelRegister("lDve0", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $7ouFS = parcelRequire("7ouFS");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $7ouFS.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $7ouFS.default)(Rgb, rgb, (0, $7ouFS.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $7ouFS.default)(Hsl, hsl, (0, $7ouFS.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("7ouFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56229199b63867af$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $56229199b63867af$export$8b58be045bf06082; });
function $56229199b63867af$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $56229199b63867af$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("1ihob", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $0f14f5f7594e2c8c$export$2e2bcd8739ae039; });

var $hgmfu = parcelRequire("hgmfu");

var $gQlHt = parcelRequire("gQlHt");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $hgmfu.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $hgmfu.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0f14f5f7594e2c8c$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $gQlHt.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("hgmfu", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $c9153075a6805cfe$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan2", function () { return $c9153075a6805cfe$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $c9153075a6805cfe$export$50d414a77b60d802; });
$parcel$export(module.exports, "max", function () { return $c9153075a6805cfe$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $c9153075a6805cfe$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $c9153075a6805cfe$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $c9153075a6805cfe$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $c9153075a6805cfe$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $c9153075a6805cfe$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $c9153075a6805cfe$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $c9153075a6805cfe$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "acos", function () { return $c9153075a6805cfe$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $c9153075a6805cfe$export$41726bdb1fc63f; });
var $c9153075a6805cfe$export$2335f513bbd82c6d = Math.abs;
var $c9153075a6805cfe$export$b8b770ee6a0d9760 = Math.atan2;
var $c9153075a6805cfe$export$50d414a77b60d802 = Math.cos;
var $c9153075a6805cfe$export$8960430cfd85939f = Math.max;
var $c9153075a6805cfe$export$96ec731ed4dcb222 = Math.min;
var $c9153075a6805cfe$export$5de3937cb4b592ed = Math.sin;
var $c9153075a6805cfe$export$eba8049fb5020b81 = Math.sqrt;
var $c9153075a6805cfe$export$6c421550c66a327d = 1e-12;
var $c9153075a6805cfe$export$18c7bea995a110f = Math.PI;
var $c9153075a6805cfe$export$e51408a300e8929a = $c9153075a6805cfe$export$18c7bea995a110f / 2;
var $c9153075a6805cfe$export$a4b4b4d4d776fe92 = 2 * $c9153075a6805cfe$export$18c7bea995a110f;
function $c9153075a6805cfe$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $c9153075a6805cfe$export$18c7bea995a110f : Math.acos(x);
}
function $c9153075a6805cfe$export$41726bdb1fc63f(x) {
    return x >= 1 ? $c9153075a6805cfe$export$e51408a300e8929a : x <= -1 ? -$c9153075a6805cfe$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("gQlHt", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $c43255dc50793b1f$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $c43255dc50793b1f$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $c43255dc50793b1f$export$2e2bcd8739ae039; });
function $c43255dc50793b1f$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c43255dc50793b1f$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c43255dc50793b1f$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c43255dc50793b1f$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $c43255dc50793b1f$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c43255dc50793b1f$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c43255dc50793b1f$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


"use strict";
var $33cad05b1ab8f358$exports = {};
"use strict";
$33cad05b1ab8f358$exports = JSON.parse("{\"AI\":{\"pos1\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-63.4296,18.1499,-62.9244,18.5953]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpCeEFGOnY0\",\"adm1\":{\"description\":\"territory\",\"z_min\":\"1\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"3\"}},\"CL\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[-109.4498,-55.982,-66.4148,-17.4984]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpMaEF1OnY0\",\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"}},\"CN\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[73.4993,7.3643,134.7755,53.561]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpMeEF3OnY0\",\"adm1\":{\"description\":\"province, special administrative region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"prefecture, sub-prefecture, special administrative region\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"county, district, autonomous prefecture\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"6-4 digit postcode area\",\"z_min\":\"3\"}},\"DE\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[5.8663,47.2701,15.0418,55.0568]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpWUkE1OnY0\",\"adm1\":{\"description\":\"federal state\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"rural district, urban district, district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality, unincorporated area\",\"z_min\":\"6\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"postal directing area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"GB\":{\"pos1\":{\"description\":\"postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-8.6501,49.8668,1.763,60.8608]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo3aEJOOnY0\",\"adm1\":{\"description\":\"country\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"ITL 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"ITL 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"ITL 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"unitary authority, council area, county\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"non-metropolitan district, unitary authority, metropolitan district\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"postcode district\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"postcode sector\",\"z_min\":\"5\"},\"pos4\":{\"description\":\"postcode unit\",\"z_min\":\"8\"}},\"GG\":{\"pos1\":{\"description\":\"postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-2.6751,49.4002,-2.1586,49.7328]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpYeEJSOnY0\",\"adm1\":{\"description\":\"crown dependency\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish, island\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"postcode district\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"postcode sector\",\"z_min\":\"5\"}},\"GI\":{\"pos1\":{\"description\":\"postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-5.3661,36.1089,-5.3386,36.155]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpWeEJUOnY0\",\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos2\":{\"description\":\"postcode district\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"postcode sector\",\"z_min\":\"5\"},\"pos4\":{\"description\":\"postcode unit\",\"z_min\":\"8\"}},\"IM\":{\"pos1\":{\"description\":\"postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-4.8307,54.0431,-4.3079,54.4181]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpiaEJvOnY0\",\"adm1\":{\"description\":\"crown dependency\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"sheading\",\"z_min\":\"3\"},\"adm2\":{\"description\":\"parish, town, district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"postcode district\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"postcode sector\",\"z_min\":\"5\"}},\"IN\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[68.1745,6.756,97.3954,35.6733]\",\"mapbox_id\":\"dXJuOm1ieGJuZDphUkJwOnY0\",\"adm1\":{\"description\":\"state, union territory\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"tehsil, circle, mandal\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"4\"}},\"IR\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[44.032,25.0591,63.3333,39.7825]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpheEJzOnY0\",\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county\",\"z_min\":\"1\"}},\"JE\":{\"pos1\":{\"description\":\"postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-2.2545,49.1631,-2.017,49.2623]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpkQkJ2OnY0\",\"adm1\":{\"description\":\"crown dependency\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"postcode district\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"postcode sector\",\"z_min\":\"5\"}},\"JM\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"2\"},\"bbox\":\"[-78.3688,17.7058,-76.1829,18.525]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpjaEJ3OnY0\",\"adm1\":{\"description\":\"parish\",\"z_min\":\"2\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"}},\"JO\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"bbox\":\"[34.9581,29.185,39.3012,33.3747]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpkUkJ4OnY0\",\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"}},\"JP\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"bbox\":\"[122.9338,24.0457,145.8175,45.523]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpjeEJ5OnY0\",\"adm1\":{\"description\":\"prefecture\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"metropolitan area, major metropolitan area, disputed area\",\"z_min\":\"2\"},\"sta3\":{\"description\":\"statistical area, disputed area\",\"z_min\":\"7\"},\"sta2\":{\"description\":\"city, town, village\",\"z_min\":\"3\"},\"adm2\":{\"description\":\"city, town, village\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"ward\",\"z_min\":\"5\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"},\"pos4\":{\"description\":\"7-digit postcode area\",\"z_min\":\"7\"}},\"KE\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[33.9098,-4.6913,41.9069,5.0334]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpkeEJ6OnY0\",\"adm1\":{\"description\":\"county\",\"z_min\":\"1\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"province\",\"z_min\":\"0\"},\"sta2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"sub-county\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"ward\",\"z_min\":\"4\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"}},\"KH\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"bbox\":\"[102.3337,10.3531,107.6277,14.6902]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpKaEIxOnY0\",\"adm1\":{\"description\":\"province, autonomous municipality\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, municipality, section\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"commune, quarter\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"6\"}},\"MA\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"0\"},\"bbox\":\"[-13.1671,27.6705,-0.997,35.9222]\",\"mapbox_id\":\"dXJuOm1ieGJuZDptQkNKOnY0\",\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"commune\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"MU\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"0\"},\"bbox\":\"[56.5853,-20.5255,63.5033,-10.3372]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpqeENhOnY0\",\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"3-digit postcode areas\",\"z_min\":\"0\"}},\"NL\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"bbox\":\"[3.3584,50.7504,7.2275,53.555]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpuaENtOnY0\",\"adm1\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"5-digit postcode area\",\"z_min\":\"7\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"9\"}},\"SA\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"0\"},\"bbox\":\"[34.4953,16.3795,55.6667,32.1543]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp4UkRCOnY0\",\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"governorate\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"EH\":{\"pos1\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"},\"bbox\":\"[-17.1033,20.77,-8.6676,27.6837]\",\"mapbox_id\":\"dXJuOm1ieGJuZDorUkJDOnY0\",\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"commune\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"HK\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"bbox\":\"[113.8351,22.1539,114.4417,22.5619]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBL0FRWHc6djQ\",\"adm1\":{\"description\":\"special administrative region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"prefecture\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"3\"}},\"MO\":{\"pos1\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"bbox\":\"[113.5287,22.1098,113.5983,22.2171]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBL0VRbEE6djQ\",\"adm1\":{\"description\":\"special administrative region\",\"z_min\":\"0\"},\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"prefecture\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"3\"}},\"AD\":{\"adm1\":{\"description\":\"parish\",\"z_min\":\"5\"},\"bbox\":\"[1.4136,42.4287,1.7867,42.6559]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpCUkFCOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"AE\":{\"adm1\":{\"description\":\"emirate\",\"z_min\":\"1\"},\"bbox\":\"[51.498,22.6315,56.3816,26.0694]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo3UkFDOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"loc2\":{\"description\":\"settlement, city\",\"z_min\":\"1\"},\"loc4\":{\"description\":\"neighborhood\",\"z_min\":\"3\"},\"adm2\":{\"description\":\"municipality, sector, area\",\"z_min\":\"2\"}},\"AF\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[60.5176,29.3772,74.8899,38.4907]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBUkFEOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"1\"}},\"AG\":{\"adm1\":{\"description\":\"parish\",\"z_min\":\"5\"},\"bbox\":\"[-62.3482,16.9323,-61.657,17.7294]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpDUkFFOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"AL\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"2\"},\"bbox\":\"[19.2635,39.6448,21.0573,42.6611]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBaEFHOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"7\"}},\"AM\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"2\"},\"bbox\":\"[43.4473,38.8402,46.6342,41.3011]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpDeEFIOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"AO\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[11.6693,-18.0391,24.0879,-4.3881]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpCaEFJOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"1\"}},\"AR\":{\"adm1\":{\"description\":\"province, autonomous city\",\"z_min\":\"0\"},\"bbox\":\"[-73.5604,-55.0572,-53.6374,-21.7809]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpDaEFLOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department, partido, comuna\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"AS\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[-171.09,-14.5698,-168.1303,-11.0479]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpCQkFMOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"senate\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, island\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"county, unorganised atoll\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"adm4\":{\"description\":\"village\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"},\"leg2\":{\"description\":\"congressional district\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"tract\",\"z_min\":\"5\"},\"sta5\":{\"description\":\"block group\",\"z_min\":\"6\"}},\"AT\":{\"adm1\":{\"description\":\"state\",\"z_min\":\"1\"},\"bbox\":\"[9.5307,46.3723,17.1608,49.0205]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpEaEFNOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district, city\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality, district\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"cadastral community\",\"z_min\":\"7\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"AU\":{\"adm1\":{\"description\":\"state, territory, external territory\",\"z_min\":\"0\"},\"bbox\":\"[112.9211,-54.778,159.1092,-9.1422]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpEUkFOOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"state, territory, external territory\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"statistical areas level 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"statistical areas level 4\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"local government area, unincorporated area, territory\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"statistical areas level 2\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"statistical areas level 1\",\"z_min\":\"5\"}},\"AW\":{\"adm1\":{\"description\":\"constituent country\",\"z_min\":\"1\"},\"bbox\":\"[-70.0637,12.4118,-69.8657,12.6234]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpEQkFPOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"region\",\"z_min\":\"5\"}},\"AX\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"1\"},\"bbox\":\"[19.2633,59.7333,21.3303,60.6657]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBKzhRRHc6djQ\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"sub-regional unit\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"AZ\":{\"adm1\":{\"description\":\"district, city\",\"z_min\":\"2\"},\"bbox\":\"[44.7633,38.3922,50.6248,41.9123]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpEeEFROnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"economic region\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"BA\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"1\"},\"bbox\":\"[15.7287,42.5555,19.6237,45.2765]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpIQkFSOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"canton, region, district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"BB\":{\"adm1\":{\"description\":\"parish\",\"z_min\":\"5\"},\"bbox\":\"[-59.6526,13.0447,-59.4203,13.3348]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpFeEFTOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"BD\":{\"adm1\":{\"description\":\"division\",\"z_min\":\"1\"},\"bbox\":\"[88.0086,20.5751,92.6801,26.6339]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpFaEFUOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"subdistrict, metropolitan subdistrict\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"union, ward, cantonment\",\"z_min\":\"4\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"}},\"BE\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"1\"},\"bbox\":\"[2.5454,49.497,6.4081,51.5051]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpGUkFVOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"province, region\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"district, region\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"adm4\":{\"description\":\"municipality\",\"z_min\":\"5\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"5\"}},\"BF\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"1\"},\"bbox\":\"[-5.5132,9.4105,2.4044,15.084]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpKQkFWOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"department\",\"z_min\":\"2\"}},\"BG\":{\"adm1\":{\"description\":\"province, city\",\"z_min\":\"1\"},\"bbox\":\"[22.3572,41.2353,28.6119,44.2155]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpJeEFXOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"BH\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[50.3129,25.5717,50.8245,26.4229]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpFUkFYOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"area\",\"z_min\":\"6\"},\"adm3\":{\"description\":\"block\",\"z_min\":\"7\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"}},\"BI\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"1\"},\"bbox\":\"[29.001,-4.4693,30.8495,-2.3097]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpKUkFZOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"commune\",\"z_min\":\"4\"}},\"BJ\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[0.7754,6.235,3.8431,12.4086]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpGeEFaOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"1\"}},\"BL\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"1\"},\"bbox\":\"[-62.9104,17.8782,-62.7891,17.9609]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp1eEFhOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"BM\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[-64.8875,32.2472,-64.647,32.391]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpHQkFiOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"BN\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[114.0759,4.0026,115.3647,5.0459]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpJaEFjOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"subdivision\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"BO\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[-69.6449,-22.898,-57.4498,-9.6687]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpHaEFkOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"2\"}},\"BQ\":{\"adm1\":{\"description\":\"island\",\"z_min\":\"1\"},\"bbox\":\"[-68.4207,12.0247,-62.9459,17.6501]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpHeEFlOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"BR\":{\"adm1\":{\"description\":\"state, federal district\",\"z_min\":\"0\"},\"bbox\":\"[-73.9832,-33.7511,-28.8478,5.2718]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpIeEFmOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"State\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"Immediate region\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"Intermediate region\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality, federal district\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-2-digit postcode area\",\"z_min\":\"4\"}},\"BS\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[-79.3055,20.912,-72.7118,27.2629]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpFQkFnOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"BT\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[88.7455,26.702,92.1252,28.247]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpHUkFoOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"block\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"BV\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[3.2845,-54.4549,3.4333,-54.3864]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpIaEFpOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"BW\":{\"adm1\":{\"description\":\"district, town, city\",\"z_min\":\"0\"},\"bbox\":\"[19.9989,-26.9075,29.3753,-17.7781]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpIUkFqOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"subdistrict\",\"z_min\":\"1\"}},\"BY\":{\"adm1\":{\"description\":\"region, city\",\"z_min\":\"0\"},\"bbox\":\"[23.1783,51.2622,32.7769,56.1722]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpGQkFrOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"5\"}},\"BZ\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[-89.2276,15.8856,-87.486,18.4959]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpGaEFsOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"CA\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[-141.0019,41.6814,-52.6194,83.1355]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpLUkFtOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"province\",\"z_min\":\"0\"},\"loc3\":{\"description\":\"cdp;hamlet\",\"z_min\":\"5\"},\"loc2\":{\"description\":\"place\",\"z_min\":\"4\"},\"loc4\":{\"description\":\"neighborhoods\",\"z_min\":\"6\"},\"leg1\":{\"description\":\"Senate\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"municipality, reserve, town\",\"z_min\":\"3\"},\"sta2\":{\"description\":\"census division, regional county municipality, county\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"6-digit postcode area, 6-digit postcode\",\"z_min\":\"9\"},\"leg2\":{\"description\":\"federal electoral districts\",\"z_min\":\"1\"},\"leg3\":{\"description\":\"electoral divisions\",\"z_min\":\"2\"}},\"CC\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[96.8169,-12.2087,96.9295,-11.8146]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpOQkFuOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"statistical areas level 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"statistical areas level 4\",\"z_min\":\"0\"},\"sta4\":{\"description\":\"statistical areas level 2\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"statistical areas level 1\",\"z_min\":\"5\"}},\"CD\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[12.2024,-13.459,31.3146,5.392]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpQaEFvOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"territory, city\",\"z_min\":\"1\"}},\"CF\":{\"adm1\":{\"description\":\"prefecture\",\"z_min\":\"0\"},\"bbox\":\"[14.4151,2.2231,27.4583,11.018]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpMQkFwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"sub-prefecture\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"commune\",\"z_min\":\"2\"}},\"CG\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[11.153,-5.0407,18.6504,3.7078]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpOeEFxOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, commune\",\"z_min\":\"1\"}},\"CH\":{\"adm1\":{\"description\":\"canton\",\"z_min\":\"0\"},\"bbox\":\"[5.9559,45.818,10.4922,47.8085]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoyeEFyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district, canton\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"}},\"CI\":{\"adm1\":{\"description\":\"district, autonomous district\",\"z_min\":\"0\"},\"bbox\":\"[-8.6021,4.3619,-2.493,10.7411]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpjUkFzOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"region, autonomous district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"department\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"sub-prefectures\",\"z_min\":\"2\"}},\"CK\":{\"adm1\":{\"description\":\"country\",\"z_min\":\"3\"},\"bbox\":\"[-165.8794,-21.9591,-157.3206,-8.9147]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpPQkF0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"CM\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[8.4987,1.6559,16.1944,13.0833]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpKeEF2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"}},\"CO\":{\"adm1\":{\"description\":\"department, capital district\",\"z_min\":\"0\"},\"bbox\":\"[-81.7356,-4.2271,-66.8463,13.3947]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpOUkF4OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality, non municipal area, capital district\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"3\"}},\"CR\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[-87.102,5.4991,-82.5514,11.2197]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpPUkF5OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"canton\",\"z_min\":\"4\"},\"adm3\":{\"description\":\"district\",\"z_min\":\"5\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"CU\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"1\"},\"bbox\":\"[-84.9521,19.8262,-74.1314,23.2767]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpPeEF6OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"}},\"CV\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"1\"},\"bbox\":\"[-25.3616,14.8021,-22.6572,17.2053]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpLaEEwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"island\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"CW\":{\"adm1\":{\"description\":\"island\",\"z_min\":\"1\"},\"bbox\":\"[-69.1623,11.978,-68.6395,12.3924]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpQQkExOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"CX\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[105.5333,-10.5705,105.7126,-10.4124]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpNeEEyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"statistical areas level 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"statistical areas level 4\",\"z_min\":\"0\"},\"sta4\":{\"description\":\"statistical areas level 2\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"statistical areas level 1\",\"z_min\":\"5\"}},\"CY\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[32.2692,34.6323,34.6066,35.7109]\",\"mapbox_id\":\"dXJuOm1ieGJuZDovaEEzOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"community\",\"z_min\":\"5\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"CZ\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[12.0906,48.5518,18.8593,51.0557]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpQUkE0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"loc1\":{\"description\":\"orp\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"locality\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"DJ\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[41.7708,10.913,43.4537,12.7137]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpRQkE2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"}},\"DK\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[8.0725,54.5591,15.1974,57.7522]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpQeEE3OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality, island\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"5\"},\"sta4\":{\"description\":\"LAU 1\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"LAU 2\",\"z_min\":\"3\"}},\"DM\":{\"adm1\":{\"description\":\"parish\",\"z_min\":\"4\"},\"bbox\":\"[-61.4801,15.2076,-61.2401,15.6402]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpRUkE4OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"DO\":{\"adm1\":{\"description\":\"province, federal district\",\"z_min\":\"2\"},\"bbox\":\"[-72.0075,17.4706,-68.323,19.932]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpRaEE5OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"macro region\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"region\",\"z_min\":\"3\"},\"adm2\":{\"description\":\"municipality, municipio\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"DZ\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[-8.6676,18.9681,11.9985,37.0897]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBeEErOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"commune\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"}},\"EC\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[-92.0081,-5.0162,-75.1871,1.6817]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpReEEvOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"canton\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"EE\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"0\"},\"bbox\":\"[21.7643,57.5093,28.21,59.822]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpTQkJBOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"6\"}},\"EG\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[24.6968,22,36.8944,31.671]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpSQkJCOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"region\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"ER\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[36.4333,12.3547,43.1588,18.0199]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpSeEJEOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"subregion\",\"z_min\":\"1\"}},\"ES\":{\"adm1\":{\"description\":\"autonomous community, autonomous city\",\"z_min\":\"0\"},\"bbox\":\"[-18.1612,27.6377,4.3278,43.7924]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoxQkJFOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"ET\":{\"adm1\":{\"description\":\"region, city\",\"z_min\":\"0\"},\"bbox\":\"[32.9977,3.4041,48.0011,14.8942]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpTUkJGOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"zone, special district, special zone\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"district, town, subcity\",\"z_min\":\"2\"}},\"FI\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"1\"},\"bbox\":\"[20.5486,59.6761,31.5867,70.0923]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpUUkJHOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"sub-regional unit\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"FJ\":{\"adm1\":{\"description\":\"division, dependency\",\"z_min\":\"3\"},\"bbox\":\"[176.8997,-21.0425,181.7714,-12.4617]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpUQkJIOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province, dependency\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"tikinas\",\"z_min\":\"4\"}},\"FM\":{\"adm1\":{\"description\":\"state\",\"z_min\":\"3\"},\"bbox\":\"[137.4253,1.0253,163.0356,10.0906]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpraEJKOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"FO\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"2\"},\"bbox\":\"[-7.6919,61.3903,-6.2536,62.3941]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpTeEJLOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"shire\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"4\"},\"pos4\":{\"description\":\"3-digit postcode area\",\"z_min\":\"5\"}},\"FR\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-5.143,41.3333,9.5603,51.0891]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpUaEJMOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"leg4\":{\"description\":\"canton\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"commune\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"GA\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[8.6989,-3.9602,14.5269,2.3181]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpVaEJNOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"}},\"GD\":{\"adm1\":{\"description\":\"parish, dependency\",\"z_min\":\"5\"},\"bbox\":\"[-61.8024,11.9849,-61.3783,12.5402]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpXeEJPOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"GE\":{\"adm1\":{\"description\":\"region, autonomous republic\",\"z_min\":\"0\"},\"bbox\":\"[40.0066,41.0552,46.7361,43.5866]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpWQkJQOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality, district, city\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"GF\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-54.6032,2.1111,-51.6286,5.7482]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpUeEJROnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"commune\",\"z_min\":\"4\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"GH\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-3.2608,4.7392,1.1996,11.175]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpWaEJTOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, municipal district, metropolitan district\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode\",\"z_min\":\"0\"}},\"GL\":{\"adm1\":{\"description\":\"autonomous territory\",\"z_min\":\"0\"},\"bbox\":\"[-73.2481,59.7756,-11.4833,83.6607]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpXaEJVOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"1\"}},\"GM\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-16.8137,13.0639,-13.7914,13.8251]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpVeEJWOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"}},\"GN\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-15.0761,7.1906,-7.6379,12.6749]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpZQkJXOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"prefecture\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"2\"}},\"GP\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-61.8096,15.8321,-61.002,16.5144]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpYQkJYOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"commune\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"GQ\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[5.6169,-1.4681,11.3333,3.7883]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpSaEJZOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"}},\"GR\":{\"adm1\":{\"description\":\"decentralized administration, autonomous state\",\"z_min\":\"0\"},\"bbox\":\"[19.3728,34.8006,29.6457,41.7503]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpXUkJaOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"periphery, autonomous state\",\"z_min\":\"0\"},\"adm3\":{\"description\":\"peripheral unit, autonomous state\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"municipality, autonomous state\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"},\"sta4\":{\"description\":\"LAU1 1\",\"z_min\":\"3\"},\"sta5\":{\"description\":\"LAU 2\",\"z_min\":\"3\"}},\"GT\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[-92.2314,13.74,-88.2317,17.8157]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpYaEJiOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"GU\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[144.6181,13.2338,144.9569,13.6544]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpYUkJjOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"senate\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"county subdivision\",\"z_min\":\"6\"},\"adm2\":{\"description\":\"village\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"6\"},\"leg2\":{\"description\":\"congressional district\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"tract\",\"z_min\":\"5\"},\"sta5\":{\"description\":\"block group\",\"z_min\":\"6\"}},\"GW\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-16.7153,10.8643,-13.6265,12.6869]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpZUkJkOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"sector\",\"z_min\":\"1\"}},\"GY\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-61.4108,1.1693,-56.4911,8.5479]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpZaEJlOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"neighbourhood democratic council\",\"z_min\":\"1\"}},\"HM\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[72.5826,-53.1949,73.8764,-52.9021]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpaUkJnOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"statistical areas level 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"statistical areas level 4\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"statistical areas level 2\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"statistical areas level 1\",\"z_min\":\"5\"}},\"HN\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[-89.3565,12.9808,-83.1488,16.5168]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpaaEJoOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"settlement\",\"z_min\":\"5\"},\"pos2\":{\"description\":\"2-digit postcode areas\",\"z_min\":\"1\"}},\"HR\":{\"adm1\":{\"description\":\"county, city\",\"z_min\":\"1\"},\"bbox\":\"[13.4898,42.3922,19.4474,46.555]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpPaEJpOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"},\"sta4\":{\"description\":\"district\",\"z_min\":\"3\"},\"sta5\":{\"description\":\"subdistrict\",\"z_min\":\"4\"}},\"HT\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"2\"},\"bbox\":\"[-74.4808,18.0219,-71.6218,20.0893]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpaQkJqOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"arrondissement\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"commune\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"adm4\":{\"description\":\"section\",\"z_min\":\"5\"}},\"HU\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"1\"},\"bbox\":\"[16.1139,45.7371,22.8968,48.5852]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpaeEJrOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"region\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"village, city, large village\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"ID\":{\"adm1\":{\"description\":\"province, special capital region, special region\",\"z_min\":\"0\"},\"bbox\":\"[95.0105,-11.0097,141.0222,6.0769]\",\"mapbox_id\":\"dXJuOm1ieGJuZDphaEJsOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"regency, city\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"district\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"adm4\":{\"description\":\"village\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"IE\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"2\"},\"bbox\":\"[-10.663,51.4199,-5.9942,55.4351]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpiUkJtOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"leg4\":{\"description\":\"Local Electoral Areas\",\"z_min\":\"2\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipal district, borough district, city council\",\"z_min\":\"4\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"},\"sta4\":{\"description\":\"LAU 1\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"LAU 2\",\"z_min\":\"3\"}},\"IL\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[34.2676,29.4956,35.8962,33.3328]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpieEJuOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"subdistrict\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"natural region\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"IO\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[71.2374,-7.4446,72.4957,-5.236]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpJQkJxOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"postcode unit\",\"z_min\":\"3\"}},\"IQ\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[38.7937,29.0612,48.6147,37.3807]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpiQkJyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"subdistrict\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"IS\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"0\"},\"bbox\":\"[-24.5327,63.2958,-13.4946,66.5664]\",\"mapbox_id\":\"dXJuOm1ieGJuZDphQkJ0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"region\",\"z_min\":\"0\"}},\"IT\":{\"adm1\":{\"description\":\"region, autonomous region\",\"z_min\":\"0\"},\"bbox\":\"[6.6268,35.4929,18.5204,47.0921]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpjQkJ1OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"province, metropolitan city, free consortium\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"KG\":{\"adm1\":{\"description\":\"region, city\",\"z_min\":\"0\"},\"bbox\":\"[69.2516,39.181,80.2282,43.2662]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpleEIwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, city\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"KM\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[43.2291,-12.4221,44.5406,-11.3649]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpOaEIzOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"KN\":{\"adm1\":{\"description\":\"island\",\"z_min\":\"0\"},\"bbox\":\"[-62.8643,17.0941,-62.5395,17.4178]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp2UkI0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish\",\"z_min\":\"5\"}},\"KP\":{\"adm1\":{\"description\":\"province, metropolitan city, capital city\",\"z_min\":\"0\"},\"bbox\":\"[124.1813,37.6769,130.699,43.0092]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpwaEI1OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county, city, district\",\"z_min\":\"2\"}},\"KR\":{\"adm1\":{\"description\":\"province, metropolitan city, special city\",\"z_min\":\"0\"},\"bbox\":\"[124.6098,33.1128,131.8728,38.6172]\",\"mapbox_id\":\"dXJuOm1ieGJuZDowaEI2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county, city, district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"non-autonomous district\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"4\"},\"adm4\":{\"description\":\"neighborhood, township, town\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"6\"}},\"KW\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[46.553,28.5244,48.7781,30.1037]\",\"mapbox_id\":\"dXJuOm1ieGJuZDplaEI3OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"KY\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"1\"},\"bbox\":\"[-81.4202,19.263,-79.723,19.7569]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpLeEI4OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"1-digit postcode area\",\"z_min\":\"2\"}},\"KZ\":{\"adm1\":{\"description\":\"region, city\",\"z_min\":\"0\"},\"bbox\":\"[46.4937,40.5687,87.3154,55.442]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpkaEI5OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, city, city district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"LA\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[100.0839,13.9097,107.6351,22.509]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpmQkIrOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"LB\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"1\"},\"bbox\":\"[35.1036,33.055,36.6237,34.6921]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpmaEIvOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"municipality\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"LC\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"5\"},\"bbox\":\"[-61.0798,13.7076,-60.8732,14.1104]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp2aENBOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"LI\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"5\"},\"bbox\":\"[9.4717,47.0484,9.6357,47.2706]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpnaENCOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"}},\"LK\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[79.5213,5.9187,81.879,9.836]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoxUkNDOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"divisional secretariat\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"village\",\"z_min\":\"3\"}},\"LR\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"1\"},\"bbox\":\"[-11.4991,4.3535,-7.3693,8.553]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpnQkNEOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"LS\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[27.0112,-30.6777,29.4562,-28.5705]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpmeENFOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"community council\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"3-digit postcode areas\",\"z_min\":\"0\"}},\"LT\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"0\"},\"bbox\":\"[20.954,53.8968,26.8355,56.4504]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpneENGOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"eldership, city\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"6\"}},\"LU\":{\"adm1\":{\"description\":\"canton\",\"z_min\":\"1\"},\"bbox\":\"[5.7357,49.4479,6.531,50.1828]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpoQkNHOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"commune\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"}},\"LV\":{\"adm1\":{\"description\":\"municipality, state city\",\"z_min\":\"1\"},\"bbox\":\"[20.9706,55.6747,28.2415,58.0856]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpmUkNIOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"parish, city\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"}},\"LY\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[9.3915,19.5,25.1496,33.1665]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpnUkNJOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"MC\":{\"adm1\":{\"description\":\"commune\",\"z_min\":\"3\"},\"bbox\":\"[7.4091,43.7248,7.44,43.7519]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpsQkNLOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"quartier\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"MD\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"1\"},\"bbox\":\"[26.6164,45.4664,30.1637,48.492]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpreENMOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"ME\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"0\"},\"bbox\":\"[18.4335,41.8468,20.3529,43.5582]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpsaENNOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"MF\":{\"adm1\":{\"description\":\"collectivity\",\"z_min\":\"3\"},\"bbox\":\"[-63.1533,18.0466,-62.9706,18.1252]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp2eENOOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"MG\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[43.1885,-25.6062,50.4861,-11.9488]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpoaENPOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"commune\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"}},\"MH\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"bbox\":\"[160.7953,4.5725,172.1725,14.7232]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpqQkNQOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"MK\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"1\"},\"bbox\":\"[20.4533,40.8539,23.034,42.3736]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpoUkNROnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"ML\":{\"adm1\":{\"description\":\"region, city\",\"z_min\":\"0\"},\"bbox\":\"[-12.2403,10.1436,4.2667,25.0011]\",\"mapbox_id\":\"dXJuOm1ieGJuZDppaENSOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"cercle, district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"commune\",\"z_min\":\"1\"}},\"MM\":{\"adm1\":{\"description\":\"state, region, union territory\",\"z_min\":\"0\"},\"bbox\":\"[92.172,9.5979,101.1703,28.5478]\",\"mapbox_id\":\"dXJuOm1ieGJuZDptaENTOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"township\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"MN\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[87.7345,41.5818,119.9315,52.1484]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpsUkNUOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"MP\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[144.8863,14.1104,146.0648,20.5538]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpweENWOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"senate\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"election district\",\"z_min\":\"6\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"5-digit postcode areas\",\"z_min\":\"3\"},\"leg2\":{\"description\":\"congressional district\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"tract\",\"z_min\":\"4\"},\"sta5\":{\"description\":\"block group\",\"z_min\":\"6\"}},\"MQ\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-61.2293,14.3887,-60.8095,14.8788]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpqUkNXOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"region\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"adm4\":{\"description\":\"commune\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"MR\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-17.0687,14.7213,-4.8341,27.3159]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpqaENYOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"}},\"MS\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"1\"},\"bbox\":\"[-62.242,16.6744,-62.1442,16.824]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpseENZOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"MT\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"1\"},\"bbox\":\"[14.1834,35.8062,14.5765,36.0824]\",\"mapbox_id\":\"dXJuOm1ieGJuZDppeENaOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"LAU 1\",\"z_min\":\"2\"}},\"MV\":{\"adm1\":{\"description\":\"atoll\",\"z_min\":\"0\"},\"bbox\":\"[72.6385,-0.7037,73.7597,7.1063]\",\"mapbox_id\":\"dXJuOm1ieGJuZDppUkNiOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"former province\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"MW\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[32.6725,-17.1295,35.9186,-9.3672]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpoeENjOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"traditional authority\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode areas\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"6-digit postcode areas\",\"z_min\":\"1\"}},\"MX\":{\"adm1\":{\"description\":\"state, federal district\",\"z_min\":\"0\"},\"bbox\":\"[-118.3651,14.5341,-86.7104,32.7187]\",\"mapbox_id\":\"dXJuOm1ieGJuZDprUkNkOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-2-digit postcode area\",\"z_min\":\"4\"}},\"MY\":{\"adm1\":{\"description\":\"state, federal territory\",\"z_min\":\"0\"},\"bbox\":\"[99.6407,0.8539,119.2697,7.3806]\",\"mapbox_id\":\"dXJuOm1ieGJuZDppQkNlOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"division\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"MZ\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[30.2155,-26.8682,40.8393,-10.4704]\",\"mapbox_id\":\"dXJuOm1ieGJuZDptUkNmOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, municipal district\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"NA\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[11.7366,-28.9706,25.2618,-16.9635]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpteENnOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"constituency\",\"z_min\":\"0\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"0\"}},\"NC\":{\"adm1\":{\"description\":\"collectivity\",\"z_min\":\"3\"},\"bbox\":\"[158.2487,-22.848,172.09,-18.0264]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpueENoOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"NE\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[0.1617,11.6938,16,23.515]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpvaENpOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"1-digit postcode areas\",\"z_min\":\"0\"}},\"NF\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[167.9138,-29.1366,167.998,-28.9942]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpwUkNqOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"statistical areas level 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"statistical areas level 4\",\"z_min\":\"0\"},\"sta4\":{\"description\":\"statistical areas level 2\",\"z_min\":\"2\"},\"sta5\":{\"description\":\"statistical areas level 1\",\"z_min\":\"5\"}},\"NG\":{\"adm1\":{\"description\":\"state, federal territory\",\"z_min\":\"0\"},\"bbox\":\"[2.6636,4.2707,14.678,13.8856]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpveENrOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"local government area\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"NI\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[-87.6906,10.7081,-82.7346,15.0297]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpvUkNsOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"1-digit postcode areas\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode areas\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"3-5-digit postcode areas\",\"z_min\":\"3\"}},\"NO\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"0\"},\"bbox\":\"[4.4999,57.9594,31.1683,71.1855]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpxQkNuOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"},\"sta4\":{\"description\":\"LAU 1\",\"z_min\":\"2\"}},\"NP\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[80.0585,26.3474,88.2018,30.4474]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpuUkNvOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"region\",\"z_min\":\"0\"},\"loc2\":{\"description\":\"village, town, city\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"zone\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"2\"}},\"NR\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"3\"},\"bbox\":\"[166.9095,-0.5543,166.9593,-0.5021]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpuQkNwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"NU\":{\"adm1\":{\"description\":\"country\",\"z_min\":\"3\"},\"bbox\":\"[-169.9508,-19.1561,-169.7737,-18.9523]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpwQkNxOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"village\",\"z_min\":\"4\"}},\"NZ\":{\"adm1\":{\"description\":\"region, special island authority\",\"z_min\":\"0\"},\"bbox\":\"[165.87,-52.6088,183.8456,-34.1296]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpvQkNyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"Rural settlement, Small urban area, Rural other\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"region, special island authority\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"statistical area 1\",\"z_min\":\"3\"},\"sta2\":{\"description\":\"statistical area 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"territorial authority, special island authority\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"ward, territorial authority, special island authority\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"},\"leg2\":{\"description\":\"constituency\",\"z_min\":\"1\"},\"leg3\":{\"description\":\"community board\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"meshblock\",\"z_min\":\"4\"}},\"OM\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[52,16.6501,59.8398,26.4049]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpxUkNzOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"1-digit postcode area\",\"z_min\":\"2\"}},\"PA\":{\"adm1\":{\"description\":\"province, indigenous region\",\"z_min\":\"0\"},\"bbox\":\"[-83.0526,7.2038,-77.1586,9.6457]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpyUkN0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, indigenous region\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode areas\",\"z_min\":\"1\"}},\"PE\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[-81.3282,-18.3501,-68.6523,-0.0388]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpzQkN1OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"districts\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"PF\":{\"adm1\":{\"description\":\"collectivity\",\"z_min\":\"0\"},\"bbox\":\"[-154.7272,-27.9005,-134.4511,-7.895]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpVQkN2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"PG\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[140.842,-11.6554,155.9831,-1.3148]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpyaEN3OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"}},\"PH\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[114.2779,4.5873,126.6049,21.1219]\",\"mapbox_id\":\"dXJuOm1ieGJuZDovUkN4OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"province, highly urbanized city, municipality\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"municipality, city, highly urbanized city\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"barangay\",\"z_min\":\"7\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"5\"}},\"PK\":{\"adm1\":{\"description\":\"autonomous territory, province, federal territory\",\"z_min\":\"0\"},\"bbox\":\"[60.873,23.7046,77.1204,37.0914]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpxaEN5OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"division\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"subdistrict\",\"z_min\":\"3\"}},\"PL\":{\"adm1\":{\"description\":\"voivodeship\",\"z_min\":\"0\"},\"bbox\":\"[14.1229,49.002,24.1459,54.8358]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpzeEN6OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"powiat, city powiat, capital city\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"rural municipality, urban-rural municipality, urban municipality\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"rural municipality, rural area, city\",\"z_min\":\"5\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"PM\":{\"adm1\":{\"description\":\"collectivity\",\"z_min\":\"3\"},\"bbox\":\"[-56.406,46.7489,-56.1266,47.145]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp3QkMwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"PN\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[-130.7562,-25.0798,-124.772,-23.9077]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpzaEMxOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"postcode unit\",\"z_min\":\"3\"}},\"PR\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"2\"},\"bbox\":\"[-67.9514,17.8814,-65.2211,18.516]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp0UkMyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"senate\",\"z_min\":\"0\"},\"leg4\":{\"description\":\"state house district\",\"z_min\":\"4\"},\"sta3\":{\"description\":\"county subdivision\",\"z_min\":\"5\"},\"adm2\":{\"description\":\"municipio\",\"z_min\":\"4\"},\"adm3\":{\"description\":\"barrio\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"},\"leg2\":{\"description\":\"congressional district\",\"z_min\":\"2\"},\"leg3\":{\"description\":\"state senate district\",\"z_min\":\"3\"},\"sta4\":{\"description\":\"tract\",\"z_min\":\"5\"},\"sta5\":{\"description\":\"block group\",\"z_min\":\"6\"}},\"PS\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[34.2186,31.2203,35.5741,32.5521]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpyQkMzOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"governorate\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"}},\"PT\":{\"adm1\":{\"description\":\"district, autonomous region\",\"z_min\":\"1\"},\"bbox\":\"[-31.269,30.0288,-6.1892,42.1543]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp0QkM0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"local council\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"parish\",\"z_min\":\"6\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"7-digit postcode area\",\"z_min\":\"9\"}},\"PW\":{\"adm1\":{\"description\":\"state\",\"z_min\":\"3\"},\"bbox\":\"[131.1199,2.9714,134.7214,8.0942]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpxeEM1OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"hamlet\",\"z_min\":\"3\"}},\"PY\":{\"adm1\":{\"description\":\"department, capital district\",\"z_min\":\"0\"},\"bbox\":\"[-62.6423,-27.6069,-54.2586,-19.2877]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpyeEM2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"2\"}},\"QA\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"bbox\":\"[50.7501,24.4711,51.6608,26.1835]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp0aEM3OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"zone\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"district\",\"z_min\":\"2\"}},\"RE\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[55.2165,-21.3896,55.8366,-20.8718]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp0eEM4OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"commune\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"RO\":{\"adm1\":{\"description\":\"county, city\",\"z_min\":\"1\"},\"bbox\":\"[20.2618,43.6194,29.7153,48.2656]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp1QkM5OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"commune, town, city\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-6-digit postcode area\",\"z_min\":\"6\"}},\"RS\":{\"adm1\":{\"description\":\"district, city\",\"z_min\":\"1\"},\"bbox\":\"[18.839,42.2315,23.0064,46.1901]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp4eEMrOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"3\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality, city\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"city municipality\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"6\"}},\"RU\":{\"adm1\":{\"description\":\"oblast, republic, krai\",\"z_min\":\"0\"},\"bbox\":\"[19.6385,41.1854,190.3416,81.8574]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp1UkMvOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"federal district\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, urban district, city\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"city district\",\"z_min\":\"3\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"6-2-digit postcode area\",\"z_min\":\"3\"}},\"RW\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[28.8618,-2.8399,30.8991,-1.0474]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp1aERBOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"sector\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"cell\",\"z_min\":\"2\"}},\"SB\":{\"adm1\":{\"description\":\"province, capital territory\",\"z_min\":\"3\"},\"bbox\":\"[155.5122,-12.3083,170.1925,-5.0269]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp6aERDOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"ward\",\"z_min\":\"4\"}},\"SC\":{\"adm1\":{\"description\":\"district, island group\",\"z_min\":\"0\"},\"bbox\":\"[46.2029,-10.2271,56.2947,-3.7129]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp5QkREOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"SD\":{\"adm1\":{\"description\":\"state, special administrative area\",\"z_min\":\"0\"},\"bbox\":\"[21.8146,8.6825,38.8492,22]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoxaERFOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"}},\"SE\":{\"adm1\":{\"description\":\"county\",\"z_min\":\"0\"},\"bbox\":\"[10.9577,55.3367,24.1761,69.06]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoyaERGOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"SG\":{\"adm1\":{\"description\":\"community development council\",\"z_min\":\"0\"},\"bbox\":\"[103.6057,1.1587,104.0885,1.4709]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp5aERHOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"region\",\"z_min\":\"4\"},\"leg1\":{\"description\":\"constituency\",\"z_min\":\"1\"},\"sta3\":{\"description\":\"subzone\",\"z_min\":\"6\"},\"sta2\":{\"description\":\"planning area\",\"z_min\":\"5\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"6-digit postcode area\",\"z_min\":\"8\"}},\"SH\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[-14.421,-40.3714,-5.6341,-7.8892]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp2QkRIOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"division\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"district, island\",\"z_min\":\"4\"},\"pos4\":{\"description\":\"postcode unit\",\"z_min\":\"3\"}},\"SI\":{\"adm1\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"bbox\":\"[13.3755,45.4214,16.5974,46.8767]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp6UkRJOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"1\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"rural settlement, urban settlement\",\"z_min\":\"5\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"7\"}},\"SJ\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-9.0864,70.8278,37.0668,80.8212]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoyQkRKOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"settlement, island, area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"4\"}},\"SK\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[16.8332,47.7312,22.5657,49.6138]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp6QkRLOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"municipality, borough, military district\",\"z_min\":\"6\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"SL\":{\"adm1\":{\"description\":\"province, area\",\"z_min\":\"0\"},\"bbox\":\"[-13.3008,6.9234,-10.2717,10]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp5UkRMOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"chiefdom\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"section\",\"z_min\":\"3\"}},\"SM\":{\"adm1\":{\"description\":\"castello\",\"z_min\":\"3\"},\"bbox\":\"[12.4033,43.8936,12.5162,43.9921]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp3eERNOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"SN\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-17.5302,12.3073,-11.3458,16.693]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp4aEROOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode areas\",\"z_min\":\"0\"}},\"SO\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[40.9912,-1.6628,51.4156,11.9893]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp6eERPOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"}},\"SR\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[-58.0715,1.8385,-53.9799,6.0088]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoxeERQOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"resort\",\"z_min\":\"1\"}},\"SS\":{\"adm1\":{\"description\":\"state, administrative area\",\"z_min\":\"0\"},\"bbox\":\"[24.1533,3.489,35.949,12.2364]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoweERROnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county\",\"z_min\":\"0\"}},\"ST\":{\"adm1\":{\"description\":\"district, region\",\"z_min\":\"1\"},\"bbox\":\"[6.46,-0.0138,7.4625,1.701]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp4QkRSOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"province\",\"z_min\":\"0\"},\"sta2\":{\"description\":\"region\",\"z_min\":\"4\"}},\"SV\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[-90.1347,13.1524,-87.6905,14.4506]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpSUkRTOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"2-digit postcode areas\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"3-digit postcode areas\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"5-digit postcode areas\",\"z_min\":\"0\"}},\"SX\":{\"adm1\":{\"description\":\"island\",\"z_min\":\"1\"},\"bbox\":\"[-63.1389,18.0051,-63.0135,18.0641]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp5eERUOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"SY\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[35.7167,32.3111,42.3763,37.3185]\",\"mapbox_id\":\"dXJuOm1ieGJuZDozQkRVOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"subdistrict\",\"z_min\":\"2\"}},\"SZ\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[30.7906,-27.3174,32.1349,-25.7179]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoyUkRWOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"constituency\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"}},\"TC\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"1\"},\"bbox\":\"[-72.4829,21.1777,-71.0828,21.9625]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo2UkRXOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"postcode unit\",\"z_min\":\"2\"}},\"TD\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[13.4706,7.443,24,23.4524]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpMUkRYOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"prefecture\",\"z_min\":\"1\"}},\"TF\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[40.3259,-50.0213,77.5957,-11.5678]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpVUkRZOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"TG\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[-0.144,6.1124,1.8089,11.1396]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo0aERaOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"prefecture\",\"z_min\":\"1\"}},\"TH\":{\"adm1\":{\"description\":\"province, special administrative area\",\"z_min\":\"1\"},\"bbox\":\"[97.3434,5.6129,105.6368,20.4651]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo0QkRhOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"tambon\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"TJ\":{\"adm1\":{\"description\":\"region, district under republic administration, autonomous region\",\"z_min\":\"0\"},\"bbox\":\"[67.3372,36.672,75.154,41.0449]\",\"mapbox_id\":\"dXJuOm1ieGJuZDozaERiOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"TK\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[-172.5208,-9.444,-171.1814,-8.532]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo0eERjOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"TL\":{\"adm1\":{\"description\":\"municipality, special administrative region\",\"z_min\":\"0\"},\"bbox\":\"[124.0419,-9.5037,127.3423,-8.1269]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo0UkRkOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"administrative post\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"village\",\"z_min\":\"2\"}},\"TM\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[52.4456,35.1291,66.7074,42.7983]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo2QkRlOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, city\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"TN\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[7.5223,30.228,11.5992,37.5597]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo1aERmOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"regions\",\"z_min\":\"2\"},\"adm2\":{\"description\":\"delegation\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"TO\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"3\"},\"bbox\":\"[-176.2137,-22.3497,-173.7351,-15.5659]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo1QkRnOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"3\"},\"adm3\":{\"description\":\"village\",\"z_min\":\"3\"}},\"TR\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[25.6652,35.8086,44.8179,42.1049]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo1eERoOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district, central district\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"neighborhood\",\"z_min\":\"5\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"TT\":{\"adm1\":{\"description\":\"region, borough, city\",\"z_min\":\"1\"},\"bbox\":\"[-61.9309,10.0425,-60.4925,11.3588]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo1UkRpOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"parish\",\"z_min\":\"1\"}},\"TV\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"3\"},\"bbox\":\"[176.0588,-10.7916,179.8711,-5.6425]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo2aERqOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"TZ\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[29.34,-11.7613,40.4451,-0.9844]\",\"mapbox_id\":\"dXJuOm1ieGJuZDozeERsOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"ward\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"1\"}},\"UA\":{\"adm1\":{\"description\":\"region, city, autonomous republic\",\"z_min\":\"0\"},\"bbox\":\"[22.1371,44.3866,40.2256,52.3794]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo3QkRtOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, city\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"community, city, exclusion zone\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"3\"},\"adm4\":{\"description\":\"urban district\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"3-5 digit postcode area\",\"z_min\":\"5\"}},\"UG\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[29.5734,-1.4823,35.033,4.2186]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo2eERuOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"region\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"sub-county\",\"z_min\":\"4\"},\"pos3\":{\"description\":\"3-digit postcode areas\",\"z_min\":\"0\"}},\"UM\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"3\"},\"bbox\":\"[-193.4023,-0.3805,-75.002,28.2186]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo4QkRvOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"US\":{\"adm1\":{\"description\":\"state, federal district\",\"z_min\":\"0\"},\"bbox\":\"[-187.5552,18.9107,-66.9496,71.3885]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo4aERwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"core statistical area\",\"z_min\":\"1\"},\"loc3\":{\"description\":\"cdp;hamlet\",\"z_min\":\"5\"},\"loc2\":{\"description\":\"postal place\",\"z_min\":\"4\"},\"loc4\":{\"description\":\"neighborhoods\",\"z_min\":\"6\"},\"leg1\":{\"description\":\"senate\",\"z_min\":\"0\"},\"leg4\":{\"description\":\"state house district\",\"z_min\":\"4\"},\"sta3\":{\"description\":\"county subdivision\",\"z_min\":\"4\"},\"sta2\":{\"description\":\"micropolitan statistical area, metropolitan statistical area, core-based statistical area\",\"z_min\":\"2\"},\"loc1\":{\"description\":\"state, federal district\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county, parish, city\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"township, town, charter township\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"0\"},\"adm4\":{\"description\":\"city, town, village\",\"z_min\":\"5\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"},\"leg2\":{\"description\":\"congressional district\",\"z_min\":\"2\"},\"leg3\":{\"description\":\"state senate district\",\"z_min\":\"3\"},\"sta4\":{\"description\":\"tract\",\"z_min\":\"5\"},\"sta5\":{\"description\":\"block group\",\"z_min\":\"6\"}},\"UY\":{\"adm1\":{\"description\":\"department\",\"z_min\":\"0\"},\"bbox\":\"[-58.4947,-34.9735,-53.0756,-30.0854]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo3eERxOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"}},\"UZ\":{\"adm1\":{\"description\":\"province, city, autonomous republic\",\"z_min\":\"0\"},\"bbox\":\"[55.9982,37.1723,73.1489,45.5901]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo4eERyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, city\",\"z_min\":\"2\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"VC\":{\"adm1\":{\"description\":\"parish\",\"z_min\":\"5\"},\"bbox\":\"[-61.4609,12.5789,-61.1149,13.3832]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp3UkR0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"}},\"VE\":{\"adm1\":{\"description\":\"state, federal district\",\"z_min\":\"0\"},\"bbox\":\"[-73.367,0.6475,-59.8055,12.4912]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo5aER1OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"}},\"VG\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"1\"},\"bbox\":\"[-64.8501,18.3064,-64.2706,18.7497]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpJUkR2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"district\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"VI\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[-65.0853,17.674,-64.5652,18.413]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo4UkR3OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"senate\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"county subdivision\",\"z_min\":\"5\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"subdistrict\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"2\"},\"leg2\":{\"description\":\"congressional district\",\"z_min\":\"2\"},\"sta4\":{\"description\":\"tract\",\"z_min\":\"5\"},\"sta5\":{\"description\":\"block group\",\"z_min\":\"6\"}},\"VN\":{\"adm1\":{\"description\":\"province, city\",\"z_min\":\"1\"},\"bbox\":\"[102.1439,7.6024,116.6811,23.3927]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo5eER4OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"commune, ward, special administrative region\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"3-digit postcode area\",\"z_min\":\"4\"}},\"VU\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"3\"},\"bbox\":\"[166.5414,-20.2532,170.2402,-13.0725]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo5QkR5OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"council\",\"z_min\":\"4\"}},\"WF\":{\"adm1\":{\"description\":\"collectivity\",\"z_min\":\"3\"},\"bbox\":\"[-178.1824,-14.3622,-176.1242,-13.1828]\",\"mapbox_id\":\"dXJuOm1ieGJuZDorQkR6OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"5-digit postcode areas\",\"z_min\":\"3\"}},\"WS\":{\"adm1\":{\"description\":\"itumalo\",\"z_min\":\"3\"},\"bbox\":\"[-172.8041,-14.0772,-171.3977,-13.4398]\",\"mapbox_id\":\"dXJuOm1ieGJuZDp3aEQwOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"itumalo\",\"z_min\":\"3\"},\"sta2\":{\"description\":\"faipule\",\"z_min\":\"4\"},\"adm2\":{\"description\":\"village\",\"z_min\":\"4\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"3\"}},\"XS\":{\"adm1\":{\"description\":\"base area\",\"z_min\":\"0\"},\"bbox\":\"[32.7549,34.5623,33.9166,35.1237]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoveEQyOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"community\",\"z_min\":\"5\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"6\"}},\"YE\":{\"adm1\":{\"description\":\"governorate\",\"z_min\":\"0\"},\"bbox\":\"[41.9037,12.1081,54.5343,18.9996]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoraEQzOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"1\"}},\"YT\":{\"adm1\":{\"description\":\"region\",\"z_min\":\"0\"},\"bbox\":\"[45.0181,-13.0058,45.3,-12.636]\",\"mapbox_id\":\"dXJuOm1ieGJuZDprQkQ0OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"department\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"arrondissement\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"adm4\":{\"description\":\"commune\",\"z_min\":\"6\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"4\"}},\"ZA\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[16.4546,-34.8342,32.8911,-22.1254]\",\"mapbox_id\":\"dXJuOm1ieGJuZDowQkQ1OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg5\":{\"description\":\"ward\",\"z_min\":\"3\"},\"adm2\":{\"description\":\"district municipality, metropolitan municipality\",\"z_min\":\"1\"},\"adm3\":{\"description\":\"local municipality, metropolitan municipality\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"1\"},\"pos4\":{\"description\":\"4-digit postcode area\",\"z_min\":\"2\"}},\"ZM\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[21.9994,-18.0775,33.709,-8.2033]\",\"mapbox_id\":\"dXJuOm1ieGJuZDoreEQ2OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"leg1\":{\"description\":\"constituency\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"district\",\"z_min\":\"0\"}},\"ZW\":{\"adm1\":{\"description\":\"province\",\"z_min\":\"0\"},\"bbox\":\"[25.2374,-22.422,33.0682,-15.6096]\",\"mapbox_id\":\"dXJuOm1ieGJuZDovQkQ3OnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"district, town, city\",\"z_min\":\"1\"}},\"TW\":{\"adm1\":{\"description\":\"special municipality, province\",\"z_min\":\"0\"},\"bbox\":\"[114.3593,10.3713,122.1091,26.3853]\",\"mapbox_id\":\"dXJuOm1ieGJuZDozUkRrOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"adm2\":{\"description\":\"county, special municipality, provincial city\",\"z_min\":\"2\"},\"adm3\":{\"description\":\"district, township, mountain township\",\"z_min\":\"3\"},\"pos2\":{\"description\":\"1-digit postcode area\",\"z_min\":\"2\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"3\"},\"adm4\":{\"description\":\"village\",\"z_min\":\"7\"},\"pos4\":{\"description\":\"3-digit postcode area\",\"z_min\":\"4\"}},\"XK\":{\"adm1\":{\"description\":\"district\",\"z_min\":\"0\"},\"bbox\":\"[20.0143,41.8576,21.7899,43.2677]\",\"mapbox_id\":\"dXJuOm1ieGJuZDplUkQxOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"sta1\":{\"description\":\"NUTS 1\",\"z_min\":\"0\"},\"sta3\":{\"description\":\"NUTS 3\",\"z_min\":\"2\"},\"sta2\":{\"description\":\"NUTS 2\",\"z_min\":\"1\"},\"adm2\":{\"description\":\"municipality\",\"z_min\":\"1\"},\"pos2\":{\"description\":\"1-digit postcode area\",\"z_min\":\"1\"},\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"3\"}},\"FK\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"1\"},\"bbox\":\"[-61.4563,-52.9191,-57.7147,-50.9967]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpTaEJJOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"7-digit postcode area\",\"z_min\":\"2\"}},\"GS\":{\"adm1\":{\"description\":\"territory\",\"z_min\":\"0\"},\"bbox\":\"[-42.2024,-59.4855,-26.2675,-53.3417]\",\"mapbox_id\":\"dXJuOm1ieGJuZDowUkJhOnY0\",\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"pos4\":{\"description\":\"7-digit postcode area\",\"z_min\":\"2\"}},\"AQ\":{\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"bbox\":\"[-180,-85.0511,180,-60.5155]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpDQkFKOnY0\"},\"KI\":{\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"bbox\":\"[-190.4791,-11.4479,-150.1953,4.6994]\",\"mapbox_id\":\"dXJuOm1ieGJuZDplQkIyOnY0\",\"sta1\":{\"description\":\"group\",\"z_min\":\"3\"},\"sta3\":{\"description\":\"island\",\"z_min\":\"3\"},\"sta2\":{\"description\":\"division\",\"z_min\":\"3\"}},\"VA\":{\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"bbox\":\"[12.4457,41.9002,12.4584,41.9074]\",\"mapbox_id\":\"dXJuOm1ieGJuZDo5UkRzOnY0\",\"pos3\":{\"description\":\"2-digit postcode area\",\"z_min\":\"2\"},\"pos4\":{\"description\":\"5-digit postcode area\",\"z_min\":\"5\"}},\"XB\":{\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"bbox\":\"[32.5909,34.988,34.0025,35.2015]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBUUFRL0E6djQ\"},\"XC\":{\"adm0\":{\"description\":\"country/territory\",\"z_min\":\"0\"},\"bbox\":\"[32.5984,35.0028,34.6066,35.7109]\",\"mapbox_id\":\"dXJuOm1ieGJuZDpBUUVRL1E6djQ\"}}");


var $aa6103d484f83752$var$_coverage2 = $aa6103d484f83752$var$_interopRequireDefault($33cad05b1ab8f358$exports);
var $89adb9a48dc525a2$exports = {};

$parcel$export($89adb9a48dc525a2$exports, "viewport", function () { return $89adb9a48dc525a2$export$d7b7311ec04a3e8f; }, function (v) { return $89adb9a48dc525a2$export$d7b7311ec04a3e8f = v; });
$parcel$export($89adb9a48dc525a2$exports, "bounds", function () { return $89adb9a48dc525a2$export$40e55eae2f766967; }, function (v) { return $89adb9a48dc525a2$export$40e55eae2f766967 = v; });
var $89adb9a48dc525a2$export$d7b7311ec04a3e8f;
var $89adb9a48dc525a2$export$40e55eae2f766967;

var $88tg0 = parcelRequire("88tg0");
// The SphericalMercator library only accepts a variable
// tileSize on instantiation, which it uses to pre-cache
// calculations by zoom level.
// We cache each instantiation, keyed by tile size, to avoid
// repeating this cost when working with a single tile size
// (assumed to be the most-common use case).
var $89adb9a48dc525a2$var$smCache = {};
$89adb9a48dc525a2$export$d7b7311ec04a3e8f = $89adb9a48dc525a2$var$viewport;
$89adb9a48dc525a2$export$40e55eae2f766967 = $89adb9a48dc525a2$var$bounds;
function $89adb9a48dc525a2$var$fetchMerc(tileSize) {
    tileSize = tileSize || 256;
    if (!$89adb9a48dc525a2$var$smCache[tileSize]) $89adb9a48dc525a2$var$smCache[tileSize] = new $88tg0({
        size: tileSize
    });
    return $89adb9a48dc525a2$var$smCache[tileSize];
}
function $89adb9a48dc525a2$var$viewport(bounds, dimensions, minzoom, maxzoom, tileSize) {
    minzoom = minzoom === undefined ? 0 : minzoom;
    maxzoom = maxzoom === undefined ? 20 : maxzoom;
    var merc = $89adb9a48dc525a2$var$fetchMerc(tileSize);
    var base = maxzoom, bl = merc.px([
        bounds[0],
        bounds[1]
    ], base), tr = merc.px([
        bounds[2],
        bounds[3]
    ], base), width = tr[0] - bl[0], height = bl[1] - tr[1], ratios = [
        width / dimensions[0],
        height / dimensions[1]
    ], center = [
        (bounds[0] + bounds[2]) / 2,
        (bounds[1] + bounds[3]) / 2
    ], adjusted = Math.floor(Math.min(base - Math.log(ratios[0]) / Math.log(2), base - Math.log(ratios[1]) / Math.log(2))), zoom = Math.max(minzoom, Math.min(maxzoom, adjusted));
    return {
        center: center,
        zoom: zoom
    };
}
function $89adb9a48dc525a2$var$bounds(viewport, zoom, dimensions, tileSize) {
    if (viewport.lon !== undefined) viewport = [
        viewport.lon,
        viewport.lat
    ];
    var merc = $89adb9a48dc525a2$var$fetchMerc(tileSize);
    var px = merc.px(viewport, zoom);
    var tl = merc.ll([
        px[0] - dimensions[0] / 2,
        px[1] - dimensions[1] / 2
    ], zoom);
    var br = merc.ll([
        px[0] + dimensions[0] / 2,
        px[1] + dimensions[1] / 2
    ], zoom);
    return [
        tl[0],
        br[1],
        br[0],
        tl[1]
    ];
}


var $aa6103d484f83752$var$_geoViewport2 = $aa6103d484f83752$var$_interopRequireDefault($89adb9a48dc525a2$exports);
var $3c4c698c1c5e9521$exports = {};

$parcel$export($3c4c698c1c5e9521$exports, "version", function () { return $417392c2461aa29e$export$83d89fbfd8236492; });
var $417392c2461aa29e$export$a8ff84c12d48cfa6 = "d3";
var $417392c2461aa29e$export$83d89fbfd8236492 = "6.7.0";
var $417392c2461aa29e$export$6d59db4903f20f7d = "Data-Driven Documents";
var $417392c2461aa29e$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $417392c2461aa29e$export$4cec2234a9c7ce6d = "https://d3js.org";
var $417392c2461aa29e$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $417392c2461aa29e$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $417392c2461aa29e$export$f22da7240b7add18 = "dist/d3.node.js";
var $417392c2461aa29e$export$101358e655b23e68 = "dist/d3.min.js";
var $417392c2461aa29e$export$a2877c4988dda7ec = "dist/d3.min.js";
var $417392c2461aa29e$export$130be424786e852f = "index.js";
var $417392c2461aa29e$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $417392c2461aa29e$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $417392c2461aa29e$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $417392c2461aa29e$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "3",
    "rollup": "2",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "5",
    "rollup-plugin-terser": "7",
    "tape": "4",
    "tape-await": "0.1"
};
var $417392c2461aa29e$export$b74ff737e0e298b5 = {
    "d3-array": "2",
    "d3-axis": "2",
    "d3-brush": "2",
    "d3-chord": "2",
    "d3-color": "2",
    "d3-contour": "2",
    "d3-delaunay": "5",
    "d3-dispatch": "2",
    "d3-drag": "2",
    "d3-dsv": "2",
    "d3-ease": "2",
    "d3-fetch": "2",
    "d3-force": "2",
    "d3-format": "2",
    "d3-geo": "2",
    "d3-hierarchy": "2",
    "d3-interpolate": "2",
    "d3-path": "2",
    "d3-polygon": "2",
    "d3-quadtree": "2",
    "d3-random": "2",
    "d3-scale": "3",
    "d3-scale-chromatic": "2",
    "d3-selection": "2",
    "d3-shape": "2",
    "d3-time": "2",
    "d3-time-format": "3",
    "d3-timer": "2",
    "d3-transition": "2",
    "d3-zoom": "2"
};


var $1fbb7a3af39b757c$exports = {};

$parcel$export($1fbb7a3af39b757c$exports, "bisect", function () { return $4fe96e9a0ca23dac$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "bisectRight", function () { return $4fe96e9a0ca23dac$export$4d945ad3ad5751b0; });
$parcel$export($1fbb7a3af39b757c$exports, "bisectLeft", function () { return $4fe96e9a0ca23dac$export$df7d25c84ebd12a5; });
$parcel$export($1fbb7a3af39b757c$exports, "bisectCenter", function () { return $4fe96e9a0ca23dac$export$c1cb828b1117c77b; });
$parcel$export($1fbb7a3af39b757c$exports, "ascending", function () { return $2d29f4eda77c8a37$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "bisector", function () { return $46841868eb2484de$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "count", function () { return $fd3b3ac415f0ac84$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "cross", function () { return $d7d55d49ef6ebc9b$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "cumsum", function () { return $1e7bbb0661e4cd9d$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "descending", function () { return $5528bc49158e5018$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "deviation", function () { return $44b8a41aa66845f1$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "extent", function () { return $a44db36a0002e759$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "Adder", function () { return $5393af5c7231911f$export$bda7ba77fb86c375; });
$parcel$export($1fbb7a3af39b757c$exports, "fsum", function () { return $5393af5c7231911f$export$61cb83f1a93e9fae; });
$parcel$export($1fbb7a3af39b757c$exports, "fcumsum", function () { return $5393af5c7231911f$export$5a6391da70c130da; });
$parcel$export($1fbb7a3af39b757c$exports, "group", function () { return $bbf96d15bbfc5042$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "groups", function () { return $bbf96d15bbfc5042$export$d4abd167df80d226; });
$parcel$export($1fbb7a3af39b757c$exports, "index", function () { return $bbf96d15bbfc5042$export$b610b8812bbcded9; });
$parcel$export($1fbb7a3af39b757c$exports, "indexes", function () { return $bbf96d15bbfc5042$export$8b04ba635e5803cd; });
$parcel$export($1fbb7a3af39b757c$exports, "rollup", function () { return $bbf96d15bbfc5042$export$97e11c0b0230f130; });
$parcel$export($1fbb7a3af39b757c$exports, "rollups", function () { return $bbf96d15bbfc5042$export$24814875ed03194b; });
$parcel$export($1fbb7a3af39b757c$exports, "groupSort", function () { return $f808a72f320e3d8d$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "bin", function () { return $92a230a56717ea72$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "histogram", function () { return $92a230a56717ea72$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "thresholdFreedmanDiaconis", function () { return $ad1ef483ef4463f2$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "thresholdScott", function () { return $bf706972be9ed137$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "thresholdSturges", function () { return $90bcb739cf9d355b$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "max", function () { return $7eb47354b7ef1ed9$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "maxIndex", function () { return $3d3a8c57ce55fcc8$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "mean", function () { return $bad0c09afa432f0e$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "median", function () { return $1833bf16d7a8cc89$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "merge", function () { return $8a226ba821d468da$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "min", function () { return $f7c071bdf3fd3489$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "minIndex", function () { return $2248e740476d70c2$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "nice", function () { return $badf1266f201fcae$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "pairs", function () { return $3ac34fe5fd33010d$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "permute", function () { return $867c9a04a17ddf6f$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "quantile", function () { return $6023399c16b3ae9b$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "quantileSorted", function () { return $6023399c16b3ae9b$export$f924a6cad778dddb; });
$parcel$export($1fbb7a3af39b757c$exports, "quickselect", function () { return $4ffe45e0c3fb3c67$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "range", function () { return $a9c85d866204d0d0$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "least", function () { return $4b448ceb40ee5fa4$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "leastIndex", function () { return $42a5cac43f842b6e$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "greatest", function () { return $6f46fda92dbe78ac$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "greatestIndex", function () { return $cf2d9184e509cd8e$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "scan", function () { return $58b2a36628399e4d$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "shuffle", function () { return $b2d414e81e227a13$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "shuffler", function () { return $b2d414e81e227a13$export$a430ea578c95d356; });
$parcel$export($1fbb7a3af39b757c$exports, "sum", function () { return $e5b294d7e0152785$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "ticks", function () { return $0c0e85ae379d5115$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "tickIncrement", function () { return $0c0e85ae379d5115$export$bc64d00cc98e7e95; });
$parcel$export($1fbb7a3af39b757c$exports, "tickStep", function () { return $0c0e85ae379d5115$export$81087d9b915d4ede; });
$parcel$export($1fbb7a3af39b757c$exports, "transpose", function () { return $3d869d8f707cdd49$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "variance", function () { return $a47c801f80dba306$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "zip", function () { return $49c77b74eade4473$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "every", function () { return $fabc63873481f0a3$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "some", function () { return $f9f3e6d85f12ba1e$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "filter", function () { return $864c391953587c01$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "map", function () { return $c61770aa4af95878$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "reduce", function () { return $ac243b5f04b4f16e$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "reverse", function () { return $1d25fca424d967d0$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "sort", function () { return $29cfb78b31925f70$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "difference", function () { return $6bee1620d04e6561$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "disjoint", function () { return $508a2c6ec7f96fa8$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "intersection", function () { return $cb6340feebb1e6a2$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "subset", function () { return $8f124c625a51a69e$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "superset", function () { return $b1079f1e9e2807bb$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "union", function () { return $6bf721dbab5e3013$export$2e2bcd8739ae039; });
$parcel$export($1fbb7a3af39b757c$exports, "InternMap", function () { return $2746e431782cd4f2$export$dcc6fb7d82b5bc7b; });
$parcel$export($1fbb7a3af39b757c$exports, "InternSet", function () { return $2746e431782cd4f2$export$55278c3294239828; });
function $2d29f4eda77c8a37$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $46841868eb2484de$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $46841868eb2484de$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $46841868eb2484de$var$ascendingComparator(f) {
    return (d, x)=>(0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(f(d), x);
}


function $3376eae76898b561$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $3376eae76898b561$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $4fe96e9a0ca23dac$var$ascendingBisect = (0, $46841868eb2484de$export$2e2bcd8739ae039)((0, $2d29f4eda77c8a37$export$2e2bcd8739ae039));
const $4fe96e9a0ca23dac$export$4d945ad3ad5751b0 = $4fe96e9a0ca23dac$var$ascendingBisect.right;
const $4fe96e9a0ca23dac$export$df7d25c84ebd12a5 = $4fe96e9a0ca23dac$var$ascendingBisect.left;
const $4fe96e9a0ca23dac$export$c1cb828b1117c77b = (0, $46841868eb2484de$export$2e2bcd8739ae039)((0, $3376eae76898b561$export$2e2bcd8739ae039)).center;
var $4fe96e9a0ca23dac$export$2e2bcd8739ae039 = $4fe96e9a0ca23dac$export$4d945ad3ad5751b0;




function $fd3b3ac415f0ac84$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}


function $d7d55d49ef6ebc9b$var$length(array) {
    return array.length | 0;
}
function $d7d55d49ef6ebc9b$var$empty(length) {
    return !(length > 0);
}
function $d7d55d49ef6ebc9b$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $d7d55d49ef6ebc9b$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $d7d55d49ef6ebc9b$export$2e2bcd8739ae039(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $d7d55d49ef6ebc9b$var$reducer(values.pop());
    values = values.map($d7d55d49ef6ebc9b$var$arrayify);
    const lengths = values.map($d7d55d49ef6ebc9b$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($d7d55d49ef6ebc9b$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}


function $1e7bbb0661e4cd9d$export$2e2bcd8739ae039(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}


function $5528bc49158e5018$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $a47c801f80dba306$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}


function $44b8a41aa66845f1$export$2e2bcd8739ae039(values, valueof) {
    const v = (0, $a47c801f80dba306$export$2e2bcd8739ae039)(values, valueof);
    return v ? Math.sqrt(v) : v;
}


function $a44db36a0002e759$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $5393af5c7231911f$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $5393af5c7231911f$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $5393af5c7231911f$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $5393af5c7231911f$export$5a6391da70c130da(values, valueof) {
    const adder = new $5393af5c7231911f$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}


class $2746e431782cd4f2$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $2746e431782cd4f2$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($2746e431782cd4f2$var$intern_get(this, key));
    }
    has(key) {
        return super.has($2746e431782cd4f2$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($2746e431782cd4f2$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($2746e431782cd4f2$var$intern_delete(this, key));
    }
}
class $2746e431782cd4f2$export$55278c3294239828 extends Set {
    constructor(values, key = $2746e431782cd4f2$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($2746e431782cd4f2$var$intern_get(this, value));
    }
    add(value) {
        return super.add($2746e431782cd4f2$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($2746e431782cd4f2$var$intern_delete(this, value));
    }
}
function $2746e431782cd4f2$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $2746e431782cd4f2$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $2746e431782cd4f2$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function $2746e431782cd4f2$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $5b93744659d71707$export$2e2bcd8739ae039(x) {
    return x;
}


function $bbf96d15bbfc5042$export$2e2bcd8739ae039(values, ...keys) {
    return $bbf96d15bbfc5042$var$nest(values, (0, $5b93744659d71707$export$2e2bcd8739ae039), (0, $5b93744659d71707$export$2e2bcd8739ae039), keys);
}
function $bbf96d15bbfc5042$export$d4abd167df80d226(values, ...keys) {
    return $bbf96d15bbfc5042$var$nest(values, Array.from, (0, $5b93744659d71707$export$2e2bcd8739ae039), keys);
}
function $bbf96d15bbfc5042$export$97e11c0b0230f130(values, reduce, ...keys) {
    return $bbf96d15bbfc5042$var$nest(values, (0, $5b93744659d71707$export$2e2bcd8739ae039), reduce, keys);
}
function $bbf96d15bbfc5042$export$24814875ed03194b(values, reduce, ...keys) {
    return $bbf96d15bbfc5042$var$nest(values, Array.from, reduce, keys);
}
function $bbf96d15bbfc5042$export$b610b8812bbcded9(values, ...keys) {
    return $bbf96d15bbfc5042$var$nest(values, (0, $5b93744659d71707$export$2e2bcd8739ae039), $bbf96d15bbfc5042$var$unique, keys);
}
function $bbf96d15bbfc5042$export$8b04ba635e5803cd(values, ...keys) {
    return $bbf96d15bbfc5042$var$nest(values, Array.from, $bbf96d15bbfc5042$var$unique, keys);
}
function $bbf96d15bbfc5042$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $bbf96d15bbfc5042$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new (0, $2746e431782cd4f2$export$dcc6fb7d82b5bc7b)();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}





function $867c9a04a17ddf6f$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}


function $29cfb78b31925f70$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)] = F;
    if (f.length === 1 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>(0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(f[i], f[j]));
        }
        return (0, $867c9a04a17ddf6f$export$2e2bcd8739ae039)(values, index);
    }
    return values.sort(f);
}


function $f808a72f320e3d8d$export$2e2bcd8739ae039(values, reduce, key) {
    return (reduce.length === 1 ? (0, $29cfb78b31925f70$export$2e2bcd8739ae039)((0, $bbf96d15bbfc5042$export$97e11c0b0230f130)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(av, bv) || (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(ak, bk)) : (0, $29cfb78b31925f70$export$2e2bcd8739ae039)((0, $bbf96d15bbfc5042$export$2e2bcd8739ae039)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(ak, bk))).map(([key])=>key);
}


var $113c191067548f83$var$array = Array.prototype;
var $113c191067548f83$export$58adb3bec8346d0f = $113c191067548f83$var$array.slice;
var $113c191067548f83$export$871de8747c9eaa88 = $113c191067548f83$var$array.map;



function $dd56f652fd1ec085$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}




var $0c0e85ae379d5115$var$e10 = Math.sqrt(50), $0c0e85ae379d5115$var$e5 = Math.sqrt(10), $0c0e85ae379d5115$var$e2 = Math.sqrt(2);
function $0c0e85ae379d5115$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $0c0e85ae379d5115$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $0c0e85ae379d5115$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $0c0e85ae379d5115$var$e10 ? 10 : error >= $0c0e85ae379d5115$var$e5 ? 5 : error >= $0c0e85ae379d5115$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $0c0e85ae379d5115$var$e10 ? 10 : error >= $0c0e85ae379d5115$var$e5 ? 5 : error >= $0c0e85ae379d5115$var$e2 ? 2 : 1);
}
function $0c0e85ae379d5115$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $0c0e85ae379d5115$var$e10) step1 *= 10;
    else if (error >= $0c0e85ae379d5115$var$e5) step1 *= 5;
    else if (error >= $0c0e85ae379d5115$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $badf1266f201fcae$export$2e2bcd8739ae039(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $0c0e85ae379d5115$export$bc64d00cc98e7e95)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}




function $90bcb739cf9d355b$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log((0, $fd3b3ac415f0ac84$export$2e2bcd8739ae039)(values)) / Math.LN2) + 1;
}


function $92a230a56717ea72$export$2e2bcd8739ae039() {
    var value = (0, $5b93744659d71707$export$2e2bcd8739ae039), domain = (0, $a44db36a0002e759$export$2e2bcd8739ae039), threshold = (0, $90bcb739cf9d355b$export$2e2bcd8739ae039);
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === (0, $a44db36a0002e759$export$2e2bcd8739ae039)) [x0, x1] = (0, $badf1266f201fcae$export$2e2bcd8739ae039)(x0, x1, tn);
            tz = (0, $0c0e85ae379d5115$export$2e2bcd8739ae039)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === (0, $a44db36a0002e759$export$2e2bcd8739ae039)) {
                    const step = (0, $0c0e85ae379d5115$export$bc64d00cc98e7e95)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $4fe96e9a0ca23dac$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $dd56f652fd1ec085$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $dd56f652fd1ec085$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $dd56f652fd1ec085$export$2e2bcd8739ae039)((0, $113c191067548f83$export$58adb3bec8346d0f).call(_)) : (0, $dd56f652fd1ec085$export$2e2bcd8739ae039)(_), histogram) : threshold;
    };
    return histogram;
}



function $7eb47354b7ef1ed9$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $f7c071bdf3fd3489$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}



function $4ffe45e0c3fb3c67$export$2e2bcd8739ae039(array, k, left = 0, right = array.length - 1, compare = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $4ffe45e0c3fb3c67$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $4ffe45e0c3fb3c67$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $4ffe45e0c3fb3c67$var$swap(array, left, right);
        while(i < j){
            $4ffe45e0c3fb3c67$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $4ffe45e0c3fb3c67$var$swap(array, left, j);
        else ++j, $4ffe45e0c3fb3c67$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $4ffe45e0c3fb3c67$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}



function $6023399c16b3ae9b$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $3376eae76898b561$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $f7c071bdf3fd3489$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $7eb47354b7ef1ed9$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $7eb47354b7ef1ed9$export$2e2bcd8739ae039)((0, $4ffe45e0c3fb3c67$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $f7c071bdf3fd3489$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $6023399c16b3ae9b$export$f924a6cad778dddb(values, p, valueof = (0, $3376eae76898b561$export$2e2bcd8739ae039)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}


function $ad1ef483ef4463f2$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $6023399c16b3ae9b$export$2e2bcd8739ae039)(values, 0.75) - (0, $6023399c16b3ae9b$export$2e2bcd8739ae039)(values, 0.25)) * Math.pow((0, $fd3b3ac415f0ac84$export$2e2bcd8739ae039)(values), -1 / 3)));
}




function $bf706972be9ed137$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $44b8a41aa66845f1$export$2e2bcd8739ae039)(values) * Math.pow((0, $fd3b3ac415f0ac84$export$2e2bcd8739ae039)(values), -1 / 3)));
}




function $3d3a8c57ce55fcc8$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}


function $bad0c09afa432f0e$export$2e2bcd8739ae039(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}



function $1833bf16d7a8cc89$export$2e2bcd8739ae039(values, valueof) {
    return (0, $6023399c16b3ae9b$export$2e2bcd8739ae039)(values, 0.5, valueof);
}


function* $8a226ba821d468da$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $8a226ba821d468da$export$2e2bcd8739ae039(arrays) {
    return Array.from($8a226ba821d468da$var$flatten(arrays));
}



function $2248e740476d70c2$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}



function $3ac34fe5fd33010d$export$2e2bcd8739ae039(values, pairof = $3ac34fe5fd33010d$export$a04cb3fe8b81dd) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $3ac34fe5fd33010d$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}





function $a9c85d866204d0d0$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}



function $4b448ceb40ee5fa4$export$2e2bcd8739ae039(values, compare = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(value, minValue) < 0 : (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}




function $42a5cac43f842b6e$export$2e2bcd8739ae039(values, compare = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)) {
    if (compare.length === 1) return (0, $2248e740476d70c2$export$2e2bcd8739ae039)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}



function $6f46fda92dbe78ac$export$2e2bcd8739ae039(values, compare = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(value, maxValue) > 0 : (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}




function $cf2d9184e509cd8e$export$2e2bcd8739ae039(values, compare = (0, $2d29f4eda77c8a37$export$2e2bcd8739ae039)) {
    if (compare.length === 1) return (0, $3d3a8c57ce55fcc8$export$2e2bcd8739ae039)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}



function $58b2a36628399e4d$export$2e2bcd8739ae039(values, compare) {
    const index = (0, $42a5cac43f842b6e$export$2e2bcd8739ae039)(values, compare);
    return index < 0 ? undefined : index;
}


var $b2d414e81e227a13$export$2e2bcd8739ae039 = $b2d414e81e227a13$export$a430ea578c95d356(Math.random);
function $b2d414e81e227a13$export$a430ea578c95d356(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}


function $e5b294d7e0152785$export$2e2bcd8739ae039(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}




function $3d869d8f707cdd49$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f7c071bdf3fd3489$export$2e2bcd8739ae039)(matrix, $3d869d8f707cdd49$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $3d869d8f707cdd49$var$length(d) {
    return d.length;
}




function $49c77b74eade4473$export$2e2bcd8739ae039() {
    return (0, $3d869d8f707cdd49$export$2e2bcd8739ae039)(arguments);
}


function $fabc63873481f0a3$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}


function $f9f3e6d85f12ba1e$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}


function $864c391953587c01$export$2e2bcd8739ae039(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}


function $c61770aa4af95878$export$2e2bcd8739ae039(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}


function $ac243b5f04b4f16e$export$2e2bcd8739ae039(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}


function $1d25fca424d967d0$export$2e2bcd8739ae039(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}



function $6bee1620d04e6561$export$2e2bcd8739ae039(values, ...others) {
    values = new Set(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}


function $508a2c6ec7f96fa8$export$2e2bcd8739ae039(values, other) {
    const iterator = other[Symbol.iterator](), set = new Set();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}


function $7ff1d79b3b1886f2$export$2e2bcd8739ae039(values) {
    return values instanceof Set ? values : new Set(values);
}


function $cb6340feebb1e6a2$export$2e2bcd8739ae039(values, ...others) {
    values = new Set(values);
    others = others.map((0, $7ff1d79b3b1886f2$export$2e2bcd8739ae039));
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}


function $b1079f1e9e2807bb$export$2e2bcd8739ae039(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        if (set.has(o)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            set.add(value);
            if (Object.is(o, value)) break;
        }
    }
    return true;
}


function $8f124c625a51a69e$export$2e2bcd8739ae039(values, other) {
    return (0, $b1079f1e9e2807bb$export$2e2bcd8739ae039)(other, values);
}



function $6bf721dbab5e3013$export$2e2bcd8739ae039(...others) {
    const set = new Set();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}





var $925ec43add5f3b4d$exports = {};

$parcel$export($925ec43add5f3b4d$exports, "axisTop", function () { return $443ce07ecf2224fa$export$59b8cfab074bdeb1; });
$parcel$export($925ec43add5f3b4d$exports, "axisRight", function () { return $443ce07ecf2224fa$export$b0d2e24dc4f898f0; });
$parcel$export($925ec43add5f3b4d$exports, "axisBottom", function () { return $443ce07ecf2224fa$export$e5cb22533a15e72e; });
$parcel$export($925ec43add5f3b4d$exports, "axisLeft", function () { return $443ce07ecf2224fa$export$2749afb169a520d2; });
var $3c45f51faf73a0a0$export$58adb3bec8346d0f = Array.prototype.slice;


function $68ea8a9aae6f35bc$export$2e2bcd8739ae039(x) {
    return x;
}


var $443ce07ecf2224fa$var$top = 1, $443ce07ecf2224fa$var$right = 2, $443ce07ecf2224fa$var$bottom = 3, $443ce07ecf2224fa$var$left = 4, $443ce07ecf2224fa$var$epsilon = 1e-6;
function $443ce07ecf2224fa$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $443ce07ecf2224fa$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $443ce07ecf2224fa$var$number(scale) {
    return (d)=>+scale(d);
}
function $443ce07ecf2224fa$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $443ce07ecf2224fa$var$entering() {
    return !this.__axis;
}
function $443ce07ecf2224fa$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $443ce07ecf2224fa$var$top || orient === $443ce07ecf2224fa$var$left ? -1 : 1, x = orient === $443ce07ecf2224fa$var$left || orient === $443ce07ecf2224fa$var$right ? "x" : "y", transform = orient === $443ce07ecf2224fa$var$top || orient === $443ce07ecf2224fa$var$bottom ? $443ce07ecf2224fa$var$translateX : $443ce07ecf2224fa$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $68ea8a9aae6f35bc$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $443ce07ecf2224fa$var$center : $443ce07ecf2224fa$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $443ce07ecf2224fa$var$top ? "0em" : orient === $443ce07ecf2224fa$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $443ce07ecf2224fa$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $443ce07ecf2224fa$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $443ce07ecf2224fa$var$left || orient === $443ce07ecf2224fa$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($443ce07ecf2224fa$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $443ce07ecf2224fa$var$right ? "start" : orient === $443ce07ecf2224fa$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $3c45f51faf73a0a0$export$58adb3bec8346d0f).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $3c45f51faf73a0a0$export$58adb3bec8346d0f).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $3c45f51faf73a0a0$export$58adb3bec8346d0f).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $443ce07ecf2224fa$export$59b8cfab074bdeb1(scale) {
    return $443ce07ecf2224fa$var$axis($443ce07ecf2224fa$var$top, scale);
}
function $443ce07ecf2224fa$export$b0d2e24dc4f898f0(scale) {
    return $443ce07ecf2224fa$var$axis($443ce07ecf2224fa$var$right, scale);
}
function $443ce07ecf2224fa$export$e5cb22533a15e72e(scale) {
    return $443ce07ecf2224fa$var$axis($443ce07ecf2224fa$var$bottom, scale);
}
function $443ce07ecf2224fa$export$2749afb169a520d2(scale) {
    return $443ce07ecf2224fa$var$axis($443ce07ecf2224fa$var$left, scale);
}




var $270c3609e16d9ece$exports = {};

$parcel$export($270c3609e16d9ece$exports, "brush", function () { return $e0117cd89c43313a$export$2e2bcd8739ae039; });
$parcel$export($270c3609e16d9ece$exports, "brushX", function () { return $e0117cd89c43313a$export$979ace6c88860aa8; });
$parcel$export($270c3609e16d9ece$exports, "brushY", function () { return $e0117cd89c43313a$export$468748b530991c54; });
$parcel$export($270c3609e16d9ece$exports, "brushSelection", function () { return $e0117cd89c43313a$export$69760394fc76f689; });
var $41d77768dbc6b7a5$var$noop = {
    value: ()=>{}
};
function $41d77768dbc6b7a5$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $41d77768dbc6b7a5$var$Dispatch(_);
}
function $41d77768dbc6b7a5$var$Dispatch(_) {
    this._ = _;
}
function $41d77768dbc6b7a5$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$41d77768dbc6b7a5$var$Dispatch.prototype = $41d77768dbc6b7a5$var$dispatch.prototype = {
    constructor: $41d77768dbc6b7a5$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $41d77768dbc6b7a5$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $41d77768dbc6b7a5$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $41d77768dbc6b7a5$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $41d77768dbc6b7a5$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $41d77768dbc6b7a5$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $41d77768dbc6b7a5$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $41d77768dbc6b7a5$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $41d77768dbc6b7a5$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $41d77768dbc6b7a5$export$2e2bcd8739ae039 = $41d77768dbc6b7a5$var$dispatch;



function $dfd5f4da69e6fc89$var$none() {}
function $dfd5f4da69e6fc89$export$2e2bcd8739ae039(selector) {
    return selector == null ? $dfd5f4da69e6fc89$var$none : function() {
        return this.querySelector(selector);
    };
}


function $4e75faa7b65743f8$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $dfd5f4da69e6fc89$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(subgroups, this._parents);
}



function $4d3c2139300ccec0$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $4edfa6f7c70b9ae4$var$empty() {
    return [];
}
function $4edfa6f7c70b9ae4$export$2e2bcd8739ae039(selector) {
    return selector == null ? $4edfa6f7c70b9ae4$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $ae1e08819593016f$var$arrayAll(select) {
    return function() {
        var group = select.apply(this, arguments);
        return group == null ? [] : (0, $4d3c2139300ccec0$export$2e2bcd8739ae039)(group);
    };
}
function $ae1e08819593016f$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $ae1e08819593016f$var$arrayAll(select);
    else select = (0, $4edfa6f7c70b9ae4$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(subgroups, parents);
}


function $98ead6b7044d2c9b$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $98ead6b7044d2c9b$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $8f7c938db777ac56$var$find = Array.prototype.find;
function $8f7c938db777ac56$var$childFind(match) {
    return function() {
        return $8f7c938db777ac56$var$find.call(this.children, match);
    };
}
function $8f7c938db777ac56$var$childFirst() {
    return this.firstElementChild;
}
function $8f7c938db777ac56$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $8f7c938db777ac56$var$childFirst : $8f7c938db777ac56$var$childFind(typeof match === "function" ? match : (0, $98ead6b7044d2c9b$export$90c2759c036528)(match)));
}



var $4b6d96e940aa5ad3$var$filter = Array.prototype.filter;
function $4b6d96e940aa5ad3$var$children() {
    return this.children;
}
function $4b6d96e940aa5ad3$var$childrenFilter(match) {
    return function() {
        return $4b6d96e940aa5ad3$var$filter.call(this.children, match);
    };
}
function $4b6d96e940aa5ad3$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $4b6d96e940aa5ad3$var$children : $4b6d96e940aa5ad3$var$childrenFilter(typeof match === "function" ? match : (0, $98ead6b7044d2c9b$export$90c2759c036528)(match)));
}




function $f9a345103dd38550$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $98ead6b7044d2c9b$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(subgroups, this._parents);
}



function $bcdeb4e6d2470b8d$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $c1c49ee3b277110a$export$2e2bcd8739ae039() {
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(this._enter || this._groups.map((0, $bcdeb4e6d2470b8d$export$2e2bcd8739ae039)), this._parents);
}
function $c1c49ee3b277110a$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$c1c49ee3b277110a$export$67b01759a14cf6a4.prototype = {
    constructor: $c1c49ee3b277110a$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};



function $d96d6431ad0be8a0$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $ce9100132ba539f4$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $c1c49ee3b277110a$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $ce9100132ba539f4$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $c1c49ee3b277110a$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $ce9100132ba539f4$var$datum(node) {
    return node.__data__;
}
function $ce9100132ba539f4$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $ce9100132ba539f4$var$datum);
    var bind = key ? $ce9100132ba539f4$var$bindKey : $ce9100132ba539f4$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d96d6431ad0be8a0$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = (0, $4d3c2139300ccec0$export$2e2bcd8739ae039)(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $30b99eabd4635d88$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $411f7abd69a8112b$export$2e2bcd8739ae039() {
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(this._exit || this._groups.map((0, $bcdeb4e6d2470b8d$export$2e2bcd8739ae039)), this._parents);
}


function $e2cc450a52a225f5$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $938a08d66b2100ec$export$2e2bcd8739ae039(selection) {
    if (!(selection instanceof (0, $30b99eabd4635d88$export$52baac22726c72bf))) throw new Error("invalid merge");
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(merges, this._parents);
}


function $7dfb91ea9a487fd1$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $03542f025131ee68$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $03542f025131ee68$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $30b99eabd4635d88$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $03542f025131ee68$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $4289632208c7be8e$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $5bcdbe8e54b95d65$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $d0a4d05ec074a9fd$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $f26c9a02ed3db5fa$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $4d1f28c6d0ac80c8$export$2e2bcd8739ae039() {
    return !this.node();
}


function $a04eaac68148ae85$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $2bf80764bc2ec3dc$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $2bf80764bc2ec3dc$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $2bf80764bc2ec3dc$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $5361d4c7390d69ee$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $2bf80764bc2ec3dc$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $2bf80764bc2ec3dc$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $38c777b2425e5031$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $38c777b2425e5031$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $38c777b2425e5031$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $38c777b2425e5031$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $38c777b2425e5031$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $38c777b2425e5031$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $38c777b2425e5031$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $5361d4c7390d69ee$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $38c777b2425e5031$var$attrRemoveNS : $38c777b2425e5031$var$attrRemove : typeof value === "function" ? fullname.local ? $38c777b2425e5031$var$attrFunctionNS : $38c777b2425e5031$var$attrFunction : fullname.local ? $38c777b2425e5031$var$attrConstantNS : $38c777b2425e5031$var$attrConstant)(fullname, value));
}


function $db81a2739179290d$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $3ee26f6a7e3758bf$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $3ee26f6a7e3758bf$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $3ee26f6a7e3758bf$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $3ee26f6a7e3758bf$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $3ee26f6a7e3758bf$var$styleRemove : typeof value === "function" ? $3ee26f6a7e3758bf$var$styleFunction : $3ee26f6a7e3758bf$var$styleConstant)(name, value, priority == null ? "" : priority)) : $3ee26f6a7e3758bf$export$5e3cec964f0b5efd(this.node(), name);
}
function $3ee26f6a7e3758bf$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $db81a2739179290d$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $d7173b5d1be1729a$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $d7173b5d1be1729a$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $d7173b5d1be1729a$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $d7173b5d1be1729a$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $d7173b5d1be1729a$var$propertyRemove : typeof value === "function" ? $d7173b5d1be1729a$var$propertyFunction : $d7173b5d1be1729a$var$propertyConstant)(name, value)) : this.node()[name];
}


function $3d246f3b60ebaf84$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $3d246f3b60ebaf84$var$classList(node) {
    return node.classList || new $3d246f3b60ebaf84$var$ClassList(node);
}
function $3d246f3b60ebaf84$var$ClassList(node) {
    this._node = node;
    this._names = $3d246f3b60ebaf84$var$classArray(node.getAttribute("class") || "");
}
$3d246f3b60ebaf84$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $3d246f3b60ebaf84$var$classedAdd(node, names) {
    var list = $3d246f3b60ebaf84$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $3d246f3b60ebaf84$var$classedRemove(node, names) {
    var list = $3d246f3b60ebaf84$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $3d246f3b60ebaf84$var$classedTrue(names) {
    return function() {
        $3d246f3b60ebaf84$var$classedAdd(this, names);
    };
}
function $3d246f3b60ebaf84$var$classedFalse(names) {
    return function() {
        $3d246f3b60ebaf84$var$classedRemove(this, names);
    };
}
function $3d246f3b60ebaf84$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $3d246f3b60ebaf84$var$classedAdd : $3d246f3b60ebaf84$var$classedRemove)(this, names);
    };
}
function $3d246f3b60ebaf84$export$2e2bcd8739ae039(name, value) {
    var names = $3d246f3b60ebaf84$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $3d246f3b60ebaf84$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $3d246f3b60ebaf84$var$classedFunction : value ? $3d246f3b60ebaf84$var$classedTrue : $3d246f3b60ebaf84$var$classedFalse)(names, value));
}


function $1a72993f767ec7f2$var$textRemove() {
    this.textContent = "";
}
function $1a72993f767ec7f2$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $1a72993f767ec7f2$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $1a72993f767ec7f2$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $1a72993f767ec7f2$var$textRemove : (typeof value === "function" ? $1a72993f767ec7f2$var$textFunction : $1a72993f767ec7f2$var$textConstant)(value)) : this.node().textContent;
}


function $ba7a24e685e6a87d$var$htmlRemove() {
    this.innerHTML = "";
}
function $ba7a24e685e6a87d$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $ba7a24e685e6a87d$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $ba7a24e685e6a87d$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $ba7a24e685e6a87d$var$htmlRemove : (typeof value === "function" ? $ba7a24e685e6a87d$var$htmlFunction : $ba7a24e685e6a87d$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $ef87bf71f69f58bf$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $ef87bf71f69f58bf$export$2e2bcd8739ae039() {
    return this.each($ef87bf71f69f58bf$var$raise);
}


function $a82c5d4dca79b983$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $a82c5d4dca79b983$export$2e2bcd8739ae039() {
    return this.each($a82c5d4dca79b983$var$lower);
}




function $05ff5bb28f55c49f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $2bf80764bc2ec3dc$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $2bf80764bc2ec3dc$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $05ff5bb28f55c49f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $05ff5bb28f55c49f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $5361d4c7390d69ee$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $05ff5bb28f55c49f$var$creatorFixed : $05ff5bb28f55c49f$var$creatorInherit)(fullname);
}


function $53d770277df30032$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $05ff5bb28f55c49f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $c366a9e6ed96e257$var$constantNull() {
    return null;
}
function $c366a9e6ed96e257$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $05ff5bb28f55c49f$export$2e2bcd8739ae039)(name), select = before == null ? $c366a9e6ed96e257$var$constantNull : typeof before === "function" ? before : (0, $dfd5f4da69e6fc89$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $84c888428c496f23$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $84c888428c496f23$export$2e2bcd8739ae039() {
    return this.each($84c888428c496f23$var$remove);
}


function $fbfefc1267465edc$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $fbfefc1267465edc$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $fbfefc1267465edc$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $fbfefc1267465edc$var$selection_cloneDeep : $fbfefc1267465edc$var$selection_cloneShallow);
}


function $f5006bda8f19112a$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $11d78ee00843d045$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $11d78ee00843d045$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $11d78ee00843d045$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $11d78ee00843d045$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $11d78ee00843d045$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $11d78ee00843d045$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $11d78ee00843d045$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $11d78ee00843d045$var$onAdd : $11d78ee00843d045$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $a9554a4fedda2a2b$var$dispatchEvent(node, type, params) {
    var window = (0, $db81a2739179290d$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $a9554a4fedda2a2b$var$dispatchConstant(type, params) {
    return function() {
        return $a9554a4fedda2a2b$var$dispatchEvent(this, type, params);
    };
}
function $a9554a4fedda2a2b$var$dispatchFunction(type, params) {
    return function() {
        return $a9554a4fedda2a2b$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $a9554a4fedda2a2b$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $a9554a4fedda2a2b$var$dispatchFunction : $a9554a4fedda2a2b$var$dispatchConstant)(type, params));
}


function* $321ebc729de34945$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $30b99eabd4635d88$export$e8e78c978b129247 = [
    null
];
function $30b99eabd4635d88$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $30b99eabd4635d88$var$selection() {
    return new $30b99eabd4635d88$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $30b99eabd4635d88$export$e8e78c978b129247);
}
function $30b99eabd4635d88$var$selection_selection() {
    return this;
}
$30b99eabd4635d88$export$52baac22726c72bf.prototype = $30b99eabd4635d88$var$selection.prototype = {
    constructor: $30b99eabd4635d88$export$52baac22726c72bf,
    select: (0, $4e75faa7b65743f8$export$2e2bcd8739ae039),
    selectAll: (0, $ae1e08819593016f$export$2e2bcd8739ae039),
    selectChild: (0, $8f7c938db777ac56$export$2e2bcd8739ae039),
    selectChildren: (0, $4b6d96e940aa5ad3$export$2e2bcd8739ae039),
    filter: (0, $f9a345103dd38550$export$2e2bcd8739ae039),
    data: (0, $ce9100132ba539f4$export$2e2bcd8739ae039),
    enter: (0, $c1c49ee3b277110a$export$2e2bcd8739ae039),
    exit: (0, $411f7abd69a8112b$export$2e2bcd8739ae039),
    join: (0, $e2cc450a52a225f5$export$2e2bcd8739ae039),
    merge: (0, $938a08d66b2100ec$export$2e2bcd8739ae039),
    selection: $30b99eabd4635d88$var$selection_selection,
    order: (0, $7dfb91ea9a487fd1$export$2e2bcd8739ae039),
    sort: (0, $03542f025131ee68$export$2e2bcd8739ae039),
    call: (0, $4289632208c7be8e$export$2e2bcd8739ae039),
    nodes: (0, $5bcdbe8e54b95d65$export$2e2bcd8739ae039),
    node: (0, $d0a4d05ec074a9fd$export$2e2bcd8739ae039),
    size: (0, $f26c9a02ed3db5fa$export$2e2bcd8739ae039),
    empty: (0, $4d1f28c6d0ac80c8$export$2e2bcd8739ae039),
    each: (0, $a04eaac68148ae85$export$2e2bcd8739ae039),
    attr: (0, $38c777b2425e5031$export$2e2bcd8739ae039),
    style: (0, $3ee26f6a7e3758bf$export$2e2bcd8739ae039),
    property: (0, $d7173b5d1be1729a$export$2e2bcd8739ae039),
    classed: (0, $3d246f3b60ebaf84$export$2e2bcd8739ae039),
    text: (0, $1a72993f767ec7f2$export$2e2bcd8739ae039),
    html: (0, $ba7a24e685e6a87d$export$2e2bcd8739ae039),
    raise: (0, $ef87bf71f69f58bf$export$2e2bcd8739ae039),
    lower: (0, $a82c5d4dca79b983$export$2e2bcd8739ae039),
    append: (0, $53d770277df30032$export$2e2bcd8739ae039),
    insert: (0, $c366a9e6ed96e257$export$2e2bcd8739ae039),
    remove: (0, $84c888428c496f23$export$2e2bcd8739ae039),
    clone: (0, $fbfefc1267465edc$export$2e2bcd8739ae039),
    datum: (0, $f5006bda8f19112a$export$2e2bcd8739ae039),
    on: (0, $11d78ee00843d045$export$2e2bcd8739ae039),
    dispatch: (0, $a9554a4fedda2a2b$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $321ebc729de34945$export$2e2bcd8739ae039)
};
var $30b99eabd4635d88$export$2e2bcd8739ae039 = $30b99eabd4635d88$var$selection;


function $0fd7b7faefc9df82$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $30b99eabd4635d88$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $30b99eabd4635d88$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $30b99eabd4635d88$export$e8e78c978b129247));
}


function $510d3bad7f87cd39$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $510d3bad7f87cd39$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $9fc1ee0544073e59$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $510d3bad7f87cd39$export$2e2bcd8739ae039), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $510d3bad7f87cd39$export$2e2bcd8739ae039), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $9fc1ee0544073e59$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $510d3bad7f87cd39$export$2e2bcd8739ae039), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $lDve0 = parcelRequire("lDve0");

var $lDve0 = parcelRequire("lDve0");
function $33515a6dd91223a1$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $33515a6dd91223a1$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $33515a6dd91223a1$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $888ce499c318081d$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $33515a6dd91223a1$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $31311d3204e4fbdc$export$2e2bcd8739ae039 = (x)=>()=>x;


function $b0ff832a4c016961$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $b0ff832a4c016961$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $b0ff832a4c016961$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $b0ff832a4c016961$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $31311d3204e4fbdc$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $b0ff832a4c016961$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $b0ff832a4c016961$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $b0ff832a4c016961$var$exponential(a, b, y) : (0, $31311d3204e4fbdc$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $b0ff832a4c016961$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $b0ff832a4c016961$var$linear(a, d) : (0, $31311d3204e4fbdc$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $4efcfc37f0c760c0$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $b0ff832a4c016961$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $lDve0.rgb)(start)).r, (end = (0, $lDve0.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $4efcfc37f0c760c0$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $lDve0.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $4efcfc37f0c760c0$export$2c0e28f2e2852d3f = $4efcfc37f0c760c0$var$rgbSpline((0, $33515a6dd91223a1$export$2e2bcd8739ae039));
var $4efcfc37f0c760c0$export$53d5214f625ccd4c = $4efcfc37f0c760c0$var$rgbSpline((0, $888ce499c318081d$export$2e2bcd8739ae039));



function $be2a2995a264064a$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $be2a2995a264064a$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $a678abf0bb18ad83$export$2e2bcd8739ae039(a, b) {
    return ((0, $be2a2995a264064a$export$5cd576d1827d40c8)(b) ? (0, $be2a2995a264064a$export$2e2bcd8739ae039) : $a678abf0bb18ad83$export$15d09067c6a5ee49)(a, b);
}
function $a678abf0bb18ad83$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $1be8536f58239452$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $b64d332320181a08$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $986d71b685263615$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $6425152590f6a238$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6425152590f6a238$var$reB = new RegExp($6425152590f6a238$var$reA.source, "g");
function $6425152590f6a238$var$zero(b) {
    return function() {
        return b;
    };
}
function $6425152590f6a238$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6425152590f6a238$export$2e2bcd8739ae039(a, b) {
    var bi = $6425152590f6a238$var$reA.lastIndex = $6425152590f6a238$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $6425152590f6a238$var$reA.exec(a)) && (bm = $6425152590f6a238$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $6425152590f6a238$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6425152590f6a238$var$one(q[0].x) : $6425152590f6a238$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $0f8c512c5c8a77f6$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $31311d3204e4fbdc$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $b64d332320181a08$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $lDve0.default)(b)) ? (b = c, $4efcfc37f0c760c0$export$2e2bcd8739ae039) : (0, $6425152590f6a238$export$2e2bcd8739ae039) : b instanceof (0, $lDve0.default) ? (0, $4efcfc37f0c760c0$export$2e2bcd8739ae039) : b instanceof Date ? (0, $1be8536f58239452$export$2e2bcd8739ae039) : (0, $be2a2995a264064a$export$5cd576d1827d40c8)(b) ? (0, $be2a2995a264064a$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $a678abf0bb18ad83$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $986d71b685263615$export$2e2bcd8739ae039) : (0, $b64d332320181a08$export$2e2bcd8739ae039))(a, b);
}


function $6e0b2ce48c5fb1d6$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $f414987f08497e2f$export$2e2bcd8739ae039(event, node) {
    event = (0, $6e0b2ce48c5fb1d6$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}


var $39a1595cb57fba7f$exports = {};

$parcel$export($39a1595cb57fba7f$exports, "transition", function () { return $1e7e527b952a4990$export$2e2bcd8739ae039; });
$parcel$export($39a1595cb57fba7f$exports, "active", function () { return $f334b4590ec2d151$export$2e2bcd8739ae039; });
$parcel$export($39a1595cb57fba7f$exports, "interrupt", function () { return $688fa9c8100803a6$export$2e2bcd8739ae039; });


var $9c58fce6e008e685$var$frame = 0, $9c58fce6e008e685$var$timeout = 0, $9c58fce6e008e685$var$interval = 0, $9c58fce6e008e685$var$pokeDelay = 1000, $9c58fce6e008e685$var$taskHead, $9c58fce6e008e685$var$taskTail, $9c58fce6e008e685$var$clockLast = 0, $9c58fce6e008e685$var$clockNow = 0, $9c58fce6e008e685$var$clockSkew = 0, $9c58fce6e008e685$var$clock = typeof performance === "object" && performance.now ? performance : Date, $9c58fce6e008e685$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $9c58fce6e008e685$export$461939dd4422153() {
    return $9c58fce6e008e685$var$clockNow || ($9c58fce6e008e685$var$setFrame($9c58fce6e008e685$var$clearNow), $9c58fce6e008e685$var$clockNow = $9c58fce6e008e685$var$clock.now() + $9c58fce6e008e685$var$clockSkew);
}
function $9c58fce6e008e685$var$clearNow() {
    $9c58fce6e008e685$var$clockNow = 0;
}
function $9c58fce6e008e685$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$9c58fce6e008e685$export$c57e9b2d8b9e4de.prototype = $9c58fce6e008e685$export$9dc4ecf953986f04.prototype = {
    constructor: $9c58fce6e008e685$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $9c58fce6e008e685$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $9c58fce6e008e685$var$taskTail !== this) {
            if ($9c58fce6e008e685$var$taskTail) $9c58fce6e008e685$var$taskTail._next = this;
            else $9c58fce6e008e685$var$taskHead = this;
            $9c58fce6e008e685$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $9c58fce6e008e685$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $9c58fce6e008e685$var$sleep();
        }
    }
};
function $9c58fce6e008e685$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $9c58fce6e008e685$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $9c58fce6e008e685$export$d60154c1d7f3990e() {
    $9c58fce6e008e685$export$461939dd4422153(); // Get the current time, if not already set.
    ++$9c58fce6e008e685$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $9c58fce6e008e685$var$taskHead, e;
    while(t){
        if ((e = $9c58fce6e008e685$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$9c58fce6e008e685$var$frame;
}
function $9c58fce6e008e685$var$wake() {
    $9c58fce6e008e685$var$clockNow = ($9c58fce6e008e685$var$clockLast = $9c58fce6e008e685$var$clock.now()) + $9c58fce6e008e685$var$clockSkew;
    $9c58fce6e008e685$var$frame = $9c58fce6e008e685$var$timeout = 0;
    try {
        $9c58fce6e008e685$export$d60154c1d7f3990e();
    } finally{
        $9c58fce6e008e685$var$frame = 0;
        $9c58fce6e008e685$var$nap();
        $9c58fce6e008e685$var$clockNow = 0;
    }
}
function $9c58fce6e008e685$var$poke() {
    var now = $9c58fce6e008e685$var$clock.now(), delay = now - $9c58fce6e008e685$var$clockLast;
    if (delay > $9c58fce6e008e685$var$pokeDelay) $9c58fce6e008e685$var$clockSkew -= delay, $9c58fce6e008e685$var$clockLast = now;
}
function $9c58fce6e008e685$var$nap() {
    var t0, t1 = $9c58fce6e008e685$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $9c58fce6e008e685$var$taskHead = t2;
    }
    $9c58fce6e008e685$var$taskTail = t0;
    $9c58fce6e008e685$var$sleep(time);
}
function $9c58fce6e008e685$var$sleep(time) {
    if ($9c58fce6e008e685$var$frame) return; // Soonest alarm already set, or will be.
    if ($9c58fce6e008e685$var$timeout) $9c58fce6e008e685$var$timeout = clearTimeout($9c58fce6e008e685$var$timeout);
    var delay = time - $9c58fce6e008e685$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $9c58fce6e008e685$var$timeout = setTimeout($9c58fce6e008e685$var$wake, time - $9c58fce6e008e685$var$clock.now() - $9c58fce6e008e685$var$clockSkew);
        if ($9c58fce6e008e685$var$interval) $9c58fce6e008e685$var$interval = clearInterval($9c58fce6e008e685$var$interval);
    } else {
        if (!$9c58fce6e008e685$var$interval) $9c58fce6e008e685$var$clockLast = $9c58fce6e008e685$var$clock.now(), $9c58fce6e008e685$var$interval = setInterval($9c58fce6e008e685$var$poke, $9c58fce6e008e685$var$pokeDelay);
        $9c58fce6e008e685$var$frame = 1, $9c58fce6e008e685$var$setFrame($9c58fce6e008e685$var$wake);
    }
}


function $070e9a4f0e21c528$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $9c58fce6e008e685$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $c63bf3f2e1974159$var$emptyOn = (0, $41d77768dbc6b7a5$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $c63bf3f2e1974159$var$emptyTween = [];
var $c63bf3f2e1974159$export$ff39ebd4bb12b718 = 0;
var $c63bf3f2e1974159$export$584530fe98d14a84 = 1;
var $c63bf3f2e1974159$export$a5d151aee16efd42 = 2;
var $c63bf3f2e1974159$export$fb935ab5849a0db9 = 3;
var $c63bf3f2e1974159$export$1573e22b087389af = 4;
var $c63bf3f2e1974159$export$a2e792214ded83b2 = 5;
var $c63bf3f2e1974159$export$9d38167254403955 = 6;
function $c63bf3f2e1974159$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $c63bf3f2e1974159$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $c63bf3f2e1974159$var$emptyOn,
        tween: $c63bf3f2e1974159$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $c63bf3f2e1974159$export$ff39ebd4bb12b718
    });
}
function $c63bf3f2e1974159$export$2cd8252107eb640b(node, id) {
    var schedule = $c63bf3f2e1974159$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $c63bf3f2e1974159$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $c63bf3f2e1974159$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $c63bf3f2e1974159$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $c63bf3f2e1974159$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $c63bf3f2e1974159$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $c63bf3f2e1974159$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $9c58fce6e008e685$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $c63bf3f2e1974159$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $c63bf3f2e1974159$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $c63bf3f2e1974159$export$fb935ab5849a0db9) return (0, $070e9a4f0e21c528$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $c63bf3f2e1974159$export$1573e22b087389af) {
                o.state = $c63bf3f2e1974159$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $c63bf3f2e1974159$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $070e9a4f0e21c528$export$2e2bcd8739ae039)(function() {
            if (self.state === $c63bf3f2e1974159$export$fb935ab5849a0db9) {
                self.state = $c63bf3f2e1974159$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $c63bf3f2e1974159$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $c63bf3f2e1974159$export$a5d151aee16efd42) return; // interrupted
        self.state = $c63bf3f2e1974159$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $c63bf3f2e1974159$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $c63bf3f2e1974159$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $c63bf3f2e1974159$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $688fa9c8100803a6$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $c63bf3f2e1974159$export$a5d151aee16efd42) && schedule.state < (0, $c63bf3f2e1974159$export$a2e792214ded83b2);
        schedule.state = (0, $c63bf3f2e1974159$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $2058d88cc79b624a$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $688fa9c8100803a6$export$2e2bcd8739ae039)(this, name);
    });
}




var $83f23c13ff257568$var$degrees = 180 / Math.PI;
var $83f23c13ff257568$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $83f23c13ff257568$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $83f23c13ff257568$var$degrees,
        skewX: Math.atan(skewX) * $83f23c13ff257568$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $086e916772beebe4$var$svgNode;
function $086e916772beebe4$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $83f23c13ff257568$export$f0954fd7d5368655) : (0, $83f23c13ff257568$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $086e916772beebe4$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $83f23c13ff257568$export$f0954fd7d5368655;
    if (!$086e916772beebe4$var$svgNode) $086e916772beebe4$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $086e916772beebe4$var$svgNode.setAttribute("transform", value);
    if (!(value = $086e916772beebe4$var$svgNode.transform.baseVal.consolidate())) return 0, $83f23c13ff257568$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $83f23c13ff257568$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $babc24069484a6a3$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b64d332320181a08$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $babc24069484a6a3$export$56bec7123bb3589a = $babc24069484a6a3$var$interpolateTransform((0, $086e916772beebe4$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $babc24069484a6a3$export$da8cba906d64c082 = $babc24069484a6a3$var$interpolateTransform((0, $086e916772beebe4$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $58f0dd526e595752$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $58f0dd526e595752$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $58f0dd526e595752$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $58f0dd526e595752$var$tweenRemove : $58f0dd526e595752$var$tweenFunction)(id, name, value));
}
function $58f0dd526e595752$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $lDve0 = parcelRequire("lDve0");

function $14e5c1edd05520a0$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $b64d332320181a08$export$2e2bcd8739ae039) : b instanceof (0, $lDve0.default) ? (0, $4efcfc37f0c760c0$export$2e2bcd8739ae039) : (c = (0, $lDve0.default)(b)) ? (b = c, $4efcfc37f0c760c0$export$2e2bcd8739ae039) : (0, $6425152590f6a238$export$2e2bcd8739ae039))(a, b);
}


function $d163bf54e83fcce0$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $d163bf54e83fcce0$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $d163bf54e83fcce0$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d163bf54e83fcce0$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d163bf54e83fcce0$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d163bf54e83fcce0$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d163bf54e83fcce0$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $5361d4c7390d69ee$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $babc24069484a6a3$export$da8cba906d64c082) : (0, $14e5c1edd05520a0$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $d163bf54e83fcce0$var$attrFunctionNS : $d163bf54e83fcce0$var$attrFunction)(fullname, i, (0, $58f0dd526e595752$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $d163bf54e83fcce0$var$attrRemoveNS : $d163bf54e83fcce0$var$attrRemove)(fullname) : (fullname.local ? $d163bf54e83fcce0$var$attrConstantNS : $d163bf54e83fcce0$var$attrConstant)(fullname, i, value));
}



function $0062c8c4fe5cb8b1$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $0062c8c4fe5cb8b1$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $0062c8c4fe5cb8b1$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $0062c8c4fe5cb8b1$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $0062c8c4fe5cb8b1$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $0062c8c4fe5cb8b1$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $0062c8c4fe5cb8b1$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $5361d4c7390d69ee$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $0062c8c4fe5cb8b1$var$attrTweenNS : $0062c8c4fe5cb8b1$var$attrTween)(fullname, value));
}



function $c909af1d4fa88d9d$var$delayFunction(id, value) {
    return function() {
        (0, $c63bf3f2e1974159$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $c909af1d4fa88d9d$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $c63bf3f2e1974159$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $c909af1d4fa88d9d$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $c909af1d4fa88d9d$var$delayFunction : $c909af1d4fa88d9d$var$delayConstant)(id, value)) : (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $1e45693456014950$var$durationFunction(id, value) {
    return function() {
        (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $1e45693456014950$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $1e45693456014950$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $1e45693456014950$var$durationFunction : $1e45693456014950$var$durationConstant)(id, value)) : (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $3a06c99d4b0d7611$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $3a06c99d4b0d7611$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($3a06c99d4b0d7611$var$easeConstant(id, value)) : (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $c0d66f393b6f1840$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $c0d66f393b6f1840$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($c0d66f393b6f1840$var$easeVarying(this._id, value));
}




function $e706a90650ffa1b9$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $98ead6b7044d2c9b$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $1e7e527b952a4990$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $7726cabfead4764e$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $1e7e527b952a4990$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $d7f2e95393eb7613$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $d7f2e95393eb7613$var$onFunction(id, name, listener) {
    var on0, on1, sit = $d7f2e95393eb7613$var$start(name) ? (0, $c63bf3f2e1974159$export$2cd8252107eb640b) : (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $d7f2e95393eb7613$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($d7f2e95393eb7613$var$onFunction(id, name, listener));
}


function $30523956498d568b$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $30523956498d568b$export$2e2bcd8739ae039() {
    return this.on("end.remove", $30523956498d568b$var$removeFunction(this._id));
}





function $44858dcabf2e2c6d$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $dfd5f4da69e6fc89$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $c63bf3f2e1974159$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $1e7e527b952a4990$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $850829062e762e71$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $4edfa6f7c70b9ae4$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $c63bf3f2e1974159$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $1e7e527b952a4990$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $e5322b7717d708fa$var$Selection = (0, $30b99eabd4635d88$export$2e2bcd8739ae039).prototype.constructor;
function $e5322b7717d708fa$export$2e2bcd8739ae039() {
    return new $e5322b7717d708fa$var$Selection(this._groups, this._parents);
}







function $2c82856d533d5bf5$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $3ee26f6a7e3758bf$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $3ee26f6a7e3758bf$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $2c82856d533d5bf5$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $2c82856d533d5bf5$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $3ee26f6a7e3758bf$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2c82856d533d5bf5$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $3ee26f6a7e3758bf$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $3ee26f6a7e3758bf$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2c82856d533d5bf5$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $2c82856d533d5bf5$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $2c82856d533d5bf5$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $babc24069484a6a3$export$56bec7123bb3589a) : (0, $14e5c1edd05520a0$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $2c82856d533d5bf5$var$styleNull(name, i)).on("end.style." + name, $2c82856d533d5bf5$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $2c82856d533d5bf5$var$styleFunction(name, i, (0, $58f0dd526e595752$export$f78ce6ab10405d82)(this, "style." + name, value))).each($2c82856d533d5bf5$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $2c82856d533d5bf5$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $abfb9b0994023c04$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $abfb9b0994023c04$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $abfb9b0994023c04$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $abfb9b0994023c04$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $abfb9b0994023c04$var$styleTween(name, value, priority == null ? "" : priority));
}



function $a379ad37251fdf6f$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $a379ad37251fdf6f$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $a379ad37251fdf6f$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $a379ad37251fdf6f$var$textFunction((0, $58f0dd526e595752$export$f78ce6ab10405d82)(this, "text", value)) : $a379ad37251fdf6f$var$textConstant(value == null ? "" : value + ""));
}


function $4ca4d9db873967cf$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $4ca4d9db873967cf$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $4ca4d9db873967cf$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $4ca4d9db873967cf$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $4ca4d9db873967cf$var$textTween(value));
}




function $00757afb7f289ba6$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $1e7e527b952a4990$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $c63bf3f2e1974159$export$3988ae62b71be9a3)(node, id0);
            (0, $c63bf3f2e1974159$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $1e7e527b952a4990$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $f09cb5572a77e31d$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $c63bf3f2e1974159$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $1e7e527b952a4990$var$id = 0;
function $1e7e527b952a4990$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $1e7e527b952a4990$export$2e2bcd8739ae039(name) {
    return (0, $30b99eabd4635d88$export$2e2bcd8739ae039)().transition(name);
}
function $1e7e527b952a4990$export$9ffd10a3fbdc175b() {
    return ++$1e7e527b952a4990$var$id;
}
var $1e7e527b952a4990$var$selection_prototype = (0, $30b99eabd4635d88$export$2e2bcd8739ae039).prototype;
$1e7e527b952a4990$export$be58926105124dd4.prototype = $1e7e527b952a4990$export$2e2bcd8739ae039.prototype = {
    constructor: $1e7e527b952a4990$export$be58926105124dd4,
    select: (0, $44858dcabf2e2c6d$export$2e2bcd8739ae039),
    selectAll: (0, $850829062e762e71$export$2e2bcd8739ae039),
    filter: (0, $e706a90650ffa1b9$export$2e2bcd8739ae039),
    merge: (0, $7726cabfead4764e$export$2e2bcd8739ae039),
    selection: (0, $e5322b7717d708fa$export$2e2bcd8739ae039),
    transition: (0, $00757afb7f289ba6$export$2e2bcd8739ae039),
    call: $1e7e527b952a4990$var$selection_prototype.call,
    nodes: $1e7e527b952a4990$var$selection_prototype.nodes,
    node: $1e7e527b952a4990$var$selection_prototype.node,
    size: $1e7e527b952a4990$var$selection_prototype.size,
    empty: $1e7e527b952a4990$var$selection_prototype.empty,
    each: $1e7e527b952a4990$var$selection_prototype.each,
    on: (0, $d7f2e95393eb7613$export$2e2bcd8739ae039),
    attr: (0, $d163bf54e83fcce0$export$2e2bcd8739ae039),
    attrTween: (0, $0062c8c4fe5cb8b1$export$2e2bcd8739ae039),
    style: (0, $2c82856d533d5bf5$export$2e2bcd8739ae039),
    styleTween: (0, $abfb9b0994023c04$export$2e2bcd8739ae039),
    text: (0, $a379ad37251fdf6f$export$2e2bcd8739ae039),
    textTween: (0, $4ca4d9db873967cf$export$2e2bcd8739ae039),
    remove: (0, $30523956498d568b$export$2e2bcd8739ae039),
    tween: (0, $58f0dd526e595752$export$2e2bcd8739ae039),
    delay: (0, $c909af1d4fa88d9d$export$2e2bcd8739ae039),
    duration: (0, $1e45693456014950$export$2e2bcd8739ae039),
    ease: (0, $3a06c99d4b0d7611$export$2e2bcd8739ae039),
    easeVarying: (0, $c0d66f393b6f1840$export$2e2bcd8739ae039),
    end: (0, $f09cb5572a77e31d$export$2e2bcd8739ae039),
    [Symbol.iterator]: $1e7e527b952a4990$var$selection_prototype[Symbol.iterator]
};



function $15fd710f7785072c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $15fd710f7785072c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $15fd710f7785072c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $9eb579e91972b679$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $15fd710f7785072c$export$89238d3bc79d3ada)
};
function $9eb579e91972b679$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $9eb579e91972b679$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $1e7e527b952a4990$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $1e7e527b952a4990$export$9ffd10a3fbdc175b)(), (timing = $9eb579e91972b679$var$defaultTiming).time = (0, $9c58fce6e008e685$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $c63bf3f2e1974159$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $9eb579e91972b679$var$inherit(node, id));
    }
    return new (0, $1e7e527b952a4990$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $30b99eabd4635d88$export$2e2bcd8739ae039).prototype.interrupt = (0, $2058d88cc79b624a$export$2e2bcd8739ae039);
(0, $30b99eabd4635d88$export$2e2bcd8739ae039).prototype.transition = (0, $9eb579e91972b679$export$2e2bcd8739ae039);





var $f334b4590ec2d151$var$root = [
    null
];
function $f334b4590ec2d151$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $c63bf3f2e1974159$export$584530fe98d14a84) && schedule.name === name) return new (0, $1e7e527b952a4990$export$be58926105124dd4)([
                [
                    node
                ]
            ], $f334b4590ec2d151$var$root, name, +i);
        }
    }
    return null;
}





var $3a6cd97bee25a717$export$2e2bcd8739ae039 = (x)=>()=>x;


function $aafd72c9ab0e61ee$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $4cdf8953c8533902$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $4cdf8953c8533902$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $e0117cd89c43313a$var$MODE_DRAG = {
    name: "drag"
}, $e0117cd89c43313a$var$MODE_SPACE = {
    name: "space"
}, $e0117cd89c43313a$var$MODE_HANDLE = {
    name: "handle"
}, $e0117cd89c43313a$var$MODE_CENTER = {
    name: "center"
};
const { abs: $e0117cd89c43313a$var$abs, max: $e0117cd89c43313a$var$max, min: $e0117cd89c43313a$var$min } = Math;
function $e0117cd89c43313a$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $e0117cd89c43313a$var$number2(e) {
    return [
        $e0117cd89c43313a$var$number1(e[0]),
        $e0117cd89c43313a$var$number1(e[1])
    ];
}
var $e0117cd89c43313a$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($e0117cd89c43313a$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $e0117cd89c43313a$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($e0117cd89c43313a$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $e0117cd89c43313a$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($e0117cd89c43313a$var$type),
    input: function(xy) {
        return xy == null ? null : $e0117cd89c43313a$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $e0117cd89c43313a$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $e0117cd89c43313a$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $e0117cd89c43313a$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $e0117cd89c43313a$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $e0117cd89c43313a$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $e0117cd89c43313a$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $e0117cd89c43313a$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $e0117cd89c43313a$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $e0117cd89c43313a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $e0117cd89c43313a$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $e0117cd89c43313a$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $e0117cd89c43313a$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $e0117cd89c43313a$export$979ace6c88860aa8() {
    return $e0117cd89c43313a$var$brush($e0117cd89c43313a$var$X);
}
function $e0117cd89c43313a$export$468748b530991c54() {
    return $e0117cd89c43313a$var$brush($e0117cd89c43313a$var$Y);
}
function $e0117cd89c43313a$export$2e2bcd8739ae039() {
    return $e0117cd89c43313a$var$brush($e0117cd89c43313a$var$XY);
}
function $e0117cd89c43313a$var$brush(dim) {
    var extent = $e0117cd89c43313a$var$defaultExtent, filter = $e0117cd89c43313a$var$defaultFilter, touchable = $e0117cd89c43313a$var$defaultTouchable, keys = true, listeners = (0, $41d77768dbc6b7a5$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $e0117cd89c43313a$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $e0117cd89c43313a$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $e0117cd89c43313a$var$local(this).extent;
            (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $e0117cd89c43313a$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $e0117cd89c43313a$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $e0117cd89c43313a$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $688fa9c8100803a6$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this), selection = $e0117cd89c43313a$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $aafd72c9ab0e61ee$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $e0117cd89c43313a$var$MODE_DRAG : keys && event.altKey ? $e0117cd89c43313a$var$MODE_CENTER : $e0117cd89c43313a$var$MODE_HANDLE, signX = dim === $e0117cd89c43313a$var$Y ? null : $e0117cd89c43313a$var$signsX[type], signY = dim === $e0117cd89c43313a$var$X ? null : $e0117cd89c43313a$var$signsY[type], state = $e0117cd89c43313a$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $e0117cd89c43313a$var$Y ? W : $e0117cd89c43313a$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $e0117cd89c43313a$var$X ? N : $e0117cd89c43313a$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $e0117cd89c43313a$var$Y ? E : $e0117cd89c43313a$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $e0117cd89c43313a$var$X ? S : $e0117cd89c43313a$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move();
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $e0117cd89c43313a$var$cursors[type]);
        (0, $688fa9c8100803a6$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $9fc1ee0544073e59$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($e0117cd89c43313a$var$abs(point.cur[0] - point[0]) > $e0117cd89c43313a$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $4cdf8953c8533902$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $e0117cd89c43313a$var$MODE_SPACE:
                case $e0117cd89c43313a$var$MODE_DRAG:
                    if (signX) dx = $e0117cd89c43313a$var$max(W - w0, $e0117cd89c43313a$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $e0117cd89c43313a$var$max(N - n0, $e0117cd89c43313a$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $e0117cd89c43313a$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $e0117cd89c43313a$var$max(W, $e0117cd89c43313a$var$min(E, points[0][0])), e1 = $e0117cd89c43313a$var$max(W, $e0117cd89c43313a$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $e0117cd89c43313a$var$max(N, $e0117cd89c43313a$var$min(S, points[0][1])), s1 = $e0117cd89c43313a$var$max(N, $e0117cd89c43313a$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $e0117cd89c43313a$var$max(W - w0, $e0117cd89c43313a$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $e0117cd89c43313a$var$max(W - e0, $e0117cd89c43313a$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $e0117cd89c43313a$var$max(N - n0, $e0117cd89c43313a$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $e0117cd89c43313a$var$max(N - s0, $e0117cd89c43313a$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $e0117cd89c43313a$var$MODE_CENTER:
                    if (signX) w1 = $e0117cd89c43313a$var$max(W, $e0117cd89c43313a$var$min(E, w0 - dx * signX)), e1 = $e0117cd89c43313a$var$max(W, $e0117cd89c43313a$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $e0117cd89c43313a$var$max(N, $e0117cd89c43313a$var$min(S, n0 - dy * signY)), s1 = $e0117cd89c43313a$var$max(N, $e0117cd89c43313a$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $e0117cd89c43313a$var$flipX) overlay.attr("cursor", $e0117cd89c43313a$var$cursors[type = $e0117cd89c43313a$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $e0117cd89c43313a$var$flipY) overlay.attr("cursor", $e0117cd89c43313a$var$cursors[type = $e0117cd89c43313a$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $4cdf8953c8533902$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $9fc1ee0544073e59$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $e0117cd89c43313a$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($e0117cd89c43313a$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $e0117cd89c43313a$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $e0117cd89c43313a$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $e0117cd89c43313a$var$MODE_HANDLE || mode === $e0117cd89c43313a$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $e0117cd89c43313a$var$MODE_SPACE;
                        overlay.attr("cursor", $e0117cd89c43313a$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $4cdf8953c8533902$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $e0117cd89c43313a$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $e0117cd89c43313a$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $e0117cd89c43313a$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $e0117cd89c43313a$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $e0117cd89c43313a$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $e0117cd89c43313a$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $4cdf8953c8533902$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $e0117cd89c43313a$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $3a6cd97bee25a717$export$2e2bcd8739ae039)($e0117cd89c43313a$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $3a6cd97bee25a717$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $3a6cd97bee25a717$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}




var $828b7d4df36becc4$exports = {};

$parcel$export($828b7d4df36becc4$exports, "chord", function () { return $bc69f0c88f767c4c$export$2e2bcd8739ae039; });
$parcel$export($828b7d4df36becc4$exports, "chordTranspose", function () { return $bc69f0c88f767c4c$export$ccf0fb804feeadb0; });
$parcel$export($828b7d4df36becc4$exports, "chordDirected", function () { return $bc69f0c88f767c4c$export$66e653ba9a7a4d8c; });
$parcel$export($828b7d4df36becc4$exports, "ribbon", function () { return $3951361a7ca0581b$export$2e2bcd8739ae039; });
$parcel$export($828b7d4df36becc4$exports, "ribbonArrow", function () { return $3951361a7ca0581b$export$63f6c8bb9e816a34; });
var $c2ed6df8f9472dda$export$2335f513bbd82c6d = Math.abs;
var $c2ed6df8f9472dda$export$50d414a77b60d802 = Math.cos;
var $c2ed6df8f9472dda$export$5de3937cb4b592ed = Math.sin;
var $c2ed6df8f9472dda$export$18c7bea995a110f = Math.PI;
var $c2ed6df8f9472dda$export$e51408a300e8929a = $c2ed6df8f9472dda$export$18c7bea995a110f / 2;
var $c2ed6df8f9472dda$export$a4b4b4d4d776fe92 = $c2ed6df8f9472dda$export$18c7bea995a110f * 2;
var $c2ed6df8f9472dda$export$8960430cfd85939f = Math.max;
var $c2ed6df8f9472dda$export$6c421550c66a327d = 1e-12;


function $bc69f0c88f767c4c$var$range(i, j) {
    return Array.from({
        length: j - i
    }, (_, k)=>i + k);
}
function $bc69f0c88f767c4c$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $bc69f0c88f767c4c$export$2e2bcd8739ae039() {
    return $bc69f0c88f767c4c$var$chord(false, false);
}
function $bc69f0c88f767c4c$export$ccf0fb804feeadb0() {
    return $bc69f0c88f767c4c$var$chord(false, true);
}
function $bc69f0c88f767c4c$export$66e653ba9a7a4d8c() {
    return $bc69f0c88f767c4c$var$chord(true, false);
}
function $bc69f0c88f767c4c$var$chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = $bc69f0c88f767c4c$var$range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({
            length: n * n
        }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
        // Compute the scaling factor from value to angle in [0, 2pi].
        for(let i = 0; i < n; ++i){
            let x = 0;
            for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = (0, $c2ed6df8f9472dda$export$8960430cfd85939f)(0, (0, $c2ed6df8f9472dda$export$a4b4b4d4d776fe92) - padAngle * n) / k;
        dx = k ? padAngle : (0, $c2ed6df8f9472dda$export$a4b4b4d4d776fe92) / n;
        // Compute the angles for each group and constituent chord.
        {
            let x = 0;
            if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
            for (const i of groupIndex){
                const x0 = x;
                if (directed) {
                    const subgroupIndex = $bc69f0c88f767c4c$var$range(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                    for (const j of subgroupIndex)if (j < 0) {
                        const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                            source: null,
                            target: null
                        });
                        chord.target = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[~j * n + i] * k,
                            value: matrix[~j * n + i]
                        };
                    } else {
                        const chord = chords[i * n + j] || (chords[i * n + j] = {
                            source: null,
                            target: null
                        });
                        chord.source = {
                            index: i,
                            startAngle: x,
                            endAngle: x += matrix[i * n + j] * k,
                            value: matrix[i * n + j]
                        };
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                } else {
                    const subgroupIndex = $bc69f0c88f767c4c$var$range(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                    if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                    for (const j of subgroupIndex){
                        let chord;
                        if (i < j) {
                            chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        } else {
                            chord = chords[j * n + i] || (chords[j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                            if (i === j) chord.source = chord.target;
                        }
                        if (chord.source && chord.target && chord.source.value < chord.target.value) {
                            const source = chord.source;
                            chord.source = chord.target;
                            chord.target = source;
                        }
                    }
                    groups[i] = {
                        index: i,
                        startAngle: x0,
                        endAngle: x,
                        value: groupSums[i]
                    };
                }
                x += dx;
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $c2ed6df8f9472dda$export$8960430cfd85939f)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $bc69f0c88f767c4c$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}


const $a56e6346ae45e61d$var$pi = Math.PI, $a56e6346ae45e61d$var$tau = 2 * $a56e6346ae45e61d$var$pi, $a56e6346ae45e61d$var$epsilon = 1e-6, $a56e6346ae45e61d$var$tauEpsilon = $a56e6346ae45e61d$var$tau - $a56e6346ae45e61d$var$epsilon;
function $a56e6346ae45e61d$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $a56e6346ae45e61d$var$path() {
    return new $a56e6346ae45e61d$var$Path;
}
$a56e6346ae45e61d$var$Path.prototype = $a56e6346ae45e61d$var$path.prototype = {
    constructor: $a56e6346ae45e61d$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $a56e6346ae45e61d$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $a56e6346ae45e61d$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($a56e6346ae45e61d$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $a56e6346ae45e61d$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $a56e6346ae45e61d$var$epsilon || Math.abs(this._y1 - y0) > $a56e6346ae45e61d$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $a56e6346ae45e61d$var$tau + $a56e6346ae45e61d$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $a56e6346ae45e61d$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $a56e6346ae45e61d$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $a56e6346ae45e61d$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $a56e6346ae45e61d$export$2e2bcd8739ae039 = $a56e6346ae45e61d$var$path;


var $240ee9f1f10e62ca$export$58adb3bec8346d0f = Array.prototype.slice;


function $a86dfd87267c8552$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $3951361a7ca0581b$var$defaultSource(d) {
    return d.source;
}
function $3951361a7ca0581b$var$defaultTarget(d) {
    return d.target;
}
function $3951361a7ca0581b$var$defaultRadius(d) {
    return d.radius;
}
function $3951361a7ca0581b$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $3951361a7ca0581b$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $3951361a7ca0581b$var$defaultPadAngle() {
    return 0;
}
function $3951361a7ca0581b$var$defaultArrowheadRadius() {
    return 10;
}
function $3951361a7ca0581b$var$ribbon(headRadius) {
    var source = $3951361a7ca0581b$var$defaultSource, target = $3951361a7ca0581b$var$defaultTarget, sourceRadius = $3951361a7ca0581b$var$defaultRadius, targetRadius = $3951361a7ca0581b$var$defaultRadius, startAngle = $3951361a7ca0581b$var$defaultStartAngle, endAngle = $3951361a7ca0581b$var$defaultEndAngle, padAngle = $3951361a7ca0581b$var$defaultPadAngle, context = null;
    function ribbon() {
        var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = (0, $240ee9f1f10e62ca$export$58adb3bec8346d0f).call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $c2ed6df8f9472dda$export$e51408a300e8929a), sa1 = endAngle.apply(this, argv) - (0, $c2ed6df8f9472dda$export$e51408a300e8929a), tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $c2ed6df8f9472dda$export$e51408a300e8929a), ta1 = endAngle.apply(this, argv) - (0, $c2ed6df8f9472dda$export$e51408a300e8929a);
        if (!context) context = buffer = (0, $a56e6346ae45e61d$export$2e2bcd8739ae039)();
        if (ap > (0, $c2ed6df8f9472dda$export$6c421550c66a327d)) {
            if ((0, $c2ed6df8f9472dda$export$2335f513bbd82c6d)(sa1 - sa0) > ap * 2 + (0, $c2ed6df8f9472dda$export$6c421550c66a327d)) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
            else sa0 = sa1 = (sa0 + sa1) / 2;
            if ((0, $c2ed6df8f9472dda$export$2335f513bbd82c6d)(ta1 - ta0) > ap * 2 + (0, $c2ed6df8f9472dda$export$6c421550c66a327d)) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
            else ta0 = ta1 = (ta0 + ta1) / 2;
        }
        context.moveTo(sr * (0, $c2ed6df8f9472dda$export$50d414a77b60d802)(sa0), sr * (0, $c2ed6df8f9472dda$export$5de3937cb4b592ed)(sa0));
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            if (headRadius) {
                var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                context.quadraticCurveTo(0, 0, tr2 * (0, $c2ed6df8f9472dda$export$50d414a77b60d802)(ta0), tr2 * (0, $c2ed6df8f9472dda$export$5de3937cb4b592ed)(ta0));
                context.lineTo(tr * (0, $c2ed6df8f9472dda$export$50d414a77b60d802)(ta2), tr * (0, $c2ed6df8f9472dda$export$5de3937cb4b592ed)(ta2));
                context.lineTo(tr2 * (0, $c2ed6df8f9472dda$export$50d414a77b60d802)(ta1), tr2 * (0, $c2ed6df8f9472dda$export$5de3937cb4b592ed)(ta1));
            } else {
                context.quadraticCurveTo(0, 0, tr * (0, $c2ed6df8f9472dda$export$50d414a77b60d802)(ta0), tr * (0, $c2ed6df8f9472dda$export$5de3937cb4b592ed)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
        }
        context.quadraticCurveTo(0, 0, sr * (0, $c2ed6df8f9472dda$export$50d414a77b60d802)(sa0), sr * (0, $c2ed6df8f9472dda$export$5de3937cb4b592ed)(sa0));
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    if (headRadius) ribbon.headRadius = function(_) {
        return arguments.length ? (headRadius = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : headRadius;
    };
    ribbon.radius = function(_) {
        return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : sourceRadius;
    };
    ribbon.sourceRadius = function(_) {
        return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : sourceRadius;
    };
    ribbon.targetRadius = function(_) {
        return arguments.length ? (targetRadius = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : targetRadius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : endAngle;
    };
    ribbon.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $a86dfd87267c8552$export$2e2bcd8739ae039)(+_), ribbon) : padAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}
function $3951361a7ca0581b$export$2e2bcd8739ae039() {
    return $3951361a7ca0581b$var$ribbon();
}
function $3951361a7ca0581b$export$63f6c8bb9e816a34() {
    return $3951361a7ca0581b$var$ribbon($3951361a7ca0581b$var$defaultArrowheadRadius);
}




var $b22cf5597f86a3f8$exports = {};

$parcel$export($b22cf5597f86a3f8$exports, "color", function () { return (parcelRequire("lDve0")).default; });
$parcel$export($b22cf5597f86a3f8$exports, "rgb", function () { return (parcelRequire("lDve0")).rgb; });
$parcel$export($b22cf5597f86a3f8$exports, "hsl", function () { return (parcelRequire("lDve0")).hsl; });
$parcel$export($b22cf5597f86a3f8$exports, "lab", function () { return $3ba1f60a5b08d697$export$2e2bcd8739ae039; });
$parcel$export($b22cf5597f86a3f8$exports, "hcl", function () { return $3ba1f60a5b08d697$export$d0e870ba50062ff1; });
$parcel$export($b22cf5597f86a3f8$exports, "lch", function () { return $3ba1f60a5b08d697$export$5a21418738164530; });
$parcel$export($b22cf5597f86a3f8$exports, "gray", function () { return $3ba1f60a5b08d697$export$3e2c219d3ab79d01; });
$parcel$export($b22cf5597f86a3f8$exports, "cubehelix", function () { return $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039; });

var $lDve0 = parcelRequire("lDve0");

var $7ouFS = parcelRequire("7ouFS");

var $lDve0 = parcelRequire("lDve0");
const $341e81175beb7548$export$8449e153fbd325fc = Math.PI / 180;
const $341e81175beb7548$export$41fc368e1a942b97 = 180 / Math.PI;


// https://observablehq.com/@mbostock/lab-and-rgb
const $3ba1f60a5b08d697$var$K = 18, $3ba1f60a5b08d697$var$Xn = 0.96422, $3ba1f60a5b08d697$var$Yn = 1, $3ba1f60a5b08d697$var$Zn = 0.82521, $3ba1f60a5b08d697$var$t0 = 4 / 29, $3ba1f60a5b08d697$var$t1 = 6 / 29, $3ba1f60a5b08d697$var$t2 = 3 * $3ba1f60a5b08d697$var$t1 * $3ba1f60a5b08d697$var$t1, $3ba1f60a5b08d697$var$t3 = $3ba1f60a5b08d697$var$t1 * $3ba1f60a5b08d697$var$t1 * $3ba1f60a5b08d697$var$t1;
function $3ba1f60a5b08d697$var$labConvert(o) {
    if (o instanceof $3ba1f60a5b08d697$export$f2722c70a60257f7) return new $3ba1f60a5b08d697$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $3ba1f60a5b08d697$export$d9397e094a5fbb9a) return $3ba1f60a5b08d697$var$hcl2lab(o);
    if (!(o instanceof (0, $lDve0.Rgb))) o = (0, $lDve0.rgbConvert)(o);
    var r = $3ba1f60a5b08d697$var$rgb2lrgb(o.r), g = $3ba1f60a5b08d697$var$rgb2lrgb(o.g), b = $3ba1f60a5b08d697$var$rgb2lrgb(o.b), y = $3ba1f60a5b08d697$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $3ba1f60a5b08d697$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $3ba1f60a5b08d697$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $3ba1f60a5b08d697$var$Xn);
        z = $3ba1f60a5b08d697$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $3ba1f60a5b08d697$var$Zn);
    }
    return new $3ba1f60a5b08d697$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $3ba1f60a5b08d697$export$3e2c219d3ab79d01(l, opacity) {
    return new $3ba1f60a5b08d697$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $3ba1f60a5b08d697$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $3ba1f60a5b08d697$var$labConvert(l) : new $3ba1f60a5b08d697$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $3ba1f60a5b08d697$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $7ouFS.default)($3ba1f60a5b08d697$export$f2722c70a60257f7, $3ba1f60a5b08d697$export$2e2bcd8739ae039, (0, $7ouFS.extend)((0, $lDve0.Color), {
    brighter: function(k) {
        return new $3ba1f60a5b08d697$export$f2722c70a60257f7(this.l + $3ba1f60a5b08d697$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $3ba1f60a5b08d697$export$f2722c70a60257f7(this.l - $3ba1f60a5b08d697$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $3ba1f60a5b08d697$var$Xn * $3ba1f60a5b08d697$var$lab2xyz(x);
        y = $3ba1f60a5b08d697$var$Yn * $3ba1f60a5b08d697$var$lab2xyz(y);
        z = $3ba1f60a5b08d697$var$Zn * $3ba1f60a5b08d697$var$lab2xyz(z);
        return new (0, $lDve0.Rgb)($3ba1f60a5b08d697$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $3ba1f60a5b08d697$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $3ba1f60a5b08d697$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $3ba1f60a5b08d697$var$xyz2lab(t) {
    return t > $3ba1f60a5b08d697$var$t3 ? Math.pow(t, 1 / 3) : t / $3ba1f60a5b08d697$var$t2 + $3ba1f60a5b08d697$var$t0;
}
function $3ba1f60a5b08d697$var$lab2xyz(t) {
    return t > $3ba1f60a5b08d697$var$t1 ? t * t * t : $3ba1f60a5b08d697$var$t2 * (t - $3ba1f60a5b08d697$var$t0);
}
function $3ba1f60a5b08d697$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $3ba1f60a5b08d697$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $3ba1f60a5b08d697$var$hclConvert(o) {
    if (o instanceof $3ba1f60a5b08d697$export$d9397e094a5fbb9a) return new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $3ba1f60a5b08d697$export$f2722c70a60257f7)) o = $3ba1f60a5b08d697$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $341e81175beb7548$export$41fc368e1a942b97);
    return new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $3ba1f60a5b08d697$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $3ba1f60a5b08d697$var$hclConvert(l) : new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $3ba1f60a5b08d697$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $3ba1f60a5b08d697$var$hclConvert(h) : new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $3ba1f60a5b08d697$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $3ba1f60a5b08d697$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $3ba1f60a5b08d697$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $341e81175beb7548$export$8449e153fbd325fc);
    return new $3ba1f60a5b08d697$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $7ouFS.default)($3ba1f60a5b08d697$export$d9397e094a5fbb9a, $3ba1f60a5b08d697$export$d0e870ba50062ff1, (0, $7ouFS.extend)((0, $lDve0.Color), {
    brighter: function(k) {
        return new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(this.h, this.c, this.l + $3ba1f60a5b08d697$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $3ba1f60a5b08d697$export$d9397e094a5fbb9a(this.h, this.c, this.l - $3ba1f60a5b08d697$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $3ba1f60a5b08d697$var$hcl2lab(this).rgb();
    }
}));



var $7ouFS = parcelRequire("7ouFS");

var $lDve0 = parcelRequire("lDve0");

var $b6a1d8d4ad5ffe11$var$A = -0.14861, $b6a1d8d4ad5ffe11$var$B = 1.78277, $b6a1d8d4ad5ffe11$var$C = -0.29227, $b6a1d8d4ad5ffe11$var$D = -0.90649, $b6a1d8d4ad5ffe11$var$E = 1.97294, $b6a1d8d4ad5ffe11$var$ED = $b6a1d8d4ad5ffe11$var$E * $b6a1d8d4ad5ffe11$var$D, $b6a1d8d4ad5ffe11$var$EB = $b6a1d8d4ad5ffe11$var$E * $b6a1d8d4ad5ffe11$var$B, $b6a1d8d4ad5ffe11$var$BC_DA = $b6a1d8d4ad5ffe11$var$B * $b6a1d8d4ad5ffe11$var$C - $b6a1d8d4ad5ffe11$var$D * $b6a1d8d4ad5ffe11$var$A;
function $b6a1d8d4ad5ffe11$var$cubehelixConvert(o) {
    if (o instanceof $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2) return new $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $lDve0.Rgb))) o = (0, $lDve0.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($b6a1d8d4ad5ffe11$var$BC_DA * b + $b6a1d8d4ad5ffe11$var$ED * r - $b6a1d8d4ad5ffe11$var$EB * g) / ($b6a1d8d4ad5ffe11$var$BC_DA + $b6a1d8d4ad5ffe11$var$ED - $b6a1d8d4ad5ffe11$var$EB), bl = b - l, k = ($b6a1d8d4ad5ffe11$var$E * (g - l) - $b6a1d8d4ad5ffe11$var$C * bl) / $b6a1d8d4ad5ffe11$var$D, s = Math.sqrt(k * k + bl * bl) / ($b6a1d8d4ad5ffe11$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $341e81175beb7548$export$41fc368e1a942b97) - 120 : NaN;
    return new $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $b6a1d8d4ad5ffe11$var$cubehelixConvert(h) : new $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $7ouFS.default)($b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039, (0, $7ouFS.extend)((0, $lDve0.Color), {
    brighter: function(k) {
        k = k == null ? (0, $lDve0.brighter) : Math.pow((0, $lDve0.brighter), k);
        return new $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $lDve0.darker) : Math.pow((0, $lDve0.darker), k);
        return new $b6a1d8d4ad5ffe11$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $341e81175beb7548$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $lDve0.Rgb)(255 * (l + a * ($b6a1d8d4ad5ffe11$var$A * cosh + $b6a1d8d4ad5ffe11$var$B * sinh)), 255 * (l + a * ($b6a1d8d4ad5ffe11$var$C * cosh + $b6a1d8d4ad5ffe11$var$D * sinh)), 255 * (l + a * ($b6a1d8d4ad5ffe11$var$E * cosh)), this.opacity);
    }
}));




var $72b642dff39391d8$exports = {};

$parcel$export($72b642dff39391d8$exports, "contours", function () { return $b71fe5a1bf868fc7$export$2e2bcd8739ae039; });
$parcel$export($72b642dff39391d8$exports, "contourDensity", function () { return $c8fb869b0ce27252$export$2e2bcd8739ae039; });

var $0b995a7046bf1afa$var$array = Array.prototype;
var $0b995a7046bf1afa$export$58adb3bec8346d0f = $0b995a7046bf1afa$var$array.slice;


function $a5421fad9a15ad33$export$2e2bcd8739ae039(a, b) {
    return a - b;
}


function $20ff7c5e754f46d9$export$2e2bcd8739ae039(ring) {
    var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
    while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
    return area;
}


var $0b26de0443f8c2ed$export$2e2bcd8739ae039 = (x)=>()=>x;


function $2512145f6b54126b$export$2e2bcd8739ae039(ring, hole) {
    var i = -1, n = hole.length, c;
    while(++i < n)if (c = $2512145f6b54126b$var$ringContains(ring, hole[i])) return c;
    return 0;
}
function $2512145f6b54126b$var$ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if ($2512145f6b54126b$var$segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function $2512145f6b54126b$var$segmentContains(a, b, c) {
    var i;
    return $2512145f6b54126b$var$collinear(a, b, c) && $2512145f6b54126b$var$within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function $2512145f6b54126b$var$collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function $2512145f6b54126b$var$within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}


function $2ac77a0761f5b0a6$export$2e2bcd8739ae039() {}


var $b71fe5a1bf868fc7$var$cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];
function $b71fe5a1bf868fc7$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, threshold = (0, $90bcb739cf9d355b$export$2e2bcd8739ae039), smooth = smoothLinear;
    function contours(values) {
        var tz = threshold(values);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var domain = (0, $a44db36a0002e759$export$2e2bcd8739ae039)(values), start = domain[0], stop = domain[1];
            tz = (0, $0c0e85ae379d5115$export$81087d9b915d4ede)(start, stop, tz);
            tz = (0, $a9c85d866204d0d0$export$2e2bcd8739ae039)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
        } else tz = tz.slice().sort((0, $a5421fad9a15ad33$export$2e2bcd8739ae039));
        return tz.map(function(value) {
            return contour(values, value);
        });
    }
    // Accumulate, smooth contour rings, assign holes to exterior rings.
    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
    function contour(values, value) {
        var polygons = [], holes = [];
        isorings(values, value, function(ring) {
            smooth(ring, values, value);
            if ((0, $20ff7c5e754f46d9$export$2e2bcd8739ae039)(ring) > 0) polygons.push([
                ring
            ]);
            else holes.push(ring);
        });
        holes.forEach(function(hole) {
            for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, $2512145f6b54126b$export$2e2bcd8739ae039)((polygon = polygons[i])[0], hole) !== -1) {
                polygon.push(hole);
                return;
            }
        });
        return {
            type: "MultiPolygon",
            value: value,
            coordinates: polygons
        };
    }
    // Marching squares with isolines stitched into rings.
    // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
    function isorings(values, value, callback) {
        var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
        // Special case for the first row (y = -1, t2 = t3 = 0).
        x = y = -1;
        t1 = values[0] >= value;
        $b71fe5a1bf868fc7$var$cases[t1 << 1].forEach(stitch);
        while(++x < dx - 1){
            t0 = t1, t1 = values[x + 1] >= value;
            $b71fe5a1bf868fc7$var$cases[t0 | t1 << 1].forEach(stitch);
        }
        $b71fe5a1bf868fc7$var$cases[t1 << 0].forEach(stitch);
        // General case for the intermediate rows.
        while(++y < dy - 1){
            x = -1;
            t1 = values[y * dx + dx] >= value;
            t2 = values[y * dx] >= value;
            $b71fe5a1bf868fc7$var$cases[t1 << 1 | t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                $b71fe5a1bf868fc7$var$cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
            }
            $b71fe5a1bf868fc7$var$cases[t1 | t2 << 3].forEach(stitch);
        }
        // Special case for the last row (y = dy - 1, t0 = t1 = 0).
        x = -1;
        t2 = values[y * dx] >= value;
        $b71fe5a1bf868fc7$var$cases[t2 << 2].forEach(stitch);
        while(++x < dx - 1){
            t3 = t2, t2 = values[y * dx + x + 1] >= value;
            $b71fe5a1bf868fc7$var$cases[t2 << 2 | t3 << 3].forEach(stitch);
        }
        $b71fe5a1bf868fc7$var$cases[t2 << 3].forEach(stitch);
        function stitch(line) {
            var start = [
                line[0][0] + x,
                line[0][1] + y
            ], end = [
                line[1][0] + x,
                line[1][1] + y
            ], startIndex = index(start), endIndex = index(end), f, g;
            if (f = fragmentByEnd[startIndex]) {
                if (g = fragmentByStart[endIndex]) {
                    delete fragmentByEnd[f.end];
                    delete fragmentByStart[g.start];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                        start: f.start,
                        end: g.end,
                        ring: f.ring.concat(g.ring)
                    };
                } else {
                    delete fragmentByEnd[f.end];
                    f.ring.push(end);
                    fragmentByEnd[f.end = endIndex] = f;
                }
            } else if (f = fragmentByStart[endIndex]) {
                if (g = fragmentByEnd[startIndex]) {
                    delete fragmentByStart[f.start];
                    delete fragmentByEnd[g.end];
                    if (f === g) {
                        f.ring.push(end);
                        callback(f.ring);
                    } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                        start: g.start,
                        end: f.end,
                        ring: g.ring.concat(f.ring)
                    };
                } else {
                    delete fragmentByStart[f.start];
                    f.ring.unshift(start);
                    fragmentByStart[f.start = startIndex] = f;
                }
            } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                start: startIndex,
                end: endIndex,
                ring: [
                    start,
                    end
                ]
            };
        }
    }
    function index(point) {
        return point[0] * 2 + point[1] * (dx + 1) * 4;
    }
    function smoothLinear(ring, values, value) {
        ring.forEach(function(point) {
            var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
            if (x > 0 && x < dx && xt === x) {
                v0 = values[yt * dx + xt - 1];
                point[0] = x + (value - v0) / (v1 - v0) - 0.5;
            }
            if (y > 0 && y < dy && yt === y) {
                v0 = values[(yt - 1) * dx + xt];
                point[1] = y + (value - v0) / (v1 - v0) - 0.5;
            }
        });
    }
    contours.contour = contour;
    contours.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, contours;
    };
    contours.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)((0, $0b995a7046bf1afa$export$58adb3bec8346d0f).call(_)) : (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)(_), contours) : threshold;
    };
    contours.smooth = function(_) {
        return arguments.length ? (smooth = _ ? smoothLinear : (0, $2ac77a0761f5b0a6$export$2e2bcd8739ae039), contours) : smooth === smoothLinear;
    };
    return contours;
}




// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function $b5e120591ad9d763$export$d6b6c69cb5897b44(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function $b5e120591ad9d763$export$96ba1179f8344c4b(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}




function $c8fb869b0ce27252$var$defaultX(d) {
    return d[0];
}
function $c8fb869b0ce27252$var$defaultY(d) {
    return d[1];
}
function $c8fb869b0ce27252$var$defaultWeight() {
    return 1;
}
function $c8fb869b0ce27252$export$2e2bcd8739ae039() {
    var x = $c8fb869b0ce27252$var$defaultX, y = $c8fb869b0ce27252$var$defaultY, weight = $c8fb869b0ce27252$var$defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)(20);
    function density(data) {
        var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
        data.forEach(function(d, i, data) {
            var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
            if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
        });
        // TODO Optimize.
        (0, $b5e120591ad9d763$export$d6b6c69cb5897b44)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $b5e120591ad9d763$export$96ba1179f8344c4b)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $b5e120591ad9d763$export$d6b6c69cb5897b44)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $b5e120591ad9d763$export$96ba1179f8344c4b)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        (0, $b5e120591ad9d763$export$d6b6c69cb5897b44)({
            width: n,
            height: m,
            data: values0
        }, {
            width: n,
            height: m,
            data: values1
        }, r >> k);
        (0, $b5e120591ad9d763$export$96ba1179f8344c4b)({
            width: n,
            height: m,
            data: values1
        }, {
            width: n,
            height: m,
            data: values0
        }, r >> k);
        var tz = threshold(values0);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            var stop = (0, $7eb47354b7ef1ed9$export$2e2bcd8739ae039)(values0);
            tz = (0, $0c0e85ae379d5115$export$81087d9b915d4ede)(0, stop, tz);
            tz = (0, $a9c85d866204d0d0$export$2e2bcd8739ae039)(0, Math.floor(stop / tz) * tz, tz);
            tz.shift();
        }
        return (0, $b71fe5a1bf868fc7$export$2e2bcd8739ae039)().thresholds(tz).size([
            n,
            m
        ])(values0).map(transform);
    }
    function transform(geometry) {
        geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
        geometry.coordinates.forEach(transformPolygon);
        return geometry;
    }
    function transformPolygon(coordinates) {
        coordinates.forEach(transformRing);
    }
    function transformRing(coordinates) {
        coordinates.forEach(transformPoint);
    }
    // TODO Optimize.
    function transformPoint(coordinates) {
        coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
        coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
    }
    function resize() {
        o = r * 3;
        n = dx + o * 2 >> k;
        m = dy + o * 2 >> k;
        return density;
    }
    density.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)(+_), density) : x;
    };
    density.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)(+_), density) : y;
    };
    density.weight = function(_) {
        return arguments.length ? (weight = typeof _ === "function" ? _ : (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)(+_), density) : weight;
    };
    density.size = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        var _0 = +_[0], _1 = +_[1];
        if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
        return dx = _0, dy = _1, resize();
    };
    density.cellSize = function(_) {
        if (!arguments.length) return 1 << k;
        if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
        return k = Math.floor(Math.log(_) / Math.LN2), resize();
    };
    density.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)((0, $0b995a7046bf1afa$export$58adb3bec8346d0f).call(_)) : (0, $0b26de0443f8c2ed$export$2e2bcd8739ae039)(_), density) : threshold;
    };
    density.bandwidth = function(_) {
        if (!arguments.length) return Math.sqrt(r * (r + 1));
        if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
        return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
    };
    return density;
}




var $b3e4fba1facfc225$exports = {};

$parcel$export($b3e4fba1facfc225$exports, "Delaunay", function () { return $c5840e4191c692a8$export$2e2bcd8739ae039; });
$parcel$export($b3e4fba1facfc225$exports, "Voronoi", function () { return $b71d5d42efe29563$export$2e2bcd8739ae039; });
const $5edbccff765071bd$var$EPSILON = Math.pow(2, -52);
const $5edbccff765071bd$var$EDGE_STACK = new Uint32Array(512);
class $5edbccff765071bd$export$2e2bcd8739ae039 {
    static from(points, getX = $5edbccff765071bd$var$defaultGetX, getY = $5edbccff765071bd$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $5edbccff765071bd$export$2e2bcd8739ae039(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = $5edbccff765071bd$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = $5edbccff765071bd$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $5edbccff765071bd$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $5edbccff765071bd$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ($5edbccff765071bd$var$orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $5edbccff765071bd$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $5edbccff765071bd$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $5edbccff765071bd$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $5edbccff765071bd$var$EPSILON && Math.abs(y - yp) <= $5edbccff765071bd$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], !$5edbccff765071bd$var$orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], $5edbccff765071bd$var$orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], $5edbccff765071bd$var$orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($5edbccff765071bd$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $5edbccff765071bd$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $5edbccff765071bd$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $5edbccff765071bd$var$EDGE_STACK.length) $5edbccff765071bd$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $5edbccff765071bd$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $5edbccff765071bd$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $5edbccff765071bd$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function $5edbccff765071bd$var$orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}
// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function $5edbccff765071bd$var$orient(rx, ry, qx, qy, px, py) {
    const sign = $5edbccff765071bd$var$orientIfSure(px, py, rx, ry, qx, qy) || $5edbccff765071bd$var$orientIfSure(rx, ry, qx, qy, px, py) || $5edbccff765071bd$var$orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
}
function $5edbccff765071bd$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $5edbccff765071bd$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $5edbccff765071bd$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $5edbccff765071bd$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $5edbccff765071bd$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $5edbccff765071bd$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $5edbccff765071bd$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $5edbccff765071bd$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $5edbccff765071bd$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $5edbccff765071bd$var$quicksort(ids, dists, i, right);
            $5edbccff765071bd$var$quicksort(ids, dists, left, j - 1);
        } else {
            $5edbccff765071bd$var$quicksort(ids, dists, left, j - 1);
            $5edbccff765071bd$var$quicksort(ids, dists, i, right);
        }
    }
}
function $5edbccff765071bd$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $5edbccff765071bd$var$defaultGetX(p) {
    return p[0];
}
function $5edbccff765071bd$var$defaultGetY(p) {
    return p[1];
}


const $ea86980b85e9dba6$var$epsilon = 1e-6;
class $ea86980b85e9dba6$export$2e2bcd8739ae039 {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $ea86980b85e9dba6$var$epsilon || Math.abs(this._y1 - y0) > $ea86980b85e9dba6$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}


class $da1b875892658658$export$2e2bcd8739ae039 {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}




class $b71d5d42efe29563$export$2e2bcd8739ae039 {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const ab = (dx * ey - dy * ex) * 2;
            if (!ab) {
                // degenerate case (collinear diagram)
                x = (x1 + x3) / 2 - 1e8 * ey;
                y = (y1 + y3) / 2 + 1e8 * ex;
            } else if (Math.abs(ab) < 1e-8) {
                // almost equal points (degenerate triangle)
                x = (x1 + x3) / 2;
                y = (y1 + y3) / 2;
            } else {
                const d = 1 / ab;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $da1b875892658658$export$2e2bcd8739ae039);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        while(true){
            if (c0 === 0 && c1 === 0) return [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        if (P.length > 4) for(let i = 0; i < P.length; i += 2){
            const j = (i + 2) % P.length, k = (i + 4) % P.length;
            if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
}


const $c5840e4191c692a8$var$tau = 2 * Math.PI, $c5840e4191c692a8$var$pow = Math.pow;
function $c5840e4191c692a8$var$pointX(p) {
    return p[0];
}
function $c5840e4191c692a8$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $c5840e4191c692a8$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $c5840e4191c692a8$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $c5840e4191c692a8$export$2e2bcd8739ae039 {
    static from(points, fx = $c5840e4191c692a8$var$pointX, fy = $c5840e4191c692a8$var$pointY, that) {
        return new $c5840e4191c692a8$export$2e2bcd8739ae039("length" in points ? $c5840e4191c692a8$var$flatArray(points, fx, fy, that) : Float64Array.from($c5840e4191c692a8$var$flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, $5edbccff765071bd$export$2e2bcd8739ae039)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $c5840e4191c692a8$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $c5840e4191c692a8$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $5edbccff765071bd$export$2e2bcd8739ae039)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            this.triangles[1] = hull[1];
            this.triangles[2] = hull[1];
            inedges[hull[0]] = 1;
            if (hull.length === 2) inedges[hull[1]] = 0;
        }
    }
    voronoi(bounds) {
        return new (0, $b71d5d42efe29563$export$2e2bcd8739ae039)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $c5840e4191c692a8$var$pow(x - points[i * 2], 2) + $c5840e4191c692a8$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $c5840e4191c692a8$var$pow(x - points[t * 2], 2) + $c5840e4191c692a8$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($c5840e4191c692a8$var$pow(x - points[e * 2], 2) + $c5840e4191c692a8$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r = 2) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $c5840e4191c692a8$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $da1b875892658658$export$2e2bcd8739ae039);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $ea86980b85e9dba6$export$2e2bcd8739ae039) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $da1b875892658658$export$2e2bcd8739ae039);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
function $c5840e4191c692a8$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $c5840e4191c692a8$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}





var $deeed27c05a2c2eb$exports = {};

$parcel$export($deeed27c05a2c2eb$exports, "dispatch", function () { return $41d77768dbc6b7a5$export$2e2bcd8739ae039; });



var $d62f46194e6840cb$exports = {};

$parcel$export($d62f46194e6840cb$exports, "drag", function () { return $427ef29c692c6744$export$2e2bcd8739ae039; });
$parcel$export($d62f46194e6840cb$exports, "dragDisable", function () { return $9fc1ee0544073e59$export$2e2bcd8739ae039; });
$parcel$export($d62f46194e6840cb$exports, "dragEnable", function () { return $9fc1ee0544073e59$export$833237748009e1e1; });




var $fc8f9c1f4e5e1bbb$export$2e2bcd8739ae039 = (x)=>()=>x;


function $b4cfb17fe8bb2e20$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$b4cfb17fe8bb2e20$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $427ef29c692c6744$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $427ef29c692c6744$var$defaultContainer() {
    return this.parentNode;
}
function $427ef29c692c6744$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $427ef29c692c6744$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $427ef29c692c6744$export$2e2bcd8739ae039() {
    var filter = $427ef29c692c6744$var$defaultFilter, container = $427ef29c692c6744$var$defaultContainer, subject = $427ef29c692c6744$var$defaultSubject, touchable = $427ef29c692c6744$var$defaultTouchable, gestures = {}, listeners = (0, $41d77768dbc6b7a5$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $9fc1ee0544073e59$export$2e2bcd8739ae039)(event.view);
        (0, $510d3bad7f87cd39$export$2e2561858db9bf47)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $510d3bad7f87cd39$export$2e2bcd8739ae039)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $9fc1ee0544073e59$export$833237748009e1e1)(event.view, mousemoving);
        (0, $510d3bad7f87cd39$export$2e2bcd8739ae039)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $510d3bad7f87cd39$export$2e2561858db9bf47)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $510d3bad7f87cd39$export$2e2bcd8739ae039)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $510d3bad7f87cd39$export$2e2561858db9bf47)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $b4cfb17fe8bb2e20$export$2e2bcd8739ae039)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // nobreak
                case "drag":
                    p = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $b4cfb17fe8bb2e20$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $fc8f9c1f4e5e1bbb$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $fc8f9c1f4e5e1bbb$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $fc8f9c1f4e5e1bbb$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $fc8f9c1f4e5e1bbb$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}





var $e9335085431cbaa1$exports = {};

$parcel$export($e9335085431cbaa1$exports, "dsvFormat", function () { return $92f7d7524adefcf8$export$2e2bcd8739ae039; });
$parcel$export($e9335085431cbaa1$exports, "csvParse", function () { return $115e6a0d54217e7d$export$289d25497b0f4c16; });
$parcel$export($e9335085431cbaa1$exports, "csvParseRows", function () { return $115e6a0d54217e7d$export$c82550ca942d869; });
$parcel$export($e9335085431cbaa1$exports, "csvFormat", function () { return $115e6a0d54217e7d$export$afe767551074aa08; });
$parcel$export($e9335085431cbaa1$exports, "csvFormatBody", function () { return $115e6a0d54217e7d$export$b46fa59a5e3bc8a2; });
$parcel$export($e9335085431cbaa1$exports, "csvFormatRows", function () { return $115e6a0d54217e7d$export$3f42a65843fbd1d9; });
$parcel$export($e9335085431cbaa1$exports, "csvFormatRow", function () { return $115e6a0d54217e7d$export$c30212b87b2d080f; });
$parcel$export($e9335085431cbaa1$exports, "csvFormatValue", function () { return $115e6a0d54217e7d$export$2771de09a60fc648; });
$parcel$export($e9335085431cbaa1$exports, "tsvParse", function () { return $b211d081e77995e0$export$f913251db2f734ee; });
$parcel$export($e9335085431cbaa1$exports, "tsvParseRows", function () { return $b211d081e77995e0$export$8de3b5abc40a067f; });
$parcel$export($e9335085431cbaa1$exports, "tsvFormat", function () { return $b211d081e77995e0$export$77e754c4f8504293; });
$parcel$export($e9335085431cbaa1$exports, "tsvFormatBody", function () { return $b211d081e77995e0$export$9d44987d460c9cb3; });
$parcel$export($e9335085431cbaa1$exports, "tsvFormatRows", function () { return $b211d081e77995e0$export$ae461973f6adc981; });
$parcel$export($e9335085431cbaa1$exports, "tsvFormatRow", function () { return $b211d081e77995e0$export$5d61cf35a4a738d2; });
$parcel$export($e9335085431cbaa1$exports, "tsvFormatValue", function () { return $b211d081e77995e0$export$4280e6a416cd92a3; });
$parcel$export($e9335085431cbaa1$exports, "autoType", function () { return $2e52bda6ad04419a$export$2e2bcd8739ae039; });
var $92f7d7524adefcf8$var$EOL = {}, $92f7d7524adefcf8$var$EOF = {}, $92f7d7524adefcf8$var$QUOTE = 34, $92f7d7524adefcf8$var$NEWLINE = 10, $92f7d7524adefcf8$var$RETURN = 13;
function $92f7d7524adefcf8$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function $92f7d7524adefcf8$var$customConverter(columns, f) {
    var object = $92f7d7524adefcf8$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $92f7d7524adefcf8$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $92f7d7524adefcf8$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $92f7d7524adefcf8$var$formatYear(year) {
    return year < 0 ? "-" + $92f7d7524adefcf8$var$pad(-year, 6) : year > 9999 ? "+" + $92f7d7524adefcf8$var$pad(year, 6) : $92f7d7524adefcf8$var$pad(year, 4);
}
function $92f7d7524adefcf8$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $92f7d7524adefcf8$var$formatYear(date.getUTCFullYear(), 4) + "-" + $92f7d7524adefcf8$var$pad(date.getUTCMonth() + 1, 2) + "-" + $92f7d7524adefcf8$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $92f7d7524adefcf8$var$pad(hours, 2) + ":" + $92f7d7524adefcf8$var$pad(minutes, 2) + ":" + $92f7d7524adefcf8$var$pad(seconds, 2) + "." + $92f7d7524adefcf8$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $92f7d7524adefcf8$var$pad(hours, 2) + ":" + $92f7d7524adefcf8$var$pad(minutes, 2) + ":" + $92f7d7524adefcf8$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $92f7d7524adefcf8$var$pad(hours, 2) + ":" + $92f7d7524adefcf8$var$pad(minutes, 2) + "Z" : "");
}
function $92f7d7524adefcf8$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $92f7d7524adefcf8$var$customConverter(row, f) : $92f7d7524adefcf8$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $92f7d7524adefcf8$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $92f7d7524adefcf8$var$RETURN) --N;
        function token() {
            if (eof) return $92f7d7524adefcf8$var$EOF;
            if (eol) return eol = false, $92f7d7524adefcf8$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $92f7d7524adefcf8$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $92f7d7524adefcf8$var$QUOTE || text.charCodeAt(++I) === $92f7d7524adefcf8$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $92f7d7524adefcf8$var$NEWLINE) eol = true;
                else if (c === $92f7d7524adefcf8$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $92f7d7524adefcf8$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $92f7d7524adefcf8$var$NEWLINE) eol = true;
                else if (c === $92f7d7524adefcf8$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $92f7d7524adefcf8$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $92f7d7524adefcf8$var$EOF){
            var row = [];
            while(t !== $92f7d7524adefcf8$var$EOL && t !== $92f7d7524adefcf8$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $92f7d7524adefcf8$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $92f7d7524adefcf8$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $92f7d7524adefcf8$var$formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}



var $115e6a0d54217e7d$var$csv = (0, $92f7d7524adefcf8$export$2e2bcd8739ae039)(",");
var $115e6a0d54217e7d$export$289d25497b0f4c16 = $115e6a0d54217e7d$var$csv.parse;
var $115e6a0d54217e7d$export$c82550ca942d869 = $115e6a0d54217e7d$var$csv.parseRows;
var $115e6a0d54217e7d$export$afe767551074aa08 = $115e6a0d54217e7d$var$csv.format;
var $115e6a0d54217e7d$export$b46fa59a5e3bc8a2 = $115e6a0d54217e7d$var$csv.formatBody;
var $115e6a0d54217e7d$export$3f42a65843fbd1d9 = $115e6a0d54217e7d$var$csv.formatRows;
var $115e6a0d54217e7d$export$c30212b87b2d080f = $115e6a0d54217e7d$var$csv.formatRow;
var $115e6a0d54217e7d$export$2771de09a60fc648 = $115e6a0d54217e7d$var$csv.formatValue;



var $b211d081e77995e0$var$tsv = (0, $92f7d7524adefcf8$export$2e2bcd8739ae039)("\t");
var $b211d081e77995e0$export$f913251db2f734ee = $b211d081e77995e0$var$tsv.parse;
var $b211d081e77995e0$export$8de3b5abc40a067f = $b211d081e77995e0$var$tsv.parseRows;
var $b211d081e77995e0$export$77e754c4f8504293 = $b211d081e77995e0$var$tsv.format;
var $b211d081e77995e0$export$9d44987d460c9cb3 = $b211d081e77995e0$var$tsv.formatBody;
var $b211d081e77995e0$export$ae461973f6adc981 = $b211d081e77995e0$var$tsv.formatRows;
var $b211d081e77995e0$export$5d61cf35a4a738d2 = $b211d081e77995e0$var$tsv.formatRow;
var $b211d081e77995e0$export$4280e6a416cd92a3 = $b211d081e77995e0$var$tsv.formatValue;


function $2e52bda6ad04419a$export$2e2bcd8739ae039(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if ($2e52bda6ad04419a$var$fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
const $2e52bda6ad04419a$var$fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();




var $1e73b5bce73843e9$exports = {};

$parcel$export($1e73b5bce73843e9$exports, "easeLinear", function () { return $fc7917a2e95b613b$export$45db2fc2f15997e7; });
$parcel$export($1e73b5bce73843e9$exports, "easeQuad", function () { return $02c52462c55dcf7d$export$d6ded66933892ed3; });
$parcel$export($1e73b5bce73843e9$exports, "easeQuadIn", function () { return $02c52462c55dcf7d$export$5118fc7a1e64441b; });
$parcel$export($1e73b5bce73843e9$exports, "easeQuadOut", function () { return $02c52462c55dcf7d$export$5be5f5e804d0b60c; });
$parcel$export($1e73b5bce73843e9$exports, "easeQuadInOut", function () { return $02c52462c55dcf7d$export$d6ded66933892ed3; });
$parcel$export($1e73b5bce73843e9$exports, "easeCubic", function () { return $15fd710f7785072c$export$89238d3bc79d3ada; });
$parcel$export($1e73b5bce73843e9$exports, "easeCubicIn", function () { return $15fd710f7785072c$export$b1a09cb1b71f86aa; });
$parcel$export($1e73b5bce73843e9$exports, "easeCubicOut", function () { return $15fd710f7785072c$export$68d528839c701b6; });
$parcel$export($1e73b5bce73843e9$exports, "easeCubicInOut", function () { return $15fd710f7785072c$export$89238d3bc79d3ada; });
$parcel$export($1e73b5bce73843e9$exports, "easePoly", function () { return $a912772a377f47e6$export$ae94c6a40058b429; });
$parcel$export($1e73b5bce73843e9$exports, "easePolyIn", function () { return $a912772a377f47e6$export$aa0b5c3ce2df9d7d; });
$parcel$export($1e73b5bce73843e9$exports, "easePolyOut", function () { return $a912772a377f47e6$export$e3d987a417dc6640; });
$parcel$export($1e73b5bce73843e9$exports, "easePolyInOut", function () { return $a912772a377f47e6$export$ae94c6a40058b429; });
$parcel$export($1e73b5bce73843e9$exports, "easeSin", function () { return $214a62301ce0a916$export$ff58b604d3ba15ba; });
$parcel$export($1e73b5bce73843e9$exports, "easeSinIn", function () { return $214a62301ce0a916$export$a83a280f8d31ba8d; });
$parcel$export($1e73b5bce73843e9$exports, "easeSinOut", function () { return $214a62301ce0a916$export$62ec6410ca53f2a7; });
$parcel$export($1e73b5bce73843e9$exports, "easeSinInOut", function () { return $214a62301ce0a916$export$ff58b604d3ba15ba; });
$parcel$export($1e73b5bce73843e9$exports, "easeExp", function () { return $c857790af9d48b62$export$ae4d4e77fab188ff; });
$parcel$export($1e73b5bce73843e9$exports, "easeExpIn", function () { return $c857790af9d48b62$export$fc3e95f15e1ef38e; });
$parcel$export($1e73b5bce73843e9$exports, "easeExpOut", function () { return $c857790af9d48b62$export$f3c9b2f85fbcf0ab; });
$parcel$export($1e73b5bce73843e9$exports, "easeExpInOut", function () { return $c857790af9d48b62$export$ae4d4e77fab188ff; });
$parcel$export($1e73b5bce73843e9$exports, "easeCircle", function () { return $23f22bb4bdc830e5$export$2d757ff9ad09038f; });
$parcel$export($1e73b5bce73843e9$exports, "easeCircleIn", function () { return $23f22bb4bdc830e5$export$9f82a71b0377c018; });
$parcel$export($1e73b5bce73843e9$exports, "easeCircleOut", function () { return $23f22bb4bdc830e5$export$27989e665abef2c8; });
$parcel$export($1e73b5bce73843e9$exports, "easeCircleInOut", function () { return $23f22bb4bdc830e5$export$2d757ff9ad09038f; });
$parcel$export($1e73b5bce73843e9$exports, "easeBounce", function () { return $3652df729380fdac$export$cccc9e04465dce11; });
$parcel$export($1e73b5bce73843e9$exports, "easeBounceIn", function () { return $3652df729380fdac$export$fccebd7948554554; });
$parcel$export($1e73b5bce73843e9$exports, "easeBounceOut", function () { return $3652df729380fdac$export$cccc9e04465dce11; });
$parcel$export($1e73b5bce73843e9$exports, "easeBounceInOut", function () { return $3652df729380fdac$export$41ad9e9849a703ce; });
$parcel$export($1e73b5bce73843e9$exports, "easeBack", function () { return $3e3ed9473f6f02aa$export$ddc5fd596f6c71b2; });
$parcel$export($1e73b5bce73843e9$exports, "easeBackIn", function () { return $3e3ed9473f6f02aa$export$b01116c84cdfe1a2; });
$parcel$export($1e73b5bce73843e9$exports, "easeBackOut", function () { return $3e3ed9473f6f02aa$export$77edfce482316a60; });
$parcel$export($1e73b5bce73843e9$exports, "easeBackInOut", function () { return $3e3ed9473f6f02aa$export$ddc5fd596f6c71b2; });
$parcel$export($1e73b5bce73843e9$exports, "easeElastic", function () { return $bd3c7b3d711b377d$export$ed1782b99e69bbc8; });
$parcel$export($1e73b5bce73843e9$exports, "easeElasticIn", function () { return $bd3c7b3d711b377d$export$41f42134872a5fa0; });
$parcel$export($1e73b5bce73843e9$exports, "easeElasticOut", function () { return $bd3c7b3d711b377d$export$ed1782b99e69bbc8; });
$parcel$export($1e73b5bce73843e9$exports, "easeElasticInOut", function () { return $bd3c7b3d711b377d$export$309de4f35f218bfd; });
const $fc7917a2e95b613b$export$45db2fc2f15997e7 = (t)=>+t;


function $02c52462c55dcf7d$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $02c52462c55dcf7d$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $02c52462c55dcf7d$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}



var $a912772a377f47e6$var$exponent = 3;
var $a912772a377f47e6$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($a912772a377f47e6$var$exponent);
var $a912772a377f47e6$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($a912772a377f47e6$var$exponent);
var $a912772a377f47e6$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($a912772a377f47e6$var$exponent);


var $214a62301ce0a916$var$pi = Math.PI, $214a62301ce0a916$var$halfPi = $214a62301ce0a916$var$pi / 2;
function $214a62301ce0a916$export$a83a280f8d31ba8d(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * $214a62301ce0a916$var$halfPi);
}
function $214a62301ce0a916$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $214a62301ce0a916$var$halfPi);
}
function $214a62301ce0a916$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($214a62301ce0a916$var$pi * t)) / 2;
}


// tpmt is two power minus ten times t scaled to [0,1]
function $b263389e3f889bca$export$be3f0f7224794b88(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}


function $c857790af9d48b62$export$fc3e95f15e1ef38e(t) {
    return (0, $b263389e3f889bca$export$be3f0f7224794b88)(1 - +t);
}
function $c857790af9d48b62$export$f3c9b2f85fbcf0ab(t) {
    return 1 - (0, $b263389e3f889bca$export$be3f0f7224794b88)(t);
}
function $c857790af9d48b62$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? (0, $b263389e3f889bca$export$be3f0f7224794b88)(1 - t) : 2 - (0, $b263389e3f889bca$export$be3f0f7224794b88)(t - 1)) / 2;
}


function $23f22bb4bdc830e5$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $23f22bb4bdc830e5$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $23f22bb4bdc830e5$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


var $3652df729380fdac$var$b1 = 4 / 11, $3652df729380fdac$var$b2 = 6 / 11, $3652df729380fdac$var$b3 = 8 / 11, $3652df729380fdac$var$b4 = 3 / 4, $3652df729380fdac$var$b5 = 9 / 11, $3652df729380fdac$var$b6 = 10 / 11, $3652df729380fdac$var$b7 = 15 / 16, $3652df729380fdac$var$b8 = 21 / 22, $3652df729380fdac$var$b9 = 63 / 64, $3652df729380fdac$var$b0 = 1 / $3652df729380fdac$var$b1 / $3652df729380fdac$var$b1;
function $3652df729380fdac$export$fccebd7948554554(t) {
    return 1 - $3652df729380fdac$export$cccc9e04465dce11(1 - t);
}
function $3652df729380fdac$export$cccc9e04465dce11(t) {
    return (t = +t) < $3652df729380fdac$var$b1 ? $3652df729380fdac$var$b0 * t * t : t < $3652df729380fdac$var$b3 ? $3652df729380fdac$var$b0 * (t -= $3652df729380fdac$var$b2) * t + $3652df729380fdac$var$b4 : t < $3652df729380fdac$var$b6 ? $3652df729380fdac$var$b0 * (t -= $3652df729380fdac$var$b5) * t + $3652df729380fdac$var$b7 : $3652df729380fdac$var$b0 * (t -= $3652df729380fdac$var$b8) * t + $3652df729380fdac$var$b9;
}
function $3652df729380fdac$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $3652df729380fdac$export$cccc9e04465dce11(1 - t) : $3652df729380fdac$export$cccc9e04465dce11(t - 1) + 1) / 2;
}


var $3e3ed9473f6f02aa$var$overshoot = 1.70158;
var $3e3ed9473f6f02aa$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}($3e3ed9473f6f02aa$var$overshoot);
var $3e3ed9473f6f02aa$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($3e3ed9473f6f02aa$var$overshoot);
var $3e3ed9473f6f02aa$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($3e3ed9473f6f02aa$var$overshoot);



var $bd3c7b3d711b377d$var$tau = 2 * Math.PI, $bd3c7b3d711b377d$var$amplitude = 1, $bd3c7b3d711b377d$var$period = 0.3;
var $bd3c7b3d711b377d$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $bd3c7b3d711b377d$var$tau);
    function elasticIn(t) {
        return a * (0, $b263389e3f889bca$export$be3f0f7224794b88)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $bd3c7b3d711b377d$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($bd3c7b3d711b377d$var$amplitude, $bd3c7b3d711b377d$var$period);
var $bd3c7b3d711b377d$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $bd3c7b3d711b377d$var$tau);
    function elasticOut(t) {
        return 1 - a * (0, $b263389e3f889bca$export$be3f0f7224794b88)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $bd3c7b3d711b377d$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($bd3c7b3d711b377d$var$amplitude, $bd3c7b3d711b377d$var$period);
var $bd3c7b3d711b377d$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $bd3c7b3d711b377d$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, $b263389e3f889bca$export$be3f0f7224794b88)(-t) * Math.sin((s - t) / p) : 2 - a * (0, $b263389e3f889bca$export$be3f0f7224794b88)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $bd3c7b3d711b377d$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($bd3c7b3d711b377d$var$amplitude, $bd3c7b3d711b377d$var$period);




var $fe8713a76744544a$exports = {};

$parcel$export($fe8713a76744544a$exports, "blob", function () { return $e3d9f1be48f4b47c$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "buffer", function () { return $c68a8c297370c2ad$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "dsv", function () { return $14ffb76ec8465ed0$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "csv", function () { return $14ffb76ec8465ed0$export$901ba78aa04f49da; });
$parcel$export($fe8713a76744544a$exports, "tsv", function () { return $14ffb76ec8465ed0$export$580b2de76423ff18; });
$parcel$export($fe8713a76744544a$exports, "image", function () { return $128d3e3099668767$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "json", function () { return $0d2f4231982e1932$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "text", function () { return $dd3b1f7a90fa38f1$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "xml", function () { return $0c56f6ffb9fcfdbe$export$2e2bcd8739ae039; });
$parcel$export($fe8713a76744544a$exports, "html", function () { return $0c56f6ffb9fcfdbe$export$c0bb0b647f701bb5; });
$parcel$export($fe8713a76744544a$exports, "svg", function () { return $0c56f6ffb9fcfdbe$export$7ed1367e7fa1ad68; });
function $e3d9f1be48f4b47c$var$responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}
function $e3d9f1be48f4b47c$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($e3d9f1be48f4b47c$var$responseBlob);
}


function $c68a8c297370c2ad$var$responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}
function $c68a8c297370c2ad$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($c68a8c297370c2ad$var$responseArrayBuffer);
}



function $dd3b1f7a90fa38f1$var$responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}
function $dd3b1f7a90fa38f1$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($dd3b1f7a90fa38f1$var$responseText);
}


function $14ffb76ec8465ed0$var$dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, $dd3b1f7a90fa38f1$export$2e2bcd8739ae039)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function $14ffb76ec8465ed0$export$2e2bcd8739ae039(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, $92f7d7524adefcf8$export$2e2bcd8739ae039)(delimiter);
    return (0, $dd3b1f7a90fa38f1$export$2e2bcd8739ae039)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var $14ffb76ec8465ed0$export$901ba78aa04f49da = $14ffb76ec8465ed0$var$dsvParse((0, $115e6a0d54217e7d$export$289d25497b0f4c16));
var $14ffb76ec8465ed0$export$580b2de76423ff18 = $14ffb76ec8465ed0$var$dsvParse((0, $b211d081e77995e0$export$f913251db2f734ee));


function $128d3e3099668767$export$2e2bcd8739ae039(input, init) {
    return new Promise(function(resolve, reject) {
        var image = new Image;
        for(var key in init)image[key] = init[key];
        image.onerror = reject;
        image.onload = function() {
            resolve(image);
        };
        image.src = input;
    });
}


function $0d2f4231982e1932$var$responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}
function $0d2f4231982e1932$export$2e2bcd8739ae039(input, init) {
    return fetch(input, init).then($0d2f4231982e1932$var$responseJson);
}




function $0c56f6ffb9fcfdbe$var$parser(type) {
    return (input, init)=>(0, $dd3b1f7a90fa38f1$export$2e2bcd8739ae039)(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
}
var $0c56f6ffb9fcfdbe$export$2e2bcd8739ae039 = $0c56f6ffb9fcfdbe$var$parser("application/xml");
var $0c56f6ffb9fcfdbe$export$c0bb0b647f701bb5 = $0c56f6ffb9fcfdbe$var$parser("text/html");
var $0c56f6ffb9fcfdbe$export$7ed1367e7fa1ad68 = $0c56f6ffb9fcfdbe$var$parser("image/svg+xml");




var $764845f9c28e2fad$exports = {};

$parcel$export($764845f9c28e2fad$exports, "forceCenter", function () { return $652e494992ea1fa4$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceCollide", function () { return $31caf9d80942b734$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceLink", function () { return $75a1dbb46ead9b74$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceManyBody", function () { return $112b6964e6d549ae$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceRadial", function () { return $67d609698f85c6b8$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceSimulation", function () { return $e4a3858c4798f783$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceX", function () { return $3946bf6097494125$export$2e2bcd8739ae039; });
$parcel$export($764845f9c28e2fad$exports, "forceY", function () { return $78b2944d8b23d1ea$export$2e2bcd8739ae039; });
function $652e494992ea1fa4$export$2e2bcd8739ae039(x, y) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}


function $2725c413e1ecbb8c$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $2725c413e1ecbb8c$var$add(this.cover(x, y), x, y, d);
}
function $2725c413e1ecbb8c$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $2725c413e1ecbb8c$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$2725c413e1ecbb8c$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $7226418b03aaf6fa$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $5917e15992cb6265$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $c0eb3bdf5a2f725a$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $2ab881593bd78eb5$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $ee5c722d9c51ad73$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $a105fa631d07396d$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $a105fa631d07396d$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $87e3b44e5173e180$export$2e2bcd8739ae039() {
    return this._root;
}


function $b0480f57e696bec9$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $ac3db410b8e643df$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $b3991fd852d3d3aa$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $2ab881593bd78eb5$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $3c3432bed3c67736$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $3c3432bed3c67736$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $37a3c0b574218678$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $37a3c0b574218678$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $0035ef5bae9355cf$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $0035ef5bae9355cf$var$Quadtree(x == null ? (0, $3c3432bed3c67736$export$e6fafc98131d2a44) : x, y == null ? (0, $37a3c0b574218678$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $0035ef5bae9355cf$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $0035ef5bae9355cf$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $0035ef5bae9355cf$var$treeProto = $0035ef5bae9355cf$export$2e2bcd8739ae039.prototype = $0035ef5bae9355cf$var$Quadtree.prototype;
$0035ef5bae9355cf$var$treeProto.copy = function() {
    var copy = new $0035ef5bae9355cf$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $0035ef5bae9355cf$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $0035ef5bae9355cf$var$leaf_copy(child);
        }
    }
    return copy;
};
$0035ef5bae9355cf$var$treeProto.add = (0, $2725c413e1ecbb8c$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.addAll = (0, $2725c413e1ecbb8c$export$32ed0561867ec8a1);
$0035ef5bae9355cf$var$treeProto.cover = (0, $7226418b03aaf6fa$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.data = (0, $5917e15992cb6265$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.extent = (0, $c0eb3bdf5a2f725a$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.find = (0, $ee5c722d9c51ad73$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.remove = (0, $a105fa631d07396d$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.removeAll = (0, $a105fa631d07396d$export$1cfc7aad5cb1833b);
$0035ef5bae9355cf$var$treeProto.root = (0, $87e3b44e5173e180$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.size = (0, $b0480f57e696bec9$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.visit = (0, $ac3db410b8e643df$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.visitAfter = (0, $b3991fd852d3d3aa$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.x = (0, $3c3432bed3c67736$export$2e2bcd8739ae039);
$0035ef5bae9355cf$var$treeProto.y = (0, $37a3c0b574218678$export$2e2bcd8739ae039);


function $961e8f37cf0f3fa7$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $8baf224593ab7dc7$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $31caf9d80942b734$var$x(d) {
    return d.x + d.vx;
}
function $31caf9d80942b734$var$y(d) {
    return d.y + d.vy;
}
function $31caf9d80942b734$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $0035ef5bae9355cf$export$2e2bcd8739ae039)(nodes, $31caf9d80942b734$var$x, $31caf9d80942b734$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random), l += x * x;
                        if (y === 0) y = (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}




function $75a1dbb46ead9b74$var$index(d) {
    return d.index;
}
function $75a1dbb46ead9b74$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $75a1dbb46ead9b74$export$2e2bcd8739ae039(links) {
    var id = $75a1dbb46ead9b74$var$index, strength = defaultStrength, strengths, distance = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $75a1dbb46ead9b74$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $75a1dbb46ead9b74$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}







// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $ad27eef204c35699$var$a = 1664525;
const $ad27eef204c35699$var$c = 1013904223;
const $ad27eef204c35699$var$m = 4294967296; // 2^32
function $ad27eef204c35699$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($ad27eef204c35699$var$a * s + $ad27eef204c35699$var$c) % $ad27eef204c35699$var$m) / $ad27eef204c35699$var$m;
}


function $e4a3858c4798f783$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $e4a3858c4798f783$export$4a5767248b18ef41(d) {
    return d.y;
}
var $e4a3858c4798f783$var$initialRadius = 10, $e4a3858c4798f783$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $e4a3858c4798f783$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $9c58fce6e008e685$export$9dc4ecf953986f04)(step), event = (0, $41d77768dbc6b7a5$export$2e2bcd8739ae039)("tick", "end"), random = (0, $ad27eef204c35699$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $e4a3858c4798f783$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $e4a3858c4798f783$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $112b6964e6d549ae$export$2e2bcd8739ae039() {
    var nodes, node, random, alpha, strength = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $0035ef5bae9355cf$export$2e2bcd8739ae039)(nodes, (0, $e4a3858c4798f783$export$d141bba7fdc215a3), (0, $e4a3858c4798f783$export$4a5767248b18ef41)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random), l += x * x;
                if (y === 0) y = (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random), l += x * x;
            if (y === 0) y = (0, $8baf224593ab7dc7$export$2e2bcd8739ae039)(random), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}



function $67d609698f85c6b8$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}




function $3946bf6097494125$export$2e2bcd8739ae039(x) {
    var strength = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : x;
    };
    return force;
}



function $78b2944d8b23d1ea$export$2e2bcd8739ae039(y) {
    var strength = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $961e8f37cf0f3fa7$export$2e2bcd8739ae039)(+_), initialize(), force) : y;
    };
    return force;
}




var $1a86e122fa7d41d6$exports = {};

$parcel$export($1a86e122fa7d41d6$exports, "formatDefaultLocale", function () { return $45fe3ebe07b00990$export$2e2bcd8739ae039; });
$parcel$export($1a86e122fa7d41d6$exports, "format", function () { return $45fe3ebe07b00990$export$d9468344d3651243; });
$parcel$export($1a86e122fa7d41d6$exports, "formatPrefix", function () { return $45fe3ebe07b00990$export$8d85692a469dde6f; });
$parcel$export($1a86e122fa7d41d6$exports, "formatLocale", function () { return $5e1209ec8e88c966$export$2e2bcd8739ae039; });
$parcel$export($1a86e122fa7d41d6$exports, "formatSpecifier", function () { return $33c20a36f475948f$export$2e2bcd8739ae039; });
$parcel$export($1a86e122fa7d41d6$exports, "FormatSpecifier", function () { return $33c20a36f475948f$export$963aac351db36ed4; });
$parcel$export($1a86e122fa7d41d6$exports, "precisionFixed", function () { return $bfebf1720f6e6a79$export$2e2bcd8739ae039; });
$parcel$export($1a86e122fa7d41d6$exports, "precisionPrefix", function () { return $f9f7af4086e97456$export$2e2bcd8739ae039; });
$parcel$export($1a86e122fa7d41d6$exports, "precisionRound", function () { return $39f18c436813ddb0$export$2e2bcd8739ae039; });
function $7c64e9ca6536dad3$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $7c64e9ca6536dad3$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $2a9597a67629f358$export$2e2bcd8739ae039(x) {
    return x = (0, $7c64e9ca6536dad3$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $508944e3fbb3d910$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $cdf9e33b9db0a1ee$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $33c20a36f475948f$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $33c20a36f475948f$export$2e2bcd8739ae039(specifier) {
    if (!(match = $33c20a36f475948f$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $33c20a36f475948f$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$33c20a36f475948f$export$2e2bcd8739ae039.prototype = $33c20a36f475948f$export$963aac351db36ed4.prototype; // instanceof
function $33c20a36f475948f$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$33c20a36f475948f$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $95dd51bbeff895d0$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $687086a6f9b79a1b$export$6863724d9a42263;
function $687086a6f9b79a1b$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7c64e9ca6536dad3$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($687086a6f9b79a1b$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $7c64e9ca6536dad3$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $509991ecab027b75$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7c64e9ca6536dad3$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $0e89112f8225c475$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $7c64e9ca6536dad3$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $509991ecab027b75$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $509991ecab027b75$export$2e2bcd8739ae039),
    "s": (0, $687086a6f9b79a1b$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $13d6bac5d1937a53$export$2e2bcd8739ae039(x) {
    return x;
}


var $5e1209ec8e88c966$var$map = Array.prototype.map, $5e1209ec8e88c966$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $5e1209ec8e88c966$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $13d6bac5d1937a53$export$2e2bcd8739ae039) : (0, $508944e3fbb3d910$export$2e2bcd8739ae039)($5e1209ec8e88c966$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $13d6bac5d1937a53$export$2e2bcd8739ae039) : (0, $cdf9e33b9db0a1ee$export$2e2bcd8739ae039)($5e1209ec8e88c966$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $33c20a36f475948f$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $0e89112f8225c475$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $0e89112f8225c475$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $95dd51bbeff895d0$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $5e1209ec8e88c966$var$prefixes[8 + (0, $687086a6f9b79a1b$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $33c20a36f475948f$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $2a9597a67629f358$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $5e1209ec8e88c966$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $45fe3ebe07b00990$var$locale;
var $45fe3ebe07b00990$export$d9468344d3651243;
var $45fe3ebe07b00990$export$8d85692a469dde6f;
$45fe3ebe07b00990$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $45fe3ebe07b00990$export$2e2bcd8739ae039(definition) {
    $45fe3ebe07b00990$var$locale = (0, $5e1209ec8e88c966$export$2e2bcd8739ae039)(definition);
    $45fe3ebe07b00990$export$d9468344d3651243 = $45fe3ebe07b00990$var$locale.format;
    $45fe3ebe07b00990$export$8d85692a469dde6f = $45fe3ebe07b00990$var$locale.formatPrefix;
    return $45fe3ebe07b00990$var$locale;
}





function $bfebf1720f6e6a79$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $2a9597a67629f358$export$2e2bcd8739ae039)(Math.abs(step)));
}



function $f9f7af4086e97456$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $2a9597a67629f358$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $2a9597a67629f358$export$2e2bcd8739ae039)(Math.abs(step)));
}



function $39f18c436813ddb0$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $2a9597a67629f358$export$2e2bcd8739ae039)(max) - (0, $2a9597a67629f358$export$2e2bcd8739ae039)(step)) + 1;
}




var $8760d5288478873d$exports = {};

$parcel$export($8760d5288478873d$exports, "geoArea", function () { return $bc22ec97a7463173$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoBounds", function () { return $acc575c874e2b89a$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoCentroid", function () { return $c990cf62d39b38ec$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoCircle", function () { return $9a3b436ca5e33308$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoClipAntimeridian", function () { return $77ecf5d7118d4e24$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoClipCircle", function () { return $2c12f65a02141e37$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoClipExtent", function () { return $074050eb8b890992$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoClipRectangle", function () { return $c40b90e739aa0c57$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoContains", function () { return $4144a31ba5603c5a$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoDistance", function () { return $1778a7fd0aead7df$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoGraticule", function () { return $9c6c7ba3ea47ad20$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoGraticule10", function () { return $9c6c7ba3ea47ad20$export$b8db4e9403a5b6f1; });
$parcel$export($8760d5288478873d$exports, "geoInterpolate", function () { return $bd252e0f920822bf$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoLength", function () { return $6ec010e8f5535f93$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoPath", function () { return $55f4551d20fc45eb$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoAlbers", function () { return $818785c899a3e78e$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoAlbersUsa", function () { return $4750388187065daf$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoAzimuthalEqualArea", function () { return $712be8798957743b$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoAzimuthalEqualAreaRaw", function () { return $712be8798957743b$export$5e11f94fc4a8d2c6; });
$parcel$export($8760d5288478873d$exports, "geoAzimuthalEquidistant", function () { return $f3dd0aa4ef3821a9$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoAzimuthalEquidistantRaw", function () { return $f3dd0aa4ef3821a9$export$b94a4d6aa3dd25c; });
$parcel$export($8760d5288478873d$exports, "geoConicConformal", function () { return $85f9fbbcdef95343$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoConicConformalRaw", function () { return $85f9fbbcdef95343$export$2b1bc913962ed170; });
$parcel$export($8760d5288478873d$exports, "geoConicEqualArea", function () { return $cf50254c00676fc9$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoConicEqualAreaRaw", function () { return $cf50254c00676fc9$export$75409dad1c406288; });
$parcel$export($8760d5288478873d$exports, "geoConicEquidistant", function () { return $fd0514e4e5bb2392$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoConicEquidistantRaw", function () { return $fd0514e4e5bb2392$export$24f604fe80e5f192; });
$parcel$export($8760d5288478873d$exports, "geoEqualEarth", function () { return $d37439c40fd25fef$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoEqualEarthRaw", function () { return $d37439c40fd25fef$export$a320734067e7a731; });
$parcel$export($8760d5288478873d$exports, "geoEquirectangular", function () { return $0eafe8a9698064f1$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoEquirectangularRaw", function () { return $0eafe8a9698064f1$export$f5fee52180f2f058; });
$parcel$export($8760d5288478873d$exports, "geoGnomonic", function () { return $e49d0d022364e606$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoGnomonicRaw", function () { return $e49d0d022364e606$export$dc8c6ddfc8b22c85; });
$parcel$export($8760d5288478873d$exports, "geoIdentity", function () { return $f9d44b0c96673d8d$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoProjection", function () { return $b5bd7d563f966bea$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoProjectionMutator", function () { return $b5bd7d563f966bea$export$155d5a6fa6fddeba; });
$parcel$export($8760d5288478873d$exports, "geoMercator", function () { return $0246b40a5294c58d$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoMercatorRaw", function () { return $0246b40a5294c58d$export$94ff8a57e9b91cc3; });
$parcel$export($8760d5288478873d$exports, "geoNaturalEarth1", function () { return $eca045369819d70c$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoNaturalEarth1Raw", function () { return $eca045369819d70c$export$acb6def22fe878e6; });
$parcel$export($8760d5288478873d$exports, "geoOrthographic", function () { return $26f619327c062256$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoOrthographicRaw", function () { return $26f619327c062256$export$1cd9c2eb846182a; });
$parcel$export($8760d5288478873d$exports, "geoStereographic", function () { return $847b42dca2e809a4$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoStereographicRaw", function () { return $847b42dca2e809a4$export$f9ccbb0dcb3dcd2b; });
$parcel$export($8760d5288478873d$exports, "geoTransverseMercator", function () { return $1ce1dd886730e28c$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoTransverseMercatorRaw", function () { return $1ce1dd886730e28c$export$e84942adec6de533; });
$parcel$export($8760d5288478873d$exports, "geoRotation", function () { return $e96038c603a78247$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoStream", function () { return $fea8e992e2cdfb90$export$2e2bcd8739ae039; });
$parcel$export($8760d5288478873d$exports, "geoTransform", function () { return $ffa1cb2d4dc49483$export$2e2bcd8739ae039; });

var $a95495fc7e2b96ad$export$6c421550c66a327d = 1e-6;
var $a95495fc7e2b96ad$export$92c06fba281fe81b = 1e-12;
var $a95495fc7e2b96ad$export$18c7bea995a110f = Math.PI;
var $a95495fc7e2b96ad$export$e51408a300e8929a = $a95495fc7e2b96ad$export$18c7bea995a110f / 2;
var $a95495fc7e2b96ad$export$c39a5cba78ea0fc2 = $a95495fc7e2b96ad$export$18c7bea995a110f / 4;
var $a95495fc7e2b96ad$export$a4b4b4d4d776fe92 = $a95495fc7e2b96ad$export$18c7bea995a110f * 2;
var $a95495fc7e2b96ad$export$41fc368e1a942b97 = 180 / $a95495fc7e2b96ad$export$18c7bea995a110f;
var $a95495fc7e2b96ad$export$8449e153fbd325fc = $a95495fc7e2b96ad$export$18c7bea995a110f / 180;
var $a95495fc7e2b96ad$export$2335f513bbd82c6d = Math.abs;
var $a95495fc7e2b96ad$export$628dc4eed22b0fbd = Math.atan;
var $a95495fc7e2b96ad$export$b8b770ee6a0d9760 = Math.atan2;
var $a95495fc7e2b96ad$export$50d414a77b60d802 = Math.cos;
var $a95495fc7e2b96ad$export$803ce6b71a0a94b2 = Math.ceil;
var $a95495fc7e2b96ad$export$b310ec824aaee37f = Math.exp;
var $a95495fc7e2b96ad$export$a3fe094919f356fd = Math.floor;
var $a95495fc7e2b96ad$export$f95c7888b62f8e9a = Math.hypot;
var $a95495fc7e2b96ad$export$bef1f36f5486a6a3 = Math.log;
var $a95495fc7e2b96ad$export$9c297f60e22e3389 = Math.pow;
var $a95495fc7e2b96ad$export$5de3937cb4b592ed = Math.sin;
var $a95495fc7e2b96ad$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $a95495fc7e2b96ad$export$eba8049fb5020b81 = Math.sqrt;
var $a95495fc7e2b96ad$export$fcdd3b0b3246a325 = Math.tan;
function $a95495fc7e2b96ad$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $a95495fc7e2b96ad$export$18c7bea995a110f : Math.acos(x);
}
function $a95495fc7e2b96ad$export$41726bdb1fc63f(x) {
    return x > 1 ? $a95495fc7e2b96ad$export$e51408a300e8929a : x < -1 ? -$a95495fc7e2b96ad$export$e51408a300e8929a : Math.asin(x);
}
function $a95495fc7e2b96ad$export$e808712c2966e662(x) {
    return (x = $a95495fc7e2b96ad$export$5de3937cb4b592ed(x / 2)) * x;
}


function $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039() {}


function $fea8e992e2cdfb90$var$streamGeometry(geometry, stream) {
    if (geometry && $fea8e992e2cdfb90$var$streamGeometryType.hasOwnProperty(geometry.type)) $fea8e992e2cdfb90$var$streamGeometryType[geometry.type](geometry, stream);
}
var $fea8e992e2cdfb90$var$streamObjectType = {
    Feature: function(object, stream) {
        $fea8e992e2cdfb90$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$fea8e992e2cdfb90$var$streamGeometry(features[i].geometry, stream);
    }
};
var $fea8e992e2cdfb90$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $fea8e992e2cdfb90$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$fea8e992e2cdfb90$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $fea8e992e2cdfb90$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$fea8e992e2cdfb90$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$fea8e992e2cdfb90$var$streamGeometry(geometries[i], stream);
    }
};
function $fea8e992e2cdfb90$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $fea8e992e2cdfb90$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$fea8e992e2cdfb90$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $fea8e992e2cdfb90$export$2e2bcd8739ae039(object, stream) {
    if (object && $fea8e992e2cdfb90$var$streamObjectType.hasOwnProperty(object.type)) $fea8e992e2cdfb90$var$streamObjectType[object.type](object, stream);
    else $fea8e992e2cdfb90$var$streamGeometry(object, stream);
}


var $bc22ec97a7463173$export$bf8f994332070c7f = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
// hello?
var $bc22ec97a7463173$var$areaSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)(), $bc22ec97a7463173$var$lambda00, $bc22ec97a7463173$var$phi00, $bc22ec97a7463173$var$lambda0, $bc22ec97a7463173$var$cosPhi0, $bc22ec97a7463173$var$sinPhi0;
var $bc22ec97a7463173$export$cb67cfa750ae69dc = {
    point: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineStart: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    polygonStart: function() {
        $bc22ec97a7463173$export$bf8f994332070c7f = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
        $bc22ec97a7463173$export$cb67cfa750ae69dc.lineStart = $bc22ec97a7463173$var$areaRingStart;
        $bc22ec97a7463173$export$cb67cfa750ae69dc.lineEnd = $bc22ec97a7463173$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$bc22ec97a7463173$export$bf8f994332070c7f;
        $bc22ec97a7463173$var$areaSum.add(areaRing < 0 ? (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039);
    },
    sphere: function() {
        $bc22ec97a7463173$var$areaSum.add((0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92));
    }
};
function $bc22ec97a7463173$var$areaRingStart() {
    $bc22ec97a7463173$export$cb67cfa750ae69dc.point = $bc22ec97a7463173$var$areaPointFirst;
}
function $bc22ec97a7463173$var$areaRingEnd() {
    $bc22ec97a7463173$var$areaPoint($bc22ec97a7463173$var$lambda00, $bc22ec97a7463173$var$phi00);
}
function $bc22ec97a7463173$var$areaPointFirst(lambda, phi) {
    $bc22ec97a7463173$export$cb67cfa750ae69dc.point = $bc22ec97a7463173$var$areaPoint;
    $bc22ec97a7463173$var$lambda00 = lambda, $bc22ec97a7463173$var$phi00 = phi;
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    $bc22ec97a7463173$var$lambda0 = lambda, $bc22ec97a7463173$var$cosPhi0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi = phi / 2 + (0, $a95495fc7e2b96ad$export$c39a5cba78ea0fc2)), $bc22ec97a7463173$var$sinPhi0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi);
}
function $bc22ec97a7463173$var$areaPoint(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    phi = phi / 2 + (0, $a95495fc7e2b96ad$export$c39a5cba78ea0fc2); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $bc22ec97a7463173$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi), sinPhi = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), k = $bc22ec97a7463173$var$sinPhi0 * sinPhi, u = $bc22ec97a7463173$var$cosPhi0 * cosPhi + k * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(adLambda), v = k * sdLambda * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(adLambda);
    $bc22ec97a7463173$export$bf8f994332070c7f.add((0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(v, u));
    // Advance the previous points.
    $bc22ec97a7463173$var$lambda0 = lambda, $bc22ec97a7463173$var$cosPhi0 = cosPhi, $bc22ec97a7463173$var$sinPhi0 = sinPhi;
}
function $bc22ec97a7463173$export$2e2bcd8739ae039(object) {
    $bc22ec97a7463173$var$areaSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, $bc22ec97a7463173$export$cb67cfa750ae69dc);
    return $bc22ec97a7463173$var$areaSum * 2;
}





function $c6c8cb5fd36f99a5$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $c6c8cb5fd36f99a5$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda),
        (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi)
    ];
}
function $c6c8cb5fd36f99a5$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $c6c8cb5fd36f99a5$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $c6c8cb5fd36f99a5$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $c6c8cb5fd36f99a5$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $c6c8cb5fd36f99a5$export$6789498aec2cb34b(d) {
    var l = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}




var $acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$phi0, $acc575c874e2b89a$var$lambda1, $acc575c874e2b89a$var$phi1, $acc575c874e2b89a$var$lambda2, $acc575c874e2b89a$var$lambda00, $acc575c874e2b89a$var$phi00, $acc575c874e2b89a$var$p0, $acc575c874e2b89a$var$deltaSum, $acc575c874e2b89a$var$ranges, $acc575c874e2b89a$var$range;
var $acc575c874e2b89a$var$boundsStream = {
    point: $acc575c874e2b89a$var$boundsPoint,
    lineStart: $acc575c874e2b89a$var$boundsLineStart,
    lineEnd: $acc575c874e2b89a$var$boundsLineEnd,
    polygonStart: function() {
        $acc575c874e2b89a$var$boundsStream.point = $acc575c874e2b89a$var$boundsRingPoint;
        $acc575c874e2b89a$var$boundsStream.lineStart = $acc575c874e2b89a$var$boundsRingStart;
        $acc575c874e2b89a$var$boundsStream.lineEnd = $acc575c874e2b89a$var$boundsRingEnd;
        $acc575c874e2b89a$var$deltaSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
        (0, $bc22ec97a7463173$export$cb67cfa750ae69dc).polygonStart();
    },
    polygonEnd: function() {
        (0, $bc22ec97a7463173$export$cb67cfa750ae69dc).polygonEnd();
        $acc575c874e2b89a$var$boundsStream.point = $acc575c874e2b89a$var$boundsPoint;
        $acc575c874e2b89a$var$boundsStream.lineStart = $acc575c874e2b89a$var$boundsLineStart;
        $acc575c874e2b89a$var$boundsStream.lineEnd = $acc575c874e2b89a$var$boundsLineEnd;
        if ((0, $bc22ec97a7463173$export$bf8f994332070c7f) < 0) $acc575c874e2b89a$var$lambda0 = -($acc575c874e2b89a$var$lambda1 = 180), $acc575c874e2b89a$var$phi0 = -($acc575c874e2b89a$var$phi1 = 90);
        else if ($acc575c874e2b89a$var$deltaSum > (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) $acc575c874e2b89a$var$phi1 = 90;
        else if ($acc575c874e2b89a$var$deltaSum < -(0, $a95495fc7e2b96ad$export$6c421550c66a327d)) $acc575c874e2b89a$var$phi0 = -90;
        $acc575c874e2b89a$var$range[0] = $acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$range[1] = $acc575c874e2b89a$var$lambda1;
    },
    sphere: function() {
        $acc575c874e2b89a$var$lambda0 = -($acc575c874e2b89a$var$lambda1 = 180), $acc575c874e2b89a$var$phi0 = -($acc575c874e2b89a$var$phi1 = 90);
    }
};
function $acc575c874e2b89a$var$boundsPoint(lambda, phi) {
    $acc575c874e2b89a$var$ranges.push($acc575c874e2b89a$var$range = [
        $acc575c874e2b89a$var$lambda0 = lambda,
        $acc575c874e2b89a$var$lambda1 = lambda
    ]);
    if (phi < $acc575c874e2b89a$var$phi0) $acc575c874e2b89a$var$phi0 = phi;
    if (phi > $acc575c874e2b89a$var$phi1) $acc575c874e2b89a$var$phi1 = phi;
}
function $acc575c874e2b89a$var$linePoint(lambda, phi) {
    var p = (0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)([
        lambda * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc),
        phi * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc)
    ]);
    if ($acc575c874e2b89a$var$p0) {
        var normal = (0, $c6c8cb5fd36f99a5$export$4763f5351b14293f)($acc575c874e2b89a$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $c6c8cb5fd36f99a5$export$4763f5351b14293f)(equatorial, normal);
        (0, $c6c8cb5fd36f99a5$export$6789498aec2cb34b)(inflection);
        inflection = (0, $c6c8cb5fd36f99a5$export$12f9ad44fe773943)(inflection);
        var delta = lambda - $acc575c874e2b89a$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97) * sign, phii, antimeridian = (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(delta) > 180;
        if (antimeridian ^ (sign * $acc575c874e2b89a$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97);
            if (phii > $acc575c874e2b89a$var$phi1) $acc575c874e2b89a$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $acc575c874e2b89a$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97);
            if (phii < $acc575c874e2b89a$var$phi0) $acc575c874e2b89a$var$phi0 = phii;
        } else {
            if (phi < $acc575c874e2b89a$var$phi0) $acc575c874e2b89a$var$phi0 = phi;
            if (phi > $acc575c874e2b89a$var$phi1) $acc575c874e2b89a$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $acc575c874e2b89a$var$lambda2) {
                if ($acc575c874e2b89a$var$angle($acc575c874e2b89a$var$lambda0, lambda) > $acc575c874e2b89a$var$angle($acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$lambda1)) $acc575c874e2b89a$var$lambda1 = lambda;
            } else if ($acc575c874e2b89a$var$angle(lambda, $acc575c874e2b89a$var$lambda1) > $acc575c874e2b89a$var$angle($acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$lambda1)) $acc575c874e2b89a$var$lambda0 = lambda;
        } else if ($acc575c874e2b89a$var$lambda1 >= $acc575c874e2b89a$var$lambda0) {
            if (lambda < $acc575c874e2b89a$var$lambda0) $acc575c874e2b89a$var$lambda0 = lambda;
            if (lambda > $acc575c874e2b89a$var$lambda1) $acc575c874e2b89a$var$lambda1 = lambda;
        } else {
            if (lambda > $acc575c874e2b89a$var$lambda2) {
                if ($acc575c874e2b89a$var$angle($acc575c874e2b89a$var$lambda0, lambda) > $acc575c874e2b89a$var$angle($acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$lambda1)) $acc575c874e2b89a$var$lambda1 = lambda;
            } else if ($acc575c874e2b89a$var$angle(lambda, $acc575c874e2b89a$var$lambda1) > $acc575c874e2b89a$var$angle($acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$lambda1)) $acc575c874e2b89a$var$lambda0 = lambda;
        }
    } else $acc575c874e2b89a$var$ranges.push($acc575c874e2b89a$var$range = [
        $acc575c874e2b89a$var$lambda0 = lambda,
        $acc575c874e2b89a$var$lambda1 = lambda
    ]);
    if (phi < $acc575c874e2b89a$var$phi0) $acc575c874e2b89a$var$phi0 = phi;
    if (phi > $acc575c874e2b89a$var$phi1) $acc575c874e2b89a$var$phi1 = phi;
    $acc575c874e2b89a$var$p0 = p, $acc575c874e2b89a$var$lambda2 = lambda;
}
function $acc575c874e2b89a$var$boundsLineStart() {
    $acc575c874e2b89a$var$boundsStream.point = $acc575c874e2b89a$var$linePoint;
}
function $acc575c874e2b89a$var$boundsLineEnd() {
    $acc575c874e2b89a$var$range[0] = $acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$range[1] = $acc575c874e2b89a$var$lambda1;
    $acc575c874e2b89a$var$boundsStream.point = $acc575c874e2b89a$var$boundsPoint;
    $acc575c874e2b89a$var$p0 = null;
}
function $acc575c874e2b89a$var$boundsRingPoint(lambda, phi) {
    if ($acc575c874e2b89a$var$p0) {
        var delta = lambda - $acc575c874e2b89a$var$lambda2;
        $acc575c874e2b89a$var$deltaSum.add((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $acc575c874e2b89a$var$lambda00 = lambda, $acc575c874e2b89a$var$phi00 = phi;
    (0, $bc22ec97a7463173$export$cb67cfa750ae69dc).point(lambda, phi);
    $acc575c874e2b89a$var$linePoint(lambda, phi);
}
function $acc575c874e2b89a$var$boundsRingStart() {
    (0, $bc22ec97a7463173$export$cb67cfa750ae69dc).lineStart();
}
function $acc575c874e2b89a$var$boundsRingEnd() {
    $acc575c874e2b89a$var$boundsRingPoint($acc575c874e2b89a$var$lambda00, $acc575c874e2b89a$var$phi00);
    (0, $bc22ec97a7463173$export$cb67cfa750ae69dc).lineEnd();
    if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)($acc575c874e2b89a$var$deltaSum) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) $acc575c874e2b89a$var$lambda0 = -($acc575c874e2b89a$var$lambda1 = 180);
    $acc575c874e2b89a$var$range[0] = $acc575c874e2b89a$var$lambda0, $acc575c874e2b89a$var$range[1] = $acc575c874e2b89a$var$lambda1;
    $acc575c874e2b89a$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $acc575c874e2b89a$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $acc575c874e2b89a$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $acc575c874e2b89a$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $acc575c874e2b89a$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $acc575c874e2b89a$var$phi1 = $acc575c874e2b89a$var$lambda1 = -($acc575c874e2b89a$var$lambda0 = $acc575c874e2b89a$var$phi0 = Infinity);
    $acc575c874e2b89a$var$ranges = [];
    (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(feature, $acc575c874e2b89a$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $acc575c874e2b89a$var$ranges.length) {
        $acc575c874e2b89a$var$ranges.sort($acc575c874e2b89a$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $acc575c874e2b89a$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $acc575c874e2b89a$var$ranges[i];
            if ($acc575c874e2b89a$var$rangeContains(a, b[0]) || $acc575c874e2b89a$var$rangeContains(a, b[1])) {
                if ($acc575c874e2b89a$var$angle(a[0], b[1]) > $acc575c874e2b89a$var$angle(a[0], a[1])) a[1] = b[1];
                if ($acc575c874e2b89a$var$angle(b[0], a[1]) > $acc575c874e2b89a$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $acc575c874e2b89a$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $acc575c874e2b89a$var$lambda0 = b[0], $acc575c874e2b89a$var$lambda1 = a[1];
        }
    }
    $acc575c874e2b89a$var$ranges = $acc575c874e2b89a$var$range = null;
    return $acc575c874e2b89a$var$lambda0 === Infinity || $acc575c874e2b89a$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $acc575c874e2b89a$var$lambda0,
            $acc575c874e2b89a$var$phi0
        ],
        [
            $acc575c874e2b89a$var$lambda1,
            $acc575c874e2b89a$var$phi1
        ]
    ];
}






var $c990cf62d39b38ec$var$W0, $c990cf62d39b38ec$var$W1, $c990cf62d39b38ec$var$X0, $c990cf62d39b38ec$var$Y0, $c990cf62d39b38ec$var$Z0, $c990cf62d39b38ec$var$X1, $c990cf62d39b38ec$var$Y1, $c990cf62d39b38ec$var$Z1, $c990cf62d39b38ec$var$X2, $c990cf62d39b38ec$var$Y2, $c990cf62d39b38ec$var$Z2, $c990cf62d39b38ec$var$lambda00, $c990cf62d39b38ec$var$phi00, $c990cf62d39b38ec$var$x0, $c990cf62d39b38ec$var$y0, $c990cf62d39b38ec$var$z0; // previous point
var $c990cf62d39b38ec$var$centroidStream = {
    sphere: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    point: $c990cf62d39b38ec$var$centroidPoint,
    lineStart: $c990cf62d39b38ec$var$centroidLineStart,
    lineEnd: $c990cf62d39b38ec$var$centroidLineEnd,
    polygonStart: function() {
        $c990cf62d39b38ec$var$centroidStream.lineStart = $c990cf62d39b38ec$var$centroidRingStart;
        $c990cf62d39b38ec$var$centroidStream.lineEnd = $c990cf62d39b38ec$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $c990cf62d39b38ec$var$centroidStream.lineStart = $c990cf62d39b38ec$var$centroidLineStart;
        $c990cf62d39b38ec$var$centroidStream.lineEnd = $c990cf62d39b38ec$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $c990cf62d39b38ec$var$centroidPoint(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi);
    $c990cf62d39b38ec$var$centroidPointCartesian(cosPhi * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda), cosPhi * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda), (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi));
}
function $c990cf62d39b38ec$var$centroidPointCartesian(x, y, z) {
    ++$c990cf62d39b38ec$var$W0;
    $c990cf62d39b38ec$var$X0 += (x - $c990cf62d39b38ec$var$X0) / $c990cf62d39b38ec$var$W0;
    $c990cf62d39b38ec$var$Y0 += (y - $c990cf62d39b38ec$var$Y0) / $c990cf62d39b38ec$var$W0;
    $c990cf62d39b38ec$var$Z0 += (z - $c990cf62d39b38ec$var$Z0) / $c990cf62d39b38ec$var$W0;
}
function $c990cf62d39b38ec$var$centroidLineStart() {
    $c990cf62d39b38ec$var$centroidStream.point = $c990cf62d39b38ec$var$centroidLinePointFirst;
}
function $c990cf62d39b38ec$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi);
    $c990cf62d39b38ec$var$x0 = cosPhi * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda);
    $c990cf62d39b38ec$var$y0 = cosPhi * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda);
    $c990cf62d39b38ec$var$z0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi);
    $c990cf62d39b38ec$var$centroidStream.point = $c990cf62d39b38ec$var$centroidLinePoint;
    $c990cf62d39b38ec$var$centroidPointCartesian($c990cf62d39b38ec$var$x0, $c990cf62d39b38ec$var$y0, $c990cf62d39b38ec$var$z0);
}
function $c990cf62d39b38ec$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi), x = cosPhi * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda), z = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), w = (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)((0, $a95495fc7e2b96ad$export$eba8049fb5020b81)((w = $c990cf62d39b38ec$var$y0 * z - $c990cf62d39b38ec$var$z0 * y) * w + (w = $c990cf62d39b38ec$var$z0 * x - $c990cf62d39b38ec$var$x0 * z) * w + (w = $c990cf62d39b38ec$var$x0 * y - $c990cf62d39b38ec$var$y0 * x) * w), $c990cf62d39b38ec$var$x0 * x + $c990cf62d39b38ec$var$y0 * y + $c990cf62d39b38ec$var$z0 * z);
    $c990cf62d39b38ec$var$W1 += w;
    $c990cf62d39b38ec$var$X1 += w * ($c990cf62d39b38ec$var$x0 + ($c990cf62d39b38ec$var$x0 = x));
    $c990cf62d39b38ec$var$Y1 += w * ($c990cf62d39b38ec$var$y0 + ($c990cf62d39b38ec$var$y0 = y));
    $c990cf62d39b38ec$var$Z1 += w * ($c990cf62d39b38ec$var$z0 + ($c990cf62d39b38ec$var$z0 = z));
    $c990cf62d39b38ec$var$centroidPointCartesian($c990cf62d39b38ec$var$x0, $c990cf62d39b38ec$var$y0, $c990cf62d39b38ec$var$z0);
}
function $c990cf62d39b38ec$var$centroidLineEnd() {
    $c990cf62d39b38ec$var$centroidStream.point = $c990cf62d39b38ec$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $c990cf62d39b38ec$var$centroidRingStart() {
    $c990cf62d39b38ec$var$centroidStream.point = $c990cf62d39b38ec$var$centroidRingPointFirst;
}
function $c990cf62d39b38ec$var$centroidRingEnd() {
    $c990cf62d39b38ec$var$centroidRingPoint($c990cf62d39b38ec$var$lambda00, $c990cf62d39b38ec$var$phi00);
    $c990cf62d39b38ec$var$centroidStream.point = $c990cf62d39b38ec$var$centroidPoint;
}
function $c990cf62d39b38ec$var$centroidRingPointFirst(lambda, phi) {
    $c990cf62d39b38ec$var$lambda00 = lambda, $c990cf62d39b38ec$var$phi00 = phi;
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    $c990cf62d39b38ec$var$centroidStream.point = $c990cf62d39b38ec$var$centroidRingPoint;
    var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi);
    $c990cf62d39b38ec$var$x0 = cosPhi * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda);
    $c990cf62d39b38ec$var$y0 = cosPhi * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda);
    $c990cf62d39b38ec$var$z0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi);
    $c990cf62d39b38ec$var$centroidPointCartesian($c990cf62d39b38ec$var$x0, $c990cf62d39b38ec$var$y0, $c990cf62d39b38ec$var$z0);
}
function $c990cf62d39b38ec$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi), x = cosPhi * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda), z = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), cx = $c990cf62d39b38ec$var$y0 * z - $c990cf62d39b38ec$var$z0 * y, cy = $c990cf62d39b38ec$var$z0 * x - $c990cf62d39b38ec$var$x0 * z, cz = $c990cf62d39b38ec$var$x0 * y - $c990cf62d39b38ec$var$y0 * x, m = (0, $a95495fc7e2b96ad$export$f95c7888b62f8e9a)(cx, cy, cz), w = (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(m), v = m && -w / m; // area weight multiplier
    $c990cf62d39b38ec$var$X2.add(v * cx);
    $c990cf62d39b38ec$var$Y2.add(v * cy);
    $c990cf62d39b38ec$var$Z2.add(v * cz);
    $c990cf62d39b38ec$var$W1 += w;
    $c990cf62d39b38ec$var$X1 += w * ($c990cf62d39b38ec$var$x0 + ($c990cf62d39b38ec$var$x0 = x));
    $c990cf62d39b38ec$var$Y1 += w * ($c990cf62d39b38ec$var$y0 + ($c990cf62d39b38ec$var$y0 = y));
    $c990cf62d39b38ec$var$Z1 += w * ($c990cf62d39b38ec$var$z0 + ($c990cf62d39b38ec$var$z0 = z));
    $c990cf62d39b38ec$var$centroidPointCartesian($c990cf62d39b38ec$var$x0, $c990cf62d39b38ec$var$y0, $c990cf62d39b38ec$var$z0);
}
function $c990cf62d39b38ec$export$2e2bcd8739ae039(object) {
    $c990cf62d39b38ec$var$W0 = $c990cf62d39b38ec$var$W1 = $c990cf62d39b38ec$var$X0 = $c990cf62d39b38ec$var$Y0 = $c990cf62d39b38ec$var$Z0 = $c990cf62d39b38ec$var$X1 = $c990cf62d39b38ec$var$Y1 = $c990cf62d39b38ec$var$Z1 = 0;
    $c990cf62d39b38ec$var$X2 = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    $c990cf62d39b38ec$var$Y2 = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    $c990cf62d39b38ec$var$Z2 = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, $c990cf62d39b38ec$var$centroidStream);
    var x = +$c990cf62d39b38ec$var$X2, y = +$c990cf62d39b38ec$var$Y2, z = +$c990cf62d39b38ec$var$Z2, m = (0, $a95495fc7e2b96ad$export$f95c7888b62f8e9a)(x, y, z);
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $a95495fc7e2b96ad$export$92c06fba281fe81b)) {
        x = $c990cf62d39b38ec$var$X1, y = $c990cf62d39b38ec$var$Y1, z = $c990cf62d39b38ec$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($c990cf62d39b38ec$var$W1 < (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) x = $c990cf62d39b38ec$var$X0, y = $c990cf62d39b38ec$var$Y0, z = $c990cf62d39b38ec$var$Z0;
        m = (0, $a95495fc7e2b96ad$export$f95c7888b62f8e9a)(x, y, z);
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $a95495fc7e2b96ad$export$92c06fba281fe81b)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(y, x) * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
        (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(z / m) * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
    ];
}



function $4c24db66a1462ceb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $16efbdf626bbc080$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $e96038c603a78247$var$rotationIdentity(lambda, phi) {
    return [
        (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(lambda) > (0, $a95495fc7e2b96ad$export$18c7bea995a110f) ? lambda + Math.round(-lambda / (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92)) * (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) : lambda,
        phi
    ];
}
$e96038c603a78247$var$rotationIdentity.invert = $e96038c603a78247$var$rotationIdentity;
function $e96038c603a78247$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $16efbdf626bbc080$export$2e2bcd8739ae039)($e96038c603a78247$var$rotationLambda(deltaLambda), $e96038c603a78247$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $e96038c603a78247$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $e96038c603a78247$var$rotationPhiGamma(deltaPhi, deltaGamma) : $e96038c603a78247$var$rotationIdentity;
}
function $e96038c603a78247$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $a95495fc7e2b96ad$export$18c7bea995a110f) ? lambda - (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) : lambda < -(0, $a95495fc7e2b96ad$export$18c7bea995a110f) ? lambda + (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) : lambda,
            phi
        ];
    };
}
function $e96038c603a78247$var$rotationLambda(deltaLambda) {
    var rotation = $e96038c603a78247$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $e96038c603a78247$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $e96038c603a78247$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi), x = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi), x = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $e96038c603a78247$export$2e2bcd8739ae039(rotate) {
    rotate = $e96038c603a78247$export$a2ba89726971a90f(rotate[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), rotate[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), coordinates[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $a95495fc7e2b96ad$export$41fc368e1a942b97), coordinates[1] *= (0, $a95495fc7e2b96ad$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), coordinates[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $a95495fc7e2b96ad$export$41fc368e1a942b97), coordinates[1] *= (0, $a95495fc7e2b96ad$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $9a3b436ca5e33308$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(radius), sinRadius = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $9a3b436ca5e33308$var$circleRadius(cosRadius, t0);
        t1 = $9a3b436ca5e33308$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $c6c8cb5fd36f99a5$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(t),
            -sinRadius * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $9a3b436ca5e33308$var$circleRadius(cosRadius, point) {
    point = (0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $c6c8cb5fd36f99a5$export$6789498aec2cb34b)(point);
    var radius = (0, $a95495fc7e2b96ad$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) - (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) % (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92);
}
function $9a3b436ca5e33308$export$2e2bcd8739ae039() {
    var center = (0, $4c24db66a1462ceb$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $4c24db66a1462ceb$export$2e2bcd8739ae039)(90), precision = (0, $4c24db66a1462ceb$export$2e2bcd8739ae039)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $a95495fc7e2b96ad$export$41fc368e1a942b97), x[1] *= (0, $a95495fc7e2b96ad$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $e96038c603a78247$export$a2ba89726971a90f)(-c[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), -c[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), 0).invert;
        $9a3b436ca5e33308$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $4c24db66a1462ceb$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $4c24db66a1462ceb$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $4c24db66a1462ceb$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}



function $24d41f2dced09a3b$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $0634a65b970ab0dd$export$2e2bcd8739ae039(a, b) {
    return (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) && (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
}



function $a3b7e3ee22bb04f2$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $a3b7e3ee22bb04f2$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $0634a65b970ab0dd$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
        }
        subject.push(x = new $a3b7e3ee22bb04f2$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $a3b7e3ee22bb04f2$var$Intersection(p0, null, x, false));
        subject.push(x = new $a3b7e3ee22bb04f2$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $a3b7e3ee22bb04f2$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $a3b7e3ee22bb04f2$var$link(subject);
    $a3b7e3ee22bb04f2$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $a3b7e3ee22bb04f2$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}






function $1ec2f4e71ea98b34$var$longitude(point) {
    if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(point[0]) <= (0, $a95495fc7e2b96ad$export$18c7bea995a110f)) return point[0];
    else return (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(point[0]) * (((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(point[0]) + (0, $a95495fc7e2b96ad$export$18c7bea995a110f)) % (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) - (0, $a95495fc7e2b96ad$export$18c7bea995a110f));
}
function $1ec2f4e71ea98b34$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $1ec2f4e71ea98b34$var$longitude(point), phi = point[1], sinPhi = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), normal = [
        (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda),
        -(0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $a95495fc7e2b96ad$export$e51408a300e8929a) + (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $a95495fc7e2b96ad$export$e51408a300e8929a) - (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $1ec2f4e71ea98b34$var$longitude(point0), phi0 = point0[1] / 2 + (0, $a95495fc7e2b96ad$export$c39a5cba78ea0fc2), sinPhi0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $1ec2f4e71ea98b34$var$longitude(point1), phi1 = point1[1] / 2 + (0, $a95495fc7e2b96ad$export$c39a5cba78ea0fc2), sinPhi1 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $a95495fc7e2b96ad$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(k * sign * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $c6c8cb5fd36f99a5$export$4763f5351b14293f)((0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)(point0), (0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)(point1));
                (0, $c6c8cb5fd36f99a5$export$6789498aec2cb34b)(arc);
                var intersection = (0, $c6c8cb5fd36f99a5$export$4763f5351b14293f)(normal, arc);
                (0, $c6c8cb5fd36f99a5$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $a95495fc7e2b96ad$export$6c421550c66a327d) || angle < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) && sum < -(0, $a95495fc7e2b96ad$export$92c06fba281fe81b)) ^ winding & 1;
}



function $888282b63c598bf3$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $24d41f2dced09a3b$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $8a226ba821d468da$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $1ec2f4e71ea98b34$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $a3b7e3ee22bb04f2$export$2e2bcd8739ae039)(segments, $888282b63c598bf3$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($888282b63c598bf3$var$validSegment));
        }
        return clip;
    };
}
function $888282b63c598bf3$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $888282b63c598bf3$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $a95495fc7e2b96ad$export$e51408a300e8929a) - (0, $a95495fc7e2b96ad$export$6c421550c66a327d) : (0, $a95495fc7e2b96ad$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $a95495fc7e2b96ad$export$e51408a300e8929a) - (0, $a95495fc7e2b96ad$export$6c421550c66a327d) : (0, $a95495fc7e2b96ad$export$e51408a300e8929a) - b[1]);
}



var $77ecf5d7118d4e24$export$2e2bcd8739ae039 = (0, $888282b63c598bf3$export$2e2bcd8739ae039)(function() {
    return true;
}, $77ecf5d7118d4e24$var$clipAntimeridianLine, $77ecf5d7118d4e24$var$clipAntimeridianInterpolate, [
    -(0, $a95495fc7e2b96ad$export$18c7bea995a110f),
    -(0, $a95495fc7e2b96ad$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $77ecf5d7118d4e24$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $a95495fc7e2b96ad$export$18c7bea995a110f) : -(0, $a95495fc7e2b96ad$export$18c7bea995a110f), delta = (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(delta - (0, $a95495fc7e2b96ad$export$18c7bea995a110f)) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $a95495fc7e2b96ad$export$e51408a300e8929a) : -(0, $a95495fc7e2b96ad$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $a95495fc7e2b96ad$export$18c7bea995a110f)) {
                if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $a95495fc7e2b96ad$export$6c421550c66a327d); // handle degeneracies
                if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
                phi0 = $77ecf5d7118d4e24$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $77ecf5d7118d4e24$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d) ? (0, $a95495fc7e2b96ad$export$628dc4eed22b0fbd)(((0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi1)) * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda1) - (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi0)) * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $77ecf5d7118d4e24$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $a95495fc7e2b96ad$export$e51408a300e8929a);
        stream.point(-(0, $a95495fc7e2b96ad$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $a95495fc7e2b96ad$export$18c7bea995a110f), phi);
        stream.point((0, $a95495fc7e2b96ad$export$18c7bea995a110f), 0);
        stream.point((0, $a95495fc7e2b96ad$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $a95495fc7e2b96ad$export$18c7bea995a110f), -phi);
        stream.point(-(0, $a95495fc7e2b96ad$export$18c7bea995a110f), 0);
        stream.point(-(0, $a95495fc7e2b96ad$export$18c7bea995a110f), phi);
    } else if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $a95495fc7e2b96ad$export$18c7bea995a110f) : -(0, $a95495fc7e2b96ad$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}







function $2c12f65a02141e37$export$2e2bcd8739ae039(radius) {
    var cr = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(radius), delta = 6 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(cr) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $9a3b436ca5e33308$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(lambda) * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $a95495fc7e2b96ad$export$18c7bea995a110f) : -(0, $a95495fc7e2b96ad$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $0634a65b970ab0dd$export$2e2bcd8739ae039)(point0, point2) || (0, $0634a65b970ab0dd$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $0634a65b970ab0dd$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)(a), pb = (0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $c6c8cb5fd36f99a5$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $c6c8cb5fd36f99a5$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $c6c8cb5fd36f99a5$export$4763f5351b14293f)(n1, n2), A = (0, $c6c8cb5fd36f99a5$export$52d0ee3fc868d452)(n1, c1), B = (0, $c6c8cb5fd36f99a5$export$52d0ee3fc868d452)(n2, c2);
        (0, $c6c8cb5fd36f99a5$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $c6c8cb5fd36f99a5$export$2ef80f51436a9de9)(A, u), uu = (0, $c6c8cb5fd36f99a5$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $c6c8cb5fd36f99a5$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(t2), q = (0, $c6c8cb5fd36f99a5$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $c6c8cb5fd36f99a5$export$e62eba72fc898eae)(q, A);
        q = (0, $c6c8cb5fd36f99a5$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(delta - (0, $a95495fc7e2b96ad$export$18c7bea995a110f)) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d), meridian = polar || delta < (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $a95495fc7e2b96ad$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $c6c8cb5fd36f99a5$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $c6c8cb5fd36f99a5$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $c6c8cb5fd36f99a5$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $a95495fc7e2b96ad$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $888282b63c598bf3$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $a95495fc7e2b96ad$export$18c7bea995a110f),
        radius - (0, $a95495fc7e2b96ad$export$18c7bea995a110f)
    ]);
}




function $b3c9e50b3778d5e3$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $c40b90e739aa0c57$var$clipMax = 1e9, $c40b90e739aa0c57$var$clipMin = -$c40b90e739aa0c57$var$clipMax;
function $c40b90e739aa0c57$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(p[0] - x0) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(p[0] - x1) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(p[1] - y0) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $24d41f2dced09a3b$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $8a226ba821d468da$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $a3b7e3ee22bb04f2$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($c40b90e739aa0c57$var$clipMin, Math.min($c40b90e739aa0c57$var$clipMax, x_)),
                    y_ = Math.max($c40b90e739aa0c57$var$clipMin, Math.min($c40b90e739aa0c57$var$clipMax, y_))
                ], b = [
                    x = Math.max($c40b90e739aa0c57$var$clipMin, Math.min($c40b90e739aa0c57$var$clipMax, x)),
                    y = Math.max($c40b90e739aa0c57$var$clipMin, Math.min($c40b90e739aa0c57$var$clipMax, y))
                ];
                if ((0, $b3c9e50b3778d5e3$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}


function $074050eb8b890992$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $c40b90e739aa0c57$export$2e2bcd8739ae039)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}








var $6ec010e8f5535f93$var$lengthSum, $6ec010e8f5535f93$var$lambda0, $6ec010e8f5535f93$var$sinPhi0, $6ec010e8f5535f93$var$cosPhi0;
var $6ec010e8f5535f93$var$lengthStream = {
    sphere: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    point: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineStart: $6ec010e8f5535f93$var$lengthLineStart,
    lineEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    polygonStart: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    polygonEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039)
};
function $6ec010e8f5535f93$var$lengthLineStart() {
    $6ec010e8f5535f93$var$lengthStream.point = $6ec010e8f5535f93$var$lengthPointFirst;
    $6ec010e8f5535f93$var$lengthStream.lineEnd = $6ec010e8f5535f93$var$lengthLineEnd;
}
function $6ec010e8f5535f93$var$lengthLineEnd() {
    $6ec010e8f5535f93$var$lengthStream.point = $6ec010e8f5535f93$var$lengthStream.lineEnd = (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039);
}
function $6ec010e8f5535f93$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    $6ec010e8f5535f93$var$lambda0 = lambda, $6ec010e8f5535f93$var$sinPhi0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), $6ec010e8f5535f93$var$cosPhi0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi);
    $6ec010e8f5535f93$var$lengthStream.point = $6ec010e8f5535f93$var$lengthPoint;
}
function $6ec010e8f5535f93$var$lengthPoint(lambda, phi) {
    lambda *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi *= (0, $a95495fc7e2b96ad$export$8449e153fbd325fc);
    var sinPhi = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi), cosPhi = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi), delta = (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(lambda - $6ec010e8f5535f93$var$lambda0), cosDelta = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(delta), sinDelta = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(delta), x = cosPhi * sinDelta, y = $6ec010e8f5535f93$var$cosPhi0 * sinPhi - $6ec010e8f5535f93$var$sinPhi0 * cosPhi * cosDelta, z = $6ec010e8f5535f93$var$sinPhi0 * sinPhi + $6ec010e8f5535f93$var$cosPhi0 * cosPhi * cosDelta;
    $6ec010e8f5535f93$var$lengthSum.add((0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)((0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(x * x + y * y), z));
    $6ec010e8f5535f93$var$lambda0 = lambda, $6ec010e8f5535f93$var$sinPhi0 = sinPhi, $6ec010e8f5535f93$var$cosPhi0 = cosPhi;
}
function $6ec010e8f5535f93$export$2e2bcd8739ae039(object) {
    $6ec010e8f5535f93$var$lengthSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, $6ec010e8f5535f93$var$lengthStream);
    return +$6ec010e8f5535f93$var$lengthSum;
}


var $1778a7fd0aead7df$var$coordinates = [
    null,
    null
], $1778a7fd0aead7df$var$object = {
    type: "LineString",
    coordinates: $1778a7fd0aead7df$var$coordinates
};
function $1778a7fd0aead7df$export$2e2bcd8739ae039(a, b) {
    $1778a7fd0aead7df$var$coordinates[0] = a;
    $1778a7fd0aead7df$var$coordinates[1] = b;
    return (0, $6ec010e8f5535f93$export$2e2bcd8739ae039)($1778a7fd0aead7df$var$object);
}



var $4144a31ba5603c5a$var$containsObjectType = {
    Feature: function(object, point) {
        return $4144a31ba5603c5a$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($4144a31ba5603c5a$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $4144a31ba5603c5a$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $4144a31ba5603c5a$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($4144a31ba5603c5a$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $4144a31ba5603c5a$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($4144a31ba5603c5a$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $4144a31ba5603c5a$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($4144a31ba5603c5a$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($4144a31ba5603c5a$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $4144a31ba5603c5a$var$containsGeometry(geometry, point) {
    return geometry && $4144a31ba5603c5a$var$containsGeometryType.hasOwnProperty(geometry.type) ? $4144a31ba5603c5a$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $4144a31ba5603c5a$var$containsPoint(coordinates, point) {
    return (0, $1778a7fd0aead7df$export$2e2bcd8739ae039)(coordinates, point) === 0;
}
function $4144a31ba5603c5a$var$containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, $1778a7fd0aead7df$export$2e2bcd8739ae039)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, $1778a7fd0aead7df$export$2e2bcd8739ae039)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, $a95495fc7e2b96ad$export$92c06fba281fe81b) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function $4144a31ba5603c5a$var$containsPolygon(coordinates, point) {
    return !!(0, $1ec2f4e71ea98b34$export$2e2bcd8739ae039)(coordinates.map($4144a31ba5603c5a$var$ringRadians), $4144a31ba5603c5a$var$pointRadians(point));
}
function $4144a31ba5603c5a$var$ringRadians(ring) {
    return ring = ring.map($4144a31ba5603c5a$var$pointRadians), ring.pop(), ring;
}
function $4144a31ba5603c5a$var$pointRadians(point) {
    return [
        point[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc),
        point[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc)
    ];
}
function $4144a31ba5603c5a$export$2e2bcd8739ae039(object, point) {
    return (object && $4144a31ba5603c5a$var$containsObjectType.hasOwnProperty(object.type) ? $4144a31ba5603c5a$var$containsObjectType[object.type] : $4144a31ba5603c5a$var$containsGeometry)(object, point);
}





function $9c6c7ba3ea47ad20$var$graticuleX(y0, y1, dy) {
    var y = (0, $a9c85d866204d0d0$export$2e2bcd8739ae039)(y0, y1 - (0, $a95495fc7e2b96ad$export$6c421550c66a327d), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $9c6c7ba3ea47ad20$var$graticuleY(x0, x1, dx) {
    var x = (0, $a9c85d866204d0d0$export$2e2bcd8739ae039)(x0, x1 - (0, $a95495fc7e2b96ad$export$6c421550c66a327d), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $9c6c7ba3ea47ad20$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $a9c85d866204d0d0$export$2e2bcd8739ae039)((0, $a95495fc7e2b96ad$export$803ce6b71a0a94b2)(X0 / DX) * DX, X1, DX).map(X).concat((0, $a9c85d866204d0d0$export$2e2bcd8739ae039)((0, $a95495fc7e2b96ad$export$803ce6b71a0a94b2)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $a9c85d866204d0d0$export$2e2bcd8739ae039)((0, $a95495fc7e2b96ad$export$803ce6b71a0a94b2)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(x % DX) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
        }).map(x)).concat((0, $a9c85d866204d0d0$export$2e2bcd8739ae039)((0, $a95495fc7e2b96ad$export$803ce6b71a0a94b2)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(y % DY) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $9c6c7ba3ea47ad20$var$graticuleX(y0, y1, 90);
        y = $9c6c7ba3ea47ad20$var$graticuleY(x0, x1, precision);
        X = $9c6c7ba3ea47ad20$var$graticuleX(Y0, Y1, 90);
        Y = $9c6c7ba3ea47ad20$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
        ],
        [
            180,
            90 - (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
        ],
        [
            180,
            80 + (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
        ]
    ]);
}
function $9c6c7ba3ea47ad20$export$b8db4e9403a5b6f1() {
    return $9c6c7ba3ea47ad20$export$2e2bcd8739ae039()();
}



function $bd252e0f920822bf$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), y0 = a[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), x1 = b[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), y1 = b[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), cy0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y0), sy0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y0), cy1 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y1), sy1 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y1), kx0 = cy0 * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(x0), ky0 = cy0 * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x0), kx1 = cy1 * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(x1), ky1 = cy1 * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x1), d = 2 * (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)((0, $a95495fc7e2b96ad$export$eba8049fb5020b81)((0, $a95495fc7e2b96ad$export$e808712c2966e662)(y1 - y0) + cy0 * cy1 * (0, $a95495fc7e2b96ad$export$e808712c2966e662)(x1 - x0))), k = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(d);
    var interpolate = d ? function(t) {
        var B = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(t *= d) / k, A = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(y, x) * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(z, (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(x * x + y * y)) * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
        ];
    } : function() {
        return [
            x0 * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            y0 * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}



var $47e818e203efbb6b$export$2e2bcd8739ae039 = (x)=>x;






var $5a819607af34fa0d$var$areaSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)(), $5a819607af34fa0d$var$areaRingSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)(), $5a819607af34fa0d$var$x00, $5a819607af34fa0d$var$y00, $5a819607af34fa0d$var$x0, $5a819607af34fa0d$var$y0;
var $5a819607af34fa0d$var$areaStream = {
    point: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineStart: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    polygonStart: function() {
        $5a819607af34fa0d$var$areaStream.lineStart = $5a819607af34fa0d$var$areaRingStart;
        $5a819607af34fa0d$var$areaStream.lineEnd = $5a819607af34fa0d$var$areaRingEnd;
    },
    polygonEnd: function() {
        $5a819607af34fa0d$var$areaStream.lineStart = $5a819607af34fa0d$var$areaStream.lineEnd = $5a819607af34fa0d$var$areaStream.point = (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039);
        $5a819607af34fa0d$var$areaSum.add((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)($5a819607af34fa0d$var$areaRingSum));
        $5a819607af34fa0d$var$areaRingSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $5a819607af34fa0d$var$areaSum / 2;
        $5a819607af34fa0d$var$areaSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
        return area;
    }
};
function $5a819607af34fa0d$var$areaRingStart() {
    $5a819607af34fa0d$var$areaStream.point = $5a819607af34fa0d$var$areaPointFirst;
}
function $5a819607af34fa0d$var$areaPointFirst(x, y) {
    $5a819607af34fa0d$var$areaStream.point = $5a819607af34fa0d$var$areaPoint;
    $5a819607af34fa0d$var$x00 = $5a819607af34fa0d$var$x0 = x, $5a819607af34fa0d$var$y00 = $5a819607af34fa0d$var$y0 = y;
}
function $5a819607af34fa0d$var$areaPoint(x, y) {
    $5a819607af34fa0d$var$areaRingSum.add($5a819607af34fa0d$var$y0 * x - $5a819607af34fa0d$var$x0 * y);
    $5a819607af34fa0d$var$x0 = x, $5a819607af34fa0d$var$y0 = y;
}
function $5a819607af34fa0d$var$areaRingEnd() {
    $5a819607af34fa0d$var$areaPoint($5a819607af34fa0d$var$x00, $5a819607af34fa0d$var$y00);
}
var $5a819607af34fa0d$export$2e2bcd8739ae039 = $5a819607af34fa0d$var$areaStream;



var $21e11723b3ed3305$var$x0 = Infinity, $21e11723b3ed3305$var$y0 = $21e11723b3ed3305$var$x0, $21e11723b3ed3305$var$x1 = -$21e11723b3ed3305$var$x0, $21e11723b3ed3305$var$y1 = $21e11723b3ed3305$var$x1;
var $21e11723b3ed3305$var$boundsStream = {
    point: $21e11723b3ed3305$var$boundsPoint,
    lineStart: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    polygonStart: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    polygonEnd: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $21e11723b3ed3305$var$x0,
                $21e11723b3ed3305$var$y0
            ],
            [
                $21e11723b3ed3305$var$x1,
                $21e11723b3ed3305$var$y1
            ]
        ];
        $21e11723b3ed3305$var$x1 = $21e11723b3ed3305$var$y1 = -($21e11723b3ed3305$var$y0 = $21e11723b3ed3305$var$x0 = Infinity);
        return bounds;
    }
};
function $21e11723b3ed3305$var$boundsPoint(x, y) {
    if (x < $21e11723b3ed3305$var$x0) $21e11723b3ed3305$var$x0 = x;
    if (x > $21e11723b3ed3305$var$x1) $21e11723b3ed3305$var$x1 = x;
    if (y < $21e11723b3ed3305$var$y0) $21e11723b3ed3305$var$y0 = y;
    if (y > $21e11723b3ed3305$var$y1) $21e11723b3ed3305$var$y1 = y;
}
var $21e11723b3ed3305$export$2e2bcd8739ae039 = $21e11723b3ed3305$var$boundsStream;



// TODO Enforce positive area for exterior, negative area for interior?
var $5017720562176d5c$var$X0 = 0, $5017720562176d5c$var$Y0 = 0, $5017720562176d5c$var$Z0 = 0, $5017720562176d5c$var$X1 = 0, $5017720562176d5c$var$Y1 = 0, $5017720562176d5c$var$Z1 = 0, $5017720562176d5c$var$X2 = 0, $5017720562176d5c$var$Y2 = 0, $5017720562176d5c$var$Z2 = 0, $5017720562176d5c$var$x00, $5017720562176d5c$var$y00, $5017720562176d5c$var$x0, $5017720562176d5c$var$y0;
var $5017720562176d5c$var$centroidStream = {
    point: $5017720562176d5c$var$centroidPoint,
    lineStart: $5017720562176d5c$var$centroidLineStart,
    lineEnd: $5017720562176d5c$var$centroidLineEnd,
    polygonStart: function() {
        $5017720562176d5c$var$centroidStream.lineStart = $5017720562176d5c$var$centroidRingStart;
        $5017720562176d5c$var$centroidStream.lineEnd = $5017720562176d5c$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $5017720562176d5c$var$centroidStream.point = $5017720562176d5c$var$centroidPoint;
        $5017720562176d5c$var$centroidStream.lineStart = $5017720562176d5c$var$centroidLineStart;
        $5017720562176d5c$var$centroidStream.lineEnd = $5017720562176d5c$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $5017720562176d5c$var$Z2 ? [
            $5017720562176d5c$var$X2 / $5017720562176d5c$var$Z2,
            $5017720562176d5c$var$Y2 / $5017720562176d5c$var$Z2
        ] : $5017720562176d5c$var$Z1 ? [
            $5017720562176d5c$var$X1 / $5017720562176d5c$var$Z1,
            $5017720562176d5c$var$Y1 / $5017720562176d5c$var$Z1
        ] : $5017720562176d5c$var$Z0 ? [
            $5017720562176d5c$var$X0 / $5017720562176d5c$var$Z0,
            $5017720562176d5c$var$Y0 / $5017720562176d5c$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $5017720562176d5c$var$X0 = $5017720562176d5c$var$Y0 = $5017720562176d5c$var$Z0 = $5017720562176d5c$var$X1 = $5017720562176d5c$var$Y1 = $5017720562176d5c$var$Z1 = $5017720562176d5c$var$X2 = $5017720562176d5c$var$Y2 = $5017720562176d5c$var$Z2 = 0;
        return centroid;
    }
};
function $5017720562176d5c$var$centroidPoint(x, y) {
    $5017720562176d5c$var$X0 += x;
    $5017720562176d5c$var$Y0 += y;
    ++$5017720562176d5c$var$Z0;
}
function $5017720562176d5c$var$centroidLineStart() {
    $5017720562176d5c$var$centroidStream.point = $5017720562176d5c$var$centroidPointFirstLine;
}
function $5017720562176d5c$var$centroidPointFirstLine(x, y) {
    $5017720562176d5c$var$centroidStream.point = $5017720562176d5c$var$centroidPointLine;
    $5017720562176d5c$var$centroidPoint($5017720562176d5c$var$x0 = x, $5017720562176d5c$var$y0 = y);
}
function $5017720562176d5c$var$centroidPointLine(x, y) {
    var dx = x - $5017720562176d5c$var$x0, dy = y - $5017720562176d5c$var$y0, z = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $5017720562176d5c$var$X1 += z * ($5017720562176d5c$var$x0 + x) / 2;
    $5017720562176d5c$var$Y1 += z * ($5017720562176d5c$var$y0 + y) / 2;
    $5017720562176d5c$var$Z1 += z;
    $5017720562176d5c$var$centroidPoint($5017720562176d5c$var$x0 = x, $5017720562176d5c$var$y0 = y);
}
function $5017720562176d5c$var$centroidLineEnd() {
    $5017720562176d5c$var$centroidStream.point = $5017720562176d5c$var$centroidPoint;
}
function $5017720562176d5c$var$centroidRingStart() {
    $5017720562176d5c$var$centroidStream.point = $5017720562176d5c$var$centroidPointFirstRing;
}
function $5017720562176d5c$var$centroidRingEnd() {
    $5017720562176d5c$var$centroidPointRing($5017720562176d5c$var$x00, $5017720562176d5c$var$y00);
}
function $5017720562176d5c$var$centroidPointFirstRing(x, y) {
    $5017720562176d5c$var$centroidStream.point = $5017720562176d5c$var$centroidPointRing;
    $5017720562176d5c$var$centroidPoint($5017720562176d5c$var$x00 = $5017720562176d5c$var$x0 = x, $5017720562176d5c$var$y00 = $5017720562176d5c$var$y0 = y);
}
function $5017720562176d5c$var$centroidPointRing(x, y) {
    var dx = x - $5017720562176d5c$var$x0, dy = y - $5017720562176d5c$var$y0, z = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $5017720562176d5c$var$X1 += z * ($5017720562176d5c$var$x0 + x) / 2;
    $5017720562176d5c$var$Y1 += z * ($5017720562176d5c$var$y0 + y) / 2;
    $5017720562176d5c$var$Z1 += z;
    z = $5017720562176d5c$var$y0 * x - $5017720562176d5c$var$x0 * y;
    $5017720562176d5c$var$X2 += z * ($5017720562176d5c$var$x0 + x);
    $5017720562176d5c$var$Y2 += z * ($5017720562176d5c$var$y0 + y);
    $5017720562176d5c$var$Z2 += z * 3;
    $5017720562176d5c$var$centroidPoint($5017720562176d5c$var$x0 = x, $5017720562176d5c$var$y0 = y);
}
var $5017720562176d5c$export$2e2bcd8739ae039 = $5017720562176d5c$var$centroidStream;




function $c0bd66e8413cddce$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$c0bd66e8413cddce$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039)
};





var $14900f153b294506$var$lengthSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)(), $14900f153b294506$var$lengthRing, $14900f153b294506$var$x00, $14900f153b294506$var$y00, $14900f153b294506$var$x0, $14900f153b294506$var$y0;
var $14900f153b294506$var$lengthStream = {
    point: (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039),
    lineStart: function() {
        $14900f153b294506$var$lengthStream.point = $14900f153b294506$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($14900f153b294506$var$lengthRing) $14900f153b294506$var$lengthPoint($14900f153b294506$var$x00, $14900f153b294506$var$y00);
        $14900f153b294506$var$lengthStream.point = (0, $1d8d2c6ab05ff3c2$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $14900f153b294506$var$lengthRing = true;
    },
    polygonEnd: function() {
        $14900f153b294506$var$lengthRing = null;
    },
    result: function() {
        var length = +$14900f153b294506$var$lengthSum;
        $14900f153b294506$var$lengthSum = new (0, $5393af5c7231911f$export$bda7ba77fb86c375)();
        return length;
    }
};
function $14900f153b294506$var$lengthPointFirst(x, y) {
    $14900f153b294506$var$lengthStream.point = $14900f153b294506$var$lengthPoint;
    $14900f153b294506$var$x00 = $14900f153b294506$var$x0 = x, $14900f153b294506$var$y00 = $14900f153b294506$var$y0 = y;
}
function $14900f153b294506$var$lengthPoint(x, y) {
    $14900f153b294506$var$x0 -= x, $14900f153b294506$var$y0 -= y;
    $14900f153b294506$var$lengthSum.add((0, $a95495fc7e2b96ad$export$eba8049fb5020b81)($14900f153b294506$var$x0 * $14900f153b294506$var$x0 + $14900f153b294506$var$y0 * $14900f153b294506$var$y0));
    $14900f153b294506$var$x0 = x, $14900f153b294506$var$y0 = y;
}
var $14900f153b294506$export$2e2bcd8739ae039 = $14900f153b294506$var$lengthStream;


function $9e4309583e774e87$export$2e2bcd8739ae039() {
    this._string = [];
}
$9e4309583e774e87$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $9e4309583e774e87$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $9e4309583e774e87$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $9e4309583e774e87$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}


function $55f4551d20fc45eb$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, projectionStream((0, $5a819607af34fa0d$export$2e2bcd8739ae039)));
        return (0, $5a819607af34fa0d$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, projectionStream((0, $14900f153b294506$export$2e2bcd8739ae039)));
        return (0, $14900f153b294506$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, projectionStream((0, $21e11723b3ed3305$export$2e2bcd8739ae039)));
        return (0, $21e11723b3ed3305$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, projectionStream((0, $5017720562176d5c$export$2e2bcd8739ae039)));
        return (0, $5017720562176d5c$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $47e818e203efbb6b$export$2e2bcd8739ae039) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $9e4309583e774e87$export$2e2bcd8739ae039)) : new (0, $c0bd66e8413cddce$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}











function $ffa1cb2d4dc49483$export$2e2bcd8739ae039(methods) {
    return {
        stream: $ffa1cb2d4dc49483$export$6b468dcfb64c653c(methods)
    };
}
function $ffa1cb2d4dc49483$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $ffa1cb2d4dc49483$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $ffa1cb2d4dc49483$var$TransformStream() {}
$ffa1cb2d4dc49483$var$TransformStream.prototype = {
    constructor: $ffa1cb2d4dc49483$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};




function $a22401ff80246740$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $fea8e992e2cdfb90$export$2e2bcd8739ae039)(object, projection.stream((0, $21e11723b3ed3305$export$2e2bcd8739ae039)));
    fitBounds((0, $21e11723b3ed3305$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $a22401ff80246740$export$e450184041869e7f(projection, extent, object) {
    return $a22401ff80246740$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $a22401ff80246740$export$33a367fa1728c3ba(projection, size, object) {
    return $a22401ff80246740$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $a22401ff80246740$export$7d8f2192ef31c5a7(projection, width, object) {
    return $a22401ff80246740$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $a22401ff80246740$export$7069bab0d2ced675(projection, height, object) {
    return $a22401ff80246740$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $46cf39d07c5bdb66$var$maxDepth = 16, $46cf39d07c5bdb66$var$cosMinDistance = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(30 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $46cf39d07c5bdb66$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $46cf39d07c5bdb66$var$resample(project, delta2) : $46cf39d07c5bdb66$var$resampleNone(project);
}
function $46cf39d07c5bdb66$var$resampleNone(project) {
    return (0, $ffa1cb2d4dc49483$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $46cf39d07c5bdb66$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(c) - 1) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) || (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $46cf39d07c5bdb66$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $c6c8cb5fd36f99a5$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $46cf39d07c5bdb66$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $46cf39d07c5bdb66$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $b5bd7d563f966bea$var$transformRadians = (0, $ffa1cb2d4dc49483$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), y * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc));
    }
});
function $b5bd7d563f966bea$var$transformRotate(rotate) {
    return (0, $ffa1cb2d4dc49483$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $b5bd7d563f966bea$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $b5bd7d563f966bea$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $b5bd7d563f966bea$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(alpha), sinAlpha = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $b5bd7d563f966bea$export$2e2bcd8739ae039(project) {
    return $b5bd7d563f966bea$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $b5bd7d563f966bea$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $77ecf5d7118d4e24$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $47e818e203efbb6b$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), point[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            point[1] * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $b5bd7d563f966bea$var$transformRadians($b5bd7d563f966bea$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $2c12f65a02141e37$export$2e2bcd8739ae039)(theta = _ * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc)) : (theta = null, $77ecf5d7118d4e24$export$2e2bcd8739ae039), reset()) : theta * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $47e818e203efbb6b$export$2e2bcd8739ae039) : (0, $c40b90e739aa0c57$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            phi * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            deltaPhi * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            deltaGamma * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), recenter()) : alpha * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $46cf39d07c5bdb66$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $a22401ff80246740$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $a22401ff80246740$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $a22401ff80246740$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $a22401ff80246740$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $b5bd7d563f966bea$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $b5bd7d563f966bea$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $e96038c603a78247$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $16efbdf626bbc080$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $16efbdf626bbc080$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $46cf39d07c5bdb66$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $2e0fa55ce2d36a77$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $a95495fc7e2b96ad$export$18c7bea995a110f) / 3, m = (0, $b5bd7d563f966bea$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), phi1 = _[1] * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc)) : [
            phi0 * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97),
            phi1 * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $85e13d78f40bbb53$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $cf50254c00676fc9$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(n) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) return (0, $85e13d78f40bbb53$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(c - 2 * n * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(x, (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(r0y)) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(r0y);
        if (r0y * n < 0) l -= (0, $a95495fc7e2b96ad$export$18c7bea995a110f) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(x) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(r0y);
        return [
            l / n,
            (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $cf50254c00676fc9$export$2e2bcd8739ae039() {
    return (0, $2e0fa55ce2d36a77$export$228272587c4d24d8)($cf50254c00676fc9$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $818785c899a3e78e$export$2e2bcd8739ae039() {
    return (0, $cf50254c00676fc9$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}






// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $4750388187065daf$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $4750388187065daf$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $818785c899a3e78e$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $cf50254c00676fc9$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $cf50254c00676fc9$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $4750388187065daf$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $a95495fc7e2b96ad$export$6c421550c66a327d),
                y + 0.120 * k + (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $a95495fc7e2b96ad$export$6c421550c66a327d),
                y + 0.234 * k - (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $a95495fc7e2b96ad$export$6c421550c66a327d),
                y + 0.166 * k + (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $a95495fc7e2b96ad$export$6c421550c66a327d),
                y + 0.234 * k - (0, $a95495fc7e2b96ad$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $a22401ff80246740$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $a22401ff80246740$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $a22401ff80246740$export$7d8f2192ef31c5a7)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $a22401ff80246740$export$7069bab0d2ced675)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}




function $ebfef08780b2f185$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(x), cy = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y), k = scale(cx * cy);
        if (k === Infinity) return [
            2,
            0
        ];
        return [
            k * cy * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x),
            k * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $ebfef08780b2f185$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(c), cc = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(c);
        return [
            (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



var $712be8798957743b$export$5e11f94fc4a8d2c6 = (0, $ebfef08780b2f185$export$f1211ac1bdb0796)(function(cxcy) {
    return (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(2 / (1 + cxcy));
});
$712be8798957743b$export$5e11f94fc4a8d2c6.invert = (0, $ebfef08780b2f185$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)(z / 2);
});
function $712be8798957743b$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($712be8798957743b$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}





var $f3dd0aa4ef3821a9$export$b94a4d6aa3dd25c = (0, $ebfef08780b2f185$export$f1211ac1bdb0796)(function(c) {
    return (c = (0, $a95495fc7e2b96ad$export$fd6306be3fde5b04)(c)) && c / (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(c);
});
$f3dd0aa4ef3821a9$export$b94a4d6aa3dd25c.invert = (0, $ebfef08780b2f185$export$3cee429f13e44eac)(function(z) {
    return z;
});
function $f3dd0aa4ef3821a9$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($f3dd0aa4ef3821a9$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}







function $0246b40a5294c58d$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $a95495fc7e2b96ad$export$bef1f36f5486a6a3)((0, $a95495fc7e2b96ad$export$fcdd3b0b3246a325)(((0, $a95495fc7e2b96ad$export$e51408a300e8929a) + phi) / 2))
    ];
}
$0246b40a5294c58d$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $a95495fc7e2b96ad$export$628dc4eed22b0fbd)((0, $a95495fc7e2b96ad$export$b310ec824aaee37f)(y)) - (0, $a95495fc7e2b96ad$export$e51408a300e8929a)
    ];
};
function $0246b40a5294c58d$export$2e2bcd8739ae039() {
    return $0246b40a5294c58d$export$44b9b66a01f2127b($0246b40a5294c58d$export$94ff8a57e9b91cc3).scale(961 / (0, $a95495fc7e2b96ad$export$a4b4b4d4d776fe92));
}
function $0246b40a5294c58d$export$44b9b66a01f2127b(project) {
    var m = (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $a95495fc7e2b96ad$export$18c7bea995a110f) * scale(), t = m((0, $e96038c603a78247$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $0246b40a5294c58d$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}


function $85f9fbbcdef95343$var$tany(y) {
    return (0, $a95495fc7e2b96ad$export$fcdd3b0b3246a325)(((0, $a95495fc7e2b96ad$export$e51408a300e8929a) + y) / 2);
}
function $85f9fbbcdef95343$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y0) : (0, $a95495fc7e2b96ad$export$bef1f36f5486a6a3)(cy0 / (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y1)) / (0, $a95495fc7e2b96ad$export$bef1f36f5486a6a3)($85f9fbbcdef95343$var$tany(y1) / $85f9fbbcdef95343$var$tany(y0)), f = cy0 * (0, $a95495fc7e2b96ad$export$9c297f60e22e3389)($85f9fbbcdef95343$var$tany(y0), n) / n;
    if (!n) return 0, $0246b40a5294c58d$export$94ff8a57e9b91cc3;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $a95495fc7e2b96ad$export$e51408a300e8929a) + (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) y = -(0, $a95495fc7e2b96ad$export$e51408a300e8929a) + (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
        } else if (y > (0, $a95495fc7e2b96ad$export$e51408a300e8929a) - (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) y = (0, $a95495fc7e2b96ad$export$e51408a300e8929a) - (0, $a95495fc7e2b96ad$export$6c421550c66a327d);
        var r = f / (0, $a95495fc7e2b96ad$export$9c297f60e22e3389)($85f9fbbcdef95343$var$tany(y), n);
        return [
            r * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(n * x),
            f - r * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(n) * (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(x * x + fy * fy), l = (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(x, (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(fy)) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(fy);
        if (fy * n < 0) l -= (0, $a95495fc7e2b96ad$export$18c7bea995a110f) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(x) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(fy);
        return [
            l / n,
            2 * (0, $a95495fc7e2b96ad$export$628dc4eed22b0fbd)((0, $a95495fc7e2b96ad$export$9c297f60e22e3389)(f / r, 1 / n)) - (0, $a95495fc7e2b96ad$export$e51408a300e8929a)
        ];
    };
    return project;
}
function $85f9fbbcdef95343$export$2e2bcd8739ae039() {
    return (0, $2e0fa55ce2d36a77$export$228272587c4d24d8)($85f9fbbcdef95343$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}






function $0eafe8a9698064f1$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$0eafe8a9698064f1$export$f5fee52180f2f058.invert = $0eafe8a9698064f1$export$f5fee52180f2f058;
function $0eafe8a9698064f1$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($0eafe8a9698064f1$export$f5fee52180f2f058).scale(152.63);
}


function $fd0514e4e5bb2392$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y0) : (cy0 - (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(n) < (0, $a95495fc7e2b96ad$export$6c421550c66a327d)) return 0, $0eafe8a9698064f1$export$f5fee52180f2f058;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(nx),
            g - gy * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, $a95495fc7e2b96ad$export$b8b770ee6a0d9760)(x, (0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(gy)) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(gy);
        if (gy * n < 0) l -= (0, $a95495fc7e2b96ad$export$18c7bea995a110f) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(x) * (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(gy);
        return [
            l / n,
            g - (0, $a95495fc7e2b96ad$export$c5552dfdbc7cec71)(n) * (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(x * x + gy * gy)
        ];
    };
    return project;
}
function $fd0514e4e5bb2392$export$2e2bcd8739ae039() {
    return (0, $2e0fa55ce2d36a77$export$228272587c4d24d8)($fd0514e4e5bb2392$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}




var $d37439c40fd25fef$var$A1 = 1.340264, $d37439c40fd25fef$var$A2 = -0.081106, $d37439c40fd25fef$var$A3 = 0.000893, $d37439c40fd25fef$var$A4 = 0.003796, $d37439c40fd25fef$var$M = (0, $a95495fc7e2b96ad$export$eba8049fb5020b81)(3) / 2, $d37439c40fd25fef$var$iterations = 12;
function $d37439c40fd25fef$export$a320734067e7a731(lambda, phi) {
    var l = (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)($d37439c40fd25fef$var$M * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(l) / ($d37439c40fd25fef$var$M * ($d37439c40fd25fef$var$A1 + 3 * $d37439c40fd25fef$var$A2 * l2 + l6 * (7 * $d37439c40fd25fef$var$A3 + 9 * $d37439c40fd25fef$var$A4 * l2))),
        l * ($d37439c40fd25fef$var$A1 + $d37439c40fd25fef$var$A2 * l2 + l6 * ($d37439c40fd25fef$var$A3 + $d37439c40fd25fef$var$A4 * l2))
    ];
}
$d37439c40fd25fef$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $d37439c40fd25fef$var$iterations; ++i){
        fy = l * ($d37439c40fd25fef$var$A1 + $d37439c40fd25fef$var$A2 * l2 + l6 * ($d37439c40fd25fef$var$A3 + $d37439c40fd25fef$var$A4 * l2)) - y;
        fpy = $d37439c40fd25fef$var$A1 + 3 * $d37439c40fd25fef$var$A2 * l2 + l6 * (7 * $d37439c40fd25fef$var$A3 + 9 * $d37439c40fd25fef$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(delta) < (0, $a95495fc7e2b96ad$export$92c06fba281fe81b)) break;
    }
    return [
        $d37439c40fd25fef$var$M * x * ($d37439c40fd25fef$var$A1 + 3 * $d37439c40fd25fef$var$A2 * l2 + l6 * (7 * $d37439c40fd25fef$var$A3 + 9 * $d37439c40fd25fef$var$A4 * l2)) / (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(l),
        (0, $a95495fc7e2b96ad$export$41726bdb1fc63f)((0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(l) / $d37439c40fd25fef$var$M)
    ];
};
function $d37439c40fd25fef$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($d37439c40fd25fef$export$a320734067e7a731).scale(177.158);
}






function $e49d0d022364e606$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y), k = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x) / k,
        (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y) / k
    ];
}
$e49d0d022364e606$export$dc8c6ddfc8b22c85.invert = (0, $ebfef08780b2f185$export$3cee429f13e44eac)((0, $a95495fc7e2b96ad$export$628dc4eed22b0fbd));
function $e49d0d022364e606$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($e49d0d022364e606$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}







function $f9d44b0c96673d8d$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, $ffa1cb2d4dc49483$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var p = projection([
                x,
                y
            ]);
            this.stream.point(p[0], p[1]);
        }
    }), postclip = (0, $47e818e203efbb6b$export$2e2bcd8739ae039), cache, cacheStream;
    function reset() {
        kx = k * sx;
        ky = k * sy;
        cache = cacheStream = null;
        return projection;
    }
    function projection(p) {
        var x = p[0] * kx, y = p[1] * ky;
        if (alpha) {
            var t = y * ca - x * sa;
            x = x * ca + y * sa;
            y = t;
        }
        return [
            x + tx,
            y + ty
        ];
    }
    projection.invert = function(p) {
        var x = p[0] - tx, y = p[1] - ty;
        if (alpha) {
            var t = y * ca + x * sa;
            x = x * ca - y * sa;
            y = t;
        }
        return [
            x / kx,
            y / ky
        ];
    };
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $47e818e203efbb6b$export$2e2bcd8739ae039) : (0, $c40b90e739aa0c57$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, reset()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
            tx,
            ty
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $a95495fc7e2b96ad$export$8449e153fbd325fc), sa = (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(alpha), ca = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(alpha), reset()) : alpha * (0, $a95495fc7e2b96ad$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
    };
    projection.fitExtent = function(extent, object) {
        return (0, $a22401ff80246740$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $a22401ff80246740$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $a22401ff80246740$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $a22401ff80246740$export$7069bab0d2ced675)(projection, height, object);
    };
    return projection;
}






function $eca045369819d70c$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$eca045369819d70c$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $a95495fc7e2b96ad$export$2335f513bbd82c6d)(delta) > (0, $a95495fc7e2b96ad$export$6c421550c66a327d) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $eca045369819d70c$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($eca045369819d70c$export$acb6def22fe878e6).scale(175.295);
}





function $26f619327c062256$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y) * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x),
        (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y)
    ];
}
$26f619327c062256$export$1cd9c2eb846182a.invert = (0, $ebfef08780b2f185$export$3cee429f13e44eac)((0, $a95495fc7e2b96ad$export$41726bdb1fc63f));
function $26f619327c062256$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($26f619327c062256$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $a95495fc7e2b96ad$export$6c421550c66a327d));
}





function $847b42dca2e809a4$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(y), k = 1 + (0, $a95495fc7e2b96ad$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(x) / k,
        (0, $a95495fc7e2b96ad$export$5de3937cb4b592ed)(y) / k
    ];
}
$847b42dca2e809a4$export$f9ccbb0dcb3dcd2b.invert = (0, $ebfef08780b2f185$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $a95495fc7e2b96ad$export$628dc4eed22b0fbd)(z);
});
function $847b42dca2e809a4$export$2e2bcd8739ae039() {
    return (0, $b5bd7d563f966bea$export$2e2bcd8739ae039)($847b42dca2e809a4$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}




function $1ce1dd886730e28c$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $a95495fc7e2b96ad$export$bef1f36f5486a6a3)((0, $a95495fc7e2b96ad$export$fcdd3b0b3246a325)(((0, $a95495fc7e2b96ad$export$e51408a300e8929a) + phi) / 2)),
        -lambda
    ];
}
$1ce1dd886730e28c$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $a95495fc7e2b96ad$export$628dc4eed22b0fbd)((0, $a95495fc7e2b96ad$export$b310ec824aaee37f)(x)) - (0, $a95495fc7e2b96ad$export$e51408a300e8929a)
    ];
};
function $1ce1dd886730e28c$export$2e2bcd8739ae039() {
    var m = (0, $0246b40a5294c58d$export$44b9b66a01f2127b)($1ce1dd886730e28c$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}







var $82828c08cd175800$exports = {};

$parcel$export($82828c08cd175800$exports, "cluster", function () { return $66362157ebdabd78$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "hierarchy", function () { return $567f3f6b14cd66ec$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "pack", function () { return $ad0dfd3adb4cbb75$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "packSiblings", function () { return $875d08d21111bf98$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "packEnclose", function () { return $9630b29e9075eef2$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "partition", function () { return $e07cf325e1c6101f$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "stratify", function () { return $689643e52ad30f20$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "tree", function () { return $7ce396fbe69af7fd$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemap", function () { return $92b5fc81cad6560f$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemapBinary", function () { return $f4282b2a7ff6bcee$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemapDice", function () { return $8a6dec1b7299f67d$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemapSlice", function () { return $1c8cf6a5dc9fd662$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemapSliceDice", function () { return $21098f3941fa5aea$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemapSquarify", function () { return $ee1c6a46375ea955$export$2e2bcd8739ae039; });
$parcel$export($82828c08cd175800$exports, "treemapResquarify", function () { return $e047207521bd101b$export$2e2bcd8739ae039; });
function $66362157ebdabd78$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $66362157ebdabd78$var$meanX(children) {
    return children.reduce($66362157ebdabd78$var$meanXReduce, 0) / children.length;
}
function $66362157ebdabd78$var$meanXReduce(x, c) {
    return x + c.x;
}
function $66362157ebdabd78$var$maxY(children) {
    return 1 + children.reduce($66362157ebdabd78$var$maxYReduce, 0);
}
function $66362157ebdabd78$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $66362157ebdabd78$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $66362157ebdabd78$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $66362157ebdabd78$export$2e2bcd8739ae039() {
    var separation = $66362157ebdabd78$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $66362157ebdabd78$var$meanX(children);
                node.y = $66362157ebdabd78$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $66362157ebdabd78$var$leafLeft(root), right = $66362157ebdabd78$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}


function $c5cdc6bafb257335$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $c5cdc6bafb257335$export$2e2bcd8739ae039() {
    return this.eachAfter($c5cdc6bafb257335$var$count);
}


function $575dbd585c250738$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this)callback.call(that, node, ++index, this);
    return this;
}


function $db419ff81585c80f$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], children, i, index = -1;
    while(node = nodes.pop()){
        callback.call(that, node, ++index, this);
        if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}


function $0fa89611f4a5772a$export$2e2bcd8739ae039(callback, that) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n, index = -1;
    while(node = nodes.pop()){
        next.push(node);
        if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback.call(that, node, ++index, this);
    return this;
}


function $0629482f4411f414$export$2e2bcd8739ae039(callback, that) {
    let index = -1;
    for (const node of this){
        if (callback.call(that, node, ++index, this)) return node;
    }
}


function $5f227cb14bfa8d40$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}


function $38be3c3002f8a475$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}


function $a701f91d203eaf1e$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $a701f91d203eaf1e$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $a701f91d203eaf1e$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}


function $7845efb338d6f183$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}


function $1bf321a01e9cabf7$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $68ac9ddb6a6f0405$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}


function $445fb76417424936$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}


function* $478c2b04ce8a8095$export$2e2bcd8739ae039() {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            yield node;
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
}


function $567f3f6b14cd66ec$export$2e2bcd8739ae039(data, children) {
    if (data instanceof Map) {
        data = [
            undefined,
            data
        ];
        if (children === undefined) children = $567f3f6b14cd66ec$var$mapChildren;
    } else if (children === undefined) children = $567f3f6b14cd66ec$var$objectChildren;
    var root = new $567f3f6b14cd66ec$export$85c928794f8d04d4(data), node, nodes = [
        root
    ], child, childs, i, n;
    while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
        node.children = childs;
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = childs[i] = new $567f3f6b14cd66ec$export$85c928794f8d04d4(childs[i]));
            child.parent = node;
            child.depth = node.depth + 1;
        }
    }
    return root.eachBefore($567f3f6b14cd66ec$export$5af32d52ab5dfd57);
}
function $567f3f6b14cd66ec$var$node_copy() {
    return $567f3f6b14cd66ec$export$2e2bcd8739ae039(this).eachBefore($567f3f6b14cd66ec$var$copyData);
}
function $567f3f6b14cd66ec$var$objectChildren(d) {
    return d.children;
}
function $567f3f6b14cd66ec$var$mapChildren(d) {
    return Array.isArray(d) ? d[1] : null;
}
function $567f3f6b14cd66ec$var$copyData(node) {
    if (node.data.value !== undefined) node.value = node.data.value;
    node.data = node.data.data;
}
function $567f3f6b14cd66ec$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $567f3f6b14cd66ec$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$567f3f6b14cd66ec$export$85c928794f8d04d4.prototype = $567f3f6b14cd66ec$export$2e2bcd8739ae039.prototype = {
    constructor: $567f3f6b14cd66ec$export$85c928794f8d04d4,
    count: (0, $c5cdc6bafb257335$export$2e2bcd8739ae039),
    each: (0, $575dbd585c250738$export$2e2bcd8739ae039),
    eachAfter: (0, $0fa89611f4a5772a$export$2e2bcd8739ae039),
    eachBefore: (0, $db419ff81585c80f$export$2e2bcd8739ae039),
    find: (0, $0629482f4411f414$export$2e2bcd8739ae039),
    sum: (0, $5f227cb14bfa8d40$export$2e2bcd8739ae039),
    sort: (0, $38be3c3002f8a475$export$2e2bcd8739ae039),
    path: (0, $a701f91d203eaf1e$export$2e2bcd8739ae039),
    ancestors: (0, $7845efb338d6f183$export$2e2bcd8739ae039),
    descendants: (0, $1bf321a01e9cabf7$export$2e2bcd8739ae039),
    leaves: (0, $68ac9ddb6a6f0405$export$2e2bcd8739ae039),
    links: (0, $445fb76417424936$export$2e2bcd8739ae039),
    copy: $567f3f6b14cd66ec$var$node_copy,
    [Symbol.iterator]: (0, $478c2b04ce8a8095$export$2e2bcd8739ae039)
};


function $4aea523cb27d70c2$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}
function $4aea523cb27d70c2$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}



function $9630b29e9075eef2$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $4aea523cb27d70c2$export$448332262467e042)(Array.from(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $9630b29e9075eef2$var$enclosesWeak(e, p)) ++i;
        else e = $9630b29e9075eef2$var$encloseBasis(B = $9630b29e9075eef2$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $9630b29e9075eef2$var$extendBasis(B, p) {
    var i, j;
    if ($9630b29e9075eef2$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($9630b29e9075eef2$var$enclosesNot(p, B[i]) && $9630b29e9075eef2$var$enclosesWeakAll($9630b29e9075eef2$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($9630b29e9075eef2$var$enclosesNot($9630b29e9075eef2$var$encloseBasis2(B[i], B[j]), p) && $9630b29e9075eef2$var$enclosesNot($9630b29e9075eef2$var$encloseBasis2(B[i], p), B[j]) && $9630b29e9075eef2$var$enclosesNot($9630b29e9075eef2$var$encloseBasis2(B[j], p), B[i]) && $9630b29e9075eef2$var$enclosesWeakAll($9630b29e9075eef2$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $9630b29e9075eef2$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $9630b29e9075eef2$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $9630b29e9075eef2$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$9630b29e9075eef2$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $9630b29e9075eef2$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $9630b29e9075eef2$var$encloseBasis1(B[0]);
        case 2:
            return $9630b29e9075eef2$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $9630b29e9075eef2$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $9630b29e9075eef2$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $9630b29e9075eef2$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $9630b29e9075eef2$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}


function $875d08d21111bf98$var$place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function $875d08d21111bf98$var$intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $875d08d21111bf98$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $875d08d21111bf98$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $875d08d21111bf98$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = (circles = (0, $4aea523cb27d70c2$export$2e2bcd8739ae039)(circles)).length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $875d08d21111bf98$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $875d08d21111bf98$var$Node(a), b = new $875d08d21111bf98$var$Node(b), c = new $875d08d21111bf98$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $875d08d21111bf98$var$place(a._, b._, c = circles[i]), c = new $875d08d21111bf98$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($875d08d21111bf98$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($875d08d21111bf98$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $875d08d21111bf98$var$score(a);
        while((c = c.next) !== b)if ((ca = $875d08d21111bf98$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $9630b29e9075eef2$export$2e2bcd8739ae039)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $875d08d21111bf98$export$2e2bcd8739ae039(circles) {
    $875d08d21111bf98$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}


function $3b04aee1c232d6f1$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $3b04aee1c232d6f1$export$a7a0278c004aac3f(f);
}
function $3b04aee1c232d6f1$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}


function $49fc6a8ae92a887f$export$99e2e371aa6a9db() {
    return 0;
}
function $49fc6a8ae92a887f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $ad0dfd3adb4cbb75$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $ad0dfd3adb4cbb75$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $49fc6a8ae92a887f$export$99e2e371aa6a9db);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($ad0dfd3adb4cbb75$var$radiusLeaf(radius)).eachAfter($ad0dfd3adb4cbb75$var$packChildren(padding, 0.5)).eachBefore($ad0dfd3adb4cbb75$var$translateChild(1));
        else root.eachBefore($ad0dfd3adb4cbb75$var$radiusLeaf($ad0dfd3adb4cbb75$var$defaultRadius)).eachAfter($ad0dfd3adb4cbb75$var$packChildren((0, $49fc6a8ae92a887f$export$99e2e371aa6a9db), 1)).eachAfter($ad0dfd3adb4cbb75$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($ad0dfd3adb4cbb75$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $3b04aee1c232d6f1$export$516e28dec6a4b6d4)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $49fc6a8ae92a887f$export$2e2bcd8739ae039)(+x), pack) : padding;
    };
    return pack;
}
function $ad0dfd3adb4cbb75$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $ad0dfd3adb4cbb75$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $875d08d21111bf98$export$b86b5dcbc4bfc7a7)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $ad0dfd3adb4cbb75$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}




function $a7d02aa695286fa6$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}


function $8a6dec1b7299f67d$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}


function $e07cf325e1c6101f$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $a7d02aa695286fa6$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $8a6dec1b7299f67d$export$2e2bcd8739ae039)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}




var $689643e52ad30f20$var$preroot = {
    depth: -1
}, $689643e52ad30f20$var$ambiguous = {};
function $689643e52ad30f20$var$defaultId(d) {
    return d.id;
}
function $689643e52ad30f20$var$defaultParentId(d) {
    return d.parentId;
}
function $689643e52ad30f20$export$2e2bcd8739ae039() {
    var id = $689643e52ad30f20$var$defaultId, parentId = $689643e52ad30f20$var$defaultParentId;
    function stratify(data) {
        var nodes = Array.from(data), n = nodes.length, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
        for(i = 0; i < n; ++i){
            d = nodes[i], node = nodes[i] = new (0, $567f3f6b14cd66ec$export$85c928794f8d04d4)(d);
            if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                nodeKey = node.id = nodeId;
                nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? $689643e52ad30f20$var$ambiguous : node);
            }
            if ((nodeId = parentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
        }
        for(i = 0; i < n; ++i){
            node = nodes[i];
            if (nodeId = node.parent) {
                parent = nodeByKey.get(nodeId);
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $689643e52ad30f20$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            } else {
                if (root) throw new Error("multiple roots");
                root = node;
            }
        }
        if (!root) throw new Error("no root");
        root.parent = $689643e52ad30f20$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $567f3f6b14cd66ec$export$5af32d52ab5dfd57));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $3b04aee1c232d6f1$export$a7a0278c004aac3f)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $3b04aee1c232d6f1$export$a7a0278c004aac3f)(x), stratify) : parentId;
    };
    return stratify;
}



function $7ce396fbe69af7fd$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $7ce396fbe69af7fd$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $7ce396fbe69af7fd$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $7ce396fbe69af7fd$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $7ce396fbe69af7fd$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $7ce396fbe69af7fd$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $7ce396fbe69af7fd$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$7ce396fbe69af7fd$var$TreeNode.prototype = Object.create((0, $567f3f6b14cd66ec$export$85c928794f8d04d4).prototype);
function $7ce396fbe69af7fd$var$treeRoot(root) {
    var tree = new $7ce396fbe69af7fd$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $7ce396fbe69af7fd$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $7ce396fbe69af7fd$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $7ce396fbe69af7fd$export$2e2bcd8739ae039() {
    var separation = $7ce396fbe69af7fd$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $7ce396fbe69af7fd$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $7ce396fbe69af7fd$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $7ce396fbe69af7fd$var$nextRight(vim), vip = $7ce396fbe69af7fd$var$nextLeft(vip), vim && vip){
                vom = $7ce396fbe69af7fd$var$nextLeft(vom);
                vop = $7ce396fbe69af7fd$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $7ce396fbe69af7fd$var$moveSubtree($7ce396fbe69af7fd$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$7ce396fbe69af7fd$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$7ce396fbe69af7fd$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}




function $1c8cf6a5dc9fd662$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}


var $ee1c6a46375ea955$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $ee1c6a46375ea955$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $8a6dec1b7299f67d$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $1c8cf6a5dc9fd662$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $ee1c6a46375ea955$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $ee1c6a46375ea955$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($ee1c6a46375ea955$export$324943737027944a);




function $92b5fc81cad6560f$export$2e2bcd8739ae039() {
    var tile = (0, $ee1c6a46375ea955$export$2e2bcd8739ae039), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $49fc6a8ae92a887f$export$99e2e371aa6a9db), paddingTop = (0, $49fc6a8ae92a887f$export$99e2e371aa6a9db), paddingRight = (0, $49fc6a8ae92a887f$export$99e2e371aa6a9db), paddingBottom = (0, $49fc6a8ae92a887f$export$99e2e371aa6a9db), paddingLeft = (0, $49fc6a8ae92a887f$export$99e2e371aa6a9db);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $a7d02aa695286fa6$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $3b04aee1c232d6f1$export$a7a0278c004aac3f)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $49fc6a8ae92a887f$export$2e2bcd8739ae039)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $49fc6a8ae92a887f$export$2e2bcd8739ae039)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $49fc6a8ae92a887f$export$2e2bcd8739ae039)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $49fc6a8ae92a887f$export$2e2bcd8739ae039)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $49fc6a8ae92a887f$export$2e2bcd8739ae039)(+x), treemap) : paddingLeft;
    };
    return treemap;
}


function $f4282b2a7ff6bcee$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}






function $21098f3941fa5aea$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $1c8cf6a5dc9fd662$export$2e2bcd8739ae039) : (0, $8a6dec1b7299f67d$export$2e2bcd8739ae039))(parent, x0, y0, x1, y1);
}






var $e047207521bd101b$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $8a6dec1b7299f67d$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                else (0, $1c8cf6a5dc9fd662$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $ee1c6a46375ea955$export$9ff1217655212093)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $ee1c6a46375ea955$export$324943737027944a));




var $aca072767fbbfd2a$exports = {};

$parcel$export($aca072767fbbfd2a$exports, "interpolate", function () { return $0f8c512c5c8a77f6$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateArray", function () { return $a678abf0bb18ad83$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateBasis", function () { return $33515a6dd91223a1$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateBasisClosed", function () { return $888ce499c318081d$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateDate", function () { return $1be8536f58239452$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateDiscrete", function () { return $72ab4bbc7889eb74$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateHue", function () { return $de2da92901637b57$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateNumber", function () { return $b64d332320181a08$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateNumberArray", function () { return $be2a2995a264064a$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateObject", function () { return $986d71b685263615$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateRound", function () { return $b2e6b30770951138$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateString", function () { return $6425152590f6a238$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateTransformCss", function () { return $babc24069484a6a3$export$56bec7123bb3589a; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateTransformSvg", function () { return $babc24069484a6a3$export$da8cba906d64c082; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateZoom", function () { return $acca162f4f1c57d2$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateRgb", function () { return $4efcfc37f0c760c0$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateRgbBasis", function () { return $4efcfc37f0c760c0$export$2c0e28f2e2852d3f; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateRgbBasisClosed", function () { return $4efcfc37f0c760c0$export$53d5214f625ccd4c; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateHsl", function () { return $48f624f8a6bfe9b9$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateHslLong", function () { return $48f624f8a6bfe9b9$export$a2c535e270a59256; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateLab", function () { return $b548d688d14800bb$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateHcl", function () { return $d6380bb7bdca7ae3$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateHclLong", function () { return $d6380bb7bdca7ae3$export$5aaa50f7615f9b70; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateCubehelix", function () { return $f1f1747c3426a89f$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "interpolateCubehelixLong", function () { return $f1f1747c3426a89f$export$934fa09ad474a1b4; });
$parcel$export($aca072767fbbfd2a$exports, "piecewise", function () { return $e9fb12e4f27c1a7d$export$2e2bcd8739ae039; });
$parcel$export($aca072767fbbfd2a$exports, "quantize", function () { return $c59da363d3dc0d88$export$2e2bcd8739ae039; });





function $72ab4bbc7889eb74$export$2e2bcd8739ae039(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}



function $de2da92901637b57$export$2e2bcd8739ae039(a, b) {
    var i = (0, $b0ff832a4c016961$export$97d7b0c7ddb78dcf)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}





function $b2e6b30770951138$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}




var $acca162f4f1c57d2$var$epsilon2 = 1e-12;
function $acca162f4f1c57d2$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $acca162f4f1c57d2$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $acca162f4f1c57d2$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $acca162f4f1c57d2$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $acca162f4f1c57d2$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $acca162f4f1c57d2$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $acca162f4f1c57d2$var$tanh(rho * s + r0) - $acca162f4f1c57d2$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $acca162f4f1c57d2$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $lDve0 = parcelRequire("lDve0");

function $48f624f8a6bfe9b9$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $lDve0.hsl)(start)).h, (end = (0, $lDve0.hsl)(end)).h), s = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $48f624f8a6bfe9b9$export$2e2bcd8739ae039 = $48f624f8a6bfe9b9$var$hsl((0, $b0ff832a4c016961$export$97d7b0c7ddb78dcf));
var $48f624f8a6bfe9b9$export$a2c535e270a59256 = $48f624f8a6bfe9b9$var$hsl((0, $b0ff832a4c016961$export$2e2bcd8739ae039));




function $b548d688d14800bb$export$2e2bcd8739ae039(start, end) {
    var l = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)((start = (0, $3ba1f60a5b08d697$export$2e2bcd8739ae039)(start)).l, (end = (0, $3ba1f60a5b08d697$export$2e2bcd8739ae039)(end)).l), a = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.a, end.a), b = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.b, end.b), opacity = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}




function $d6380bb7bdca7ae3$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $3ba1f60a5b08d697$export$d0e870ba50062ff1)(start)).h, (end = (0, $3ba1f60a5b08d697$export$d0e870ba50062ff1)(end)).h), c = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $d6380bb7bdca7ae3$export$2e2bcd8739ae039 = $d6380bb7bdca7ae3$var$hcl((0, $b0ff832a4c016961$export$97d7b0c7ddb78dcf));
var $d6380bb7bdca7ae3$export$5aaa50f7615f9b70 = $d6380bb7bdca7ae3$var$hcl((0, $b0ff832a4c016961$export$2e2bcd8739ae039));




function $f1f1747c3426a89f$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(start)).h, (end = (0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(end)).h), s = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $b0ff832a4c016961$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $f1f1747c3426a89f$export$2e2bcd8739ae039 = $f1f1747c3426a89f$var$cubehelix((0, $b0ff832a4c016961$export$97d7b0c7ddb78dcf));
var $f1f1747c3426a89f$export$934fa09ad474a1b4 = $f1f1747c3426a89f$var$cubehelix((0, $b0ff832a4c016961$export$2e2bcd8739ae039));



function $e9fb12e4f27c1a7d$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}


function $c59da363d3dc0d88$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}




var $2f75f5536d77a9b5$exports = {};

$parcel$export($2f75f5536d77a9b5$exports, "path", function () { return $a56e6346ae45e61d$export$2e2bcd8739ae039; });



var $906c138d732b0dac$exports = {};

$parcel$export($906c138d732b0dac$exports, "polygonArea", function () { return $17a70e45b2be9357$export$2e2bcd8739ae039; });
$parcel$export($906c138d732b0dac$exports, "polygonCentroid", function () { return $f97aecb30c4efce3$export$2e2bcd8739ae039; });
$parcel$export($906c138d732b0dac$exports, "polygonHull", function () { return $e52f6b4a47dee8ac$export$2e2bcd8739ae039; });
$parcel$export($906c138d732b0dac$exports, "polygonContains", function () { return $e790741f3648b797$export$2e2bcd8739ae039; });
$parcel$export($906c138d732b0dac$exports, "polygonLength", function () { return $32626156cded476a$export$2e2bcd8739ae039; });
function $17a70e45b2be9357$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}


function $f97aecb30c4efce3$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}


// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $16bf7693a167c156$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}


function $e52f6b4a47dee8ac$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $e52f6b4a47dee8ac$var$computeUpperHullIndexes(points) {
    const n = points.length, indexes = [
        0,
        1
    ];
    let size = 2, i;
    for(i = 2; i < n; ++i){
        while(size > 1 && (0, $16bf7693a167c156$export$2e2bcd8739ae039)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $e52f6b4a47dee8ac$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($e52f6b4a47dee8ac$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $e52f6b4a47dee8ac$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $e52f6b4a47dee8ac$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}


function $e790741f3648b797$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}


function $32626156cded476a$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.hypot(xa, ya);
    }
    return perimeter;
}




var $c3a21cfe10a041e5$exports = {};

$parcel$export($c3a21cfe10a041e5$exports, "quadtree", function () { return $0035ef5bae9355cf$export$2e2bcd8739ae039; });



var $b12cde496d0af611$exports = {};

$parcel$export($b12cde496d0af611$exports, "randomUniform", function () { return $669a3c44dec7c697$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomInt", function () { return $64e5e893c29d7943$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomNormal", function () { return $f372fca05c83370f$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomLogNormal", function () { return $7dbff792404e65cb$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomBates", function () { return $7bb566eb35905adf$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomIrwinHall", function () { return $0fbb9d915c61a219$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomExponential", function () { return $26dcbb7b3d99355a$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomPareto", function () { return $19da8d988b78ea12$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomBernoulli", function () { return $dba9543c08eb554d$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomGeometric", function () { return $8449950437c3e8bb$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomBinomial", function () { return $211131f2819e8985$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomGamma", function () { return $aa91ff9a55c474b2$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomBeta", function () { return $bac774069adfbbea$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomWeibull", function () { return $90190793d1da729e$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomCauchy", function () { return $bc20e898b59f99c0$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomLogistic", function () { return $f779ffc18d75beb0$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomPoisson", function () { return $1b04f75a19d3f03f$export$2e2bcd8739ae039; });
$parcel$export($b12cde496d0af611$exports, "randomLcg", function () { return $e5c52bebb8117ac9$export$2e2bcd8739ae039; });
var $55738a3abf12728c$export$2e2bcd8739ae039 = Math.random;


var $669a3c44dec7c697$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $64e5e893c29d7943$export$2e2bcd8739ae039 = function sourceRandomInt(source) {
    function randomInt(min, max) {
        if (arguments.length < 2) max = min, min = 0;
        min = Math.floor(min);
        max = Math.floor(max) - min;
        return function() {
            return Math.floor(source() * max + min);
        };
    }
    randomInt.source = sourceRandomInt;
    return randomInt;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $f372fca05c83370f$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));




var $7dbff792404e65cb$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    var N = (0, $f372fca05c83370f$export$2e2bcd8739ae039).source(source);
    function randomLogNormal() {
        var randomNormal = N.apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));




var $0fbb9d915c61a219$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        if ((n = +n) <= 0) return ()=>0;
        return function() {
            for(var sum = 0, i = n; i > 1; --i)sum += source();
            return sum + i * source();
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));


var $7bb566eb35905adf$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    var I = (0, $0fbb9d915c61a219$export$2e2bcd8739ae039).source(source);
    function randomBates(n) {
        // use limiting distribution at n === 0
        if ((n = +n) === 0) return source;
        var randomIrwinHall = I(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));




var $26dcbb7b3d99355a$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log1p(-source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $19da8d988b78ea12$export$2e2bcd8739ae039 = function sourceRandomPareto(source) {
    function randomPareto(alpha) {
        if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
        alpha = 1 / -alpha;
        return function() {
            return Math.pow(1 - source(), alpha);
        };
    }
    randomPareto.source = sourceRandomPareto;
    return randomPareto;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $dba9543c08eb554d$export$2e2bcd8739ae039 = function sourceRandomBernoulli(source) {
    function randomBernoulli(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        return function() {
            return Math.floor(source() + p);
        };
    }
    randomBernoulli.source = sourceRandomBernoulli;
    return randomBernoulli;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $8449950437c3e8bb$export$2e2bcd8739ae039 = function sourceRandomGeometric(source) {
    function randomGeometric(p) {
        if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
        if (p === 0) return ()=>Infinity;
        if (p === 1) return ()=>1;
        p = Math.log1p(-p);
        return function() {
            return 1 + Math.floor(Math.log1p(-source()) / p);
        };
    }
    randomGeometric.source = sourceRandomGeometric;
    return randomGeometric;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));






var $aa91ff9a55c474b2$export$2e2bcd8739ae039 = function sourceRandomGamma(source) {
    var randomNormal = (0, $f372fca05c83370f$export$2e2bcd8739ae039).source(source)();
    function randomGamma(k, theta) {
        if ((k = +k) < 0) throw new RangeError("invalid k");
        // degenerate distribution if k === 0
        if (k === 0) return ()=>0;
        theta = theta == null ? 1 : +theta;
        // exponential distribution if k === 1
        if (k === 1) return ()=>-Math.log1p(-source()) * theta;
        var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
        return function() {
            do {
                do var x = randomNormal(), v = 1 + c * x;
                while (v <= 0);
                v *= v * v;
                var u = 1 - source();
            }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
            return d * v * multiplier() * theta;
        };
    }
    randomGamma.source = sourceRandomGamma;
    return randomGamma;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));


var $bac774069adfbbea$export$2e2bcd8739ae039 = function sourceRandomBeta(source) {
    var G = (0, $aa91ff9a55c474b2$export$2e2bcd8739ae039).source(source);
    function randomBeta(alpha, beta) {
        var X = G(alpha), Y = G(beta);
        return function() {
            var x = X();
            return x === 0 ? 0 : x / (x + Y());
        };
    }
    randomBeta.source = sourceRandomBeta;
    return randomBeta;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $211131f2819e8985$export$2e2bcd8739ae039 = function sourceRandomBinomial(source) {
    var G = (0, $8449950437c3e8bb$export$2e2bcd8739ae039).source(source), B = (0, $bac774069adfbbea$export$2e2bcd8739ae039).source(source);
    function randomBinomial(n, p) {
        n = +n;
        if ((p = +p) >= 1) return ()=>n;
        if (p <= 0) return ()=>0;
        return function() {
            var acc = 0, nn = n, pp = p;
            while(nn * pp > 16 && nn * (1 - pp) > 16){
                var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                if (y <= pp) {
                    acc += i;
                    nn -= i;
                    pp = (pp - y) / (1 - y);
                } else {
                    nn = i - 1;
                    pp /= y;
                }
            }
            var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
            for(var s = g(), k = 0; s <= nn; ++k)s += g();
            return acc + (sign ? k : nn - k);
        };
    }
    randomBinomial.source = sourceRandomBinomial;
    return randomBinomial;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));





var $90190793d1da729e$export$2e2bcd8739ae039 = function sourceRandomWeibull(source) {
    function randomWeibull(k, a, b) {
        var outerFunc;
        if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
        else {
            k = 1 / k;
            outerFunc = (x)=>Math.pow(x, k);
        }
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * outerFunc(-Math.log1p(-source()));
        };
    }
    randomWeibull.source = sourceRandomWeibull;
    return randomWeibull;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $bc20e898b59f99c0$export$2e2bcd8739ae039 = function sourceRandomCauchy(source) {
    function randomCauchy(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            return a + b * Math.tan(Math.PI * source());
        };
    }
    randomCauchy.source = sourceRandomCauchy;
    return randomCauchy;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));



var $f779ffc18d75beb0$export$2e2bcd8739ae039 = function sourceRandomLogistic(source) {
    function randomLogistic(a, b) {
        a = a == null ? 0 : +a;
        b = b == null ? 1 : +b;
        return function() {
            var u = source();
            return a + b * Math.log(u / (1 - u));
        };
    }
    randomLogistic.source = sourceRandomLogistic;
    return randomLogistic;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));





var $1b04f75a19d3f03f$export$2e2bcd8739ae039 = function sourceRandomPoisson(source) {
    var G = (0, $aa91ff9a55c474b2$export$2e2bcd8739ae039).source(source), B = (0, $211131f2819e8985$export$2e2bcd8739ae039).source(source);
    function randomPoisson(lambda) {
        return function() {
            var acc = 0, l = lambda;
            while(l > 16){
                var n = Math.floor(0.875 * l), t = G(n)();
                if (t > l) return acc + B(n - 1, l / t)();
                acc += n;
                l -= t;
            }
            for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
            return acc + k;
        };
    }
    randomPoisson.source = sourceRandomPoisson;
    return randomPoisson;
}((0, $55738a3abf12728c$export$2e2bcd8739ae039));


// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $e5c52bebb8117ac9$var$mul = 0x19660D;
const $e5c52bebb8117ac9$var$inc = 0x3C6EF35F;
const $e5c52bebb8117ac9$var$eps = 1 / 0x100000000;
function $e5c52bebb8117ac9$export$2e2bcd8739ae039(seed = Math.random()) {
    let state = (0 <= seed && seed < 1 ? seed / $e5c52bebb8117ac9$var$eps : Math.abs(seed)) | 0;
    return ()=>(state = $e5c52bebb8117ac9$var$mul * state + $e5c52bebb8117ac9$var$inc | 0, $e5c52bebb8117ac9$var$eps * (state >>> 0));
}




var $cbe2ba00b5575db6$exports = {};

$parcel$export($cbe2ba00b5575db6$exports, "scaleBand", function () { return $506f02c63c0e88e9$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scalePoint", function () { return $506f02c63c0e88e9$export$105684a3041cb6f3; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleIdentity", function () { return $b6e57cc952097f7d$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleLinear", function () { return $8d78bad205d390e0$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleLog", function () { return $e5f280bca2732078$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSymlog", function () { return $f394efeb9f7093fc$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleOrdinal", function () { return $468de7d9b5347eb9$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleImplicit", function () { return $468de7d9b5347eb9$export$e4f898ab14d9d460; });
$parcel$export($cbe2ba00b5575db6$exports, "scalePow", function () { return $6d4f92d26c1ad3fb$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSqrt", function () { return $6d4f92d26c1ad3fb$export$eba8049fb5020b81; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleRadial", function () { return $f91a03540d211e73$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleQuantile", function () { return $7e837adc189d0aa6$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleQuantize", function () { return $67e218f664a7d422$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleThreshold", function () { return $6d167ed6105e966f$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleTime", function () { return $25e925f057baa3bc$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleUtc", function () { return $f282df5ade9e3502$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSequential", function () { return $ccf132c4ddaaaa62$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSequentialLog", function () { return $ccf132c4ddaaaa62$export$6843e08bf2ff981f; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSequentialPow", function () { return $ccf132c4ddaaaa62$export$de9f78581b4f2405; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSequentialSqrt", function () { return $ccf132c4ddaaaa62$export$413d935127ed466e; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSequentialSymlog", function () { return $ccf132c4ddaaaa62$export$9d4af4de62c81941; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleSequentialQuantile", function () { return $cd7f5fe99e22e25b$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleDiverging", function () { return $0187dcad2a38585d$export$2e2bcd8739ae039; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleDivergingLog", function () { return $0187dcad2a38585d$export$5f0266a9159c47fb; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleDivergingPow", function () { return $0187dcad2a38585d$export$d6cedcc63bf26e7e; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleDivergingSqrt", function () { return $0187dcad2a38585d$export$33ddefb5c4ab9e9c; });
$parcel$export($cbe2ba00b5575db6$exports, "scaleDivergingSymlog", function () { return $0187dcad2a38585d$export$50b3da713cf557c6; });
$parcel$export($cbe2ba00b5575db6$exports, "tickFormat", function () { return $e101a5ccf775ba41$export$2e2bcd8739ae039; });

function $f6637fbcde7d18c1$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $f6637fbcde7d18c1$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}



const $468de7d9b5347eb9$export$e4f898ab14d9d460 = Symbol("implicit");
function $468de7d9b5347eb9$export$2e2bcd8739ae039() {
    var index = new Map(), domain = [], range = [], unknown = $468de7d9b5347eb9$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $468de7d9b5347eb9$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $468de7d9b5347eb9$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $506f02c63c0e88e9$export$2e2bcd8739ae039() {
    var scale = (0, $468de7d9b5347eb9$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $a9c85d866204d0d0$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $506f02c63c0e88e9$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $506f02c63c0e88e9$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $506f02c63c0e88e9$var$pointish(copy());
    };
    return scale;
}
function $506f02c63c0e88e9$export$105684a3041cb6f3() {
    return $506f02c63c0e88e9$var$pointish($506f02c63c0e88e9$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}





function $30ac9039be645390$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $bcb889c153239827$export$2e2bcd8739ae039(x) {
    return +x;
}


var $eb736f827b28f7de$var$unit = [
    0,
    1
];
function $eb736f827b28f7de$export$f0954fd7d5368655(x) {
    return x;
}
function $eb736f827b28f7de$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $30ac9039be645390$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $eb736f827b28f7de$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $eb736f827b28f7de$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $eb736f827b28f7de$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $eb736f827b28f7de$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $eb736f827b28f7de$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $eb736f827b28f7de$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $4fe96e9a0ca23dac$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $eb736f827b28f7de$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $eb736f827b28f7de$export$6b468dcfb64c653c() {
    var domain = $eb736f827b28f7de$var$unit, range = $eb736f827b28f7de$var$unit, interpolate = (0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $eb736f827b28f7de$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $eb736f827b28f7de$export$f0954fd7d5368655) clamp = $eb736f827b28f7de$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $eb736f827b28f7de$var$polymap : $eb736f827b28f7de$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $b64d332320181a08$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $bcb889c153239827$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $b2e6b30770951138$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $eb736f827b28f7de$export$f0954fd7d5368655, rescale()) : clamp !== $eb736f827b28f7de$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $eb736f827b28f7de$export$2e2bcd8739ae039() {
    return $eb736f827b28f7de$export$6b468dcfb64c653c()($eb736f827b28f7de$export$f0954fd7d5368655, $eb736f827b28f7de$export$f0954fd7d5368655);
}





function $e101a5ccf775ba41$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $0c0e85ae379d5115$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $33c20a36f475948f$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $f9f7af4086e97456$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $45fe3ebe07b00990$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $39f18c436813ddb0$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $bfebf1720f6e6a79$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $45fe3ebe07b00990$export$d9468344d3651243)(specifier);
}


function $8d78bad205d390e0$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $0c0e85ae379d5115$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $e101a5ccf775ba41$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $0c0e85ae379d5115$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $8d78bad205d390e0$export$2e2bcd8739ae039() {
    var scale = (0, $eb736f827b28f7de$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $eb736f827b28f7de$export$784d13d8ee351f07)(scale, $8d78bad205d390e0$export$2e2bcd8739ae039());
    };
    (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $8d78bad205d390e0$export$16a5d4b4a61a274d(scale);
}



function $b6e57cc952097f7d$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $bcb889c153239827$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $b6e57cc952097f7d$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $bcb889c153239827$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $8d78bad205d390e0$export$16a5d4b4a61a274d)(scale);
}





function $af566cb9913aea7e$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $e5f280bca2732078$var$transformLog(x) {
    return Math.log(x);
}
function $e5f280bca2732078$var$transformExp(x) {
    return Math.exp(x);
}
function $e5f280bca2732078$var$transformLogn(x) {
    return -Math.log(-x);
}
function $e5f280bca2732078$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $e5f280bca2732078$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $e5f280bca2732078$var$powp(base) {
    return base === 10 ? $e5f280bca2732078$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $e5f280bca2732078$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $e5f280bca2732078$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $e5f280bca2732078$export$860836db074028f0(transform) {
    var scale = transform($e5f280bca2732078$var$transformLog, $e5f280bca2732078$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $e5f280bca2732078$var$logp(base), pows = $e5f280bca2732078$var$powp(base);
        if (domain()[0] < 0) {
            logs = $e5f280bca2732078$var$reflect(logs), pows = $e5f280bca2732078$var$reflect(pows);
            transform($e5f280bca2732078$var$transformLogn, $e5f280bca2732078$var$transformExpn);
        } else transform($e5f280bca2732078$var$transformLog, $e5f280bca2732078$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $0c0e85ae379d5115$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $0c0e85ae379d5115$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $45fe3ebe07b00990$export$d9468344d3651243)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $af566cb9913aea7e$export$2e2bcd8739ae039)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $e5f280bca2732078$export$2e2bcd8739ae039() {
    var scale = $e5f280bca2732078$export$860836db074028f0((0, $eb736f827b28f7de$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $eb736f827b28f7de$export$784d13d8ee351f07)(scale, $e5f280bca2732078$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $f394efeb9f7093fc$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $f394efeb9f7093fc$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $f394efeb9f7093fc$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($f394efeb9f7093fc$var$transformSymlog(c), $f394efeb9f7093fc$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($f394efeb9f7093fc$var$transformSymlog(c = +_), $f394efeb9f7093fc$var$transformSymexp(c)) : c;
    };
    return (0, $8d78bad205d390e0$export$16a5d4b4a61a274d)(scale);
}
function $f394efeb9f7093fc$export$2e2bcd8739ae039() {
    var scale = $f394efeb9f7093fc$export$4602684e614eba38((0, $eb736f827b28f7de$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $eb736f827b28f7de$export$784d13d8ee351f07)(scale, $f394efeb9f7093fc$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $6d4f92d26c1ad3fb$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $6d4f92d26c1ad3fb$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $6d4f92d26c1ad3fb$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $6d4f92d26c1ad3fb$export$34695211ec403a46(transform) {
    var scale = transform((0, $eb736f827b28f7de$export$f0954fd7d5368655), (0, $eb736f827b28f7de$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $eb736f827b28f7de$export$f0954fd7d5368655), (0, $eb736f827b28f7de$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($6d4f92d26c1ad3fb$var$transformSqrt, $6d4f92d26c1ad3fb$var$transformSquare) : transform($6d4f92d26c1ad3fb$var$transformPow(exponent), $6d4f92d26c1ad3fb$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $8d78bad205d390e0$export$16a5d4b4a61a274d)(scale);
}
function $6d4f92d26c1ad3fb$export$2e2bcd8739ae039() {
    var scale = $6d4f92d26c1ad3fb$export$34695211ec403a46((0, $eb736f827b28f7de$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $eb736f827b28f7de$export$784d13d8ee351f07)(scale, $6d4f92d26c1ad3fb$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $6d4f92d26c1ad3fb$export$eba8049fb5020b81() {
    return $6d4f92d26c1ad3fb$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}






function $f91a03540d211e73$var$square(x) {
    return Math.sign(x) * x * x;
}
function $f91a03540d211e73$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $f91a03540d211e73$export$2e2bcd8739ae039() {
    var squared = (0, $eb736f827b28f7de$export$2e2bcd8739ae039)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $f91a03540d211e73$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($f91a03540d211e73$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $bcb889c153239827$export$2e2bcd8739ae039))).map($f91a03540d211e73$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $f91a03540d211e73$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
    return (0, $8d78bad205d390e0$export$16a5d4b4a61a274d)(scale);
}




function $7e837adc189d0aa6$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $6023399c16b3ae9b$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $4fe96e9a0ca23dac$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $2d29f4eda77c8a37$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $7e837adc189d0aa6$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $67e218f664a7d422$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $4fe96e9a0ca23dac$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $67e218f664a7d422$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply((0, $8d78bad205d390e0$export$16a5d4b4a61a274d)(scale), arguments);
}




function $6d167ed6105e966f$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $4fe96e9a0ca23dac$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $6d167ed6105e966f$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply(scale, arguments);
}


var $05bae36f856a2c28$var$t0 = new Date, $05bae36f856a2c28$var$t1 = new Date;
function $05bae36f856a2c28$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $05bae36f856a2c28$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $05bae36f856a2c28$var$t0.setTime(+start), $05bae36f856a2c28$var$t1.setTime(+end);
            floori($05bae36f856a2c28$var$t0), floori($05bae36f856a2c28$var$t1);
            return Math.floor(count($05bae36f856a2c28$var$t0, $05bae36f856a2c28$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $59a12f114a504d11$export$79ef0e34099623dc = 1000;
const $59a12f114a504d11$export$683905d551c33fa9 = $59a12f114a504d11$export$79ef0e34099623dc * 60;
const $59a12f114a504d11$export$4157bf0c8e241659 = $59a12f114a504d11$export$683905d551c33fa9 * 60;
const $59a12f114a504d11$export$353686095f4fbf45 = $59a12f114a504d11$export$4157bf0c8e241659 * 24;
const $59a12f114a504d11$export$c241eb88520d5016 = $59a12f114a504d11$export$353686095f4fbf45 * 7;
const $59a12f114a504d11$export$ab95684df7020b26 = $59a12f114a504d11$export$353686095f4fbf45 * 30;
const $59a12f114a504d11$export$61f8ee2d834c6959 = $59a12f114a504d11$export$353686095f4fbf45 * 365;


var $2e3b45890310ac11$var$day = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $59a12f114a504d11$export$683905d551c33fa9)) / (0, $59a12f114a504d11$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $2e3b45890310ac11$export$2e2bcd8739ae039 = $2e3b45890310ac11$var$day;
var $2e3b45890310ac11$export$3cf5dda4201cc0f2 = $2e3b45890310ac11$var$day.range;



var $b922dcca6705c6ac$var$hour = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $59a12f114a504d11$export$79ef0e34099623dc) - date.getMinutes() * (0, $59a12f114a504d11$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $59a12f114a504d11$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $59a12f114a504d11$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $b922dcca6705c6ac$export$2e2bcd8739ae039 = $b922dcca6705c6ac$var$hour;
var $b922dcca6705c6ac$export$8d468796d69cdad1 = $b922dcca6705c6ac$var$hour.range;



var $18c0bdbb472f59cc$var$minute = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $59a12f114a504d11$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $59a12f114a504d11$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $59a12f114a504d11$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $18c0bdbb472f59cc$export$2e2bcd8739ae039 = $18c0bdbb472f59cc$var$minute;
var $18c0bdbb472f59cc$export$666252b437cce0c7 = $18c0bdbb472f59cc$var$minute.range;


var $1d2829b7e04b9634$var$month = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $1d2829b7e04b9634$export$2e2bcd8739ae039 = $1d2829b7e04b9634$var$month;
var $1d2829b7e04b9634$export$16352d1b10c5eb38 = $1d2829b7e04b9634$var$month.range;



var $6b4dcf2947813054$var$second = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $59a12f114a504d11$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $59a12f114a504d11$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $6b4dcf2947813054$export$2e2bcd8739ae039 = $6b4dcf2947813054$var$second;
var $6b4dcf2947813054$export$4792e48abc550fa1 = $6b4dcf2947813054$var$second.range;




var $41d752b42c5c1c8b$var$millisecond = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$41d752b42c5c1c8b$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $41d752b42c5c1c8b$var$millisecond;
    return (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $41d752b42c5c1c8b$export$2e2bcd8739ae039 = $41d752b42c5c1c8b$var$millisecond;
var $41d752b42c5c1c8b$export$9a27fac83d67afd3 = $41d752b42c5c1c8b$var$millisecond.range;








function $c512fbf1ca2d7517$var$weekday(i) {
    return (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $59a12f114a504d11$export$683905d551c33fa9)) / (0, $59a12f114a504d11$export$c241eb88520d5016);
    });
}
var $c512fbf1ca2d7517$export$fb3ee18ed410cc21 = $c512fbf1ca2d7517$var$weekday(0);
var $c512fbf1ca2d7517$export$6416afaab03bc9b8 = $c512fbf1ca2d7517$var$weekday(1);
var $c512fbf1ca2d7517$export$cb8f040f5d17ac7b = $c512fbf1ca2d7517$var$weekday(2);
var $c512fbf1ca2d7517$export$347581849975dfc8 = $c512fbf1ca2d7517$var$weekday(3);
var $c512fbf1ca2d7517$export$2f2b56683a3e5629 = $c512fbf1ca2d7517$var$weekday(4);
var $c512fbf1ca2d7517$export$59b8c2ccd931d806 = $c512fbf1ca2d7517$var$weekday(5);
var $c512fbf1ca2d7517$export$478ceadebff4d377 = $c512fbf1ca2d7517$var$weekday(6);
var $c512fbf1ca2d7517$export$e8daabaa40641211 = $c512fbf1ca2d7517$export$fb3ee18ed410cc21.range;
var $c512fbf1ca2d7517$export$74e5b559c235c00e = $c512fbf1ca2d7517$export$6416afaab03bc9b8.range;
var $c512fbf1ca2d7517$export$e7d6aa4fb107bc56 = $c512fbf1ca2d7517$export$cb8f040f5d17ac7b.range;
var $c512fbf1ca2d7517$export$fcd5880b20bb06a8 = $c512fbf1ca2d7517$export$347581849975dfc8.range;
var $c512fbf1ca2d7517$export$682716b7bbe33641 = $c512fbf1ca2d7517$export$2f2b56683a3e5629.range;
var $c512fbf1ca2d7517$export$482924968ca86084 = $c512fbf1ca2d7517$export$59b8c2ccd931d806.range;
var $c512fbf1ca2d7517$export$7d755172c9cda9d2 = $c512fbf1ca2d7517$export$478ceadebff4d377.range;




var $8bb4d0767a7f72eb$var$year = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$8bb4d0767a7f72eb$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $8bb4d0767a7f72eb$export$2e2bcd8739ae039 = $8bb4d0767a7f72eb$var$year;
var $8bb4d0767a7f72eb$export$6fda41c7fb23acf9 = $8bb4d0767a7f72eb$var$year.range;




var $1a6f32f6c85d1510$var$utcMinute = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $59a12f114a504d11$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $59a12f114a504d11$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $1a6f32f6c85d1510$export$2e2bcd8739ae039 = $1a6f32f6c85d1510$var$utcMinute;
var $1a6f32f6c85d1510$export$cedd563624e8ee50 = $1a6f32f6c85d1510$var$utcMinute.range;




var $1690692aa3b657c6$var$utcHour = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $59a12f114a504d11$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $59a12f114a504d11$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $1690692aa3b657c6$export$2e2bcd8739ae039 = $1690692aa3b657c6$var$utcHour;
var $1690692aa3b657c6$export$6e7a76cd5f50b719 = $1690692aa3b657c6$var$utcHour.range;




var $605833a40483bba5$var$utcDay = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $59a12f114a504d11$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $605833a40483bba5$export$2e2bcd8739ae039 = $605833a40483bba5$var$utcDay;
var $605833a40483bba5$export$d277e198508549a1 = $605833a40483bba5$var$utcDay.range;




function $66afc95a9e9cea5f$var$utcWeekday(i) {
    return (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $59a12f114a504d11$export$c241eb88520d5016);
    });
}
var $66afc95a9e9cea5f$export$4898b06303a92011 = $66afc95a9e9cea5f$var$utcWeekday(0);
var $66afc95a9e9cea5f$export$9cfc53b9cfafd080 = $66afc95a9e9cea5f$var$utcWeekday(1);
var $66afc95a9e9cea5f$export$2a6d545f77eceb15 = $66afc95a9e9cea5f$var$utcWeekday(2);
var $66afc95a9e9cea5f$export$a5c25d8ed64433c4 = $66afc95a9e9cea5f$var$utcWeekday(3);
var $66afc95a9e9cea5f$export$1db08111baec2f53 = $66afc95a9e9cea5f$var$utcWeekday(4);
var $66afc95a9e9cea5f$export$29265e34dd5921f7 = $66afc95a9e9cea5f$var$utcWeekday(5);
var $66afc95a9e9cea5f$export$85b74dad05049604 = $66afc95a9e9cea5f$var$utcWeekday(6);
var $66afc95a9e9cea5f$export$6f3e1c2b0f7d7880 = $66afc95a9e9cea5f$export$4898b06303a92011.range;
var $66afc95a9e9cea5f$export$1d2d8b858bb366f9 = $66afc95a9e9cea5f$export$9cfc53b9cfafd080.range;
var $66afc95a9e9cea5f$export$1d5f6785fc7f30f8 = $66afc95a9e9cea5f$export$2a6d545f77eceb15.range;
var $66afc95a9e9cea5f$export$7a75faf0e37ef4af = $66afc95a9e9cea5f$export$a5c25d8ed64433c4.range;
var $66afc95a9e9cea5f$export$417eb959611b2f2f = $66afc95a9e9cea5f$export$1db08111baec2f53.range;
var $66afc95a9e9cea5f$export$59d308db7af08c64 = $66afc95a9e9cea5f$export$29265e34dd5921f7.range;
var $66afc95a9e9cea5f$export$a124108a0a7f34c8 = $66afc95a9e9cea5f$export$85b74dad05049604.range;



var $94110fec2d3ef313$var$utcMonth = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $94110fec2d3ef313$export$2e2bcd8739ae039 = $94110fec2d3ef313$var$utcMonth;
var $94110fec2d3ef313$export$49159f585997498 = $94110fec2d3ef313$var$utcMonth.range;



var $3af5de8471aac76c$var$utcYear = (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$3af5de8471aac76c$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $05bae36f856a2c28$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $3af5de8471aac76c$export$2e2bcd8739ae039 = $3af5de8471aac76c$var$utcYear;
var $3af5de8471aac76c$export$3e24d311e17f5802 = $3af5de8471aac76c$var$utcYear.range;


function $127df85368d2c381$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $6b4dcf2947813054$export$2e2bcd8739ae039),
            1,
            (0, $59a12f114a504d11$export$79ef0e34099623dc)
        ],
        [
            (0, $6b4dcf2947813054$export$2e2bcd8739ae039),
            5,
            5 * (0, $59a12f114a504d11$export$79ef0e34099623dc)
        ],
        [
            (0, $6b4dcf2947813054$export$2e2bcd8739ae039),
            15,
            15 * (0, $59a12f114a504d11$export$79ef0e34099623dc)
        ],
        [
            (0, $6b4dcf2947813054$export$2e2bcd8739ae039),
            30,
            30 * (0, $59a12f114a504d11$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $59a12f114a504d11$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $59a12f114a504d11$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $59a12f114a504d11$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $59a12f114a504d11$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $59a12f114a504d11$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $59a12f114a504d11$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $59a12f114a504d11$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $59a12f114a504d11$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $59a12f114a504d11$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $59a12f114a504d11$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $59a12f114a504d11$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $59a12f114a504d11$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $59a12f114a504d11$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $59a12f114a504d11$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $46841868eb2484de$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $0c0e85ae379d5115$export$81087d9b915d4ede)(start / (0, $59a12f114a504d11$export$61f8ee2d834c6959), stop / (0, $59a12f114a504d11$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $41d752b42c5c1c8b$export$2e2bcd8739ae039).every(Math.max((0, $0c0e85ae379d5115$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$127df85368d2c381$export$826ba5ae907e9767, $127df85368d2c381$export$6262d8d056ea44c4] = $127df85368d2c381$var$ticker((0, $3af5de8471aac76c$export$2e2bcd8739ae039), (0, $94110fec2d3ef313$export$2e2bcd8739ae039), (0, $66afc95a9e9cea5f$export$4898b06303a92011), (0, $605833a40483bba5$export$2e2bcd8739ae039), (0, $1690692aa3b657c6$export$2e2bcd8739ae039), (0, $1a6f32f6c85d1510$export$2e2bcd8739ae039));
const [$127df85368d2c381$export$60c76498552d28a6, $127df85368d2c381$export$69511150134dd174] = $127df85368d2c381$var$ticker((0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039), (0, $1d2829b7e04b9634$export$2e2bcd8739ae039), (0, $c512fbf1ca2d7517$export$fb3ee18ed410cc21), (0, $2e3b45890310ac11$export$2e2bcd8739ae039), (0, $b922dcca6705c6ac$export$2e2bcd8739ae039), (0, $18c0bdbb472f59cc$export$2e2bcd8739ae039));



function $c9bb369e90b7a7af$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $c9bb369e90b7a7af$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $c9bb369e90b7a7af$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $c9bb369e90b7a7af$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $c9bb369e90b7a7af$var$formatRe(locale_periods), periodLookup = $c9bb369e90b7a7af$var$formatLookup(locale_periods), weekdayRe = $c9bb369e90b7a7af$var$formatRe(locale_weekdays), weekdayLookup = $c9bb369e90b7a7af$var$formatLookup(locale_weekdays), shortWeekdayRe = $c9bb369e90b7a7af$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $c9bb369e90b7a7af$var$formatLookup(locale_shortWeekdays), monthRe = $c9bb369e90b7a7af$var$formatRe(locale_months), monthLookup = $c9bb369e90b7a7af$var$formatLookup(locale_months), shortMonthRe = $c9bb369e90b7a7af$var$formatRe(locale_shortMonths), shortMonthLookup = $c9bb369e90b7a7af$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $c9bb369e90b7a7af$var$formatDayOfMonth,
        "e": $c9bb369e90b7a7af$var$formatDayOfMonth,
        "f": $c9bb369e90b7a7af$var$formatMicroseconds,
        "g": $c9bb369e90b7a7af$var$formatYearISO,
        "G": $c9bb369e90b7a7af$var$formatFullYearISO,
        "H": $c9bb369e90b7a7af$var$formatHour24,
        "I": $c9bb369e90b7a7af$var$formatHour12,
        "j": $c9bb369e90b7a7af$var$formatDayOfYear,
        "L": $c9bb369e90b7a7af$var$formatMilliseconds,
        "m": $c9bb369e90b7a7af$var$formatMonthNumber,
        "M": $c9bb369e90b7a7af$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $c9bb369e90b7a7af$var$formatUnixTimestamp,
        "s": $c9bb369e90b7a7af$var$formatUnixTimestampSeconds,
        "S": $c9bb369e90b7a7af$var$formatSeconds,
        "u": $c9bb369e90b7a7af$var$formatWeekdayNumberMonday,
        "U": $c9bb369e90b7a7af$var$formatWeekNumberSunday,
        "V": $c9bb369e90b7a7af$var$formatWeekNumberISO,
        "w": $c9bb369e90b7a7af$var$formatWeekdayNumberSunday,
        "W": $c9bb369e90b7a7af$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c9bb369e90b7a7af$var$formatYear,
        "Y": $c9bb369e90b7a7af$var$formatFullYear,
        "Z": $c9bb369e90b7a7af$var$formatZone,
        "%": $c9bb369e90b7a7af$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $c9bb369e90b7a7af$var$formatUTCDayOfMonth,
        "e": $c9bb369e90b7a7af$var$formatUTCDayOfMonth,
        "f": $c9bb369e90b7a7af$var$formatUTCMicroseconds,
        "g": $c9bb369e90b7a7af$var$formatUTCYearISO,
        "G": $c9bb369e90b7a7af$var$formatUTCFullYearISO,
        "H": $c9bb369e90b7a7af$var$formatUTCHour24,
        "I": $c9bb369e90b7a7af$var$formatUTCHour12,
        "j": $c9bb369e90b7a7af$var$formatUTCDayOfYear,
        "L": $c9bb369e90b7a7af$var$formatUTCMilliseconds,
        "m": $c9bb369e90b7a7af$var$formatUTCMonthNumber,
        "M": $c9bb369e90b7a7af$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $c9bb369e90b7a7af$var$formatUnixTimestamp,
        "s": $c9bb369e90b7a7af$var$formatUnixTimestampSeconds,
        "S": $c9bb369e90b7a7af$var$formatUTCSeconds,
        "u": $c9bb369e90b7a7af$var$formatUTCWeekdayNumberMonday,
        "U": $c9bb369e90b7a7af$var$formatUTCWeekNumberSunday,
        "V": $c9bb369e90b7a7af$var$formatUTCWeekNumberISO,
        "w": $c9bb369e90b7a7af$var$formatUTCWeekdayNumberSunday,
        "W": $c9bb369e90b7a7af$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $c9bb369e90b7a7af$var$formatUTCYear,
        "Y": $c9bb369e90b7a7af$var$formatUTCFullYear,
        "Z": $c9bb369e90b7a7af$var$formatUTCZone,
        "%": $c9bb369e90b7a7af$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $c9bb369e90b7a7af$var$parseDayOfMonth,
        "e": $c9bb369e90b7a7af$var$parseDayOfMonth,
        "f": $c9bb369e90b7a7af$var$parseMicroseconds,
        "g": $c9bb369e90b7a7af$var$parseYear,
        "G": $c9bb369e90b7a7af$var$parseFullYear,
        "H": $c9bb369e90b7a7af$var$parseHour24,
        "I": $c9bb369e90b7a7af$var$parseHour24,
        "j": $c9bb369e90b7a7af$var$parseDayOfYear,
        "L": $c9bb369e90b7a7af$var$parseMilliseconds,
        "m": $c9bb369e90b7a7af$var$parseMonthNumber,
        "M": $c9bb369e90b7a7af$var$parseMinutes,
        "p": parsePeriod,
        "q": $c9bb369e90b7a7af$var$parseQuarter,
        "Q": $c9bb369e90b7a7af$var$parseUnixTimestamp,
        "s": $c9bb369e90b7a7af$var$parseUnixTimestampSeconds,
        "S": $c9bb369e90b7a7af$var$parseSeconds,
        "u": $c9bb369e90b7a7af$var$parseWeekdayNumberMonday,
        "U": $c9bb369e90b7a7af$var$parseWeekNumberSunday,
        "V": $c9bb369e90b7a7af$var$parseWeekNumberISO,
        "w": $c9bb369e90b7a7af$var$parseWeekdayNumberSunday,
        "W": $c9bb369e90b7a7af$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $c9bb369e90b7a7af$var$parseYear,
        "Y": $c9bb369e90b7a7af$var$parseFullYear,
        "Z": $c9bb369e90b7a7af$var$parseZone,
        "%": $c9bb369e90b7a7af$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $c9bb369e90b7a7af$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $c9bb369e90b7a7af$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $c9bb369e90b7a7af$var$utcDate($c9bb369e90b7a7af$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $66afc95a9e9cea5f$export$9cfc53b9cfafd080).ceil(week) : (0, $66afc95a9e9cea5f$export$9cfc53b9cfafd080)(week);
                    week = (0, $605833a40483bba5$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $c9bb369e90b7a7af$var$localDate($c9bb369e90b7a7af$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $c512fbf1ca2d7517$export$6416afaab03bc9b8).ceil(week) : (0, $c512fbf1ca2d7517$export$6416afaab03bc9b8)(week);
                    week = (0, $2e3b45890310ac11$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $c9bb369e90b7a7af$var$utcDate($c9bb369e90b7a7af$var$newDate(d.y, 0, 1)).getUTCDay() : $c9bb369e90b7a7af$var$localDate($c9bb369e90b7a7af$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $c9bb369e90b7a7af$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $c9bb369e90b7a7af$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $c9bb369e90b7a7af$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $c9bb369e90b7a7af$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $c9bb369e90b7a7af$var$numberRe = /^\s*\d+/, $c9bb369e90b7a7af$var$percentRe = /^%/, $c9bb369e90b7a7af$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $c9bb369e90b7a7af$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $c9bb369e90b7a7af$var$requote(s) {
    return s.replace($c9bb369e90b7a7af$var$requoteRe, "\\$&");
}
function $c9bb369e90b7a7af$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($c9bb369e90b7a7af$var$requote).join("|") + ")", "i");
}
function $c9bb369e90b7a7af$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $c9bb369e90b7a7af$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseWeekNumberSunday(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseWeekNumberISO(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseWeekNumberMonday(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseFullYear(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseYear(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseQuarter(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseMonthNumber(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseDayOfMonth(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseDayOfYear(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseHour24(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseMinutes(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseSeconds(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseMilliseconds(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseMicroseconds(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseLiteralPercent(d, string, i) {
    var n = $c9bb369e90b7a7af$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $c9bb369e90b7a7af$var$parseUnixTimestamp(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $c9bb369e90b7a7af$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $c9bb369e90b7a7af$var$formatDayOfMonth(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getDate(), p, 2);
}
function $c9bb369e90b7a7af$var$formatHour24(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getHours(), p, 2);
}
function $c9bb369e90b7a7af$var$formatHour12(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $c9bb369e90b7a7af$var$formatDayOfYear(d, p) {
    return $c9bb369e90b7a7af$var$pad(1 + (0, $2e3b45890310ac11$export$2e2bcd8739ae039).count((0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $c9bb369e90b7a7af$var$formatMilliseconds(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getMilliseconds(), p, 3);
}
function $c9bb369e90b7a7af$var$formatMicroseconds(d, p) {
    return $c9bb369e90b7a7af$var$formatMilliseconds(d, p) + "000";
}
function $c9bb369e90b7a7af$var$formatMonthNumber(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getMonth() + 1, p, 2);
}
function $c9bb369e90b7a7af$var$formatMinutes(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getMinutes(), p, 2);
}
function $c9bb369e90b7a7af$var$formatSeconds(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getSeconds(), p, 2);
}
function $c9bb369e90b7a7af$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $c9bb369e90b7a7af$var$formatWeekNumberSunday(d, p) {
    return $c9bb369e90b7a7af$var$pad((0, $c512fbf1ca2d7517$export$fb3ee18ed410cc21).count((0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $c9bb369e90b7a7af$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $c512fbf1ca2d7517$export$2f2b56683a3e5629)(d) : (0, $c512fbf1ca2d7517$export$2f2b56683a3e5629).ceil(d);
}
function $c9bb369e90b7a7af$var$formatWeekNumberISO(d, p) {
    d = $c9bb369e90b7a7af$var$dISO(d);
    return $c9bb369e90b7a7af$var$pad((0, $c512fbf1ca2d7517$export$2f2b56683a3e5629).count((0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039)(d), d) + ((0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $c9bb369e90b7a7af$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $c9bb369e90b7a7af$var$formatWeekNumberMonday(d, p) {
    return $c9bb369e90b7a7af$var$pad((0, $c512fbf1ca2d7517$export$6416afaab03bc9b8).count((0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $c9bb369e90b7a7af$var$formatYear(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getFullYear() % 100, p, 2);
}
function $c9bb369e90b7a7af$var$formatYearISO(d, p) {
    d = $c9bb369e90b7a7af$var$dISO(d);
    return $c9bb369e90b7a7af$var$pad(d.getFullYear() % 100, p, 2);
}
function $c9bb369e90b7a7af$var$formatFullYear(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c9bb369e90b7a7af$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $c512fbf1ca2d7517$export$2f2b56683a3e5629)(d) : (0, $c512fbf1ca2d7517$export$2f2b56683a3e5629).ceil(d);
    return $c9bb369e90b7a7af$var$pad(d.getFullYear() % 10000, p, 4);
}
function $c9bb369e90b7a7af$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $c9bb369e90b7a7af$var$pad(z / 60 | 0, "0", 2) + $c9bb369e90b7a7af$var$pad(z % 60, "0", 2);
}
function $c9bb369e90b7a7af$var$formatUTCDayOfMonth(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCDate(), p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCHour24(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCHours(), p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCHour12(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCDayOfYear(d, p) {
    return $c9bb369e90b7a7af$var$pad(1 + (0, $605833a40483bba5$export$2e2bcd8739ae039).count((0, $3af5de8471aac76c$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $c9bb369e90b7a7af$var$formatUTCMilliseconds(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $c9bb369e90b7a7af$var$formatUTCMicroseconds(d, p) {
    return $c9bb369e90b7a7af$var$formatUTCMilliseconds(d, p) + "000";
}
function $c9bb369e90b7a7af$var$formatUTCMonthNumber(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCMinutes(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCMinutes(), p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCSeconds(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCSeconds(), p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $c9bb369e90b7a7af$var$formatUTCWeekNumberSunday(d, p) {
    return $c9bb369e90b7a7af$var$pad((0, $66afc95a9e9cea5f$export$4898b06303a92011).count((0, $3af5de8471aac76c$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $c9bb369e90b7a7af$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $66afc95a9e9cea5f$export$1db08111baec2f53)(d) : (0, $66afc95a9e9cea5f$export$1db08111baec2f53).ceil(d);
}
function $c9bb369e90b7a7af$var$formatUTCWeekNumberISO(d, p) {
    d = $c9bb369e90b7a7af$var$UTCdISO(d);
    return $c9bb369e90b7a7af$var$pad((0, $66afc95a9e9cea5f$export$1db08111baec2f53).count((0, $3af5de8471aac76c$export$2e2bcd8739ae039)(d), d) + ((0, $3af5de8471aac76c$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $c9bb369e90b7a7af$var$formatUTCWeekNumberMonday(d, p) {
    return $c9bb369e90b7a7af$var$pad((0, $66afc95a9e9cea5f$export$9cfc53b9cfafd080).count((0, $3af5de8471aac76c$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCYear(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCYearISO(d, p) {
    d = $c9bb369e90b7a7af$var$UTCdISO(d);
    return $c9bb369e90b7a7af$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $c9bb369e90b7a7af$var$formatUTCFullYear(d, p) {
    return $c9bb369e90b7a7af$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c9bb369e90b7a7af$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $66afc95a9e9cea5f$export$1db08111baec2f53)(d) : (0, $66afc95a9e9cea5f$export$1db08111baec2f53).ceil(d);
    return $c9bb369e90b7a7af$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $c9bb369e90b7a7af$var$formatUTCZone() {
    return "+0000";
}
function $c9bb369e90b7a7af$var$formatLiteralPercent() {
    return "%";
}
function $c9bb369e90b7a7af$var$formatUnixTimestamp(d) {
    return +d;
}
function $c9bb369e90b7a7af$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $9c52e761ce5e063b$var$locale;
var $9c52e761ce5e063b$export$94f4d87fad5dcf9a;
var $9c52e761ce5e063b$export$32b9cd16e1b8c8d2;
var $9c52e761ce5e063b$export$1a08fe38f63ebbbb;
var $9c52e761ce5e063b$export$3edae9cf8e233729;
$9c52e761ce5e063b$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $9c52e761ce5e063b$export$2e2bcd8739ae039(definition) {
    $9c52e761ce5e063b$var$locale = (0, $c9bb369e90b7a7af$export$2e2bcd8739ae039)(definition);
    $9c52e761ce5e063b$export$94f4d87fad5dcf9a = $9c52e761ce5e063b$var$locale.format;
    $9c52e761ce5e063b$export$32b9cd16e1b8c8d2 = $9c52e761ce5e063b$var$locale.parse;
    $9c52e761ce5e063b$export$1a08fe38f63ebbbb = $9c52e761ce5e063b$var$locale.utcFormat;
    $9c52e761ce5e063b$export$3edae9cf8e233729 = $9c52e761ce5e063b$var$locale.utcParse;
    return $9c52e761ce5e063b$var$locale;
}





function $25e925f057baa3bc$var$date(t) {
    return new Date(t);
}
function $25e925f057baa3bc$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $25e925f057baa3bc$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $eb736f827b28f7de$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $25e925f057baa3bc$var$number)) : domain().map($25e925f057baa3bc$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $af566cb9913aea7e$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $eb736f827b28f7de$export$784d13d8ee351f07)(scale, $25e925f057baa3bc$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $25e925f057baa3bc$export$2e2bcd8739ae039() {
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply($25e925f057baa3bc$export$56bbcdb8aca31149((0, $127df85368d2c381$export$60c76498552d28a6), (0, $127df85368d2c381$export$69511150134dd174), (0, $8bb4d0767a7f72eb$export$2e2bcd8739ae039), (0, $1d2829b7e04b9634$export$2e2bcd8739ae039), (0, $c512fbf1ca2d7517$export$fb3ee18ed410cc21), (0, $2e3b45890310ac11$export$2e2bcd8739ae039), (0, $b922dcca6705c6ac$export$2e2bcd8739ae039), (0, $18c0bdbb472f59cc$export$2e2bcd8739ae039), (0, $6b4dcf2947813054$export$2e2bcd8739ae039), (0, $9c52e761ce5e063b$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}






function $f282df5ade9e3502$export$2e2bcd8739ae039() {
    return (0, $f6637fbcde7d18c1$export$23c7bb9e6558da2a).apply((0, $25e925f057baa3bc$export$56bbcdb8aca31149)((0, $127df85368d2c381$export$826ba5ae907e9767), (0, $127df85368d2c381$export$6262d8d056ea44c4), (0, $3af5de8471aac76c$export$2e2bcd8739ae039), (0, $94110fec2d3ef313$export$2e2bcd8739ae039), (0, $66afc95a9e9cea5f$export$4898b06303a92011), (0, $605833a40483bba5$export$2e2bcd8739ae039), (0, $1690692aa3b657c6$export$2e2bcd8739ae039), (0, $1a6f32f6c85d1510$export$2e2bcd8739ae039), (0, $6b4dcf2947813054$export$2e2bcd8739ae039), (0, $9c52e761ce5e063b$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}









function $ccf132c4ddaaaa62$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $eb736f827b28f7de$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $b2e6b30770951138$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $ccf132c4ddaaaa62$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $ccf132c4ddaaaa62$export$2e2bcd8739ae039() {
    var scale = (0, $8d78bad205d390e0$export$16a5d4b4a61a274d)($ccf132c4ddaaaa62$var$transformer()((0, $eb736f827b28f7de$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $ccf132c4ddaaaa62$export$784d13d8ee351f07(scale, $ccf132c4ddaaaa62$export$2e2bcd8739ae039());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $ccf132c4ddaaaa62$export$6843e08bf2ff981f() {
    var scale = (0, $e5f280bca2732078$export$860836db074028f0)($ccf132c4ddaaaa62$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $ccf132c4ddaaaa62$export$784d13d8ee351f07(scale, $ccf132c4ddaaaa62$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $ccf132c4ddaaaa62$export$9d4af4de62c81941() {
    var scale = (0, $f394efeb9f7093fc$export$4602684e614eba38)($ccf132c4ddaaaa62$var$transformer());
    scale.copy = function() {
        return $ccf132c4ddaaaa62$export$784d13d8ee351f07(scale, $ccf132c4ddaaaa62$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $ccf132c4ddaaaa62$export$de9f78581b4f2405() {
    var scale = (0, $6d4f92d26c1ad3fb$export$34695211ec403a46)($ccf132c4ddaaaa62$var$transformer());
    scale.copy = function() {
        return $ccf132c4ddaaaa62$export$784d13d8ee351f07(scale, $ccf132c4ddaaaa62$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $ccf132c4ddaaaa62$export$413d935127ed466e() {
    return $ccf132c4ddaaaa62$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}





function $cd7f5fe99e22e25b$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $eb736f827b28f7de$export$f0954fd7d5368655);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $4fe96e9a0ca23dac$export$2e2bcd8739ae039)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $2d29f4eda77c8a37$export$2e2bcd8739ae039));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $6023399c16b3ae9b$export$2e2bcd8739ae039)(domain, i / n));
    };
    scale.copy = function() {
        return $cd7f5fe99e22e25b$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}










function $0187dcad2a38585d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $eb736f827b28f7de$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $e9fb12e4f27c1a7d$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $0f8c512c5c8a77f6$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $b2e6b30770951138$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $0187dcad2a38585d$export$2e2bcd8739ae039() {
    var scale = (0, $8d78bad205d390e0$export$16a5d4b4a61a274d)($0187dcad2a38585d$var$transformer()((0, $eb736f827b28f7de$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $ccf132c4ddaaaa62$export$784d13d8ee351f07)(scale, $0187dcad2a38585d$export$2e2bcd8739ae039());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $0187dcad2a38585d$export$5f0266a9159c47fb() {
    var scale = (0, $e5f280bca2732078$export$860836db074028f0)($0187dcad2a38585d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $ccf132c4ddaaaa62$export$784d13d8ee351f07)(scale, $0187dcad2a38585d$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $0187dcad2a38585d$export$50b3da713cf557c6() {
    var scale = (0, $f394efeb9f7093fc$export$4602684e614eba38)($0187dcad2a38585d$var$transformer());
    scale.copy = function() {
        return (0, $ccf132c4ddaaaa62$export$784d13d8ee351f07)(scale, $0187dcad2a38585d$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $0187dcad2a38585d$export$d6cedcc63bf26e7e() {
    var scale = (0, $6d4f92d26c1ad3fb$export$34695211ec403a46)($0187dcad2a38585d$var$transformer());
    scale.copy = function() {
        return (0, $ccf132c4ddaaaa62$export$784d13d8ee351f07)(scale, $0187dcad2a38585d$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $f6637fbcde7d18c1$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $0187dcad2a38585d$export$33ddefb5c4ab9e9c() {
    return $0187dcad2a38585d$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}





var $371d45315aa2f6f2$exports = {};

$parcel$export($371d45315aa2f6f2$exports, "schemeCategory10", function () { return $4bedada05e1b35ba$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeAccent", function () { return $553ada8baf842437$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeDark2", function () { return $6589f8f58fb69aa4$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePaired", function () { return $8225915fac77cc9b$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePastel1", function () { return $2babd27f445f3c72$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePastel2", function () { return $09a93658521c454c$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeSet1", function () { return $010473adc1af9bed$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeSet2", function () { return $8aef8481895bdd75$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeSet3", function () { return $61d0f17682da9973$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeTableau10", function () { return $5e0f2609cee6f7d8$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateBrBG", function () { return $e0d51cbe22415c41$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeBrBG", function () { return $e0d51cbe22415c41$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePRGn", function () { return $ec48f618db34331a$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePRGn", function () { return $ec48f618db34331a$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePiYG", function () { return $b108e0a4cc148a40$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePiYG", function () { return $b108e0a4cc148a40$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePuOr", function () { return $d0e5171057904e34$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePuOr", function () { return $d0e5171057904e34$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateRdBu", function () { return $a18c30814355aaf1$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeRdBu", function () { return $a18c30814355aaf1$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateRdGy", function () { return $56c7b4e28b3fc5b4$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeRdGy", function () { return $56c7b4e28b3fc5b4$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateRdYlBu", function () { return $b38f479764aa0c32$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeRdYlBu", function () { return $b38f479764aa0c32$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateRdYlGn", function () { return $735c0ce7c9a65ed3$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeRdYlGn", function () { return $735c0ce7c9a65ed3$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateSpectral", function () { return $876c87df5b64ca53$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeSpectral", function () { return $876c87df5b64ca53$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateBuGn", function () { return $9d20b645008a11cc$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeBuGn", function () { return $9d20b645008a11cc$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateBuPu", function () { return $4ff6aa2c6028e837$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeBuPu", function () { return $4ff6aa2c6028e837$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateGnBu", function () { return $2b63948fdb16e0fc$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeGnBu", function () { return $2b63948fdb16e0fc$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateOrRd", function () { return $c69260c772f7238b$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeOrRd", function () { return $c69260c772f7238b$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePuBuGn", function () { return $078c9a7fec630b9b$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePuBuGn", function () { return $078c9a7fec630b9b$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePuBu", function () { return $e2cf7541feee4f92$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePuBu", function () { return $e2cf7541feee4f92$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePuRd", function () { return $05954d956f4fd768$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePuRd", function () { return $05954d956f4fd768$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateRdPu", function () { return $a316a40ac912201a$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeRdPu", function () { return $a316a40ac912201a$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateYlGnBu", function () { return $a37a98fe3ff43d68$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeYlGnBu", function () { return $a37a98fe3ff43d68$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateYlGn", function () { return $4274274158995173$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeYlGn", function () { return $4274274158995173$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateYlOrBr", function () { return $568a13807a5f8362$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeYlOrBr", function () { return $568a13807a5f8362$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateYlOrRd", function () { return $e6214cc4da249543$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeYlOrRd", function () { return $e6214cc4da249543$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateBlues", function () { return $1b3c3a76a4d14b6a$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeBlues", function () { return $1b3c3a76a4d14b6a$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateGreens", function () { return $8d054e3dbbbca82a$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeGreens", function () { return $8d054e3dbbbca82a$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateGreys", function () { return $13859bd86d8d4f03$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeGreys", function () { return $13859bd86d8d4f03$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePurples", function () { return $0cb303d1fc469380$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemePurples", function () { return $0cb303d1fc469380$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateReds", function () { return $53a618bf295dc9f2$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeReds", function () { return $53a618bf295dc9f2$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateOranges", function () { return $4b29419239a3cbc7$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "schemeOranges", function () { return $4b29419239a3cbc7$export$3005042704f95a69; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateCividis", function () { return $290aa3857ed48f03$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateCubehelixDefault", function () { return $eab573d34e7acdc1$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateRainbow", function () { return $d0785d4218c2b53f$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateWarm", function () { return $d0785d4218c2b53f$export$fc70efcec537be98; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateCool", function () { return $d0785d4218c2b53f$export$c5cedbc1ab3be2c3; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateSinebow", function () { return $0c904401f0247225$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateTurbo", function () { return $a7ac4cdf5ad79596$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateViridis", function () { return $4846503ff3b5008a$export$2e2bcd8739ae039; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateMagma", function () { return $4846503ff3b5008a$export$c41e69203f572e8d; });
$parcel$export($371d45315aa2f6f2$exports, "interpolateInferno", function () { return $4846503ff3b5008a$export$ad0c8285c8ea6dbd; });
$parcel$export($371d45315aa2f6f2$exports, "interpolatePlasma", function () { return $4846503ff3b5008a$export$6664860a633d9daf; });
function $a7bfc36d48ae6119$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}


var $4bedada05e1b35ba$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");



var $553ada8baf842437$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");



var $6589f8f58fb69aa4$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");



var $8225915fac77cc9b$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");



var $2babd27f445f3c72$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");



var $09a93658521c454c$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");



var $010473adc1af9bed$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");



var $8aef8481895bdd75$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");



var $61d0f17682da9973$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");



var $5e0f2609cee6f7d8$export$2e2bcd8739ae039 = (0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");




var $5ad2fea4de8aed78$export$2e2bcd8739ae039 = (scheme)=>(0, $4efcfc37f0c760c0$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $e0d51cbe22415c41$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $e0d51cbe22415c41$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($e0d51cbe22415c41$export$3005042704f95a69);




var $ec48f618db34331a$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $ec48f618db34331a$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($ec48f618db34331a$export$3005042704f95a69);




var $b108e0a4cc148a40$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $b108e0a4cc148a40$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($b108e0a4cc148a40$export$3005042704f95a69);




var $d0e5171057904e34$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $d0e5171057904e34$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($d0e5171057904e34$export$3005042704f95a69);




var $a18c30814355aaf1$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $a18c30814355aaf1$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($a18c30814355aaf1$export$3005042704f95a69);




var $56c7b4e28b3fc5b4$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $56c7b4e28b3fc5b4$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($56c7b4e28b3fc5b4$export$3005042704f95a69);




var $b38f479764aa0c32$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $b38f479764aa0c32$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($b38f479764aa0c32$export$3005042704f95a69);




var $735c0ce7c9a65ed3$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $735c0ce7c9a65ed3$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($735c0ce7c9a65ed3$export$3005042704f95a69);




var $876c87df5b64ca53$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $876c87df5b64ca53$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($876c87df5b64ca53$export$3005042704f95a69);




var $9d20b645008a11cc$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $9d20b645008a11cc$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($9d20b645008a11cc$export$3005042704f95a69);




var $4ff6aa2c6028e837$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $4ff6aa2c6028e837$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($4ff6aa2c6028e837$export$3005042704f95a69);




var $2b63948fdb16e0fc$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $2b63948fdb16e0fc$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($2b63948fdb16e0fc$export$3005042704f95a69);




var $c69260c772f7238b$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $c69260c772f7238b$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($c69260c772f7238b$export$3005042704f95a69);




var $078c9a7fec630b9b$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $078c9a7fec630b9b$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($078c9a7fec630b9b$export$3005042704f95a69);




var $e2cf7541feee4f92$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $e2cf7541feee4f92$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($e2cf7541feee4f92$export$3005042704f95a69);




var $05954d956f4fd768$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $05954d956f4fd768$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($05954d956f4fd768$export$3005042704f95a69);




var $a316a40ac912201a$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $a316a40ac912201a$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($a316a40ac912201a$export$3005042704f95a69);




var $a37a98fe3ff43d68$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $a37a98fe3ff43d68$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($a37a98fe3ff43d68$export$3005042704f95a69);




var $4274274158995173$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $4274274158995173$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($4274274158995173$export$3005042704f95a69);




var $568a13807a5f8362$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $568a13807a5f8362$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($568a13807a5f8362$export$3005042704f95a69);




var $e6214cc4da249543$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $e6214cc4da249543$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($e6214cc4da249543$export$3005042704f95a69);




var $1b3c3a76a4d14b6a$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $1b3c3a76a4d14b6a$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($1b3c3a76a4d14b6a$export$3005042704f95a69);




var $8d054e3dbbbca82a$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $8d054e3dbbbca82a$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($8d054e3dbbbca82a$export$3005042704f95a69);




var $13859bd86d8d4f03$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $13859bd86d8d4f03$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($13859bd86d8d4f03$export$3005042704f95a69);




var $0cb303d1fc469380$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $0cb303d1fc469380$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($0cb303d1fc469380$export$3005042704f95a69);




var $53a618bf295dc9f2$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $53a618bf295dc9f2$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($53a618bf295dc9f2$export$3005042704f95a69);




var $4b29419239a3cbc7$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039));
var $4b29419239a3cbc7$export$2e2bcd8739ae039 = (0, $5ad2fea4de8aed78$export$2e2bcd8739ae039)($4b29419239a3cbc7$export$3005042704f95a69);


function $290aa3857ed48f03$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}




var $eab573d34e7acdc1$export$2e2bcd8739ae039 = (0, $f1f1747c3426a89f$export$934fa09ad474a1b4)((0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(-240, 0.5, 1.0));




var $d0785d4218c2b53f$export$fc70efcec537be98 = (0, $f1f1747c3426a89f$export$934fa09ad474a1b4)((0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $d0785d4218c2b53f$export$c5cedbc1ab3be2c3 = (0, $f1f1747c3426a89f$export$934fa09ad474a1b4)((0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $d0785d4218c2b53f$var$c = (0, $b6a1d8d4ad5ffe11$export$2e2bcd8739ae039)();
function $d0785d4218c2b53f$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $d0785d4218c2b53f$var$c.h = 360 * t - 100;
    $d0785d4218c2b53f$var$c.s = 1.5 - 1.5 * ts;
    $d0785d4218c2b53f$var$c.l = 0.8 - 0.9 * ts;
    return $d0785d4218c2b53f$var$c + "";
}



var $lDve0 = parcelRequire("lDve0");
var $0c904401f0247225$var$c = (0, $lDve0.rgb)(), $0c904401f0247225$var$pi_1_3 = Math.PI / 3, $0c904401f0247225$var$pi_2_3 = Math.PI * 2 / 3;
function $0c904401f0247225$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $0c904401f0247225$var$c.r = 255 * (x = Math.sin(t)) * x;
    $0c904401f0247225$var$c.g = 255 * (x = Math.sin(t + $0c904401f0247225$var$pi_1_3)) * x;
    $0c904401f0247225$var$c.b = 255 * (x = Math.sin(t + $0c904401f0247225$var$pi_2_3)) * x;
    return $0c904401f0247225$var$c + "";
}


function $a7ac4cdf5ad79596$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}



function $4846503ff3b5008a$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $4846503ff3b5008a$export$2e2bcd8739ae039 = $4846503ff3b5008a$var$ramp((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $4846503ff3b5008a$export$c41e69203f572e8d = $4846503ff3b5008a$var$ramp((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $4846503ff3b5008a$export$ad0c8285c8ea6dbd = $4846503ff3b5008a$var$ramp((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $4846503ff3b5008a$export$6664860a633d9daf = $4846503ff3b5008a$var$ramp((0, $a7bfc36d48ae6119$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));




var $bd5e2d686e6196f4$exports = {};

$parcel$export($bd5e2d686e6196f4$exports, "create", function () { return $253a0bb471001be9$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "creator", function () { return $05ff5bb28f55c49f$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "local", function () { return $85531f595c9ade35$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "matcher", function () { return $98ead6b7044d2c9b$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "namespace", function () { return $5361d4c7390d69ee$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "namespaces", function () { return $2bf80764bc2ec3dc$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "pointer", function () { return $f414987f08497e2f$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "pointers", function () { return $c917dddd087b33ac$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "select", function () { return $0fd7b7faefc9df82$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "selectAll", function () { return $b7ea63fc110f3258$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "selection", function () { return $30b99eabd4635d88$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "selector", function () { return $dfd5f4da69e6fc89$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "selectorAll", function () { return $4edfa6f7c70b9ae4$export$2e2bcd8739ae039; });
$parcel$export($bd5e2d686e6196f4$exports, "style", function () { return $3ee26f6a7e3758bf$export$5e3cec964f0b5efd; });
$parcel$export($bd5e2d686e6196f4$exports, "window", function () { return $db81a2739179290d$export$2e2bcd8739ae039; });


function $253a0bb471001be9$export$2e2bcd8739ae039(name) {
    return (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)((0, $05ff5bb28f55c49f$export$2e2bcd8739ae039)(name).call(document.documentElement));
}



var $85531f595c9ade35$var$nextId = 0;
function $85531f595c9ade35$export$2e2bcd8739ae039() {
    return new $85531f595c9ade35$var$Local;
}
function $85531f595c9ade35$var$Local() {
    this._ = "@" + (++$85531f595c9ade35$var$nextId).toString(36);
}
$85531f595c9ade35$var$Local.prototype = $85531f595c9ade35$export$2e2bcd8739ae039.prototype = {
    constructor: $85531f595c9ade35$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};








function $c917dddd087b33ac$export$2e2bcd8739ae039(events, node) {
    if (events.target) {
        events = (0, $6e0b2ce48c5fb1d6$export$2e2bcd8739ae039)(events);
        if (node === undefined) node = events.currentTarget;
        events = events.touches || [
            events
        ];
    }
    return Array.from(events, (event)=>(0, $f414987f08497e2f$export$2e2bcd8739ae039)(event, node));
}





function $b7ea63fc110f3258$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $30b99eabd4635d88$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $30b99eabd4635d88$export$52baac22726c72bf)([
        selector == null ? [] : (0, $4d3c2139300ccec0$export$2e2bcd8739ae039)(selector)
    ], (0, $30b99eabd4635d88$export$e8e78c978b129247));
}









var $a1a8175c6f9ceda9$exports = {};

$parcel$export($a1a8175c6f9ceda9$exports, "arc", function () { return $7ba9a0abd6353e45$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "area", function () { return $daff0bd8c7aeefb0$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "line", function () { return $0efbaaef705ecd04$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "pie", function () { return $532a308766abee59$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "areaRadial", function () { return $dd80b62bf41b6fc2$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "radialArea", function () { return $dd80b62bf41b6fc2$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "lineRadial", function () { return $8bc8c94cb22be38a$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "radialLine", function () { return $8bc8c94cb22be38a$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "pointRadial", function () { return $623fec17826c0369$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "linkHorizontal", function () { return $42f9b58aa8f62d80$export$e7c381889b2cd14d; });
$parcel$export($a1a8175c6f9ceda9$exports, "linkVertical", function () { return $42f9b58aa8f62d80$export$75de4c8c66884e04; });
$parcel$export($a1a8175c6f9ceda9$exports, "linkRadial", function () { return $42f9b58aa8f62d80$export$7739cfe68d4e0799; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbol", function () { return $d5a090be37c23672$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbols", function () { return $d5a090be37c23672$export$47616e9f7f5fe113; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolCircle", function () { return $33a0d11e71617e74$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolCross", function () { return $03280bc0c2427706$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolDiamond", function () { return $6868274b95c36ca5$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolSquare", function () { return $f82a84f87c004b7f$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolStar", function () { return $6aa366abfdc5ab38$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolTriangle", function () { return $1941b11a03fd696c$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "symbolWye", function () { return $969e338be7105a04$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveBasisClosed", function () { return $9937c9efff948f41$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveBasisOpen", function () { return $e4dc2d2f2b257991$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveBasis", function () { return $9a334361f31d6306$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveBumpX", function () { return $82888e0d35e50c9f$export$2c099b5096f70ce6; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveBumpY", function () { return $82888e0d35e50c9f$export$908da9dfa54cbed6; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveBundle", function () { return $a4a11fb892aadbec$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveCardinalClosed", function () { return $00f40c5baaf98134$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveCardinalOpen", function () { return $634cb64d1f1f38bc$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveCardinal", function () { return (parcelRequire("gQlHt")).default; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveCatmullRomClosed", function () { return $8d6ea64393ecd14d$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveCatmullRomOpen", function () { return $161f185e306f66b7$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveCatmullRom", function () { return (parcelRequire("1ihob")).default; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveLinearClosed", function () { return $4ce0b82cba985186$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveLinear", function () { return $386821abbbe40b33$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveMonotoneX", function () { return $8bdbc3bbe2058ddb$export$99563b5420dbdc55; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveMonotoneY", function () { return $8bdbc3bbe2058ddb$export$8b5360456d6bdb88; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveNatural", function () { return $f68a4c4bb517644d$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveStep", function () { return $3db7487d32d9e028$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveStepAfter", function () { return $3db7487d32d9e028$export$793b3db073781cbb; });
$parcel$export($a1a8175c6f9ceda9$exports, "curveStepBefore", function () { return $3db7487d32d9e028$export$10eafa5b7478b343; });
$parcel$export($a1a8175c6f9ceda9$exports, "stack", function () { return $cce6948a47273b47$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOffsetExpand", function () { return $6252ee6b01d9847a$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOffsetDiverging", function () { return $5a177cd45fe4e9c3$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOffsetNone", function () { return $4c5e6d0199e49bd7$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOffsetSilhouette", function () { return $805c25413019a972$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOffsetWiggle", function () { return $24fdf35cd1c4cf7c$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOrderAppearance", function () { return $0a6df3e6bc3df090$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOrderAscending", function () { return $56fdb10bb99bbf1a$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOrderDescending", function () { return $d8b4e6e4ba09450f$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOrderInsideOut", function () { return $67f136beeb842e9a$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOrderNone", function () { return $3c3a672c30225b5f$export$2e2bcd8739ae039; });
$parcel$export($a1a8175c6f9ceda9$exports, "stackOrderReverse", function () { return $d9882df9a36ba8b6$export$2e2bcd8739ae039; });

function $c005e83c125595ee$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}



var $hgmfu = parcelRequire("hgmfu");
function $7ba9a0abd6353e45$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $7ba9a0abd6353e45$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $7ba9a0abd6353e45$var$arcStartAngle(d) {
    return d.startAngle;
}
function $7ba9a0abd6353e45$var$arcEndAngle(d) {
    return d.endAngle;
}
function $7ba9a0abd6353e45$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $7ba9a0abd6353e45$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $hgmfu.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $7ba9a0abd6353e45$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $hgmfu.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $hgmfu.sqrt)((0, $hgmfu.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $7ba9a0abd6353e45$export$2e2bcd8739ae039() {
    var innerRadius = $7ba9a0abd6353e45$var$arcInnerRadius, outerRadius = $7ba9a0abd6353e45$var$arcOuterRadius, cornerRadius = (0, $c005e83c125595ee$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $7ba9a0abd6353e45$var$arcStartAngle, endAngle = $7ba9a0abd6353e45$var$arcEndAngle, padAngle = $7ba9a0abd6353e45$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $hgmfu.halfPi), a1 = endAngle.apply(this, arguments) - (0, $hgmfu.halfPi), da = (0, $hgmfu.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $a56e6346ae45e61d$export$2e2bcd8739ae039)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $hgmfu.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $hgmfu.tau) - (0, $hgmfu.epsilon)) {
            context.moveTo(r1 * (0, $hgmfu.cos)(a0), r1 * (0, $hgmfu.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $hgmfu.epsilon)) {
                context.moveTo(r0 * (0, $hgmfu.cos)(a1), r0 * (0, $hgmfu.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $hgmfu.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $hgmfu.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $hgmfu.min)((0, $hgmfu.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $hgmfu.epsilon)) {
                var p0 = (0, $hgmfu.asin)(rp / r0 * (0, $hgmfu.sin)(ap)), p1 = (0, $hgmfu.asin)(rp / r1 * (0, $hgmfu.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $hgmfu.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $hgmfu.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $hgmfu.cos)(a01), y01 = r1 * (0, $hgmfu.sin)(a01), x10 = r0 * (0, $hgmfu.cos)(a10), y10 = r0 * (0, $hgmfu.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $hgmfu.epsilon)) {
                var x11 = r1 * (0, $hgmfu.cos)(a11), y11 = r1 * (0, $hgmfu.sin)(a11), x00 = r0 * (0, $hgmfu.cos)(a00), y00 = r0 * (0, $hgmfu.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $hgmfu.pi) && (oc = $7ba9a0abd6353e45$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $hgmfu.sin)((0, $hgmfu.acos)((ax * bx + ay * by) / ((0, $hgmfu.sqrt)(ax * ax + ay * ay) * (0, $hgmfu.sqrt)(bx * bx + by * by))) / 2), lc = (0, $hgmfu.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $hgmfu.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $hgmfu.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $hgmfu.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $hgmfu.epsilon)) {
                t0 = $7ba9a0abd6353e45$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $7ba9a0abd6353e45$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $hgmfu.atan2)(t0.y01, t0.x01), (0, $hgmfu.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $hgmfu.atan2)(t0.y01, t0.x01), (0, $hgmfu.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $hgmfu.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $hgmfu.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $hgmfu.atan2)(t1.y11, t1.x11), (0, $hgmfu.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $hgmfu.epsilon)) || !(da0 > (0, $hgmfu.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $hgmfu.epsilon)) {
                t0 = $7ba9a0abd6353e45$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $7ba9a0abd6353e45$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $hgmfu.atan2)(t0.y01, t0.x01), (0, $hgmfu.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $hgmfu.atan2)(t0.y01, t0.x01), (0, $hgmfu.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $hgmfu.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $hgmfu.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $hgmfu.atan2)(t1.y11, t1.x11), (0, $hgmfu.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $hgmfu.pi) / 2;
        return [
            (0, $hgmfu.cos)(a) * r,
            (0, $hgmfu.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}



var $fd208bc5e60ef636$export$58adb3bec8346d0f = Array.prototype.slice;
function $fd208bc5e60ef636$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $386821abbbe40b33$var$Linear(context) {
    this._context = context;
}
$386821abbbe40b33$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $386821abbbe40b33$export$2e2bcd8739ae039(context) {
    return new $386821abbbe40b33$var$Linear(context);
}






function $d1a17a8ede51990a$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $d1a17a8ede51990a$export$4a5767248b18ef41(p) {
    return p[1];
}


function $0efbaaef705ecd04$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $c005e83c125595ee$export$2e2bcd8739ae039)(true), context = null, curve = (0, $386821abbbe40b33$export$2e2bcd8739ae039), output = null;
    x = typeof x === "function" ? x : x === undefined ? (0, $d1a17a8ede51990a$export$d141bba7fdc215a3) : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $d1a17a8ede51990a$export$4a5767248b18ef41) : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $fd208bc5e60ef636$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $a56e6346ae45e61d$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}



function $daff0bd8c7aeefb0$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $c005e83c125595ee$export$2e2bcd8739ae039)(true), context = null, curve = (0, $386821abbbe40b33$export$2e2bcd8739ae039), output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $d1a17a8ede51990a$export$d141bba7fdc215a3) : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $c005e83c125595ee$export$2e2bcd8739ae039)(0) : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $d1a17a8ede51990a$export$4a5767248b18ef41) : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $fd208bc5e60ef636$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $a56e6346ae45e61d$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $0efbaaef705ecd04$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}





function $c116c1f8ca2768ac$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $c8335baa49e10520$export$2e2bcd8739ae039(d) {
    return d;
}



var $hgmfu = parcelRequire("hgmfu");
function $532a308766abee59$export$2e2bcd8739ae039() {
    var value = (0, $c8335baa49e10520$export$2e2bcd8739ae039), sortValues = (0, $c116c1f8ca2768ac$export$2e2bcd8739ae039), sort = null, startAngle = (0, $c005e83c125595ee$export$2e2bcd8739ae039)(0), endAngle = (0, $c005e83c125595ee$export$2e2bcd8739ae039)((0, $hgmfu.tau)), padAngle = (0, $c005e83c125595ee$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $fd208bc5e60ef636$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $hgmfu.tau), Math.max(-(0, $hgmfu.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}



var $7eeb5245b07224fd$export$22d25ffb9fb15b6f = $7eeb5245b07224fd$export$2e2bcd8739ae039((0, $386821abbbe40b33$export$2e2bcd8739ae039));
function $7eeb5245b07224fd$var$Radial(curve) {
    this._curve = curve;
}
$7eeb5245b07224fd$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $7eeb5245b07224fd$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $7eeb5245b07224fd$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}





function $8bc8c94cb22be38a$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $7eeb5245b07224fd$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return l;
}
function $8bc8c94cb22be38a$export$2e2bcd8739ae039() {
    return $8bc8c94cb22be38a$export$4d8815a75dc8cd4d((0, $0efbaaef705ecd04$export$2e2bcd8739ae039)().curve((0, $7eeb5245b07224fd$export$22d25ffb9fb15b6f)));
}


function $dd80b62bf41b6fc2$export$2e2bcd8739ae039() {
    var a = (0, $daff0bd8c7aeefb0$export$2e2bcd8739ae039)().curve((0, $7eeb5245b07224fd$export$22d25ffb9fb15b6f)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $8bc8c94cb22be38a$export$4d8815a75dc8cd4d)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $8bc8c94cb22be38a$export$4d8815a75dc8cd4d)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $8bc8c94cb22be38a$export$4d8815a75dc8cd4d)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $8bc8c94cb22be38a$export$4d8815a75dc8cd4d)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $7eeb5245b07224fd$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return a;
}



function $623fec17826c0369$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}







function $42f9b58aa8f62d80$var$linkSource(d) {
    return d.source;
}
function $42f9b58aa8f62d80$var$linkTarget(d) {
    return d.target;
}
function $42f9b58aa8f62d80$var$link(curve) {
    var source = $42f9b58aa8f62d80$var$linkSource, target = $42f9b58aa8f62d80$var$linkTarget, x = (0, $d1a17a8ede51990a$export$d141bba7fdc215a3), y = (0, $d1a17a8ede51990a$export$4a5767248b18ef41), context = null;
    function link() {
        var buffer, argv = (0, $fd208bc5e60ef636$export$58adb3bec8346d0f).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $a56e6346ae45e61d$export$2e2bcd8739ae039)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $42f9b58aa8f62d80$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $42f9b58aa8f62d80$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $42f9b58aa8f62d80$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $623fec17826c0369$export$2e2bcd8739ae039)(x0, y0), p1 = (0, $623fec17826c0369$export$2e2bcd8739ae039)(x0, y0 = (y0 + y1) / 2), p2 = (0, $623fec17826c0369$export$2e2bcd8739ae039)(x1, y0), p3 = (0, $623fec17826c0369$export$2e2bcd8739ae039)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $42f9b58aa8f62d80$export$e7c381889b2cd14d() {
    return $42f9b58aa8f62d80$var$link($42f9b58aa8f62d80$var$curveHorizontal);
}
function $42f9b58aa8f62d80$export$75de4c8c66884e04() {
    return $42f9b58aa8f62d80$var$link($42f9b58aa8f62d80$var$curveVertical);
}
function $42f9b58aa8f62d80$export$7739cfe68d4e0799() {
    var l = $42f9b58aa8f62d80$var$link($42f9b58aa8f62d80$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}




var $hgmfu = parcelRequire("hgmfu");
var $33a0d11e71617e74$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, $hgmfu.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $hgmfu.tau));
    }
};


var $03280bc0c2427706$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};


var $6868274b95c36ca5$var$tan30 = Math.sqrt(1 / 3), $6868274b95c36ca5$var$tan30_2 = $6868274b95c36ca5$var$tan30 * 2;
var $6868274b95c36ca5$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = Math.sqrt(size / $6868274b95c36ca5$var$tan30_2), x = y * $6868274b95c36ca5$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $hgmfu = parcelRequire("hgmfu");
var $6aa366abfdc5ab38$var$ka = 0.89081309152928522810, $6aa366abfdc5ab38$var$kr = Math.sin((0, $hgmfu.pi) / 10) / Math.sin(7 * (0, $hgmfu.pi) / 10), $6aa366abfdc5ab38$var$kx = Math.sin((0, $hgmfu.tau) / 10) * $6aa366abfdc5ab38$var$kr, $6aa366abfdc5ab38$var$ky = -Math.cos((0, $hgmfu.tau) / 10) * $6aa366abfdc5ab38$var$kr;
var $6aa366abfdc5ab38$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size * $6aa366abfdc5ab38$var$ka), x = $6aa366abfdc5ab38$var$kx * r, y = $6aa366abfdc5ab38$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, $hgmfu.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};


var $f82a84f87c004b7f$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};


var $1941b11a03fd696c$var$sqrt3 = Math.sqrt(3);
var $1941b11a03fd696c$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / ($1941b11a03fd696c$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$1941b11a03fd696c$var$sqrt3 * y, -y);
        context.lineTo($1941b11a03fd696c$var$sqrt3 * y, -y);
        context.closePath();
    }
};


var $969e338be7105a04$var$c = -0.5, $969e338be7105a04$var$s = Math.sqrt(3) / 2, $969e338be7105a04$var$k = 1 / Math.sqrt(12), $969e338be7105a04$var$a = ($969e338be7105a04$var$k / 2 + 1) * 3;
var $969e338be7105a04$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / $969e338be7105a04$var$a), x0 = r / 2, y0 = r * $969e338be7105a04$var$k, x1 = x0, y1 = r * $969e338be7105a04$var$k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($969e338be7105a04$var$c * x0 - $969e338be7105a04$var$s * y0, $969e338be7105a04$var$s * x0 + $969e338be7105a04$var$c * y0);
        context.lineTo($969e338be7105a04$var$c * x1 - $969e338be7105a04$var$s * y1, $969e338be7105a04$var$s * x1 + $969e338be7105a04$var$c * y1);
        context.lineTo($969e338be7105a04$var$c * x2 - $969e338be7105a04$var$s * y2, $969e338be7105a04$var$s * x2 + $969e338be7105a04$var$c * y2);
        context.lineTo($969e338be7105a04$var$c * x0 + $969e338be7105a04$var$s * y0, $969e338be7105a04$var$c * y0 - $969e338be7105a04$var$s * x0);
        context.lineTo($969e338be7105a04$var$c * x1 + $969e338be7105a04$var$s * y1, $969e338be7105a04$var$c * y1 - $969e338be7105a04$var$s * x1);
        context.lineTo($969e338be7105a04$var$c * x2 + $969e338be7105a04$var$s * y2, $969e338be7105a04$var$c * y2 - $969e338be7105a04$var$s * x2);
        context.closePath();
    }
};



var $d5a090be37c23672$export$47616e9f7f5fe113 = [
    (0, $33a0d11e71617e74$export$2e2bcd8739ae039),
    (0, $03280bc0c2427706$export$2e2bcd8739ae039),
    (0, $6868274b95c36ca5$export$2e2bcd8739ae039),
    (0, $f82a84f87c004b7f$export$2e2bcd8739ae039),
    (0, $6aa366abfdc5ab38$export$2e2bcd8739ae039),
    (0, $1941b11a03fd696c$export$2e2bcd8739ae039),
    (0, $969e338be7105a04$export$2e2bcd8739ae039)
];
function $d5a090be37c23672$export$2e2bcd8739ae039(type, size) {
    var context = null;
    type = typeof type === "function" ? type : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(type || (0, $33a0d11e71617e74$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $a56e6346ae45e61d$export$2e2bcd8739ae039)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}









function $26fcc3e11dd294b8$export$2e2bcd8739ae039() {}


function $9a334361f31d6306$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $9a334361f31d6306$export$957f7263e89bedd2(context) {
    this._context = context;
}
$9a334361f31d6306$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $9a334361f31d6306$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $9a334361f31d6306$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9a334361f31d6306$export$2e2bcd8739ae039(context) {
    return new $9a334361f31d6306$export$957f7263e89bedd2(context);
}


function $9937c9efff948f41$var$BasisClosed(context) {
    this._context = context;
}
$9937c9efff948f41$var$BasisClosed.prototype = {
    areaStart: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    areaEnd: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $9a334361f31d6306$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9937c9efff948f41$export$2e2bcd8739ae039(context) {
    return new $9937c9efff948f41$var$BasisClosed(context);
}



function $e4dc2d2f2b257991$var$BasisOpen(context) {
    this._context = context;
}
$e4dc2d2f2b257991$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $9a334361f31d6306$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $e4dc2d2f2b257991$export$2e2bcd8739ae039(context) {
    return new $e4dc2d2f2b257991$var$BasisOpen(context);
}



class $82888e0d35e50c9f$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
function $82888e0d35e50c9f$export$2c099b5096f70ce6(context) {
    return new $82888e0d35e50c9f$var$Bump(context, true);
}
function $82888e0d35e50c9f$export$908da9dfa54cbed6(context) {
    return new $82888e0d35e50c9f$var$Bump(context, false);
}



function $a4a11fb892aadbec$var$Bundle(context, beta) {
    this._basis = new (0, $9a334361f31d6306$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$a4a11fb892aadbec$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $a4a11fb892aadbec$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $9a334361f31d6306$export$957f7263e89bedd2)(context) : new $a4a11fb892aadbec$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);




var $gQlHt = parcelRequire("gQlHt");
function $00f40c5baaf98134$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$00f40c5baaf98134$export$da3940d7e9162858.prototype = {
    areaStart: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    areaEnd: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $gQlHt.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $00f40c5baaf98134$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $00f40c5baaf98134$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $gQlHt = parcelRequire("gQlHt");
function $634cb64d1f1f38bc$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$634cb64d1f1f38bc$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $gQlHt.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $634cb64d1f1f38bc$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $634cb64d1f1f38bc$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $gQlHt = parcelRequire("gQlHt");



var $1ihob = parcelRequire("1ihob");
function $8d6ea64393ecd14d$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$8d6ea64393ecd14d$var$CatmullRomClosed.prototype = {
    areaStart: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    areaEnd: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $1ihob.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $8d6ea64393ecd14d$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $8d6ea64393ecd14d$var$CatmullRomClosed(context, alpha) : new (0, $00f40c5baaf98134$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);




var $1ihob = parcelRequire("1ihob");
function $161f185e306f66b7$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$161f185e306f66b7$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $1ihob.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $161f185e306f66b7$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $161f185e306f66b7$var$CatmullRomOpen(context, alpha) : new (0, $634cb64d1f1f38bc$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $1ihob = parcelRequire("1ihob");

function $4ce0b82cba985186$var$LinearClosed(context) {
    this._context = context;
}
$4ce0b82cba985186$var$LinearClosed.prototype = {
    areaStart: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    areaEnd: (0, $26fcc3e11dd294b8$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $4ce0b82cba985186$export$2e2bcd8739ae039(context) {
    return new $4ce0b82cba985186$var$LinearClosed(context);
}



function $8bdbc3bbe2058ddb$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $8bdbc3bbe2058ddb$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($8bdbc3bbe2058ddb$var$sign(s0) + $8bdbc3bbe2058ddb$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $8bdbc3bbe2058ddb$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $8bdbc3bbe2058ddb$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $8bdbc3bbe2058ddb$var$MonotoneX(context) {
    this._context = context;
}
$8bdbc3bbe2058ddb$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $8bdbc3bbe2058ddb$var$point(this, this._t0, $8bdbc3bbe2058ddb$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $8bdbc3bbe2058ddb$var$point(this, $8bdbc3bbe2058ddb$var$slope2(this, t1 = $8bdbc3bbe2058ddb$var$slope3(this, x, y)), t1);
                break;
            default:
                $8bdbc3bbe2058ddb$var$point(this, this._t0, t1 = $8bdbc3bbe2058ddb$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $8bdbc3bbe2058ddb$var$MonotoneY(context) {
    this._context = new $8bdbc3bbe2058ddb$var$ReflectContext(context);
}
($8bdbc3bbe2058ddb$var$MonotoneY.prototype = Object.create($8bdbc3bbe2058ddb$var$MonotoneX.prototype)).point = function(x, y) {
    $8bdbc3bbe2058ddb$var$MonotoneX.prototype.point.call(this, y, x);
};
function $8bdbc3bbe2058ddb$var$ReflectContext(context) {
    this._context = context;
}
$8bdbc3bbe2058ddb$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $8bdbc3bbe2058ddb$export$99563b5420dbdc55(context) {
    return new $8bdbc3bbe2058ddb$var$MonotoneX(context);
}
function $8bdbc3bbe2058ddb$export$8b5360456d6bdb88(context) {
    return new $8bdbc3bbe2058ddb$var$MonotoneY(context);
}


function $f68a4c4bb517644d$var$Natural(context) {
    this._context = context;
}
$f68a4c4bb517644d$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $f68a4c4bb517644d$var$controlPoints(x), py = $f68a4c4bb517644d$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $f68a4c4bb517644d$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $f68a4c4bb517644d$export$2e2bcd8739ae039(context) {
    return new $f68a4c4bb517644d$var$Natural(context);
}


function $3db7487d32d9e028$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$3db7487d32d9e028$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $3db7487d32d9e028$export$2e2bcd8739ae039(context) {
    return new $3db7487d32d9e028$var$Step(context, 0.5);
}
function $3db7487d32d9e028$export$10eafa5b7478b343(context) {
    return new $3db7487d32d9e028$var$Step(context, 0);
}
function $3db7487d32d9e028$export$793b3db073781cbb(context) {
    return new $3db7487d32d9e028$var$Step(context, 1);
}




function $4c5e6d0199e49bd7$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $3c3a672c30225b5f$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $cce6948a47273b47$var$stackValue(d, key) {
    return d[key];
}
function $cce6948a47273b47$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $cce6948a47273b47$export$2e2bcd8739ae039() {
    var keys = (0, $c005e83c125595ee$export$2e2bcd8739ae039)([]), order = (0, $3c3a672c30225b5f$export$2e2bcd8739ae039), offset = (0, $4c5e6d0199e49bd7$export$2e2bcd8739ae039), value = $cce6948a47273b47$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $cce6948a47273b47$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $fd208bc5e60ef636$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $3c3a672c30225b5f$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $c005e83c125595ee$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $4c5e6d0199e49bd7$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}



function $6252ee6b01d9847a$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $4c5e6d0199e49bd7$export$2e2bcd8739ae039)(series, order);
}


function $5a177cd45fe4e9c3$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}




function $805c25413019a972$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $4c5e6d0199e49bd7$export$2e2bcd8739ae039)(series, order);
}



function $24fdf35cd1c4cf7c$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $4c5e6d0199e49bd7$export$2e2bcd8739ae039)(series, order);
}



function $0a6df3e6bc3df090$export$2e2bcd8739ae039(series) {
    var peaks = series.map($0a6df3e6bc3df090$var$peak);
    return (0, $3c3a672c30225b5f$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $0a6df3e6bc3df090$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $56fdb10bb99bbf1a$export$2e2bcd8739ae039(series) {
    var sums = series.map($56fdb10bb99bbf1a$export$8a63f25cc62965f1);
    return (0, $3c3a672c30225b5f$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $56fdb10bb99bbf1a$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}



function $d8b4e6e4ba09450f$export$2e2bcd8739ae039(series) {
    return (0, $56fdb10bb99bbf1a$export$2e2bcd8739ae039)(series).reverse();
}




function $67f136beeb842e9a$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $56fdb10bb99bbf1a$export$8a63f25cc62965f1)), order = (0, $0a6df3e6bc3df090$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}




function $d9882df9a36ba8b6$export$2e2bcd8739ae039(series) {
    return (0, $3c3a672c30225b5f$export$2e2bcd8739ae039)(series).reverse();
}




var $7ac93421fd1e26f6$exports = {};

$parcel$export($7ac93421fd1e26f6$exports, "timeInterval", function () { return $05bae36f856a2c28$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMillisecond", function () { return $41d752b42c5c1c8b$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMilliseconds", function () { return $41d752b42c5c1c8b$export$9a27fac83d67afd3; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMillisecond", function () { return $41d752b42c5c1c8b$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMilliseconds", function () { return $41d752b42c5c1c8b$export$9a27fac83d67afd3; });
$parcel$export($7ac93421fd1e26f6$exports, "timeSecond", function () { return $6b4dcf2947813054$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeSeconds", function () { return $6b4dcf2947813054$export$4792e48abc550fa1; });
$parcel$export($7ac93421fd1e26f6$exports, "utcSecond", function () { return $6b4dcf2947813054$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcSeconds", function () { return $6b4dcf2947813054$export$4792e48abc550fa1; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMinute", function () { return $18c0bdbb472f59cc$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMinutes", function () { return $18c0bdbb472f59cc$export$666252b437cce0c7; });
$parcel$export($7ac93421fd1e26f6$exports, "timeHour", function () { return $b922dcca6705c6ac$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeHours", function () { return $b922dcca6705c6ac$export$8d468796d69cdad1; });
$parcel$export($7ac93421fd1e26f6$exports, "timeDay", function () { return $2e3b45890310ac11$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeDays", function () { return $2e3b45890310ac11$export$3cf5dda4201cc0f2; });
$parcel$export($7ac93421fd1e26f6$exports, "timeWeek", function () { return $c512fbf1ca2d7517$export$fb3ee18ed410cc21; });
$parcel$export($7ac93421fd1e26f6$exports, "timeWeeks", function () { return $c512fbf1ca2d7517$export$e8daabaa40641211; });
$parcel$export($7ac93421fd1e26f6$exports, "timeSunday", function () { return $c512fbf1ca2d7517$export$fb3ee18ed410cc21; });
$parcel$export($7ac93421fd1e26f6$exports, "timeSundays", function () { return $c512fbf1ca2d7517$export$e8daabaa40641211; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMonday", function () { return $c512fbf1ca2d7517$export$6416afaab03bc9b8; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMondays", function () { return $c512fbf1ca2d7517$export$74e5b559c235c00e; });
$parcel$export($7ac93421fd1e26f6$exports, "timeTuesday", function () { return $c512fbf1ca2d7517$export$cb8f040f5d17ac7b; });
$parcel$export($7ac93421fd1e26f6$exports, "timeTuesdays", function () { return $c512fbf1ca2d7517$export$e7d6aa4fb107bc56; });
$parcel$export($7ac93421fd1e26f6$exports, "timeWednesday", function () { return $c512fbf1ca2d7517$export$347581849975dfc8; });
$parcel$export($7ac93421fd1e26f6$exports, "timeWednesdays", function () { return $c512fbf1ca2d7517$export$fcd5880b20bb06a8; });
$parcel$export($7ac93421fd1e26f6$exports, "timeThursday", function () { return $c512fbf1ca2d7517$export$2f2b56683a3e5629; });
$parcel$export($7ac93421fd1e26f6$exports, "timeThursdays", function () { return $c512fbf1ca2d7517$export$682716b7bbe33641; });
$parcel$export($7ac93421fd1e26f6$exports, "timeFriday", function () { return $c512fbf1ca2d7517$export$59b8c2ccd931d806; });
$parcel$export($7ac93421fd1e26f6$exports, "timeFridays", function () { return $c512fbf1ca2d7517$export$482924968ca86084; });
$parcel$export($7ac93421fd1e26f6$exports, "timeSaturday", function () { return $c512fbf1ca2d7517$export$478ceadebff4d377; });
$parcel$export($7ac93421fd1e26f6$exports, "timeSaturdays", function () { return $c512fbf1ca2d7517$export$7d755172c9cda9d2; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMonth", function () { return $1d2829b7e04b9634$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeMonths", function () { return $1d2829b7e04b9634$export$16352d1b10c5eb38; });
$parcel$export($7ac93421fd1e26f6$exports, "timeYear", function () { return $8bb4d0767a7f72eb$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "timeYears", function () { return $8bb4d0767a7f72eb$export$6fda41c7fb23acf9; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMinute", function () { return $1a6f32f6c85d1510$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMinutes", function () { return $1a6f32f6c85d1510$export$cedd563624e8ee50; });
$parcel$export($7ac93421fd1e26f6$exports, "utcHour", function () { return $1690692aa3b657c6$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcHours", function () { return $1690692aa3b657c6$export$6e7a76cd5f50b719; });
$parcel$export($7ac93421fd1e26f6$exports, "utcDay", function () { return $605833a40483bba5$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcDays", function () { return $605833a40483bba5$export$d277e198508549a1; });
$parcel$export($7ac93421fd1e26f6$exports, "utcWeek", function () { return $66afc95a9e9cea5f$export$4898b06303a92011; });
$parcel$export($7ac93421fd1e26f6$exports, "utcWeeks", function () { return $66afc95a9e9cea5f$export$6f3e1c2b0f7d7880; });
$parcel$export($7ac93421fd1e26f6$exports, "utcSunday", function () { return $66afc95a9e9cea5f$export$4898b06303a92011; });
$parcel$export($7ac93421fd1e26f6$exports, "utcSundays", function () { return $66afc95a9e9cea5f$export$6f3e1c2b0f7d7880; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMonday", function () { return $66afc95a9e9cea5f$export$9cfc53b9cfafd080; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMondays", function () { return $66afc95a9e9cea5f$export$1d2d8b858bb366f9; });
$parcel$export($7ac93421fd1e26f6$exports, "utcTuesday", function () { return $66afc95a9e9cea5f$export$2a6d545f77eceb15; });
$parcel$export($7ac93421fd1e26f6$exports, "utcTuesdays", function () { return $66afc95a9e9cea5f$export$1d5f6785fc7f30f8; });
$parcel$export($7ac93421fd1e26f6$exports, "utcWednesday", function () { return $66afc95a9e9cea5f$export$a5c25d8ed64433c4; });
$parcel$export($7ac93421fd1e26f6$exports, "utcWednesdays", function () { return $66afc95a9e9cea5f$export$7a75faf0e37ef4af; });
$parcel$export($7ac93421fd1e26f6$exports, "utcThursday", function () { return $66afc95a9e9cea5f$export$1db08111baec2f53; });
$parcel$export($7ac93421fd1e26f6$exports, "utcThursdays", function () { return $66afc95a9e9cea5f$export$417eb959611b2f2f; });
$parcel$export($7ac93421fd1e26f6$exports, "utcFriday", function () { return $66afc95a9e9cea5f$export$29265e34dd5921f7; });
$parcel$export($7ac93421fd1e26f6$exports, "utcFridays", function () { return $66afc95a9e9cea5f$export$59d308db7af08c64; });
$parcel$export($7ac93421fd1e26f6$exports, "utcSaturday", function () { return $66afc95a9e9cea5f$export$85b74dad05049604; });
$parcel$export($7ac93421fd1e26f6$exports, "utcSaturdays", function () { return $66afc95a9e9cea5f$export$a124108a0a7f34c8; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMonth", function () { return $94110fec2d3ef313$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcMonths", function () { return $94110fec2d3ef313$export$49159f585997498; });
$parcel$export($7ac93421fd1e26f6$exports, "utcYear", function () { return $3af5de8471aac76c$export$2e2bcd8739ae039; });
$parcel$export($7ac93421fd1e26f6$exports, "utcYears", function () { return $3af5de8471aac76c$export$3e24d311e17f5802; });
$parcel$export($7ac93421fd1e26f6$exports, "utcTicks", function () { return $127df85368d2c381$export$826ba5ae907e9767; });
$parcel$export($7ac93421fd1e26f6$exports, "utcTickInterval", function () { return $127df85368d2c381$export$6262d8d056ea44c4; });
$parcel$export($7ac93421fd1e26f6$exports, "timeTicks", function () { return $127df85368d2c381$export$60c76498552d28a6; });
$parcel$export($7ac93421fd1e26f6$exports, "timeTickInterval", function () { return $127df85368d2c381$export$69511150134dd174; });


















var $1e07757977242895$exports = {};

$parcel$export($1e07757977242895$exports, "timeFormatDefaultLocale", function () { return $9c52e761ce5e063b$export$2e2bcd8739ae039; });
$parcel$export($1e07757977242895$exports, "timeFormat", function () { return $9c52e761ce5e063b$export$94f4d87fad5dcf9a; });
$parcel$export($1e07757977242895$exports, "timeParse", function () { return $9c52e761ce5e063b$export$32b9cd16e1b8c8d2; });
$parcel$export($1e07757977242895$exports, "utcFormat", function () { return $9c52e761ce5e063b$export$1a08fe38f63ebbbb; });
$parcel$export($1e07757977242895$exports, "utcParse", function () { return $9c52e761ce5e063b$export$3edae9cf8e233729; });
$parcel$export($1e07757977242895$exports, "timeFormatLocale", function () { return $c9bb369e90b7a7af$export$2e2bcd8739ae039; });
$parcel$export($1e07757977242895$exports, "isoFormat", function () { return $3dd35d731167fb3f$export$2e2bcd8739ae039; });
$parcel$export($1e07757977242895$exports, "isoParse", function () { return $8598b6c9d98cc198$export$2e2bcd8739ae039; });



var $3dd35d731167fb3f$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $3dd35d731167fb3f$var$formatIsoNative(date) {
    return date.toISOString();
}
var $3dd35d731167fb3f$var$formatIso = Date.prototype.toISOString ? $3dd35d731167fb3f$var$formatIsoNative : (0, $9c52e761ce5e063b$export$1a08fe38f63ebbbb)($3dd35d731167fb3f$export$491f7bf2e88d83ce);
var $3dd35d731167fb3f$export$2e2bcd8739ae039 = $3dd35d731167fb3f$var$formatIso;




function $8598b6c9d98cc198$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $8598b6c9d98cc198$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $8598b6c9d98cc198$var$parseIsoNative : (0, $9c52e761ce5e063b$export$3edae9cf8e233729)((0, $3dd35d731167fb3f$export$491f7bf2e88d83ce));
var $8598b6c9d98cc198$export$2e2bcd8739ae039 = $8598b6c9d98cc198$var$parseIso;




var $997c6497e6f325cf$exports = {};

$parcel$export($997c6497e6f325cf$exports, "now", function () { return $9c58fce6e008e685$export$461939dd4422153; });
$parcel$export($997c6497e6f325cf$exports, "timer", function () { return $9c58fce6e008e685$export$9dc4ecf953986f04; });
$parcel$export($997c6497e6f325cf$exports, "timerFlush", function () { return $9c58fce6e008e685$export$d60154c1d7f3990e; });
$parcel$export($997c6497e6f325cf$exports, "timeout", function () { return $070e9a4f0e21c528$export$2e2bcd8739ae039; });
$parcel$export($997c6497e6f325cf$exports, "interval", function () { return $1159f7ab91b4afa5$export$2e2bcd8739ae039; });



function $1159f7ab91b4afa5$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $9c58fce6e008e685$export$c57e9b2d8b9e4de), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    t._restart = t.restart;
    t.restart = function(callback, delay, time) {
        delay = +delay, time = time == null ? (0, $9c58fce6e008e685$export$461939dd4422153)() : +time;
        t._restart(function tick(elapsed) {
            elapsed += total;
            t._restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
    };
    t.restart(callback, delay, time);
    return t;
}





var $dc49f4091816264c$exports = {};

$parcel$export($dc49f4091816264c$exports, "zoom", function () { return $08d23a13a4beb641$export$2e2bcd8739ae039; });
$parcel$export($dc49f4091816264c$exports, "zoomTransform", function () { return $de0bd5014acb2d2e$export$2e2bcd8739ae039; });
$parcel$export($dc49f4091816264c$exports, "zoomIdentity", function () { return $de0bd5014acb2d2e$export$f0954fd7d5368655; });





var $3a9757e14d6e6b04$export$2e2bcd8739ae039 = (x)=>()=>x;


function $515a1a8b25193c0e$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $de0bd5014acb2d2e$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$de0bd5014acb2d2e$export$563a914cafbdc389.prototype = {
    constructor: $de0bd5014acb2d2e$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $de0bd5014acb2d2e$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $de0bd5014acb2d2e$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $de0bd5014acb2d2e$export$f0954fd7d5368655 = new $de0bd5014acb2d2e$export$563a914cafbdc389(1, 0, 0);
$de0bd5014acb2d2e$export$2e2bcd8739ae039.prototype = $de0bd5014acb2d2e$export$563a914cafbdc389.prototype;
function $de0bd5014acb2d2e$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $de0bd5014acb2d2e$export$f0954fd7d5368655;
    return node.__zoom;
}


function $ca8cc92039a330b3$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $ca8cc92039a330b3$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $08d23a13a4beb641$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $08d23a13a4beb641$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $08d23a13a4beb641$var$defaultTransform() {
    return this.__zoom || (0, $de0bd5014acb2d2e$export$f0954fd7d5368655);
}
function $08d23a13a4beb641$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $08d23a13a4beb641$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $08d23a13a4beb641$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $08d23a13a4beb641$export$2e2bcd8739ae039() {
    var filter = $08d23a13a4beb641$var$defaultFilter, extent = $08d23a13a4beb641$var$defaultExtent, constrain = $08d23a13a4beb641$var$defaultConstrain, wheelDelta = $08d23a13a4beb641$var$defaultWheelDelta, touchable = $08d23a13a4beb641$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $acca162f4f1c57d2$export$2e2bcd8739ae039), listeners = (0, $41d77768dbc6b7a5$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $08d23a13a4beb641$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $08d23a13a4beb641$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $de0bd5014acb2d2e$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $de0bd5014acb2d2e$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $de0bd5014acb2d2e$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $de0bd5014acb2d2e$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $515a1a8b25193c0e$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $688fa9c8100803a6$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $ca8cc92039a330b3$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, args, true).event(event), v = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(event, currentTarget), currentTarget = event.currentTarget, x0 = event.clientX, y0 = event.clientY;
        (0, $9fc1ee0544073e59$export$2e2bcd8739ae039)(event.view);
        (0, $ca8cc92039a330b3$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $688fa9c8100803a6$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $ca8cc92039a330b3$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $9fc1ee0544073e59$export$833237748009e1e1)(event.view, g.moved);
            (0, $ca8cc92039a330b3$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $ca8cc92039a330b3$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $ca8cc92039a330b3$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $688fa9c8100803a6$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $ca8cc92039a330b3$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $ca8cc92039a330b3$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $f414987f08497e2f$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $0fd7b7faefc9df82$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $3a9757e14d6e6b04$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $3a9757e14d6e6b04$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $3a9757e14d6e6b04$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $3a9757e14d6e6b04$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}





$parcel$exportWildcard($3c4c698c1c5e9521$exports, $1fbb7a3af39b757c$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $925ec43add5f3b4d$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $270c3609e16d9ece$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $828b7d4df36becc4$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $b22cf5597f86a3f8$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $72b642dff39391d8$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $b3e4fba1facfc225$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $deeed27c05a2c2eb$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $d62f46194e6840cb$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $e9335085431cbaa1$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $1e73b5bce73843e9$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $fe8713a76744544a$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $764845f9c28e2fad$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $1a86e122fa7d41d6$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $8760d5288478873d$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $82828c08cd175800$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $aca072767fbbfd2a$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $2f75f5536d77a9b5$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $906c138d732b0dac$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $c3a21cfe10a041e5$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $b12cde496d0af611$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $cbe2ba00b5575db6$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $371d45315aa2f6f2$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $bd5e2d686e6196f4$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $a1a8175c6f9ceda9$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $7ac93421fd1e26f6$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $1e07757977242895$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $997c6497e6f325cf$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $39a1595cb57fba7f$exports);
$parcel$exportWildcard($3c4c698c1c5e9521$exports, $dc49f4091816264c$exports);


var $aa6103d484f83752$var$d3 = $aa6103d484f83752$var$_interopRequireWildcard($3c4c698c1c5e9521$exports);
function $aa6103d484f83752$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($aa6103d484f83752$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $aa6103d484f83752$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
// Load default selection from URL
const $aa6103d484f83752$var$urlParams = new URLSearchParams(window.location.search);
// Read configuration from URL parameters or use defaults
const $aa6103d484f83752$var$tilesetVersion = $aa6103d484f83752$var$urlParams.get("version") || 'v4_7';
const $aa6103d484f83752$var$mapboxAccount = $aa6103d484f83752$var$tilesetVersion == 'v4_7' ? 'mapbox' : 'mbx-boundaries';
const $aa6103d484f83752$var$accessToken = $aa6103d484f83752$var$urlParams.get("access_token") || 'pk.eyJ1IjoibWJ4LWJvdW5kYXJpZXMiLCJhIjoiY203b3p3OW1sMDdtODJxc2Q0aDN4ZWp3dSJ9.1oged1CoWl2SKAH2j7_zfA';
const $aa6103d484f83752$var$searchAccessToken = $aa6103d484f83752$var$urlParams.get("search_access_token") || $aa6103d484f83752$var$accessToken; // Provide a token for the staging API
// Lookup tileset IDs include a trailing version suffix. Replace the whole suffix
// with tilesetVersion so ?version= overrides the ID from the lookup.
function $aa6103d484f83752$var$mapboxTilesetUrl(tilesetId) {
    const versioned = tilesetId.replace(/-v\d+(?:_\d+)*$/, `-${$aa6103d484f83752$var$tilesetVersion}`);
    const name = versioned.split(".").slice(1).join(".");
    return `mapbox://${$aa6103d484f83752$var$mapboxAccount}.${name}`;
}
let $aa6103d484f83752$var$data = {};
// Detect starting country from user location if not explicitly defined
if ($aa6103d484f83752$var$urlParams.get("country") == null) $aa6103d484f83752$var$detectUserLocation();
//  Setup mapbox
mapboxgl.accessToken = $aa6103d484f83752$var$accessToken;
mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.3.0/mapbox-gl-rtl-text.js', null, true // Lazy load the plugin
);
const $aa6103d484f83752$var$map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/light-v11",
    // style: "mapbox://styles/planemad/clpr7hshs013b01qt7t6ehr92",
    center: [
        -99.9,
        41.5
    ],
    zoom: 0,
    hash: true,
    bearingSnap: 0
});
// Disable scroll when embedded in https://www.mapbox.com/boundaries
/* eslint-disable */ if ($aa6103d484f83752$var$urlParams.get("embedded") == "true") $aa6103d484f83752$var$map.scrollZoom.disable();
const $aa6103d484f83752$var$mapboxGeocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    collapsed: true
});
$aa6103d484f83752$var$map.addControl($aa6103d484f83752$var$mapboxGeocoder, "top-right");
// Add zoom and rotation controls to the map.
$aa6103d484f83752$var$map.addControl(new mapboxgl.NavigationControl({
    visualizePitch: true
}), "top-right");
$aa6103d484f83752$var$map.addControl(new mapboxgl.FullscreenControl());
/* eslint-enable */ function $aa6103d484f83752$var$AppConfig() {
    this.country = $aa6103d484f83752$var$urlParams.get("country") || "US";
    this.layer = $aa6103d484f83752$var$urlParams.get("layer") || "adm1";
    this.worldview = $aa6103d484f83752$var$urlParams.get("worldview") || "US";
}
const $aa6103d484f83752$var$appConfig = new $aa6103d484f83752$var$AppConfig();
// GLOBALS
const { autocomplete: $aa6103d484f83752$var$autocomplete } = window['@algolia/autocomplete-js'];
const $aa6103d484f83752$var$selectCountryEl = document.getElementById("selectCountry");
let $aa6103d484f83752$var$selectLayerEl = document.getElementById("selectLayer");
const $aa6103d484f83752$var$selectWorldviewEl = document.getElementById("selectWorldview");
const $aa6103d484f83752$var$loadingbar = document.getElementById("loading");
let $aa6103d484f83752$var$polyLayerName, $aa6103d484f83752$var$countryChange, $aa6103d484f83752$var$levelChange, $aa6103d484f83752$var$z_min, $aa6103d484f83752$var$bounds;
let $aa6103d484f83752$var$country_filter = $aa6103d484f83752$var$appConfig["country"];
let $aa6103d484f83752$var$level = $aa6103d484f83752$var$appConfig["layer"];
let $aa6103d484f83752$var$worldview = $aa6103d484f83752$var$appConfig["worldview"];
let $aa6103d484f83752$var$lookup_url = "./lib/lookups/" + $aa6103d484f83752$var$country_filter + "/" + $aa6103d484f83752$var$level + ".json?v=4.0";
// Define worldview support for each product https://docs.mapbox.com/help/glossary/worldview/#available-worldviews
const $aa6103d484f83752$var$mapboxWorldviews = {
    basemap: [
        // https://docs.mapbox.com/data/tilesets/reference/mapbox-streets-v8/#worldview-text
        "CN",
        "IN",
        "JP",
        "US"
    ],
    boundaries: [
        // https://docs.mapbox.com/data/boundaries/reference/mapbox-boundaries-v4/#worldview-text
        "US",
        "CN",
        "IN",
        "JP",
        "AR",
        "CL",
        "MA",
        "RU",
        "TR",
        "RS"
    ],
    geocoder: [
        // https://docs.mapbox.com/api/search/geocoding/#worldviews
        "US",
        "CN",
        "IN",
        "JP",
        "AR",
        "CL",
        "MA",
        "RU",
        "TR"
    ]
};
const $aa6103d484f83752$var$mapboxLayerTypes = {
    adm: 'admin',
    leg: 'legislative',
    loc: 'locality',
    pos: 'postal',
    sta: 'stats'
};
const $aa6103d484f83752$var$popup = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false,
    offset: {
        top: [
            0,
            10
        ],
        bottom: [
            0,
            -10
        ]
    }
});
let $aa6103d484f83752$var$popupevent, $aa6103d484f83752$var$clickevent, $aa6103d484f83752$var$featureFilter, $aa6103d484f83752$var$country_hovered;
// Insert flags in the country list
document.querySelectorAll("#selectCountry option").forEach((element)=>{
    element.insertAdjacentHTML("beforeend", ' <span style="float:right">' + $aa6103d484f83752$var$getFlagEmoji(element.value) + "</span>");
});
// Create the dropdown of boundary type and levels for selected country
const $aa6103d484f83752$var$boundaryLayerTypes = {
    adm: "Administrative",
    loc: "Locality",
    leg: "Legislative",
    pos: "Postal",
    sta: "Statistical"
};
function $aa6103d484f83752$var$createLevelDropdown() {
    // Clear existing levels
    $aa6103d484f83752$var$selectLayerEl.replaceChildren();
    let currentType;
    Object.keys($aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_filter]).sort().forEach((key)=>{
        if (key === "bbox" || key === "mapbox_id") return;
        // Add a seperator option for each type
        if (key.substr(0, 3) !== currentType) {
            currentType = key.substr(0, 3);
            const optionSeperator = document.createElement("option");
            optionSeperator.text = $aa6103d484f83752$var$boundaryLayerTypes[currentType];
            optionSeperator.disabled = true;
            optionSeperator.value = key;
            $aa6103d484f83752$var$selectLayerEl.add(optionSeperator);
        }
        const option = document.createElement("option");
        option.text = key + " : " + $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_filter][key]["description"];
        option.value = key;
        $aa6103d484f83752$var$selectLayerEl.add(option);
    });
    // If target country does not have expected level,
    // default to adm1 if available or fallback to adm0
    $aa6103d484f83752$var$selectLayerEl.value = $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_filter].hasOwnProperty($aa6103d484f83752$var$level) ? $aa6103d484f83752$var$level : $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_filter].hasOwnProperty("adm1") ? "adm1" : "adm0";
}
$aa6103d484f83752$var$createLevelDropdown();
// Update dropdown selection
$aa6103d484f83752$var$selectLayerEl.value = $aa6103d484f83752$var$level || "adm1";
$aa6103d484f83752$var$selectCountryEl.value = $aa6103d484f83752$var$country_filter;
$aa6103d484f83752$var$selectWorldviewEl.value = $aa6103d484f83752$var$worldview;
// ////// MAIN FUNCTIONS /////////////
// Updates the loaded data on any selection change
function $aa6103d484f83752$var$updateMap(e) {
    // Update URL params and URL bar
    $aa6103d484f83752$var$urlParams.set("country", $aa6103d484f83752$var$selectCountryEl.value);
    $aa6103d484f83752$var$urlParams.set("layer", $aa6103d484f83752$var$selectLayerEl.value);
    $aa6103d484f83752$var$urlParams.set("worldview", $aa6103d484f83752$var$selectWorldviewEl.value);
    window.history.replaceState({}, "", `${location.pathname}?${$aa6103d484f83752$var$urlParams}${location.hash}`);
    $aa6103d484f83752$var$loadingbar.style.visibility = "visible";
    const newlevel = $aa6103d484f83752$var$selectLayerEl.value;
    const style = $aa6103d484f83752$var$map.getStyle();
    // Remove interactivity events while swapping layers and sources
    $aa6103d484f83752$var$map.off("mousemove", $aa6103d484f83752$var$popupevent);
    $aa6103d484f83752$var$map.off("click", $aa6103d484f83752$var$clickevent);
    $aa6103d484f83752$var$popup.remove();
    // Remove existing sources and layers if the admin level has changed
    // Do not remove adm0 as it is used as a base for all views
    if (newlevel !== $aa6103d484f83752$var$level && $aa6103d484f83752$var$level !== "adm0") {
        style.layers.forEach((layer)=>{
            if (layer.id.search($aa6103d484f83752$var$level) > -1) $aa6103d484f83752$var$map.removeLayer(layer.id);
        });
        for(const key in style.sources)if (key.search($aa6103d484f83752$var$level) > -1) $aa6103d484f83752$var$map.removeSource(key);
    }
    // Remove point tileset if type has changed
    const type = $aa6103d484f83752$var$level.slice(0, -1);
    if (newlevel.slice(0, -1) !== type) {
        for(const key in style.sources)if (key.search(type + "Points") > -1) {
            $aa6103d484f83752$var$map.removeSource(type + "Points");
            $aa6103d484f83752$var$map.removeLayer($aa6103d484f83752$var$level + "Points");
        }
    } else // Update existing point layer when switching countries or worldviews
    if ($aa6103d484f83752$var$map.getLayer($aa6103d484f83752$var$level + "Points")) $aa6103d484f83752$var$map.setFilter($aa6103d484f83752$var$level + "Points", [
        "all",
        [
            "==",
            [
                "get",
                "iso_3166_1"
            ],
            $aa6103d484f83752$var$selectCountryEl.value
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$selectWorldviewEl.value)
    ]);
    $aa6103d484f83752$var$country_filter = $aa6103d484f83752$var$selectCountryEl.value;
    $aa6103d484f83752$var$level = newlevel;
    $aa6103d484f83752$var$lookup_url = "./lib/lookups/" + $aa6103d484f83752$var$country_filter + "/" + $aa6103d484f83752$var$level + ".json";
    // Use a map projection based on the country selected
    // https://projectionwizard.org/
    switch($aa6103d484f83752$var$country_filter){
        case "RU":
            $aa6103d484f83752$var$map.setProjection({
                name: "mercator"
            });
            $aa6103d484f83752$var$map.setBearing(0);
            break;
        default:
            $aa6103d484f83752$var$map.setProjection({
                name: "globe"
            });
            $aa6103d484f83752$var$map.setBearing(0);
    }
    $aa6103d484f83752$var$getData($aa6103d484f83752$var$lookup_url, $aa6103d484f83752$var$initmap, $aa6103d484f83752$var$initLayers);
}
// Setup the map once the style loads
$aa6103d484f83752$var$map.on("style.load", ()=>{
    $aa6103d484f83752$var$updateMap();
    // Add event listeners to update the view when the selection dropdowns change
    $aa6103d484f83752$var$selectWorldviewEl.onchange = ()=>{
        // Update worldview before updating map
        $aa6103d484f83752$var$worldview = $aa6103d484f83752$var$selectWorldviewEl.value;
        // Update point layer filter if it exists
        if ($aa6103d484f83752$var$map.getLayer($aa6103d484f83752$var$level + "Points")) $aa6103d484f83752$var$map.setFilter($aa6103d484f83752$var$level + "Points", [
            "all",
            [
                "==",
                [
                    "get",
                    "iso_3166_1"
                ],
                $aa6103d484f83752$var$country_filter
            ],
            $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
        ]);
        $aa6103d484f83752$var$updateMap();
    };
    $aa6103d484f83752$var$selectLayerEl.onchange = function(e) {
        console.log($aa6103d484f83752$var$country_filter, $aa6103d484f83752$var$selectLayerEl.value);
        $aa6103d484f83752$var$levelChange = true;
        $aa6103d484f83752$var$updateMap();
    };
    $aa6103d484f83752$var$selectCountryEl.onchange = (e)=>{
        $aa6103d484f83752$var$countryChange = true;
        $aa6103d484f83752$var$country_filter = e.target.value;
        $aa6103d484f83752$var$createLevelDropdown();
        $aa6103d484f83752$var$updateMap();
    };
    // Collect layer ids that can be used to change country on click
    const countryLayers = $aa6103d484f83752$var$findLayers($aa6103d484f83752$var$map, (layer)=>{
        return layer["source-layer"] === "country_label" || layer.id === "country-label";
    }).map((layer)=>layer.id);
    countryLayers.push("adm0");
    // Highlight adm0 of hovered country
    $aa6103d484f83752$var$map.on("mousemove", "adm0", (e)=>{
        const features = $aa6103d484f83752$var$map.queryRenderedFeatures(e.point, {
            layers: countryLayers
        });
        if (features.length) {
            $aa6103d484f83752$var$map.getCanvasContainer().style.cursor = "pointer";
            if ($aa6103d484f83752$var$country_hovered && $aa6103d484f83752$var$country_hovered !== features[0].properties.iso_3166_1) $aa6103d484f83752$var$map.setFeatureState({
                source: "adm0",
                sourceLayer: "boundaries_admin_0",
                id: $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_hovered].mapbox_id
            }, {
                hover: 0
            });
            $aa6103d484f83752$var$country_hovered = features[0].properties.iso_3166_1;
            $aa6103d484f83752$var$map.setFeatureState({
                source: "adm0",
                sourceLayer: "boundaries_admin_0",
                id: $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_hovered].mapbox_id
            }, {
                hover: 1
            });
        } else {
            $aa6103d484f83752$var$map.getCanvasContainer().style.cursor = "";
            $aa6103d484f83752$var$map.setFeatureState({
                source: "adm0",
                sourceLayer: "boundaries_admin_0",
                id: $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_hovered].mapbox_id
            }, {
                hover: 0
            });
        }
    });
    // Reset on losing focus
    $aa6103d484f83752$var$map.on("mouseout", "adm0", ()=>{
        $aa6103d484f83752$var$map.setFeatureState({
            source: "adm0",
            sourceLayer: "boundaries_admin_0",
            id: $aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_hovered].mapbox_id
        }, {
            hover: 0
        });
    });
    // Select country by clicking on country labels
    $aa6103d484f83752$var$map.on("click", (e)=>{
        const features = $aa6103d484f83752$var$map.queryRenderedFeatures(e.point, {
            layers: countryLayers
        });
        // Trigger map update if a different country label was clicked
        if (features.length && "iso_3166_1" in features[0].properties && features[0].properties.iso_3166_1 !== $aa6103d484f83752$var$selectCountryEl.value) $aa6103d484f83752$var$selectCountry(features[0].properties.iso_3166_1);
    });
});
// //////// HELPER METHODS ////////////
function $aa6103d484f83752$var$getData(url, initMapCb, initLayersCb) {
    fetch(url).then((resp)=>{
        return resp.json();
    }).then((lookup_data)=>{
        initMapCb(lookup_data, $aa6103d484f83752$var$level);
        initLayersCb($aa6103d484f83752$var$level);
    });
}
// Fit the map features into view using an appropriate bbox and zoom level
function $aa6103d484f83752$var$setBboxFeatures() {
    $aa6103d484f83752$var$bounds = JSON.parse($aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_filter]["bbox"]);
    $aa6103d484f83752$var$z_min = parseInt($aa6103d484f83752$var$_coverage2.default[$aa6103d484f83752$var$country_filter][$aa6103d484f83752$var$level]["z_min"]);
    try {
        // Find a zoom level to fit the the target bbox for a max zoom of 12 and tile size of 512px
        const viewport = $aa6103d484f83752$var$_geoViewport2.default.viewport($aa6103d484f83752$var$bounds, [
            window.innerWidth,
            window.innerHeight
        ], 0, 12, 512);
        // Set autozoom level to be greater than layer z_min
        viewport.zoom = Math.max(viewport.zoom, $aa6103d484f83752$var$z_min + 1);
        // Viewport overrides
        // Adjust to continental US
        if ($aa6103d484f83752$var$country_filter === "US") {
            viewport.center = [
                -100,
                41
            ];
            viewport.zoom = 3.5;
        }
        if ($aa6103d484f83752$var$country_filter === "CA") {
            viewport.center = [
                -97,
                63
            ];
            viewport.zoom = 3.6;
        }
        if ($aa6103d484f83752$var$country_filter === "GL") viewport.zoom = 3.5;
        if ($aa6103d484f83752$var$country_filter === "RU") {
            viewport.center = [
                70,
                60
            ];
            viewport.zoom = 2.5;
        }
        if ($aa6103d484f83752$var$country_filter === "CN") viewport.zoom = 3;
        // CA-postal
        if ($aa6103d484f83752$var$country_filter === "CA" && $aa6103d484f83752$var$selectLayerEl.value === "pos4") {
            viewport.center = [
                -79.38656,
                43.64865
            ];
            viewport.zoom = 13;
        }
        // change zoom if we change countries, or if there's a new level selected _and_
        // that level isn't visible at our current zoom
        const changeZoom = $aa6103d484f83752$var$countryChange || $aa6103d484f83752$var$levelChange && $aa6103d484f83752$var$z_min > $aa6103d484f83752$var$map.getZoom() || $aa6103d484f83752$var$map.getZoom() < 2;
        if (changeZoom) $aa6103d484f83752$var$map.easeTo({
            center: viewport.center,
            zoom: viewport.zoom
        });
        // reset change variable after updating the map
        $aa6103d484f83752$var$levelChange = false;
        $aa6103d484f83752$var$countryChange = false;
    } catch (e) {
        console.log(e);
    }
}
function $aa6103d484f83752$var$addPopupHover(popuplayer) {
    // Add a popup to the map
    let id = "0";
    $aa6103d484f83752$var$popupevent = function(e) {
        if (!$aa6103d484f83752$var$map.getLayer(popuplayer)) return;
        // Pause popups if cmd is pressed
        if (e.originalEvent.metaKey) return;
        const features = $aa6103d484f83752$var$map.queryRenderedFeatures(e.point, {
            layers: [
                popuplayer
            ]
        });
        // map.getCanvas().style.cursor = features.length ? "pointer" : "";
        if (!features.length) {
            $aa6103d484f83752$var$popup.remove();
            $aa6103d484f83752$var$map.setFeatureState({
                source: $aa6103d484f83752$var$level + "join",
                sourceLayer: $aa6103d484f83752$var$polyLayerName,
                id: id
            }, {
                hover: 0
            });
            id = "0";
            return;
        }
        const feature = features[0];
        const newid = feature.id;
        if (id !== newid) {
            // Set the pk of the polygon to the newly hovered pk
            $aa6103d484f83752$var$map.setFeatureState({
                source: $aa6103d484f83752$var$level + "join",
                sourceLayer: $aa6103d484f83752$var$polyLayerName,
                id: id
            }, {
                hover: 0
            });
            id = newid;
            // Create the tooltip
            const featureid = feature.id;
            const featureLookupData = Object.entries($aa6103d484f83752$var$data).length ? $aa6103d484f83752$var$data[featureid] : null;
            const name = featureLookupData && featureLookupData.hasOwnProperty("name") ? featureLookupData.name : null;
            const name_en = featureLookupData && featureLookupData.hasOwnProperty("name_en") ? featureLookupData.name_en : null;
            const code = featureLookupData && featureLookupData.hasOwnProperty("code") ? featureLookupData.code : "";
            const wikidata_id = featureLookupData && featureLookupData.hasOwnProperty("wikidata_id") ? featureLookupData.wikidata_id : "";
            const outerDiv = document.createElement("div");
            outerDiv.setAttribute("class", "flex-parent-inline flex-parent--center-cross flex-parent--column");
            // Combine name and name_en into single line if both exist
            const div1 = document.createElement("div");
            div1.setAttribute("class", "txt-h4 txt-bold");
            const div1Text = document.createTextNode(name ? name_en ? `${name} / ${name_en}` : name : name_en || "");
            div1.appendChild(div1Text);
            outerDiv.appendChild(div1);
            // Only create code section if code exists
            if (code) {
                const div2 = document.createElement("div");
                div2.setAttribute("class", "txt-s mt3");
                div2.innerHTML = `Code: <span class="txt-kbd px3">${code}</span>`;
                outerDiv.appendChild(div2);
            }
            if (wikidata_id) {
                const div3 = document.createElement("div");
                outerDiv.appendChild(div3);
                // Load content from Wikipedia after 1 second
                setTimeout($aa6103d484f83752$var$fetchArticleFromWikidata, 1000, wikidata_id, "en", (wikidataJSON, wikipediaJSON)=>{
                    const wikipediaUrl = window.mobileCheck() ? wikipediaJSON.content_urls.mobile.page : wikipediaJSON.content_urls.desktop.page;
                    div3.innerHTML = `
              <div class='prose txt-s mt6' style='overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:6;-webkit-box-orient:vertical;'>
                ${wikipediaJSON.extract_html}
              </div>
              <div class='txt-xs mt3'>
                from <a class='link' href='${wikipediaUrl}'>Wikipedia</a>
              </div>`;
                });
            }
            $aa6103d484f83752$var$popup.setDOMContent(outerDiv).addTo($aa6103d484f83752$var$map);
        }
        $aa6103d484f83752$var$map.setFeatureState({
            source: $aa6103d484f83752$var$level + "join",
            sourceLayer: $aa6103d484f83752$var$polyLayerName,
            id: id
        }, {
            hover: 1
        });
        $aa6103d484f83752$var$popup.setLngLat(e.lngLat).addTo($aa6103d484f83752$var$map);
    };
    // Reset hover and popups on losing mouse focus
    $aa6103d484f83752$var$map.on("mouseout", $aa6103d484f83752$var$level + "join", ()=>{
        $aa6103d484f83752$var$map.setFeatureState({
            source: $aa6103d484f83752$var$level + "join",
            sourceLayer: $aa6103d484f83752$var$polyLayerName,
            id: id
        }, {
            hover: 0
        });
        $aa6103d484f83752$var$popup.remove();
    });
    $aa6103d484f83752$var$map.on("mousemove", $aa6103d484f83752$var$popupevent);
}
function $aa6103d484f83752$var$addSelectClick(queryLayer) {
    // When the user clicks the map, set the main fill layer opacity low
    // To indicate 'selection mode'.  As the user clicks on polygons in the map,
    // highlight the polygons and store their pk's in a Map() to use in other
    // dashboard filter elements.
    let listOfPksToSelect = new Map();
    $aa6103d484f83752$var$clickevent = function(e) {
        const features = $aa6103d484f83752$var$map.queryRenderedFeatures(e.point, {
            layers: [
                queryLayer
            ]
        });
        let id = 0;
        if (!features.length) {
            // Reset the highlightLayer if there are no features selected
            listOfPksToSelect.forEach((value)=>{
                $aa6103d484f83752$var$map.setFeatureState({
                    source: $aa6103d484f83752$var$level + "join",
                    sourceLayer: $aa6103d484f83752$var$polyLayerName,
                    id: value
                }, {
                    select: 0
                });
            });
            id = 0;
            listOfPksToSelect = new Map();
            $aa6103d484f83752$var$map.setPaintProperty(queryLayer, "fill-opacity", 1);
            return;
        }
        // Get the pk property from the selected feature
        const feature = features[0];
        id = feature.id;
        // Add or remove the clicked feature's pk to the filter list
        if (listOfPksToSelect.get(id)) {
            listOfPksToSelect.delete(id);
            $aa6103d484f83752$var$map.setFeatureState({
                source: $aa6103d484f83752$var$level + "join",
                sourceLayer: $aa6103d484f83752$var$polyLayerName,
                id: id
            }, {
                select: 0
            });
        } else listOfPksToSelect.set(id, id);
        // Set the style based on the current features selected
        if (listOfPksToSelect.size > 0) {
            $aa6103d484f83752$var$map.setPaintProperty(queryLayer, "fill-opacity", 0.9);
            listOfPksToSelect.forEach((value)=>{
                $aa6103d484f83752$var$map.setFeatureState({
                    source: $aa6103d484f83752$var$level + "join",
                    sourceLayer: $aa6103d484f83752$var$polyLayerName,
                    id: value
                }, {
                    select: 1
                });
            });
        } else {
            $aa6103d484f83752$var$map.setPaintProperty(queryLayer, "fill-opacity", 1);
            $aa6103d484f83752$var$map.setFeatureState({
                source: $aa6103d484f83752$var$level + "join",
                sourceLayer: $aa6103d484f83752$var$polyLayerName,
                id: id
            }, {
                select: 0
            });
        }
    };
    $aa6103d484f83752$var$map.on("click", queryLayer, $aa6103d484f83752$var$clickevent);
}
function $aa6103d484f83752$var$initLayers(level) {
    // Find the appropriate location to insert overlay layers, ideally before any label layers
    const styleLabelLayers = $aa6103d484f83752$var$findLayers($aa6103d484f83752$var$map, (layer)=>{
        return layer.hasOwnProperty("layout") && layer.layout.hasOwnProperty("text-font");
    });
    const insertBeforeLabelLayer = styleLabelLayers ? styleLabelLayers[0].id : null;
    const insertBeforeFillLayer = "water";
    styleLabelLayers.forEach((layer)=>{
        // Update worldview filter on place labels without distrurbing other data filters
        // This is done by iterating through the existing layer filter and checking
        // if it contains any of the the supported worldview string value and
        // replaces it with the currently selected worldview value
        if ($aa6103d484f83752$var$mapboxWorldviews.basemap.indexOf($aa6103d484f83752$var$worldview) > -1 && (layer["source-layer"] === "place_label" || layer["source-layer"] === "place_label")) {
            let placeFilter = $aa6103d484f83752$var$map.getFilter(layer.id).map((item)=>{
                if (typeof item === "object") return $aa6103d484f83752$var$mapboxWorldviews.boundaries.some((wv)=>JSON.stringify(item).includes(wv)) ? JSON.parse(JSON.stringify(item).replace(new RegExp($aa6103d484f83752$var$mapboxWorldviews.boundaries.join("|"), "g"), $aa6103d484f83752$var$worldview)) : item;
                else return item;
            });
            $aa6103d484f83752$var$map.setFilter(layer.id, placeFilter);
        }
        // Dim labels for countries not selected
        if (layer.id === "country-label") $aa6103d484f83752$var$map.setPaintProperty(layer.id, "text-opacity", [
            "case",
            [
                "==",
                [
                    "get",
                    "iso_3166_1"
                ],
                $aa6103d484f83752$var$country_filter
            ],
            1,
            0.4
        ]);
        else {
            $aa6103d484f83752$var$map.setPaintProperty(layer.id, "text-opacity", [
                "case",
                [
                    "==",
                    [
                        "get",
                        "iso_3166_1"
                    ],
                    $aa6103d484f83752$var$country_filter
                ],
                0.9,
                0.3
            ]);
            $aa6103d484f83752$var$map.setPaintProperty(layer.id, "icon-opacity", [
                "case",
                [
                    "==",
                    [
                        "get",
                        "iso_3166_1"
                    ],
                    $aa6103d484f83752$var$country_filter
                ],
                0.7,
                0.1
            ]);
        }
    });
    // Add base admin-0 polygons and lines
    if (!$aa6103d484f83752$var$map.getSource("admLines")) {
        // Remove default boundaries from mapbox-streets tilesets
        $aa6103d484f83752$var$findLayers($aa6103d484f83752$var$map, (layer)=>{
            return layer["source-layer"] === "water";
        }).map((layer)=>layer.id).forEach((layer)=>$aa6103d484f83752$var$map.setPaintProperty(layer, "fill-color", "#f0faff"));
        // Remove default boundaries from mapbox-streets tilesets
        $aa6103d484f83752$var$findLayers($aa6103d484f83752$var$map, (layer)=>{
            return layer["source-layer"] === "admin";
        }).map((layer)=>layer.id).forEach((layer)=>$aa6103d484f83752$var$map.removeLayer(layer));
        // Add boundaries from boundaries tilesets
        $aa6103d484f83752$var$map.addSource("admLines", {
            type: "vector",
            url: `mapbox://${$aa6103d484f83752$var$mapboxAccount}.boundaries-admLines-${$aa6103d484f83752$var$tilesetVersion}`,
            promoteId: "mapbox_id"
        });
        $aa6103d484f83752$var$map.addSource("adm0", {
            type: "vector",
            url: `mapbox://${$aa6103d484f83752$var$mapboxAccount}.boundaries-adm0-${$aa6103d484f83752$var$tilesetVersion}`,
            promoteId: "mapbox_id"
        });
        // Add country outlines for mouse interaction
        // Admin-0 outline
        $aa6103d484f83752$var$map.addLayer({
            id: "adm0-outline",
            type: "line",
            source: "adm0",
            "source-layer": "boundaries_admin_0",
            layout: {},
            paint: {
                "line-width": 1
            }
        }, insertBeforeLabelLayer);
        // Admin-0 polygons
        $aa6103d484f83752$var$map.addLayer({
            id: "adm0",
            type: "fill",
            source: "adm0",
            "source-layer": "boundaries_admin_0",
            layout: {},
            paint: {
                "fill-opacity": 1
            }
        }, insertBeforeFillLayer);
        // Replace default admin-0/1 lines from mapbox-streets with boundaries
        // Admin-0 boundaries background
        $aa6103d484f83752$var$map.addLayer({
            id: "admLines-0-bg",
            type: "line",
            source: "admLines",
            "source-layer": "boundaries_admin_lines",
            layout: {},
            paint: {
                "line-opacity": 1,
                "line-color": "#fafafa",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    2,
                    2,
                    10,
                    6
                ]
            }
        }, insertBeforeFillLayer);
        // Admin-1 boundaries background
        $aa6103d484f83752$var$map.addLayer({
            id: "admLines-1-bg",
            type: "line",
            source: "admLines",
            "source-layer": "boundaries_admin_lines",
            layout: {},
            paint: {
                "line-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    0,
                    8,
                    0.75
                ],
                "line-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    8,
                    "hsl(185, 0%, 84%)",
                    16,
                    "hsl(185, 0%, 84%)"
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    7,
                    3.75,
                    12,
                    5.5
                ],
                "line-dasharray": [
                    1,
                    0
                ],
                "line-blur": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    0,
                    8,
                    3
                ]
            }
        }, insertBeforeLabelLayer);
        // // Admin-0 disputed boundaries
        $aa6103d484f83752$var$map.addLayer({
            id: "admLines-0-disputed",
            type: "line",
            source: "admLines",
            "source-layer": "boundaries_admin_lines",
            layout: {},
            paint: {
                "line-color": "#ababab",
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    0.5,
                    10,
                    2
                ],
                "line-dasharray": [
                    "step",
                    [
                        "zoom"
                    ],
                    [
                        "literal",
                        [
                            3.25,
                            3.25
                        ]
                    ],
                    6,
                    [
                        "literal",
                        [
                            2.5,
                            2.5
                        ]
                    ],
                    7,
                    [
                        "literal",
                        [
                            2,
                            2.25
                        ]
                    ],
                    8,
                    [
                        "literal",
                        [
                            1.75,
                            2
                        ]
                    ]
                ]
            }
        }, insertBeforeLabelLayer);
        // Admin-1 boundaries
        $aa6103d484f83752$var$map.addLayer({
            id: "admLines-1",
            type: "line",
            source: "admLines",
            "source-layer": "boundaries_admin_lines",
            layout: {},
            paint: {
                "line-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    3,
                    "hsl(185, 0%, 83%)",
                    7,
                    "hsl(185, 3%, 68%)"
                ],
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    7,
                    0.75,
                    12,
                    1.5
                ],
                "line-dasharray": [
                    "step",
                    [
                        "zoom"
                    ],
                    [
                        "literal",
                        [
                            2,
                            0
                        ]
                    ],
                    7,
                    [
                        "literal",
                        [
                            2,
                            2,
                            6,
                            2
                        ]
                    ]
                ]
            }
        }, insertBeforeLabelLayer);
    }
    $aa6103d484f83752$var$map.setPaintProperty("adm0", "fill-color", [
        "case",
        [
            "==",
            [
                "get",
                "iso_3166_1"
            ],
            $aa6103d484f83752$var$country_filter
        ],
        "hsla(255,255,100%,1)",
        [
            "==",
            [
                "feature-state",
                "hover"
            ],
            1
        ],
        "hsla(255,255,100%,.8)",
        "hsla(0,0,93%,1)"
    ]);
    $aa6103d484f83752$var$map.setPaintProperty("adm0-outline", "line-color", [
        "case",
        [
            "==",
            [
                "get",
                "iso_3166_1"
            ],
            $aa6103d484f83752$var$country_filter
        ],
        "hsla(0,0,0%,1)",
        [
            "==",
            [
                "feature-state",
                "hover"
            ],
            1
        ],
        "hsla(0,0,0%,1)",
        "hsla(0,0,0%,0.5)"
    ]);
    $aa6103d484f83752$var$map.setPaintProperty("admLines-1", "line-color", [
        "case",
        [
            "==",
            [
                "get",
                "iso_3166_1"
            ],
            $aa6103d484f83752$var$country_filter
        ],
        "hsla(0,0,70%,1)",
        "hsla(0,0,80%,0.5)"
    ]);
    $aa6103d484f83752$var$map.setPaintProperty("admLines-1-bg", "line-color", [
        "case",
        [
            "==",
            [
                "get",
                "iso_3166_1"
            ],
            $aa6103d484f83752$var$country_filter
        ],
        "hsla(0,0,80%,1)",
        "hsla(0,0,80%,0)"
    ]);
    // Update the worldview filter on the geocoder
    if ($aa6103d484f83752$var$mapboxWorldviews.geocoder.indexOf($aa6103d484f83752$var$worldview) > -1) $aa6103d484f83752$var$mapboxGeocoder.setWorldview($aa6103d484f83752$var$worldview.toLowerCase());
    // Update the worldview filter in the added layers
    $aa6103d484f83752$var$map.setFilter("adm0", [
        "all",
        [
            "!",
            [
                "has",
                "dispute"
            ]
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
    ]);
    $aa6103d484f83752$var$map.setFilter("adm0-outline", [
        "all",
        [
            "!",
            [
                "has",
                "dispute"
            ]
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
    ]);
    $aa6103d484f83752$var$map.setFilter("admLines-0-bg", [
        "all",
        [
            "==",
            [
                "get",
                "level"
            ],
            0
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
    ]);
    $aa6103d484f83752$var$map.setFilter("admLines-1-bg", [
        "all",
        [
            "==",
            [
                "get",
                "level"
            ],
            1
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
    ]);
    $aa6103d484f83752$var$map.setFilter("admLines-0-disputed", [
        "all",
        [
            "==",
            [
                "get",
                "level"
            ],
            0
        ],
        [
            "==",
            [
                "get",
                "dispute"
            ],
            "true"
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
    ]);
    $aa6103d484f83752$var$map.setFilter("admLines-1", [
        "all",
        [
            "==",
            [
                "get",
                "level"
            ],
            1
        ],
        $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
    ]);
    // Add layer from the vector tile source with data-driven styles
    if (!$aa6103d484f83752$var$map.getLayer(level + "join")) {
        // Line layer
        $aa6103d484f83752$var$map.addLayer({
            id: level + "line",
            type: "line",
            source: level + "join",
            "source-layer": $aa6103d484f83752$var$polyLayerName,
            paint: {
                "line-opacity": 0.7,
                "line-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    6,
                    "hsla(0, 0%, 60%,0.1)",
                    14,
                    "hsla(0, 0%, 20%,0.8)"
                ]
            }
        }, insertBeforeLabelLayer);
        // Polygon layer
        $aa6103d484f83752$var$map.addLayer({
            id: level + "join",
            type: "fill",
            source: level + "join",
            "source-layer": $aa6103d484f83752$var$polyLayerName,
            paint: {
                "fill-opacity": 1
            }
        }, insertBeforeFillLayer);
        // Point layer
        if (!$aa6103d484f83752$var$map.getLayer(level + "Points")) $aa6103d484f83752$var$map.addLayer({
            id: level + "Points",
            type: "symbol",
            source: level.slice(0, -1) + "Points",
            "source-layer": $aa6103d484f83752$var$polyLayerName.replace("boundaries", "points"),
            layout: {
                "text-field": [
                    "concat",
                    [
                        "get",
                        "name"
                    ],
                    "\n",
                    [
                        "get",
                        "name_en"
                    ]
                ],
                "text-font": [
                    "Open Sans SemiBold",
                    "Arial Unicode MS Bold"
                ],
                "text-size": 14
            },
            paint: {
                "text-halo-color": "hsla(279, 1%, 100%, 0.94)",
                "text-halo-width": 2
            },
            filter: [
                "all",
                [
                    "==",
                    [
                        "get",
                        "iso_3166_1"
                    ],
                    $aa6103d484f83752$var$country_filter
                ],
                $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
            ]
        });
        else // Update the filter on the existing points layer
        $aa6103d484f83752$var$map.setFilter(level + "Points", [
            "all",
            [
                "==",
                [
                    "get",
                    "iso_3166_1"
                ],
                $aa6103d484f83752$var$country_filter
            ],
            $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
        ]);
    }
    $aa6103d484f83752$var$map.setFilter(level + "join", $aa6103d484f83752$var$featureFilter);
    function fillColorExpression(opacity) {
        return [
            "to-color",
            [
                "concat",
                "hsla(",
                [
                    "%",
                    // Use modulo to keep the hue in 0-360 range
                    [
                        "+",
                        [
                            "*",
                            [
                                "index-of",
                                [
                                    "slice",
                                    [
                                        "get",
                                        "mapbox_id"
                                    ],
                                    15,
                                    16
                                ],
                                // Use last 2 chars
                                "hVY1kTvjzLfDKZAEwisGCqtNmMyFabS8n3g04WUJQ96cB7eOulrXR2PoI5xdHp"
                            ],
                            97 // Larger prime number multiplier for more hue variation
                        ],
                        [
                            "*",
                            [
                                "index-of",
                                [
                                    "slice",
                                    [
                                        "get",
                                        "mapbox_id"
                                    ],
                                    16,
                                    17
                                ],
                                // Use 2 chars before that
                                "t6QRGZeAg4Mnmf2vILHFB7zJVE5KbPaiNYTcj1u30Sw8dXWlkysqpChOxU9orD"
                            ],
                            223 // Another larger prime number multiplier
                        ]
                    ],
                    360 // Full hue range
                ],
                ",",
                // Separate hue value
                [
                    "+",
                    45,
                    // Lower base saturation for more pastel colors
                    [
                        "%",
                        [
                            "*",
                            [
                                "index-of",
                                [
                                    "slice",
                                    [
                                        "get",
                                        "mapbox_id"
                                    ],
                                    15,
                                    16
                                ],
                                "Uo56bWvJM8D7ABqLQeERu0VmHNiFPSsx3apYhKnjy9CIrGZOTz1lwfX24kcgtd"
                            ],
                            15 // Increased saturation variation
                        ],
                        25 // Larger modulo for more saturation steps
                    ]
                ],
                "%, 80%, ",
                // Slightly reduced lightness for more vibrant colors
                opacity,
                ")" // Close HSL color
            ]
        ];
    }
    // Set polygon fill color using the feature id
    $aa6103d484f83752$var$map.setPaintProperty(level + "join", "fill-color", [
        "case",
        [
            "==",
            [
                "feature-state",
                "select"
            ],
            1
        ],
        fillColorExpression(1),
        [
            "==",
            [
                "feature-state",
                "hover"
            ],
            1
        ],
        fillColorExpression(0.6),
        fillColorExpression(0.5)
    ]);
    $aa6103d484f83752$var$map.setPaintProperty(level + "join", "fill-outline-color", [
        "interpolate",
        [
            "linear"
        ],
        [
            "zoom"
        ],
        6,
        "hsla(0, 0%, 60%,0.9)",
        14,
        "hsla(0, 0%, 20%,0.8)"
    ]);
    if (!$aa6103d484f83752$var$map.getLayer(level + "selectionLine")) $aa6103d484f83752$var$map.addLayer({
        id: level + "selectionLine",
        type: "line",
        source: level + "join",
        "source-layer": $aa6103d484f83752$var$polyLayerName,
        layout: {},
        paint: {
            "line-color": [
                "case",
                [
                    "==",
                    [
                        "feature-state",
                        "select"
                    ],
                    1
                ],
                "hsla(30, 90%, 30%,1)",
                [
                    "==",
                    [
                        "feature-state",
                        "hover"
                    ],
                    1
                ],
                "hsla(0, 0%, 30%,0.6)",
                "rgba(0,0,0,0)"
            ],
            "line-width": {
                stops: [
                    [
                        5,
                        1
                    ],
                    [
                        14,
                        3
                    ]
                ]
            }
        }
    }, insertBeforeLabelLayer);
    $aa6103d484f83752$var$map.setFilter(level + "selectionLine", $aa6103d484f83752$var$featureFilter);
}
// Update required map sources
function $aa6103d484f83752$var$initmap(lookup_data, level) {
    // Get the vector tile source to join to
    $aa6103d484f83752$var$polyLayerName = lookup_data.polyLayerName;
    $aa6103d484f83752$var$data = {};
    $aa6103d484f83752$var$worldview = $aa6103d484f83752$var$selectWorldviewEl.value;
    // Add polygon boundaries tileset for the level
    if (!$aa6103d484f83752$var$map.getSource(level + "join")) $aa6103d484f83752$var$map.addSource(level + "join", {
        type: "vector",
        url: $aa6103d484f83752$var$mapboxTilesetUrl(lookup_data.polyTilesetName),
        promoteId: "mapbox_id"
    });
    // Add point boundaries tileset for the type
    const type = level.slice(0, -1);
    if (!$aa6103d484f83752$var$map.getSource(type + "Points")) $aa6103d484f83752$var$map.addSource(type + "Points", {
        type: "vector",
        url: $aa6103d484f83752$var$mapboxTilesetUrl(lookup_data.polyTilesetName.replace(level, type + "Points")),
        promoteId: "mapbox_id"
    });
    function filterFeatures() {
        // Create a filter expression for the boundary layer using the country and worldview selection
        $aa6103d484f83752$var$featureFilter = [
            "all",
            [
                "==",
                [
                    "get",
                    "iso_3166_1"
                ],
                $aa6103d484f83752$var$country_filter
            ],
            $aa6103d484f83752$var$wvFilter($aa6103d484f83752$var$worldview)
        ];
    }
    filterFeatures();
    function updateState() {
        [
            $aa6103d484f83752$var$worldview,
            "all"
        ].forEach((worldview)=>{
            if (worldview in lookup_data) for(const key in lookup_data[worldview]){
                $aa6103d484f83752$var$data[key] = lookup_data[worldview][key];
                $aa6103d484f83752$var$data[key].worldview = worldview;
            }
        });
        // Update boundary count
        const boundaryCount = Object.keys($aa6103d484f83752$var$data).length;
        document.getElementById("boundaryCount").innerHTML = `<span class="txt-bold">${$aa6103d484f83752$var$numberWithCommas(boundaryCount)}</span> ${boundaryCount === 1 ? "Boundary" : "Boundaries"}`;
        // Generate table list if reasonable
        if (boundaryCount < 50000) {
            const features = [];
            Object.keys($aa6103d484f83752$var$data).forEach((key)=>{
                features.push(Object.assign($aa6103d484f83752$var$data[key], {
                    id: key
                }));
            });
            features.sort((a, b)=>{
                return a.hasOwnProperty("name_en") ? $aa6103d484f83752$var$d3.ascending(a.name_en, b.name_en) : $aa6103d484f83752$var$d3.ascending(a.name, b.name);
            });
            createFeatureTable(features);
        } else document.getElementById("table").textContent = "";
        //
        function createFeatureTable(data) {
            const pointSourceId = level.slice(0, -1) + "Points";
            const tableVisible = document.getElementById("table").style.display !== "none";
            $aa6103d484f83752$var$d3.select("#table table").remove();
            const thedatatable = $aa6103d484f83752$var$d3.select("#table").append("table").attr("class", "table txt-xs cursor-pointer");
            $aa6103d484f83752$var$d3.select("#table").on("mouseleave", (d)=>{
                // Only filter points if table is visible
                if (tableVisible) {
                    // Reset the clicked feature from table
                    const filter = $aa6103d484f83752$var$featureFilter;
                    filter[3] = [
                        "==",
                        [
                            "id"
                        ],
                        0
                    ];
                    $aa6103d484f83752$var$map.setFilter(level + "Points", filter);
                    $aa6103d484f83752$var$map.removeFeatureState({
                        source: level + "join",
                        sourceLayer: lookup_data.polyLayerName
                    });
                }
            });
            const tr = thedatatable.selectAll("tr").data(data).enter().append("tr").attr("id", (d)=>{
                return d.id;
            }).on("mousemove", (d)=>{
                // Find the boundary feature id from the id attribute
                const feature_id = d.currentTarget.id;
                // Save current zoom level
                const zoom = $aa6103d484f83752$var$map.getZoom();
                // Query source for features in current view
                const features = $aa6103d484f83752$var$map.querySourceFeatures(pointSourceId, {
                    sourceLayer: lookup_data.pointLayerName,
                    filter: [
                        "==",
                        [
                            "get",
                            "mapbox_id"
                        ],
                        feature_id
                    ]
                });
                // If feature was not found, it is ouside the map view
                // Zoom out to the country extent and try again
                // TODO: BUGGY
                if (!features.length) $aa6103d484f83752$var$map.fitBounds($aa6103d484f83752$var$bounds, {
                    duration: 0.5,
                    padding: 20
                });
                else showSourceFeature(features, zoom);
                // Find the feature in the tileset source
                function findSourceFeatures(feature_id) {
                    $aa6103d484f83752$var$map.off("moveend", findSourceFeatures);
                    // Query source for features in current view
                    const features = $aa6103d484f83752$var$map.querySourceFeatures(pointSourceId, {
                        sourceLayer: lookup_data.pointLayerName,
                        filter: [
                            "==",
                            [
                                "get",
                                "mapbox_id"
                            ],
                            feature_id
                        ]
                    });
                    showSourceFeature(features, zoom);
                }
                // Show the source feature on the map
                function showSourceFeature(features, zoom) {
                    // Reset the clicked feature from table
                    const filter = $aa6103d484f83752$var$featureFilter;
                    filter[3] = [
                        "==",
                        [
                            "get",
                            "mapbox_id"
                        ],
                        feature_id
                    ];
                    $aa6103d484f83752$var$map.setFilter(level + "Points", filter);
                    $aa6103d484f83752$var$map.removeFeatureState({
                        source: pointSourceId,
                        sourceLayer: lookup_data.pointLayerName
                    });
                    $aa6103d484f83752$var$map.removeFeatureState({
                        source: level + "join",
                        sourceLayer: lookup_data.polyLayerName
                    });
                    // Set the hover feature state for the point and boundary
                    $aa6103d484f83752$var$map.setFeatureState({
                        id: feature_id,
                        source: pointSourceId,
                        sourceLayer: lookup_data.pointLayerName
                    }, {
                        hover: 1
                    });
                    $aa6103d484f83752$var$map.setFeatureState({
                        id: feature_id,
                        source: level + "join",
                        sourceLayer: lookup_data.polyLayerName
                    }, {
                        hover: 1
                    });
                    $aa6103d484f83752$var$map.flyTo({
                        zoom: zoom,
                        center: features[0].geometry.coordinates,
                        speed: 0.9
                    });
                }
            });
            tr.selectAll("td").data((row)=>{
                return [
                    "name"
                ].map((d)=>{
                    let label = "";
                    const codeLabel = row.hasOwnProperty("code") ? `<span class="txt-kbd">${row["code"]}</span> ` : "";
                    label += row.hasOwnProperty("wikidata_id") ? `<a class="link" target="_blank" href="https://www.wikidata.org/wiki/${row.wikidata_id}">${codeLabel}</a>` : codeLabel;
                    label += row.hasOwnProperty("name") ? `${row["name"]} ` : "";
                    label += row.hasOwnProperty("name_en") ? `/ ${row["name_en"]} ` : "";
                    return {
                        column: d,
                        value: label
                    };
                });
            }).enter().append("td").html((d)=>{
                return d.value;
            });
        }
    }
    const setState = function(e) {
        if (e.sourceId === level + "join") {
            $aa6103d484f83752$var$map.off("sourcedataloading", setState);
            updateState();
        }
    };
    if ($aa6103d484f83752$var$map.isSourceLoaded(level + "join")) {
        updateState();
        $aa6103d484f83752$var$map.off("sourcedataloading", setState);
    } else $aa6103d484f83752$var$map.on("sourcedataloading", setState);
    $aa6103d484f83752$var$loadingbar.style.visibility = "hidden";
    // Popups and hovers
    $aa6103d484f83752$var$setBboxFeatures();
    $aa6103d484f83752$var$addPopupHover(level + "join");
    $aa6103d484f83752$var$addSelectClick(level + "join");
}
function $aa6103d484f83752$var$selectCountry(iso, worldview) {
    $aa6103d484f83752$var$countryChange = true;
    $aa6103d484f83752$var$country_filter = iso;
    $aa6103d484f83752$var$selectCountryEl.value = $aa6103d484f83752$var$country_filter;
    document.getElementById("selectCountry").dispatchEvent(new CustomEvent("change"));
    // Worldview is only passed by the initial detectUserLocation function. Dont trigger map update since the style is not yet fully loaded
    if (worldview) {
        $aa6103d484f83752$var$selectWorldviewEl.value = worldview;
        document.getElementById("selectWorldview").dispatchEvent(new CustomEvent("change"));
    } else $aa6103d484f83752$var$updateMap();
}
// Update the map view when clicking on a search result
function $aa6103d484f83752$var$selectSearchFeature(item) {
    $aa6103d484f83752$var$selectLayerEl.value = item.properties.layer_name;
    $aa6103d484f83752$var$updateMap();
    $aa6103d484f83752$var$map.fitBounds(item.bbox);
}
//
// Utility functions
//
// Mapbox
// Returns an array of map style layers that match a given filter function
function $aa6103d484f83752$var$findLayers(map, filterFn) {
    return map.getStyle().layers.filter((layer)=>{
        return filterFn ? filterFn(layer) : layer;
    });
}
// Creates a worldview filtes for Mapbox Boundaries tilesets
function $aa6103d484f83752$var$wvFilter(worldview) {
    return [
        "any",
        [
            "==",
            "all",
            [
                "get",
                "worldview"
            ]
        ],
        [
            "in",
            worldview,
            [
                "get",
                "worldview"
            ]
        ]
    ];
}
// Use the Wikidata QID to fetch the Wikipedia article summary for the given language code
function $aa6103d484f83752$var$fetchArticleFromWikidata(qid, lang, cb) {
    // Query Wikidata for the Wikipedia page title
    fetch(`https://www.wikidata.org/w/api.php?action=wbgetentities&format=json&props=sitelinks&ids=${qid}&sitefilter=${lang}wiki&origin=*`, {
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Origin: "https://demos.mapbox.com/boundaries-explorer/"
        }
    }).then((response)=>response.json()).then((data)=>{
        const wikidataJSON = data;
        // Fetch Wikipedia article if available
        if (wikidataJSON.entities[qid].sitelinks.hasOwnProperty(lang + "wiki") && wikidataJSON.entities[qid].sitelinks[lang + "wiki"].hasOwnProperty("title")) {
            const title = wikidataJSON.entities[qid].sitelinks[lang + "wiki"].title;
            // Query Wikipedia to get the summary
            fetch(`https://${lang}.wikipedia.org/api/rest_v1/page/summary/${title}`, {
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Origin: "https://demos.mapbox.com/boundaries-explorer/"
                }
            }).then((response)=>response.json()).then((wikipediaJSON)=>{
                cb(wikidataJSON, wikipediaJSON);
            });
        }
    });
}
// Boundaries Search Control
function $aa6103d484f83752$var$cleanName(name) {
    // some of our locality data has comma separated-aliases
    // only take the text before the comma
    return name.match(/^[^,]*/)[0];
}
function $aa6103d484f83752$var$prettyFormat(item) {
    const props = item.properties;
    const parentNames = props.relational.parent_names;
    // no context required if we're surfacing the adm0 country itself
    if (props.layer_name === 'adm0') var nameAndContext = [
        props.name
    ];
    else {
        var nameAndContext = [
            props.name,
            parentNames.parent_4,
            parentNames.parent_3,
            parentNames.parent_2,
            parentNames.parent_1,
            parentNames.parent_0
        ];
        // unit code display only appropriate for postal and stats types
        if ([
            "postal",
            "stats"
        ].includes(props.layer_type)) nameAndContext.unshift(props.unit_code);
    }
    // remove any null or placeholder parents
    const filtered = nameAndContext.filter(function(el) {
        return el != null && !el.includes(' remainder');
    });
    return filtered.map($aa6103d484f83752$var$cleanName);
}
const $aa6103d484f83752$var$zoomToFeature = function(event) {
    // unset ID if it's already set
    currentSelectedID;
    console.log('user selection:');
    console.log(event.item);
    $aa6103d484f83752$var$selectSearchFeature(event.item);
// currentSelectedID  = event.item.properties.mapbox_id;
// currentSelectedLayer = `boundaries_${event.item.properties.layer_name}`;
// currentSelectedSourceLayer  = event.item.properties.tileset.polygon_source_layer;
// map.setFeatureState(
//     { source: currentSelectedLayer, id: currentSelectedID, sourceLayer: currentSelectedSourceLayer},
//     { isSelected: true }
// );
};
let $aa6103d484f83752$var$markers = [];
function $aa6103d484f83752$var$addLabel(suggestion, map) {
    const feature = suggestion;
    const coordinates = feature.geometry.coordinates;
    const el = document.createElement('div');
    el.className = 'marker';
    el.innerHTML = `<span class="text-xs bg-slate-50 hover:bg-white rounded-md px-3 py-2 shadow-lg">${feature.properties.name ?? feature.properties.unit_code}</span>`;
    const marker = new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map);
    return marker;
}
$aa6103d484f83752$var$autocomplete({
    container: '#autocomplete',
    placeholder: 'Search boundaries',
    autoFocus: true,
    initialState: {
        // This uses the `search` query parameter as the initial query
        query: new URL(window.location).searchParams.get('search')
    },
    onStateChange ({ state: state }) {
        // Clear existing markers
        $aa6103d484f83752$var$markers.forEach((marker)=>{
            marker.remove();
        });
        $aa6103d484f83752$var$markers = [];
        // Clear search parameter if query is empty
        if (!state.query) {
            $aa6103d484f83752$var$urlParams.delete("search");
            window.history.replaceState({}, "", `${location.pathname}?${$aa6103d484f83752$var$urlParams}${location.hash}`);
        }
        // Generate markers to display from the search items
        if (state.collections.length && state.query.length) {
            $aa6103d484f83752$var$urlParams.set("search", state.query);
            const items = state.collections[0].items;
            // Create an empty bounds object
            const bounds = new mapboxgl.LngLatBounds();
            // Create an array to store the bounding boxes
            const boundingBoxes = [];
            // Add a map marker showing each search result
            items.forEach((item)=>{
                const marker = $aa6103d484f83752$var$addLabel(item, $aa6103d484f83752$var$map);
                $aa6103d484f83752$var$markers.push(marker);
                // Hover over overlapping markers to make it visible using z-index: 10
                const markerEl = marker.getElement();
                markerEl.addEventListener('mouseenter', ()=>{
                    markerEl.classList.add('z-10');
                    $aa6103d484f83752$var$popup.remove();
                });
                markerEl.addEventListener('mouseleave', ()=>{
                    markerEl.classList.remove('z-10');
                });
                // Zoom to feature
                markerEl.addEventListener('click', ()=>{
                    $aa6103d484f83752$var$selectSearchFeature(item);
                });
                // Center the map on the active search suggestion
                if (state.activeItemId != null) $aa6103d484f83752$var$map.flyTo({
                    center: state.collections[0].items[state.activeItemId].geometry.coordinates
                });
                else {
                    // Fit the map's viewport to the bounds object with a 10% padding
                    // Extract the bounding boxes
                    boundingBoxes.push(item.bbox);
                    const bounds = boundingBoxes.reduce((bounds, bbox)=>{
                        return bounds.extend(bbox);
                    }, new mapboxgl.LngLatBounds());
                    $aa6103d484f83752$var$map.fitBounds(bounds, {
                        padding: {
                            top: 100,
                            bottom: 100,
                            left: 400,
                            right: 100
                        }
                    });
                }
            });
        }
    },
    getSources ({ query: query }) {
        //  Use staging endpoint if custom search_access_token is provided
        const searchEndpoint = $aa6103d484f83752$var$searchAccessToken == $aa6103d484f83752$var$accessToken ? 'https://api.mapbox.com/search/boundaries/v1/search' : 'https://cloudfront-staging.tilestream.net/search/boundaries/v1/search';
        return fetch(`${searchEndpoint}?q=${query}&country=${$aa6103d484f83752$var$country_filter.toLowerCase()}&layer_type=${$aa6103d484f83752$var$mapboxLayerTypes[$aa6103d484f83752$var$level.substring(0, 3)]}&worldview=${$aa6103d484f83752$var$worldview}&version=v4&access_token=${$aa6103d484f83752$var$searchAccessToken}`).then((response)=>response.json()).then((results)=>{
            console.log(results);
            return [
                {
                    sourceId: 'results',
                    getItems () {
                        return results.features.filter((f)=>f.properties.description !== 'remainder');
                    },
                    getItemInputValue ({ item: item }) {
                        return `${item.properties.name}`;
                    },
                    templates: {
                        item ({ item: item, html: html }) {
                            const label = item.properties.layer_name == $aa6103d484f83752$var$level ? html`<b>${$aa6103d484f83752$var$prettyFormat(item)[0]}</b>` : `${$aa6103d484f83752$var$prettyFormat(item)[0]}`;
                            return html`<div>${label}</div><div><small>${item.properties.description} <span class="text-gray-400">${item.properties.iso_3166_1}-${item.properties.layer_name}</span></small></div>`;
                        },
                        renderNoResults ({ state: state, render: render }, root) {
                            render(`No results for "${state.query}".`, root);
                        }
                    },
                    onSelect: (e)=>{
                        $aa6103d484f83752$var$selectSearchFeature(e.item);
                    },
                    onActive: function displayResultLocation(e) {}
                }
            ];
        });
    }
});
// General
// Return flag emoji for a ISO-3166-1 code
// https://dev.to/jorik/country-code-to-flag-emoji-a21
function $aa6103d484f83752$var$getFlagEmoji(countryCode) {
    return countryCode.toUpperCase().replace(/./g, (char)=>String.fromCodePoint(127397 + char.charCodeAt()));
}
function $aa6103d484f83752$var$numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
//
// Detect user country code
//
function $aa6103d484f83752$var$detectUserLocation() {
    let selectedWorldview = null;
    let selectedCountryISO = null;
    const traceRequest = new XMLHttpRequest();
    traceRequest.open("GET", "https://www.cloudflare.com/cdn-cgi/trace");
    traceRequest.onreadystatechange = ()=>{
        if (traceRequest.readyState == XMLHttpRequest.DONE) {
            if (traceRequest.status == 200) {
                selectedCountryISO = traceRequest.responseText.match(/loc=([^\n+]*)/)[1].toUpperCase();
                // Select a worldview to match selected country, use US as default
                if ($aa6103d484f83752$var$mapboxWorldviews.boundaries.indexOf(selectedCountryISO) > -1) selectedWorldview = selectedCountryISO;
                else if ([
                    "HK",
                    "MO"
                ].indexOf(selectedCountryISO) > -1) selectedWorldview = "CN";
                else selectedWorldview = "US";
                $aa6103d484f83752$var$urlParams.set("country", selectedCountryISO);
                $aa6103d484f83752$var$selectCountry(selectedCountryISO, selectedWorldview);
            }
        }
    };
    traceRequest.send(null);
}
// Check if a mobile device
// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
window.mobileCheck = function() {
    let check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};


//# sourceMappingURL=boundaries-explorer.0625357a.js.map
